import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import {
  Star, MapPin, Plus, Send,
  ChevronLeft, ChevronRight, ChevronDown,
  Search, User, Coffee,
  Menu, X, Clock, Tag, ArrowUpRight,
} from "lucide-react";

/* --- Popularne pretrage - slike --- */
import psearch1Img from "./novosadski-adresar-slike/nocni-klub-splav.webp";
import psearch2Img from "./novosadski-adresar-slike/vinski-barovi.webp";
import psearch3Img from "./novosadski-adresar-slike/brunch-mesta.webp";
import psearch4Img from "./novosadski-adresar-slike/cross-fit.webp";
import psearch5Img from "./novosadski-adresar-slike/nargila-barovi.webp";
import psearch6Img from "./novosadski-adresar-slike/frizerski-saloni.webp";
import psearch7Img from "./novosadski-adresar-slike/specialty-kafa.webp";
import psearch8Img from "./novosadski-adresar-slike/ek-10.webp";

/* --- Noćni život - videi --- */
import nlVideo1 from "./novosadski-adresar-slike/nocni-klubovi.mp4";
import nlVideo2 from "./novosadski-adresar-slike/pivnice.mp4";
import nlVideo3 from "./novosadski-adresar-slike/barovi.mp4";
import nlThumb1 from "./novosadski-adresar-slike/nl-thumb-nocni-klubovi.jpg";
import nlThumb2 from "./novosadski-adresar-slike/nl-thumb-pivnice.jpg";
import nlThumb3 from "./novosadski-adresar-slike/nl-thumb-barovi.jpg";
import { categoryPath, matchBySlug } from "./slug";
import { bizPath } from "./bizPath";
import BLOG_POSTS from "./blogData.json";

/* --- Popularne kategorije - nove slike --- */
import catRestorani from "./novosadski-adresar-slike/restorani.webp";
import catKafici from "./novosadski-adresar-slike/kafici.webp";
import catSport from "./novosadski-adresar-slike/sport.webp";
import catBazeni from "./novosadski-adresar-slike/bazeni.webp";
import catZdravlje from "./novosadski-adresar-slike/zdravlje.webp";
import catHoteli from "./novosadski-adresar-slike/hoteli.webp";

/* --- Hero & Category slike (izvučene iz base64) --- */
import heroImg1 from "./novosadski-adresar-slike/hero-img-1.webp";
import heroImg2 from "./novosadski-adresar-slike/hero-img-2.webp";
import heroImg3 from "./novosadski-adresar-slike/hero-img-3.webp";


/* --- Hero slike za CategoryPage (Pexels, besplatna komercijalna licenca) --- */
// Hero slike za CategoryPage - namerno NISU webpack import (koji bi im dao
// hešovano ime), nego stabilne putanje iz public/hero-images/. Zahvaljujući
// tome, public/index.html može da pogodi tačno ime fajla za aktivnu
// kategoriju iz URL-a i da ga počne preuzimati ISTOVREMENO sa JS bandlom
// (umesto tek pošto se JS izvrši) - vidi <link rel="preload"> skriptu tamo.
const HERO_IMG_BASE = process.env.PUBLIC_URL + "/hero-images/";
const CATEGORY_HERO_IMG = {
  Restorani: HERO_IMG_BASE + "hero-restorani.jpg",
  Kafići: HERO_IMG_BASE + "hero-kafici.jpg",
  Sport: HERO_IMG_BASE + "hero-sport.jpg",
  Bazeni: HERO_IMG_BASE + "hero-bazeni.jpg",
  Zdravlje: HERO_IMG_BASE + "hero-zdravlje.jpg",
  Hoteli: HERO_IMG_BASE + "hero-hoteli.jpg",
  Nega: HERO_IMG_BASE + "hero-nega.jpg",
  "Noćni život": HERO_IMG_BASE + "hero-nocni-zivot.jpg",
  Auto: HERO_IMG_BASE + "hero-auto.jpg",
  Zanati: HERO_IMG_BASE + "hero-zanati.jpg",
};

// Sitne, jako zamućene verzije hero slika (< 1.2KB svaka), ugrađene direktno
// u JS kod umesto da se učitavaju sa mreže - prikazuju se ISTOG TRENUTKA dok
// prava slika stiže, umesto praznog/sivog prostora koji deluje kao greška.
const CATEGORY_HERO_BLUR = {
  Restorani: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAAIABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDDtQqQXQf+6P51Fsjd1O/YuOTjOPeiis0WyS5t4YYN8VwJNw4AQjrVHzFwoXoBiiinYD//2Q==",
  Kafići: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAAIABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDmicA12emSxy2MXlMoIUDn6YxRRWM9jVGX4lljAijQ5cc8fT/9VYqcjO0HPtRRQtg6n//Z",
  Sport: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAATABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDnlYbXwVBOBg81PC0YgV2BLbsZHYD3rMRuQO1Xo5ykKKANg4PHf3oETk5AAbjBJFMJHFNjIzmJijccA8EVHI+DjPakxlAVYtCfOC54bqPWiiqEPPFxtHTJOKZMT5hoopMEf//Z",
  Bazeni: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAAqABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwCZbYA/MCaT7Kc8U7yNRAOdx/4CKYbfUCGXacN3roeMS2OBYW6LkU0iJtcbvw61DKwd8sEB6YpsUd9Gm0w7scCqz2F7I7P5R+Y5rJ4qK1itTT2Mno2dB9pT/n4Sk89T0lSuc3D0/SjCnPHWt3hfMlYt9jpEmDOMOrAenapzt6Vj6UuEkI9QK1FywBxXLUjyysdlOXPFSMlbaID7nTuRmlMduvXyx+IqjO7O5DMW+Xuc1CvIiJ5JHPvXeotq9zgdl0N+0CLF8gGCe1WFbAqhZf8AHqv4/wA6vJ92uGfxM9CCtBH/2Q==",
  Zdravlje: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAAqABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDqCaip0rFI2YDJAJrm57rU4XNwJlliBG5UXp+FO4rHRAU4Co4JPOhSQDG9QcHtUtAEJeWQFRGBkdzVNEdS8JYK5GM7enoavRAmYn8KfgSSMGjAZTgHrketS43KUrDLYM8Q4wwAyKkqSJNpBJ5xtP4USIS2RVEmHZalO6xv5e9MYcgjIP0rYiuYZcPuAbpzwa5bSWIDAE4yK1JiRAxyc4pR2uN72NSS5BkZFBOOpFWFyyg8ioLZVNtESoztHarVJXG7H//Z",
  Hoteli: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAATABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDViUsQMHHerYRcYHWqmnMHkd1kBHTGDV9twlEi8jGCKlPqU0loUblCky5OODkVzlnb74if9qusuYIrh97swfGOG6VUt9KWFCqyZGc8immJIzLV2jmfYxHzVrSyv5aYYjcwBoorGJtPoWtoRcqBn1qBpXz940UVqzNH/9k=",
  Nega: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAATABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDRWBSu+SY7uxxinSR5UFZmH0A/wpVUy2R8t8NnAJXoajlSUKuXyQuDgdTzSGOEXmNtSZ2PoAP8KZJCVbAlZcdgB/hTrZJIcsJAxI7rimNIWYkg5PtTEVlY26YiJXOT1z3prXU2VHmHmiiuZtnWorsWhK+ev6VaHSiiuiJzyR//2Q==",
  "Noćni život": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAAVABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDlbSR0cFOq8g1sm+K6nHJsOGCZUD86NI0mOUI0zld3JWtSXTx/aaTKwIXHU/lWiRi2mzHvbw3d7vdG8pTu2gfwiqVxqEsspYMUHZR2rfltxb6gkm4bGyCKrXWn2TzFhkZ7ChpiTRlR3syD5WIx0qU6lcEZLmiiouzayIZL2aT7zE/jUZupM8kmiikOx//Z",
  Auto: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAATABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwC1d6nKsjNlgmMBWHf1qnHO5WScRuMoeMY59an1Hz3l8wIsiqvy1mT3EywBnUkv1HoKas0D3EhgS1dLuMlWjYFhnsa2pL23Lc3Ef/fVc5LczOhWONl6dRUaTTRoF8i3b3aMZoUrCcbnTTsTgZ4Iqlc5VcqSDjsaKKzRbE2LsBx2H8qrOo3dBRRQB//Z",
  Zanati: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDABQODxIPDRQSERIXFhQYHzMhHxwcHz8tLyUzSkFOTUlBSEZSXHZkUldvWEZIZoxob3p9hIWET2ORm4+AmnaBhH//2wBDARYXFx8bHzwhITx/VEhUf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f3//wAARCAATABwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDl7KSWObbDklxtIzjNTXFn5Mu6Y7A3O2rUd1Fbvst7YRoTjzH5NabQJcExSYl8rGcjrn0rGUrM2jG6sZlvKslssaKQqkhcipRoTMN09zHCx52PnOKt/aIrUqLRN0gzhfSs6a/laVjK8queqr0HtVRkKUS7rKLkNgZI5xUOjSvJ57OxJJHNFFR9gv7ZZukXfuwNx6mqJds9aKKmJbP/2Q==",
};

/* --- Lazy-loaded "page" components - svaka se učitava tek kad korisnik
   zaista ode na tu stranicu, umesto da uveća početni (home) JS bundle --- */
// Kao React.lazy, ali stranica može da se učita unapred (preload), npr. kad
// posetilac pređe mišem preko linka ili klikne. Kad je kod već stigao, stranica
// se prikazuje odmah, bez ekrana za učitavanje. Odluka "odmah ili lazy" se
// donosi jednom po prikazu, da se stranica ne bi ponovo montirala.
function lazyWithPreload(factory) {
  let Loaded = null;
  let promise = null;
  const load = () => promise || (promise = factory().then(
    (m) => { Loaded = m.default; return m; },
    (e) => { promise = null; throw e; }
  ));
  const Lazy = React.lazy(load);
  function PreloadablePage(props) {
    const [direct] = useState(() => Loaded);
    const C = direct || Lazy;
    return <C {...props} />;
  }
  PreloadablePage.preload = load;
  PreloadablePage.isLoaded = () => !!Loaded;
  return PreloadablePage;
}

const SingleBusinessPage = lazyWithPreload(() => import("./pages/SingleBusinessPage"));
const CategoryPage       = lazyWithPreload(() => import("./pages/CategoryPage"));
// Stranica Mapa (NearbyMapPage) je uklonjena sa sajta 2026-10; fajl je ostao u src/pages.
const BlogPage           = lazyWithPreload(() => import("./pages/BlogPage"));
const ProfilePage        = lazyWithPreload(() => import("./pages/ProfilePage"));
const AddBusinessPage    = lazyWithPreload(() => import("./pages/AddBusinessPage"));
const WriteReviewPage    = lazyWithPreload(() => import("./pages/WriteReviewPage"));
const AllReviewsPage     = lazyWithPreload(() => import("./pages/AllReviewsPage"));
const ContactPage        = lazyWithPreload(() => import("./pages/ContactPage"));
const NightlifeSubPage   = lazyWithPreload(() => import("./pages/NightlifeSubPage"));
const TermsPage          = lazyWithPreload(() => import("./pages/TermsPage"));
const PrivacyPage        = lazyWithPreload(() => import("./pages/PrivacyPage"));
const CookiesPage        = lazyWithPreload(() => import("./pages/CookiesPage"));


const PSEARCH_1 = psearch1Img; // Noćni klubovi i splavovi
const PSEARCH_2 = psearch2Img; // Vinski barovi
const PSEARCH_3 = psearch3Img; // Brunch mesta
const PSEARCH_4 = psearch4Img; // Fitness centri i teretane
const PSEARCH_5 = psearch5Img; // Nargila barovi
const PSEARCH_6 = psearch6Img; // Frizerski saloni
const PSEARCH_7 = psearch7Img; // Specialty kafa
const PSEARCH_8 = psearch8Img; // Etno smeštaj


/* --- TOKENS --- */
const BLUE = "#0079FF";
const GMAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/* ==========================================
   SUPABASE CONFIG & DATA HOOK
========================================== */
const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;
const TABLE_NAME    = "Biznisi Novi Sad";

// Mapiranje UI naziva kategorije → stvarni naziv u bazi (baza čuva stare
// nazive za neke kategorije). JEDAN deljeni izvor istine - ranije su
// postojale DVE odvojene, neusklađene kopije ove mape (jedna u
// useSupabaseCategory, jedna u CategoryPage), pa je npr. "Sport" nedostajao
// u onoj koja se koristi za sam upit ka bazi, i kategorija je uvek vraćala
// 0 rezultata iako je baza imala podatke pod nazivom "Teretane".
const CATEGORY_DB_NAME_MAP = { 'Sport': 'Teretane', 'Nega': 'Usluge' };

// GA4 događaj (ključni događaji: registracija, zahtev za biznis, recenzija).
// Šalje se samo ako je korisnik prihvatio kolačiće i GA je učitan.
function trackEvent(name, params = {}) {
  try { if (typeof window.gtag === "function" && window.__nsGaLoaded) window.gtag("event", name, params); } catch {}
}

// Greška iz odgovora servera, sa statusom i kodom baze (za describeError ispod)
async function apiError(res) {
  let d = null;
  try { d = await res.json(); } catch {}
  const e = new Error((d && (d.message || d.error_description || d.msg || d.error)) || `HTTP ${res.status}`);
  e.status = res.status;
  e.code = d && (d.code || d.error_code);
  return e;
}

// Pretvara grešku u poruku koju korisnik razume: šta se desilo i šta da uradi.
// Na kraju je kratak kod greške, da korisnik može da nam ga pošalje.
const SUPPORT_EMAIL = "info@novosadski-adresar.rs";
function describeError(err) {
  const status = err && err.status;
  const code = err && err.code ? String(err.code) : "";
  const msg = String((err && err.message) || "");
  const ref = ` (kod greške: ${code || status || "mreža"})`;
  if (!status && /failed to fetch|networkerror|load failed|network/i.test(msg)) {
    return "Nema veze sa serverom. Proverite internet konekciju i pokušajte ponovo.";
  }
  if (status === 401 || /jwt expired|invalid jwt|jwt/i.test(msg)) {
    return "Vaša prijava je istekla. Odjavite se i ponovo prijavite, pa pošaljite još jednom. Uneti podaci ostaju na stranici." + ref;
  }
  if (status === 403 || code === "42501" || /row-level security|permission denied/i.test(msg)) {
    return `Server je odbio zahtev jer vaš nalog nema dozvolu za ovu radnju. Odjavite se i prijavite ponovo. Ako se ponovi, pišite nam na ${SUPPORT_EMAIL}.` + ref;
  }
  if (status === 409 || code === "23505") return "Ovo je već poslato i čeka pregled. Nije potrebno slati ponovo." + ref;
  if (status === 413 || code === "22001") return "Neki od unetih tekstova je predugačak. Skratite ga i pokušajte ponovo." + ref;
  if (code === "23502") return "Nedostaje obavezan podatak. Proverite da su sva obavezna polja popunjena." + ref;
  if (code === "23514" || code === "P0001") return `Neki podatak nije prihvaćen: ${msg}` + ref;
  if (status === 429) return "Previše pokušaja u kratkom vremenu. Sačekajte minut, pa pokušajte ponovo." + ref;
  if (status >= 500) return "Server trenutno ne odgovara. Pokušajte ponovo za nekoliko minuta." + ref;
  if (status === 400 || /^PGRST|^22|^42/.test(code)) {
    // tehnički opis iz baze (npr. "malformed array literal") pomaže da odmah vidimo koje polje ne valja
    const detail = msg && !/^HTTP \d+$/.test(msg) ? ` Detalj: ${msg.slice(0, 160)}.` : "";
    return `Server nije prihvatio podatke zbog tehničke greške na sajtu. Pišite nam na ${SUPPORT_EMAIL} i rešićemo to.${detail}` + ref;
  }
  return `Slanje nije uspelo. Pokušajte ponovo, a ako se ponovi, pišite nam na ${SUPPORT_EMAIL}.` + ref;
}

/* ==========================================
   SUPABASE AUTH HELPERS
========================================== */
async function supabaseRequest(method, path, body) {
  const res = await fetch(`${SUPABASE_URL}${path}`, {
    method,
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${SUPABASE_ANON}`,
      "Content-Type": "application/json",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) {
    // Supabase vraća greške u različitim poljima - uhvatimo sve
    const raw = data.error_description || data.msg || data.message || data.error_code || data.error || "";
    throw new Error(raw || `HTTP ${res.status}`);
  }
  return data;
}

// Auth API helpers
const authAPI = {
  signUp: async (email, password, firstName = "", lastName = "") => {
    const d = await supabaseRequest("POST", "/auth/v1/signup", {
      email, password,
      data: { first_name: firstName, last_name: lastName, full_name: `${firstName} ${lastName}`.trim(), vocative_name: serbianVocative(firstName) }
    });
    trackEvent("sign_up", { method: "email" });
    return d;
  },
  signIn: (email, password) =>
    supabaseRequest("POST", "/auth/v1/token?grant_type=password", { email, password }),
  signOut: (token) =>
    fetch(`${SUPABASE_URL}/auth/v1/logout`, {
      method: "POST",
      headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` },
    }),
  oauthURL: (provider) => {
    markAuthFlow();
    return `${SUPABASE_URL}/auth/v1/authorize?provider=${provider}&redirect_to=${encodeURIComponent(window.location.origin)}`;
  },
};

// Oznaka da je OVAJ browser započeo prijavu (OAuth, registracija, reset lozinke).
// Token iz URL hash-a bez ove oznake ne prihvatamo tiho - inače bi tuđ link
// sa napadačevim tokenom ulogovao posetioca u napadačev nalog.
const AUTH_FLOW_KEY = "ns_auth_flow";
const AUTH_FLOW_MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000; // mejl potvrde se često otvaraju kasnije
export function markAuthFlow() {
  try { localStorage.setItem(AUTH_FLOW_KEY, String(Date.now())); } catch {}
}
function consumeAuthFlow() {
  try {
    const t = Number(localStorage.getItem(AUTH_FLOW_KEY));
    localStorage.removeItem(AUTH_FLOW_KEY);
    return t > 0 && Date.now() - t < AUTH_FLOW_MAX_AGE_MS;
  } catch { return false; }
}

// Prevodi Supabase greške na srpski
function translateAuthError(msg, context) {
  const m = (msg || "").toLowerCase().trim();

  // Nema poruke ili generički HTTP status
  if (!m || m.startsWith("http ")) {
    return context === "login"
      ? "Prijava nije uspela. Proverite email i lozinku pa pokušajte ponovo."
      : "Registracija nije uspela. Pokušajte ponovo ili nas kontaktirajte.";
  }

  // ── Prijava greške ───────────────────────────────────────────────
  if (m.includes("invalid login credentials") || m.includes("invalid credentials") || m.includes("invalid grant"))
    return "Pogrešan email ili lozinka. Proverite podatke i pokušajte ponovo.";

  if (m.includes("email not confirmed"))
    return "Email adresa nije potvrđena. Proverite inbox i kliknite na link koji smo vam poslali.";

  if (m.includes("user not found") || m.includes("no user found"))
    return "Korisnik sa ovim email-om ne postoji. Registrujte se prvo.";

  if (m.includes("wrong password") || m.includes("invalid password"))
    return "Pogrešna lozinka. Pokušajte ponovo.";

  // ── Registracija greške ──────────────────────────────────────────
  if (m.includes("user already registered") || m.includes("already been registered") || m.includes("already exists") || m.includes("duplicate"))
    return "Ovaj email je već registrovan. Prijavite se ili resetujte lozinku.";

  if (m.includes("password should be at least") || m.includes("password is too short"))
    return "Lozinka mora imati najmanje 8 karaktera.";

  if (m.includes("character of each") || m.includes("should contain at least one"))
    return "Lozinka mora sadržati malo slovo, veliko slovo i broj.";

  if (m.includes("unable to validate email") || m.includes("invalid email") || m.includes("valid email") || m.includes("email address"))
    return "Email adresa nije u ispravnom formatu. Proverite i pokušajte ponovo.";

  // ── Opšte greške ────────────────────────────────────────────────
  if (m.includes("too many requests") || m.includes("rate limit") || m.includes("429"))
    return "Previše pokušaja. Sačekajte nekoliko minuta pa pokušajte ponovo.";

  if (m.includes("network") || m.includes("fetch") || m.includes("failed to fetch"))
    return "Problem sa internet konekcijom. Proverite mrežu i pokušajte ponovo.";

  if (m.includes("signup disabled") || m.includes("signups not allowed"))
    return "Registracija je trenutno onemogućena. Pokušajte kasnije.";

  // Fallback - originalna Supabase poruka bez duplog "Greška"
  return msg;
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
}

// Poznata muška srpska imena koja se završavaju na suglasnik - SAMO za ova
// imena računamo vokativ. Sva ostala (strana, izmišljena, nepoznata) ostaju
// nepromenjena, da ne bismo pogrešno "poravativili" ime koje uopšte nije
// srpsko (npr. "John", "Uttoph").
const SERBIAN_CONSONANT_NAMES = new Set([
  "aleksandar","boban","bogdan","bojan","boris","branislav","dalibor","damjan",
  "david","dejan","denis","dragan","dragoljub","dražen","drazen","dušan","dusan",
  "filip","goran","igor","ivan","jovan","konstantin","lazar","marijan",
  "miloš","milos","milan","miodrag","miroslav","nenad","nikodim","novak",
  "obrad","ognjen","panta","petar","predrag","radoslav","radovan","rodoljub",
  "slobodan","srđan","srdjan","stanislav","stevan","stefan","uroš","uros",
  "velimir","veroljub","vladan","vladimir","vlastimir","vojin","vojislav",
  "vuk","vukašin","vukasin","zoran","zvonimir","živorad","zivorad","živojin","zivojin",
]);

// Najbolji-pokušaj vokativ srpskog imena (za personalizaciju mejlova, npr.
// "Zdravo, Milane!"). Radi samo za imena iz gornje liste - sva ostala
// (uključujući ona na samoglasnik: Ana, Luka, Nemanja, Marko...) ostaju
// nepromenjena, jer je za njih pravilo nepouzdano i pogrešan oblik izgleda
// gore od neizmenjenog imena.
function serbianVocative(name) {
  if (!name || typeof name !== "string") return name;
  const trimmed = name.trim();
  if (!trimmed) return trimmed;
  const lower = trimmed.toLowerCase();

  if (!SERBIAN_CONSONANT_NAMES.has(lower)) return trimmed; // nepoznato ime - ne diramo

  const EXCEPTIONS = { petar: "Petre", aleksandar: "Aleksandre" }; // nepostojano "a"
  if (EXCEPTIONS[lower]) return EXCEPTIONS[lower];

  const last = trimmed.slice(-1).toLowerCase();
  if (last === "k") return trimmed.slice(0, -1) + "če";
  if (last === "g") return trimmed.slice(0, -1) + "že";
  if (last === "h") return trimmed.slice(0, -1) + "še";

  return trimmed + "e";
}
async function dbRequest(method, path, body, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, {
    method,
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": method === "POST" ? "return=representation" : "return=minimal",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (method === "PATCH" || (method === "DELETE" && res.status === 204)) return null;
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.error || "DB greška");
  return data;
}

async function getProfile(userId, token) {
  const data = await dbRequest("GET", `/profiles?id=eq.${userId}&select=*`, null, token);
  return Array.isArray(data) ? data[0] : null;
}
// onlyIfMissing: upiši samo ako profil ne postoji (Google prijava ne sme da pregazi
// ime koje je korisnik već imao, npr. pri prijavi lozinkom na isti mejl)
async function insertProfile(userId, firstName, lastName, token, { onlyIfMissing = false } = {}) {
  // Pokušaj INSERT sa korisnikovim tokenom (zahteva RLS: auth.uid() = id)
  // Ako token nije dostupan (email potvrda), koristimo anon key
  const authToken = token || SUPABASE_ANON;

  const res = await fetch(`${SUPABASE_URL}/rest/v1/profiles`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${authToken}`,
      "Content-Type": "application/json",
      "Prefer": `resolution=${onlyIfMissing ? "ignore" : "merge"}-duplicates,return=minimal`,
    },
    body: JSON.stringify({ id: userId, first_name: firstName, last_name: lastName }),
  });

  if (!res.ok) {
    let errMsg = `HTTP ${res.status}`;
    try { const d = await res.json(); errMsg = d.message || d.hint || d.details || d.error || errMsg; } catch {}
    console.error("insertProfile GREŠKA:", errMsg);
    // Bacamo grešku da je caller vidi - ne gušimo je više tiho
    throw new Error(errMsg);
  }
  return true;
}

// Generalni upsert za profil - prima ceo objekat (id, first_name, last_name, interesovanja...)
async function upsertProfile(profile, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/profiles`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": "resolution=merge-duplicates,return=minimal",
    },
    body: JSON.stringify(profile),
  });
  if (!res.ok) {
    let errMsg = `HTTP ${res.status}`;
    try { const d = await res.json(); errMsg = d.message || d.hint || d.details || d.error || errMsg; } catch {}
    console.warn("upsertProfile greška:", errMsg);
  }
  return null;
}
async function getFavorites(userId, token) {
  return dbRequest("GET", `/favorites?user_id=eq.${userId}&select=*&order=id.desc`, null, token);
}
// Sačuvani blogovi (tabela blog_favorites: user_id + slug). Ako tabela još ne postoji,
// greška se tiho preskače i čuvanje blogova jednostavno nije dostupno.
const blogFavHeaders = (token) => ({ "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token || SUPABASE_ANON}`, "Content-Type": "application/json" });
async function getBlogFavorites(userId, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/blog_favorites?user_id=eq.${userId}&select=slug,created_at&order=created_at.desc`, { headers: blogFavHeaders(token) });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
async function addBlogFavorite(userId, slug, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/blog_favorites`, { method: "POST", headers: blogFavHeaders(token), body: JSON.stringify({ user_id: userId, slug }) });
  if (!res.ok && res.status !== 409) throw new Error(`HTTP ${res.status}`);
}
async function removeBlogFavorite(userId, slug, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/blog_favorites?user_id=eq.${userId}&slug=eq.${encodeURIComponent(slug)}`, { method: "DELETE", headers: blogFavHeaders(token) });
  if (!res.ok && res.status !== 204) throw new Error(`HTTP ${res.status}`);
}
async function addFavorite(userId, biznisId, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/favorites`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": "return=representation",
    },
    body: JSON.stringify({ user_id: userId, biznis_id: biznisId }),
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(d.message || d.error || `HTTP ${res.status}`);
  }
  return res.json();
}
async function removeFavorite(userId, biznisId, token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/favorites?user_id=eq.${userId}&biznis_id=eq.${biznisId}`,
    {
      method: "DELETE",
      headers: {
        "apikey": SUPABASE_ANON,
        "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      },
    }
  );
  if (!res.ok && res.status !== 204) {
    throw new Error(`HTTP ${res.status}`);
  }
  return true;
}
// Recenzije prijavljenog korisnika po vlasniku (user_id, vidi sql-izmene/09),
// ne po imenu - ime može imati više ljudi i može se promeniti u profilu.
async function getUserReviews(userId, token) {
  if (!userId) return [];
  const tableName = encodeURIComponent("Recenzije Novi Sad");

  // Order by id desc - tabela nema created_at
  // izvor=neq.reply - ne prikazuj odgovore na recenzije u profilu
  const url = `${SUPABASE_URL}/rest/v1/${tableName}?user_id=eq.${encodeURIComponent(userId)}&izvor=neq.reply&or=(obrisano.is.null,obrisano.eq.false)&select=*&order=id.desc`;

  try {
    const res = await fetch(url, {
      headers: {
        "apikey": SUPABASE_ANON,
        "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      },
    });
    if (!res.ok) return [];
    const data = await res.json().catch(() => []);
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

// Briše jednu recenziju po id-u; baza (RLS) dozvoljava samo vlasniku (user_id).
async function deleteReview({ id, token }) {
  if (!id || !token) throw new Error("Niste prijavljeni");
  const tableName = encodeURIComponent("Recenzije Novi Sad");
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${tableName}?id=eq.${encodeURIComponent(id)}`, {
    method: "DELETE",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token}`,
      "Prefer": "return=representation",
    },
  });
  if (res.ok) {
    // RLS tiho ne briše tuđu recenziju (0 redova) - prijavi to kao grešku
    const rows = await res.json().catch(() => []);
    if (Array.isArray(rows) && rows.length === 0) throw new Error("Recenzija nije pronađena ili nije vaša");
  }
  if (!res.ok) {
    let errMsg = `HTTP ${res.status}`;
    try { const d = await res.json(); errMsg = d.message || d.hint || d.error || errMsg; } catch {}
    throw new Error(errMsg);
  }
  return true;
}

// Upisuje reply na recenziju
async function insertReply({ recenzija_id, autor, tekst, token }) {
  const tableName = encodeURIComponent("Recenzije Novi Sad");
  const now = new Date().toISOString();
  const row = {
    biznis_ime: "",       // nije relevantan za reply
    autor,
    ocena: "0",
    tekst,
    vreme: now,
    datum: now,
    izvor: "reply",
    reply_to_id: recenzija_id,
  };
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${tableName}`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": "return=minimal",
    },
    body: JSON.stringify(row),
  });
  if (!res.ok) throw await apiError(res);
  return true;
}

// Šalje mejl na info@ preko Edge funkcije "notify-admin" - nikad ne baca
// grešku (fire-and-forget), da eventualni pad slanja mejla ne blokira
// samo upisivanje forme u bazu.
// Funkcija mejl pravi iz reda u bazi; za zahtev za biznis traži prijavu (token korisnika)
function notifyAdmin(type, data, token) {
  fetch(`${SUPABASE_URL}/functions/v1/notify-admin`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ type, data }),
  }).catch(() => {});
}

// Šalje korisniku mejl (dobrodošlica, nalog obrisan...) preko Edge funkcije
// "send-email". Fire-and-forget - greška se samo loguje, nikad ne blokira UI.
function notifyUserEmail(type, { email, firstName, token }) {
  fetch(`${SUPABASE_URL}/functions/v1/send-email`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ type, email, firstName, vocativeName: serbianVocative(firstName || "") }),
  }).catch(e => console.warn("Email notifikacija nije poslata:", e.message));
}

// Upisuje kontakt poruku u tabelu "Kontakt"
async function insertKontakt({ ime, email, poruka }) {
  const tableName = encodeURIComponent("Kontakt");
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${tableName}`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": "return=minimal",
    },
    body: JSON.stringify({
      ime: ime || "",
      email,
      poruka,
      datum: new Date().toISOString(),
      procitano: false,
    }),
  });
  if (!res.ok) throw await apiError(res);
  notifyAdmin("kontakt", { ime: ime || "", email, poruka });
  return true;
}

// Upisuje novu recenziju u tabelu "Recenzije Novi Sad"
async function insertReview({ biznis_ime, autor, ocena, tekst, token }) {
  const tableName = encodeURIComponent("Recenzije Novi Sad");

  const now = new Date().toISOString();
  const row = {
    biznis_ime,
    autor,
    ocena: String(ocena),
    tekst,
    vreme: now, // ISO timestamp
    datum: now, // posebna kolona za tačan timeAgo
    izvor: "sajt",
  };

  const res = await fetch(`${SUPABASE_URL}/rest/v1/${tableName}`, {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token || SUPABASE_ANON}`,
      "Content-Type": "application/json",
      "Prefer": "return=representation",
    },
    body: JSON.stringify(row),
  });

  if (!res.ok) throw await apiError(res);

  const data = await res.json();
  trackEvent("review_posted", { biznis: biznis_ime, ocena: Number(ocena) });
  // Vrati normalizovani red da ga dodamo u lokalni state
  return normalizeReview(Array.isArray(data) ? data[0] : data);
}

// Čisti sve ostale tokene iz storage-a (korisno pri testiranju)
function clearAllAuthStorage() {
  try { sessionStorage.removeItem("ns_session"); } catch {}
  try { localStorage.removeItem("ns_session"); } catch {}
  try { sessionStorage.removeItem("ns_profile"); } catch {}
  try { localStorage.removeItem("ns_profile"); } catch {}
  try { sessionStorage.removeItem("ns_biz_v1"); } catch {}
}

// Auth state hook - localStorage (zapamti me) ili sessionStorage (tab-only)
function useAuth() {
  const stored = (() => {
    try {
      const ls = localStorage.getItem("ns_session");
      const ss = sessionStorage.getItem("ns_session");
      const raw = ls || ss;
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      // Istekla prijava se ne briše ako postoji refresh token: obnavlja se odmah (efekat ispod)
      if (parsed?.expires_at && Date.now() / 1000 > parsed.expires_at && !parsed.refresh_token) {
        clearAllAuthStorage();
        return null;
      }
      return parsed;
    } catch { return null; }
  })();

  const [session, setSessionState] = React.useState(stored);
  const isRemembered = !!localStorage.getItem("ns_session");

  const setSession = (s, remember = false) => {
    try {
      clearAllAuthStorage();
      if (s) {
        if (remember) localStorage.setItem("ns_session", JSON.stringify(s));
        else sessionStorage.setItem("ns_session", JSON.stringify(s));
      }
    } catch {}
    setSessionState(s);
  };

  const [recoveryMode, setRecoveryMode] = React.useState(false);

  // Obradi OAuth redirect (Google/Apple login) - Supabase posle uspešnog
  // logina vraća access_token u URL hash-u; bez ovoga se taj token nikad
  // ne čita i korisnik ostaje neulogovan uprkos uspešnom Google logovanju.
  React.useEffect(() => {
    if (!window.location.hash.includes("access_token=")) return;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const access_token = params.get("access_token");
    const refresh_token = params.get("refresh_token");
    const redirectType = params.get("type");
    if (!access_token) return;
    (async () => {
      try {
        const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
          headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${access_token}` },
        });
        if (res.ok) {
          const user = await res.json();
          // Ako prijavu nije započeo ovaj browser (npr. link dobijen od nekog),
          // korisnik mora da potvrdi nalog - ovako odmah vidi da nije njegov.
          const sameUser = session?.user?.id && session.user.id === user?.id;
          const startedHere = consumeAuthFlow();
          if (!sameUser && !startedHere &&
              !window.confirm(`Prijaviti se kao ${user?.email || "ovaj nalog"}?`)) {
            return;
          }
          setSession({
            access_token,
            refresh_token,
            expires_in: Number(params.get("expires_in")) || undefined,
            expires_at: Number(params.get("expires_at")) || undefined,
            token_type: params.get("token_type") || "bearer",
            user,
          }, true);
          // Link "Zaboravili ste lozinku": odmah otvori prozor za novu lozinku
          if (redirectType === "recovery") setRecoveryMode(true);
          // Welcome mejl šaljemo tek kad korisnik STVARNO potvrdi nalog
          // (klikne link iz mejla), ne odmah pri registraciji - tada je
          // ionako netom stigao "Potvrdite email" mejl, pa bi oba odjednom
          // bila zbunjujuća.
          // + prijava preko Google preusmerenja (bez type): funkcija šalje samo novom nalogu, jednom
          if (redirectType === "signup" || !redirectType) {
            notifyUserEmail("welcome", {
              email: user?.email,
              firstName: user?.user_metadata?.first_name || "",
              token: access_token,
            });
          }
        }
      } catch {}
      finally {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      }
    })();
  }, []); // eslint-disable-line

  // Učitaj profil (ime/prezime) ODMAH kad korisnik postane poznat - ne
  // čekamo da korisnik ručno ode na "Moj profil". Ranije se profil keširao
  // u ns_profile SAMO kad se poseti profil stranica, pa je npr. avatar sa
  // inicijalima pokazivao samo prvo slovo email-a (rezervnu opciju) sve dok
  // korisnik ne bi otvorio svoj profil bar jednom u toj sesiji.
  const userId = session?.user?.id;

  // Ime/prezime iz auth naloga (Supabase Auth "user_metadata") - ovo se
  // upisuje POUZDANO pri registraciji, nezavisno od odvojenog upisa u
  // "profiles" tabelu (koji ume tiho da ne uspe, npr. zbog RLS pravila).
  // Koristi se kao rezerva kad "profiles" red ne postoji ili je prazan.
  const metaProfile = React.useMemo(() => {
    const meta = session?.user?.user_metadata;
    if (!meta) return null;
    const full = meta.full_name || meta.name || "";
    const first = meta.first_name || full.split(" ")[0] || "";
    const last  = meta.last_name  || full.split(" ").slice(1).join(" ") || "";
    if (!first && !last) return null;
    return { first_name: first, last_name: last };
  }, [session?.user?.id]); // eslint-disable-line

  const [profile, setProfile] = React.useState(() => {
    try {
      const raw = sessionStorage.getItem("ns_profile") || localStorage.getItem("ns_profile");
      if (raw) return JSON.parse(raw);
    } catch {}
    return metaProfile;
  });
  React.useEffect(() => {
    if (!userId || !session?.access_token) { setProfile(null); return; }
    let cancelled = false;
    getProfile(userId, session.access_token).then(p => {
      if (cancelled) return;
      // Ako "profiles" red ne postoji ili nema ime/prezime, koristi rezervu.
      const finalProfile = (p && (p.first_name || p.last_name)) ? p : metaProfile;
      if (!finalProfile) return;
      setProfile(finalProfile);
      try {
        const str = JSON.stringify(finalProfile);
        sessionStorage.setItem("ns_profile", str);
        if (isRemembered) localStorage.setItem("ns_profile", str);
      } catch {}
    }).catch(() => {
      if (!cancelled && metaProfile) setProfile(metaProfile);
    });
    return () => { cancelled = true; };
  }, [userId]); // eslint-disable-line

  // Obnova prijave (access token traje sat vremena). Ranije se obnova nije pokretala
  // ako je do isteka ostalo manje od 5 minuta ili je računar bio uspavan, pa je
  // prijava tiho isticala i slanje forme (npr. zahtev za biznis) padalo.
  const sessionRef = React.useRef(session);
  sessionRef.current = session;
  const refreshingRef = React.useRef(null);
  const refreshNow = () => {
    const s = sessionRef.current;
    if (!s?.refresh_token) return Promise.resolve(s?.access_token || null);
    if (refreshingRef.current) return refreshingRef.current;
    refreshingRef.current = (async () => {
      try {
        const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
          method: "POST",
          headers: { "apikey": SUPABASE_ANON, "Content-Type": "application/json" },
          body: JSON.stringify({ refresh_token: s.refresh_token }),
        });
        if (res.ok) {
          const data = await res.json();
          if (data.access_token) { setSession(data, isRemembered); sessionRef.current = data; return data.access_token; }
        } else if (res.status === 400 || res.status === 401) {
          // refresh token više ne važi (npr. odjava na drugom uređaju): korisnik se odjavljuje
          setSession(null);
          return null;
        }
      } catch {}
      return sessionRef.current?.access_token || null; // mreža nedostupna: zadrži postojeću prijavu
    })().finally(() => { refreshingRef.current = null; });
    return refreshingRef.current;
  };
  // Važeći token pre slanja: obnavlja ga ako ističe za manje od 2 minuta
  const getFreshToken = async () => {
    const s = sessionRef.current;
    if (!s?.access_token) return null;
    if (s.expires_at && s.expires_at * 1000 - Date.now() < 2 * 60 * 1000) return refreshNow();
    return s.access_token;
  };
  React.useEffect(() => {
    if (!session?.refresh_token || !session.expires_at) return;
    const msUntilRefresh = Math.max(0, (session.expires_at * 1000) - Date.now() - 5 * 60 * 1000);
    const timer = setTimeout(() => { refreshNow(); }, msUntilRefresh);
    return () => clearTimeout(timer);
  }, [session]); // eslint-disable-line
  // Povratak na tab ili buđenje računara: tajmer je možda zakasnio
  React.useEffect(() => {
    const onVisible = () => { if (document.visibilityState === "visible") getFreshToken(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => { document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("focus", onVisible); };
  }, []); // eslint-disable-line

  return { session, setSession, user: session?.user || null, token: session?.access_token || null, profile, getFreshToken, recoveryMode, setRecoveryMode };
}

// Shared auth context
const AuthContext = React.createContext({ session: null, setSession: () => {}, user: null, token: null, profile: null, getFreshToken: async () => null, recoveryMode: false, setRecoveryMode: () => {} });
function useAuthContext() { return React.useContext(AuthContext); }

// ── Favorites global context ─────────────────────────────────────
const FavoritesContext = React.createContext({
  favIds: [],        // array of biznis_id numbers
  favRows: [],       // raw rows from favorites table
  toggle: () => {},
  isFav: () => false,
  showAuthModal: false,
  setShowAuthModal: () => {},
  blogSlugs: [],     // sačuvani blogovi (slug), najnoviji prvi
  isBlogFav: () => false,
  toggleBlog: () => {},
});
function useFavorites() { return React.useContext(FavoritesContext); }

/* helpers: prevod dana i AM/PM -> 24h */
const DAY_TRANSLATIONS = {
  "monday":"Ponedeljak","tuesday":"Utorak","wednesday":"Sreda",
  "thursday":"Četvrtak","friday":"Petak","saturday":"Subota","sunday":"Nedelja",
  "mon":"Ponedeljak","tue":"Utorak","wed":"Sreda",
  "thu":"Četvrtak","fri":"Petak","sat":"Subota","sun":"Nedelja",
  // Srpski mali → veliki
  "ponedeljak":"Ponedeljak","utorak":"Utorak","sreda":"Sreda",
  "četvrtak":"Četvrtak","cetvrtak":"Četvrtak","petak":"Petak",
  "subota":"Subota","nedelja":"Nedelja",
};

function translateDay(day) {
  if (!day) return "";
  const lo = day.toLowerCase().trim();
  if (DAY_TRANSLATIONS[lo]) return DAY_TRANSLATIONS[lo];
  // Replace svaki engleski dan unutar stringa
  let res = day;
  const pairs = Object.entries(DAY_TRANSLATIONS).sort((a,b)=>b[0].length-a[0].length);
  for (const [en,sr] of pairs) {
    res = res.replace(new RegExp("\\b"+en+"\\b","gi"), sr);
  }
  return res;
}

function to24h(t) {
  if (!t) return "";
  const s = String(t).trim();
  if (!/am|pm/i.test(s)) return s;
  const m = s.match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
  if (!m) return s;
  let h = parseInt(m[1],10);
  const min = m[2]||"00", p = m[3].toUpperCase();
  if (p==="AM"){ if(h===12)h=0; } else { if(h!==12)h+=12; }
  return String(h).padStart(2,"0")+":"+min;
}

function convertTimeRange(r) {
  if (!r) return "";
  const s = String(r);
  const m = s.match(/(\u2013|\u2014|[-]|\bto\b|\bdo\b)/i);
  if (m) {
    const i = s.search(/(\u2013|\u2014|[-]|\bto\b|\bdo\b)/i);
    const sep = m[0];
    return to24h(s.slice(0,i).trim())+" - "+to24h(s.slice(i+sep.length).trim());
  }
  return to24h(s);
}

// ── SEARCH NORMALIZACIJA ─────────────────────────────────────────────────────
const CYR_TO_LAT = {
  'а':'a','б':'b','в':'v','г':'g','д':'d','ђ':'dj','е':'e','ж':'z','з':'z',
  'и':'i','ј':'j','к':'k','л':'l','љ':'lj','м':'m','н':'n','њ':'nj','о':'o',
  'п':'p','р':'r','с':'s','т':'t','ћ':'c','у':'u','ф':'f','х':'h','ц':'c',
  'ч':'c','џ':'dz','ш':'s',
  'А':'a','Б':'b','В':'v','Г':'g','Д':'d','Ђ':'dj','Е':'e','Ж':'z','З':'z',
  'И':'i','Ј':'j','К':'k','Л':'l','Љ':'lj','М':'m','Н':'n','Њ':'nj','О':'o',
  'П':'p','Р':'r','С':'s','Т':'t','Ћ':'c','У':'u','Ф':'f','Х':'h','Ц':'c',
  'Ч':'c','Џ':'dz','Ш':'s',
};
const DIA_TO_LAT = {
  'č':'c','ć':'c','š':'s','ž':'z','đ':'dj',
  'Č':'c','Ć':'c','Š':'s','Ž':'z','Đ':'dj',
};
function normalizeSearch(str) {
  if (!str) return '';
  return str.split('').map(ch => CYR_TO_LAT[ch] || DIA_TO_LAT[ch] || ch).join('').toLowerCase().trim();
}
function searchMatch(text, query) {
  if (!query) return true;
  const norm = normalizeSearch(text);
  const words = normalizeSearch(query).split(/\s+/).filter(Boolean);
  return words.every(w => norm.includes(w));
}
// ─────────────────────────────────────────────────────────────────────────────

function normalizeHourEntry(e) {
  if (!e||typeof e!=="object") return {day:"",time:""};
  return { day: translateDay(e.day||""), time: convertTimeRange(e.time||"") };
}


/* Mapira jedan red iz Supabase u internu strukturu sajta.
   Kolone u bazi: id, ime, kategorija, potkategorija, deo_grada,
   adresa, telefon, email, sajt, opis, radno_vreme (JSON/text),
   ocena, broj_recenzija, specifikacije (array/text), slike (array/text),
   lat, lng, is_popular, created_at
   - sve nepoznate kolone gracefully fallback-uju na "". */
function mapRow(row) {
  // Parsira specifikacije: ako je JSON string niz, parsira; ako je string razdvojen zarezom → split
  const parseTags = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    try { const p = JSON.parse(val); if (Array.isArray(p)) return p; } catch {}
    return String(val).split(",").map(s => s.trim()).filter(Boolean);
  };

  // Parsira slike - handleuje sve formate: URL string, JSON array, JSON objekat
  const parseImages = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(u => typeof u === "string" ? { url: u, label: "" } : (u?.url ? u : { url: String(u), label: "" }));
    try {
      const p = JSON.parse(val);
      if (Array.isArray(p)) return p.map(u => typeof u === "string" ? { url: u, label: "" } : (u?.url ? u : { url: String(u), label: "" }));
      if (p && typeof p === "object" && p.url) return [p];
    } catch {}
    // Plain string - direktan URL
    const s = String(val).trim();
    if (s.startsWith("http") || s.startsWith("/")) return [{ url: s, label: "" }];
    // Vise URL-ova razdvojenih zarezom ili newline
    if (s.includes(",") || s.includes("\n")) {
      return s.split(/[,\n]/).map(u => u.trim()).filter(u => u.length > 5).map(u => ({ url: u, label: "" }));
    }
    return [];
  };

  // parseHours: handluje sve formate radno_vreme iz Supabase
  //   - JSON array: [{day:"Pon",time:"08-22"}, ...]
  //   - JSON object: {"Ponedeljak - Petak": "08:00 - 22:00", ...}
  //   - string sa tacka-zarezom: "Pon-Pet: 08-22; Sub: 09-18"
  //   - plain string: "08:00 - 22:00"
  const parseHours = (val) => {
    if (!val) return [];
    const toEntry = (v) => {
      if (typeof v === "object" && v !== null)
        return { day: v.day || v.Dan || v.dan || v.Days || "", time: v.time || v.Time || v.vreme || v.Vreme || v.Hours || "" };
      // String format: "Ponedeljak: 09:00 – 00:00"
      const s = String(v).trim();
      const dayMatch = s.match(/^([A-Za-zČčŠšŽžĆćĐđÀ-ɏ\s]+?)\s*:\s*(.+)$/);
      if (dayMatch) return { day: dayMatch[1].trim(), time: dayMatch[2].trim() };
      return { day: "", time: s };
    };
    if (Array.isArray(val)) return val.map(toEntry);
    try {
      const p = JSON.parse(val);
      if (Array.isArray(p)) return p.map(toEntry);
      if (p && typeof p === "object") return Object.entries(p).map(([d, t]) => ({ day: String(d), time: String(t) }));
    } catch {}
    const s = String(val).trim();

    // Pomocna f-ja: split stringa po separatoru ali ne unutar AM/PM
    const splitEntries = (str, sep) =>
      str.split(sep).map(p => p.trim()).filter(Boolean);

    // Pokusaj split po ";" ili ","
    const separators = [";", ","];
    for (const sep of separators) {
      if (s.includes(sep)) {
        const parts = splitEntries(s, sep);
        // Svaki deo treba da ima format "Dan: vreme" ili samo "vreme"
        const parsed = parts.map(part => {
          // Trazi "Ime_dana:" - reci pre prve ":" koja je pre cifara
          const dayMatch = part.match(/^([A-Za-zÀ-ɏ\s\-]+?):\s*(.+)$/);
          if (dayMatch) return { day: dayMatch[1].trim(), time: dayMatch[2].trim() };
          return { day: "", time: part.trim() };
        }).filter(h => h.time);
        if (parsed.length > 0) return parsed;
      }
    }

    // Jedan unos: "Monday: 8:00 AM - 11:00 PM" (bez separatora)
    const singleMatch = s.match(/^([A-Za-zÀ-ɏ\s\-]+?):\s*(.+)$/);
    if (singleMatch) {
      return [{ day: singleMatch[1].trim(), time: singleMatch[2].trim() }];
    }

    // Fallback: ceo string kao vreme
    return [{ day: "", time: s }];
  };

  const deo   = row.deo_grada || "";
  // DEBUG: stampa sve kolone iz prvog reda baze u konzoli (ukloni posle resavanja)
  const potkat = (row["pod_kategorija"] || row.pod_kategorija || row.potkategorija || row.podkategorija || row.sub_kategorija || row.subcategory || row.tip || "").trim();
  // Kreira "sub" u formatu koji kod očekuje: "Potkategorija . DeoGrada"
  const sub = [potkat, deo].filter(Boolean).join(" . ");

  return {
    id:          row.id,
    name:        row.ime         || row.name        || "",
    category:    row.kategorija  || row.category    || "",
    categories:  (() => {
      // kategorije_sve - array svih kategorija (npr. ["Restorani", "Noćni život"])
      if (Array.isArray(row.kategorije_sve)) return row.kategorije_sve;
      try { const p = JSON.parse(row.kategorije_sve); if (Array.isArray(p)) return p; } catch {}
      // Fallback - samo primarna kategorija
      return [row.kategorija || row.category || ""].filter(Boolean);
    })(),
    sub,
    deoGrada:    deo,
    potkategorija: potkat,
    subcategory: potkat,
    address:     row.adresa      || row.address     || (deo ? `${deo}, Novi Sad` : "Novi Sad"),
    phone:       row.telefon     || row.phone       || "",
    email:       row.email       || "",
    website:     row.sajt        || row.website     || "",
    about:       row.opis        || row.about       || "",
    rating:      parseFloat(row.ocena  || row.rating)  || 0,
    reviewCount: parseInt(row.broj_recenzija || row.reviews) || 0,
    reviews:     parseInt(row.broj_recenzija || row.reviews) || 0,
    tags:        parseTags(row.specifikacije || row.tags),
    images:      parseImages(row.slike || row.images || row.slika || row.foto || row.fotografije || row.photos || row.image_url),
    hours:       parseHours(row.radno_vreme || row.hours),
    priceRange:  row.cenovni_rang || row.priceRange || "",
    lat:         parseFloat(row.lat) || null,
    lng:         parseFloat(row.lng) || null,
    isPopular:   row.is_popular  || false,
    // Plan biznisa; dok kolona ne postoji u bazi ili je prazna, računa se "free"
    plan:        row.plan        || "free",
    // Društvene mreže i kratak opis sa sajta lokala (osveženo sa Google-a i sajtova, okt. 2026)
    instagram:   row.instagram   || "",
    facebook:    row.facebook    || "",
    tiktok:      row.tiktok      || "",
    opisSajta:   row.opis_sajta  || "",
    // Zatvoren zauvek: ne prikazuje se nigde na sajtu. Privremeno: prikazuje se sa oznakom.
    closed:      row.zatvoren === true,
    // Google vrste lokala (npr. ["night_club","restaurant"]); odatle i dodatne kategorije
    googleTypes: Array.isArray(row.google_tipovi) ? row.google_tipovi : [],
    tempClosed:  row.privremeno_zatvoren === true,
  };
}

// Lokal koji je zatvoren zauvek se ne prikazuje u listama, pretrazi ni na početnoj
const isListedBiz = (b) => !b.closed;

// ── Lokal u više kategorija ───────────────────────────────────────────────
// Svaki biznis ima jednu glavnu kategoriju u bazi, ali je npr. Giardino po
// Google-u i kafić i restoran i noćni klub. Prema Google vrstama lokala
// (kolona google_tipovi) prikazuje se i u tim kategorijama, sa odgovarajućom
// potkategorijom (ako se iz vrste može pouzdano odrediti).
const EXTRA_CAT_TYPES = {
  "Restorani":   ["restaurant", "italian_restaurant", "pizza_restaurant", "seafood_restaurant", "sushi_restaurant", "chinese_restaurant", "japanese_restaurant", "thai_restaurant", "asian_restaurant", "indian_restaurant", "fast_food_restaurant", "hamburger_restaurant", "steak_house", "barbecue_restaurant", "vegan_restaurant", "vegetarian_restaurant", "european_restaurant", "mediterranean_restaurant", "greek_restaurant", "mexican_restaurant", "bistro", "gastropub"],
  "Kafići":      ["cafe", "coffee_shop", "tea_house", "dessert_shop", "confectionery", "cafeteria", "ice_cream_shop", "juice_shop"],
  "Noćni život": ["night_club", "cocktail_bar", "wine_bar", "pub", "brewpub", "lounge_bar", "karaoke", "beer_garden", "irish_pub", "sports_bar", "hookah_bar", "gastropub"],
  "Hoteli":      ["hotel", "hostel", "motel", "guest_house", "bed_and_breakfast", "resort_hotel", "farmstay", "extended_stay_hotel"],
};
const EXTRA_SUB_BY_TYPE = {
  "Restorani":   [["italian_restaurant", "Italijanska hrana"], ["pizza_restaurant", "Italijanska hrana"], ["seafood_restaurant", "Morska hrana"], ["sushi_restaurant", "Azijski ukusi"], ["chinese_restaurant", "Azijski ukusi"], ["japanese_restaurant", "Azijski ukusi"], ["thai_restaurant", "Azijski ukusi"], ["asian_restaurant", "Azijski ukusi"], ["indian_restaurant", "Azijski ukusi"], ["fast_food_restaurant", "Brza hrana"], ["hamburger_restaurant", "Brza hrana"], ["steak_house", "Roštilj i meso"], ["barbecue_restaurant", "Roštilj i meso"], ["vegan_restaurant", "Veganski restorani"], ["vegetarian_restaurant", "Veganski restorani"]],
  "Kafići":      [["dessert_shop", "Poslastičarnice"], ["confectionery", "Poslastičarnice"], ["ice_cream_shop", "Poslastičarnice"], ["breakfast_restaurant", "Brunch kafići"], ["brunch_restaurant", "Brunch kafići"], ["coffee_shop", "Klasični kafići"], ["cafe", "Klasični kafići"]],
  "Noćni život": [["night_club", "Klubovi & Splavovi"], ["cocktail_bar", "Koktel & Vinski barovi"], ["wine_bar", "Koktel & Vinski barovi"], ["lounge_bar", "Koktel & Vinski barovi"], ["pub", "Pub-ovi & Pivnice"], ["brewpub", "Pub-ovi & Pivnice"], ["gastropub", "Pub-ovi & Pivnice"], ["beer_garden", "Pub-ovi & Pivnice"], ["irish_pub", "Pub-ovi & Pivnice"]],
  "Hoteli":      [["farmstay", "Salaši & Etno smeštaj"], ["resort_hotel", "Wellness & Spa hoteli"], ["hostel", "Hosteli & Sobe"], ["guest_house", "Hosteli & Sobe"], ["bed_and_breakfast", "Hosteli & Sobe"], ["hotel", "Hoteli & Apartmani"], ["motel", "Hoteli & Apartmani"]],
};
// Da li se biznis (čija glavna kategorija nije ova) prikazuje i u ovoj kategoriji
function isExtraIn(b, category) {
  const types = EXTRA_CAT_TYPES[category];
  if (!types || !b || !Array.isArray(b.googleTypes) || !b.googleTypes.length) return false;
  const dbKat = CATEGORY_DB_NAME_MAP[category] || category;
  if (b.category === category || b.category === dbKat) return false;
  return b.googleTypes.some((t) => types.includes(t));
}
// Sve kategorije u kojima se lokal prikazuje, nazivima sa sajta (glavna prva),
// npr. ["Kafići", "Restorani", "Noćni život"]. Koristi se u pretrazi.
const CAT_SITE_LABEL = { Teretane: "Sport", Usluge: "Nega" };
function allCategoriesOf(b) {
  const main = CAT_SITE_LABEL[b.category] || b.category || "";
  const extra = Object.keys(EXTRA_CAT_TYPES).filter((c) => c !== main && isExtraIn(b, c));
  return [main, ...extra].filter(Boolean);
}

// Kopija biznisa za listu ove kategorije: potkategorija prema Google vrsti.
// _primary čuva pravi zapis, pa se stranica biznisa uvek otvara sa glavnom kategorijom.
// Kad Google vrsta ne određuje podkategoriju, koristi se samo ono što je sigurno
// iz glavne podkategorije (salaši i kafane su domaća kuhinja); ostali ostaju bez nje.
const EXTRA_SUB_BY_PRIMARY = {
  "Restorani": { "Salaši & Etno smeštaj": "Domaći restorani", "Kafane & Tamburaši": "Domaći restorani" },
};
function asExtraIn(b, category) {
  const hit = (EXTRA_SUB_BY_TYPE[category] || []).find(([t]) => b.googleTypes.includes(t));
  const primarySub = b.potkategorija || b.subcategory || "";
  const sub = hit ? hit[1] : ((EXTRA_SUB_BY_PRIMARY[category] || {})[primarySub] || "");
  return { ...b, _primary: b._primary || b, potkategorija: sub, subcategory: sub, sub: [sub, b.deoGrada].filter(Boolean).join(" . ") };
}

/* ==========================================
   SUPABASE HOOKS - LAZY LOADING
   useSupabase() - učitava SVE, poziva se samo kad zaista treba (search, mapa, admin)
   useSupabaseCategory(cat) - učitava samo jednu kategoriju, za CategoryPage
   useSupabasePopular() - učitava samo isPopular=true biznise, za hero/home
========================================== */

// Globalni in-memory keš - traje dok je tab otvoren
let _globalBiznisiCache = null;
let _globalBiznisiLoading = false;
let _globalBiznisiCallbacks = [];

// Per-category cache
const _catCache = {};
const _catLoading = {};

// Spisak u sessionStorage važi 30 min: ranije je važio dok je tab otvoren (i posle
// osvežavanja), pa se nov odobren biznis nije video u pretrazi do novog taba.
const BIZ_CACHE_KEY = "ns_biz_v3";
const BIZ_CACHE_MAX_AGE_MS = 30 * 60 * 1000;
// Posle odobravanja biznisa: sledeće učitavanje ide ponovo u bazu
function clearBiznisiCache() {
  _globalBiznisiCache = null;
  Object.keys(_catCache).forEach((k) => { delete _catCache[k]; });
  try { sessionStorage.removeItem(BIZ_CACHE_KEY); sessionStorage.removeItem("ns_biz_v2"); } catch {}
  // već otvorena pretraga (navbar, "Oceni lokal") odmah učitava nov spisak, bez osvežavanja
  try { window.dispatchEvent(new Event("ns-biz-refresh")); } catch {}
}

async function fetchFromSupabase(url) {
  const res = await fetch(url, {
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${SUPABASE_ANON}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) throw new Error(`Supabase greška: ${res.status}`);
  return res.json();
}

// Učitava SVE biznise - koristiti samo kad zaista treba (search, mapa, admin, write review)
function useSupabase() {
  const [biznisi, setBiznisi] = useState(() => _globalBiznisiCache);
  const [loading, setLoading] = useState(() => !_globalBiznisiCache);
  const [error,   setError]   = useState(null);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const onRefresh = () => setVersion((v) => v + 1);
    window.addEventListener("ns-biz-refresh", onRefresh);
    return () => window.removeEventListener("ns-biz-refresh", onRefresh);
  }, []);

  useEffect(() => {
    if (_globalBiznisiCache) { setBiznisi(_globalBiznisiCache); setLoading(false); return; }
    if (_globalBiznisiLoading) {
      _globalBiznisiCallbacks.push((data) => { setBiznisi(data); setLoading(false); });
      return;
    }

    try {
      const raw = sessionStorage.getItem(BIZ_CACHE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        const rows = parsed && Date.now() - parsed.t < BIZ_CACHE_MAX_AGE_MS ? parsed.rows : null;
        if (Array.isArray(rows) && rows.length > 0) {
          const mapped = rows.map(mapRow).filter(isListedBiz);
          _globalBiznisiCache = mapped;
          setBiznisi(mapped); setLoading(false);
          return;
        }
      }
    } catch {}

    _globalBiznisiLoading = true;
    let cancelled = false;

    const fetchAll = async () => {
      try {
        const PAGE = 1000;
        let sve = [];
        let od = 0;
        while (true) {
          const url = `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&order=ime.asc&limit=${PAGE}&offset=${od}`;
          const data = await fetchFromSupabase(url);
          if (!Array.isArray(data) || data.length === 0) break;
          sve = sve.concat(data);
          od += PAGE;
          if (data.length < PAGE) break;
        }
        try { sessionStorage.removeItem("ns_biz_v2"); sessionStorage.setItem(BIZ_CACHE_KEY, JSON.stringify({ t: Date.now(), rows: sve })); } catch {}
        const mapped = sve.map(mapRow).filter(isListedBiz);
        _globalBiznisiCache = mapped;
        _globalBiznisiLoading = false;
        if (!cancelled) { setBiznisi(mapped); setLoading(false); }
        _globalBiznisiCallbacks.forEach(cb => cb(mapped));
        _globalBiznisiCallbacks = [];
      } catch (e) {
        _globalBiznisiLoading = false;
        if (!cancelled) { setError(e.message); setLoading(false); }
        _globalBiznisiCallbacks.forEach(cb => cb([]));
        _globalBiznisiCallbacks = [];
      }
    };
    fetchAll();
    return () => { cancelled = true; };
  }, [version]);

  return { biznisi, loading, error };
}

// Biznisi jedne kategorije ako su već u memoriji (iz pune liste ili ranijeg učitavanja)
function getCachedCategory(category) {
  if (!category) return null;
  const dbKat = CATEGORY_DB_NAME_MAP[category] || category;
  if (_globalBiznisiCache) {
    const own = _globalBiznisiCache.filter(b =>
      b.category === category || b.category === dbKat ||
      (Array.isArray(b.categories) && (b.categories.includes(category) || b.categories.includes(dbKat)))
    );
    const extra = _globalBiznisiCache.filter((b) => isExtraIn(b, category)).map((b) => asExtraIn(b, category));
    return own.concat(extra);
  }
  return _catCache[category] || null;
}

// Učitava biznise jedne kategorije i pamti ih (_catCache). Isti poziv dok traje
// vraća isto obećanje, pa preload pri prelasku mišem i sama stranica ne šalju
// dva zahteva.
const _catPromise = {};
function loadCategory(category) {
  const cached = getCachedCategory(category);
  if (cached) return Promise.resolve(cached);
  const cacheKey = category; // cache po UI nazivu
  const dbKat = CATEGORY_DB_NAME_MAP[category] || category;
  if (_catPromise[cacheKey]) return _catPromise[cacheKey];
  _catLoading[cacheKey] = true;
  const p = (async () => {
      try {
        // Pokušaj sa UI nazivom (Sport, Nega)
        const enc1 = encodeURIComponent(category);
        const enc2 = encodeURIComponent(dbKat);
        let data = await fetchFromSupabase(
          `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&kategorija=eq.${enc1}&order=ime.asc&limit=500`
        );
        // Ako nema rezultata, pokušaj sa DB nazivom (Teretane, Usluge)
        if (!Array.isArray(data) || data.length === 0) {
          data = await fetchFromSupabase(
            `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&kategorija=eq.${enc2}&order=ime.asc&limit=500`
          );
        }
        // Fallback na 'category' kolonu
        if (!Array.isArray(data) || data.length === 0) {
          data = await fetchFromSupabase(
            `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&category=eq.${enc1}&order=ime.asc&limit=500`
          );
        }
        let mapped = (Array.isArray(data) ? data : []).map(mapRow).filter(isListedBiz);
        // Lokali iz drugih kategorija koji su po Google-u i ovo (npr. kafić koji je i restoran)
        const extraTypes = EXTRA_CAT_TYPES[category];
        if (extraTypes) {
          try {
            const or = "(" + extraTypes.map((t) => `google_tipovi.cs.${JSON.stringify([t])}`).join(",") + ")";
            const extraRows = await fetchFromSupabase(
              `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&kategorija=neq.${enc1}&kategorija=neq.${enc2}&or=${encodeURIComponent(or)}&order=ime.asc&limit=500`
            );
            const seen = new Set(mapped.map((b) => b.id));
            const extra = (Array.isArray(extraRows) ? extraRows : []).map(mapRow).filter((b) => isListedBiz(b) && !seen.has(b.id) && isExtraIn(b, category)).map((b) => asExtraIn(b, category));
            mapped = mapped.concat(extra);
          } catch { /* bez dodatnih lokala ako upit ne uspe; glavna lista ostaje */ }
        }
        _catCache[cacheKey] = mapped;
        return mapped;
      } finally {
        _catLoading[cacheKey] = false;
        delete _catPromise[cacheKey];
      }
  })();
  _catPromise[cacheKey] = p;
  return p;
}

// Učitava samo jednu kategoriju - za CategoryPage, mnogo manje egress-a
function useSupabaseCategory(category) {
  const [biznisi, setBiznisi] = useState(() => getCachedCategory(category));
  const [loading, setLoading] = useState(() => !getCachedCategory(category));
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!category) return;
    const cached = getCachedCategory(category);
    if (cached) { setBiznisi(cached); setLoading(false); return; }
    let cancelled = false;
    loadCategory(category).then(
      (data) => { if (!cancelled) { setBiznisi(data); setLoading(false); } },
      (e) => { if (!cancelled) { setError(e.message); setBiznisi([]); setLoading(false); } }
    );
    return () => { cancelled = true; };
  }, [category]);

  return { biznisi, loading, error };
}

// Učitava samo popularne biznise za hero slider - minimalni egress
function useSupabasePopular() {
  const [biznisi, setBiznisi] = useState(null);

  useEffect(() => {
    // Ako imamo globalni cache, uzmi odatle
    if (_globalBiznisiCache) {
      setBiznisi(_globalBiznisiCache.filter(b => b.isPopular));
      return;
    }
    const fetch_ = async () => {
      try {
        const url = `${SUPABASE_URL}/rest/v1/${encodeURIComponent(TABLE_NAME)}?select=*&is_popular=eq.true&limit=10`;
        const data = await fetchFromSupabase(url);
        setBiznisi((Array.isArray(data) ? data : []).map(mapRow).filter(isListedBiz));
      } catch { setBiznisi([]); }
    };
    fetch_();
  }, []);

  return biznisi;
}

/* Grupiše niz biznisa po kategoriji → objekat { Restorani: [...], Kafići: [...], ... }
   Fallback-uje na listingData kategorije ako nema podataka iz baze za tu kategoriju */
function groupByCategory(biznisi, fallback) {
  if (!fallback) fallback = listingData;
  if (!biznisi || biznisi.length === 0) return fallback;

  const grouped = {};

  biznisi.forEach(b => {
    // Višestruke kategorije - pojavljuje se u svakoj
    const kategorije = (Array.isArray(b.categories) && b.categories.length > 0)
      ? b.categories
      : [b.category || "Ostalo"];

    kategorije.forEach(cat => {
      if (!cat) return;
      if (!grouped[cat]) grouped[cat] = [];
      if (!grouped[cat].find(x => x.id === b.id)) {
        grouped[cat].push(b);
      }
    });
  });

  // Fallback SAMO za kategorije koje uopšte nisu u bazi
  // Ako kategorija ima bar 1 lokal iz baze - NE koristi statičke
  Object.keys(fallback).forEach(cat => {
    if (!grouped[cat] || grouped[cat].length === 0) {
      grouped[cat] = fallback[cat];
    }
  });

  return grouped;
}
const NS_CENTER = { lat: 45.2551, lng: 19.8452 }; // Centar Novog Sada - Stari Grad, kopno

// Neighbourhood → centre coordinates for businesses without explicit lat/lng
const DEO_COORDS = {
  "Centar":        { lat: 45.2560, lng: 19.8450 }, // Bulevar Mihajla Pupina
  "Liman":         { lat: 45.2388, lng: 19.8450 }, // Liman - na kopnu juzno
  "Liman 1":       { lat: 45.2410, lng: 19.8480 },
  "Liman 2":       { lat: 45.2390, lng: 19.8510 },
  "Liman 3":       { lat: 45.2360, lng: 19.8540 },
  "Novo Naselje":  { lat: 45.2720, lng: 19.8050 }, // Novo Naselje - zapad
  "Petrovaradin":  { lat: 45.2480, lng: 19.8700 }, // Petrovaradin - istok
  "Satelit":       { lat: 45.2790, lng: 19.8210 }, // Satelit - sever
  "Detelinara":    { lat: 45.2310, lng: 19.8580 }, // Detelinara - jugoistok
  "Telep":         { lat: 45.2260, lng: 19.8340 }, // Telep - jug
  "Adice":         { lat: 45.2350, lng: 19.8060 }, // Adice - jugozapad
  "Stari Grad":    { lat: 45.2560, lng: 19.8430 }, // Stari grad centar
  "Grbavica":      { lat: 45.2530, lng: 19.8360 }, // Grbavica
  "Veternik":      { lat: 45.2880, lng: 19.7950 }, // Veternik - severozapad
  "Kamenjar":      { lat: 45.2630, lng: 19.8620 },
  "Bocke":         { lat: 45.2580, lng: 19.8280 },
  "Podbara":       { lat: 45.2600, lng: 19.8500 },
  "Ostalo":        { lat: 45.2560, lng: 19.8450 }, // Default - centar kopno
};

// Returns stable lat/lng for a business: explicit coords > neighbourhood lookup > city scatter
const _bizCoordCache = {};
// Geocoder cache za async geocoding
const _geocodeCache = {};

// Async geocoding - vraca Promise sa coords
function geocodeAddress(address, bizName) {
  const q = (address && address.length > 5 ? address : bizName) + ", Novi Sad, Serbia";
  if (_geocodeCache[q]) return Promise.resolve(_geocodeCache[q]);
  return new Promise((resolve) => {
    if (!window.google || !window.google.maps) {
      resolve(null); return;
    }
    const gc = new window.google.maps.Geocoder();
    gc.geocode({ address: q, region: "rs" }, (results, status) => {
      if (status === "OK" && results[0]) {
        const loc = results[0].geometry.location;
        const coords = { lat: loc.lat(), lng: loc.lng() };
        _geocodeCache[q] = coords;
        resolve(coords);
      } else {
        _geocodeCache[q] = null;
        resolve(null);
      }
    });
  });
}

function coordsForBiz(biz) {
  const key = biz.id || biz.name || Math.random();
  if (_bizCoordCache[key]) return _bizCoordCache[key];
  let coords;
  if (biz.lat && biz.lng && !isNaN(+biz.lat) && !isNaN(+biz.lng)) {
    coords = { lat: +biz.lat, lng: +biz.lng };
  } else {
    // Trazi deo grada iz bize
    const deo = biz.deoGrada || biz.deo_grada
      || (biz.sub ? biz.sub.split(" . ").slice(1).join(" ") : "");
    const match = Object.keys(DEO_COORDS).find(k =>
      deo.toLowerCase().includes(k.toLowerCase())
    );
    if (match) {
      // Mali random offset unutar istog dela grada (max ~300m)
      coords = {
        lat: DEO_COORDS[match].lat + (Math.random() - 0.5) * 0.004,
        lng: DEO_COORDS[match].lng + (Math.random() - 0.5) * 0.005,
      };
    } else {
      // Fallback: scatter oko centra ALI samo na kopnu (ne u Dunavu)
      // Dunav je priblizno lat < 45.248 ili lat > 45.260 za NS centar
      // Sigurno scatter: koristimo Centar koordinate
      const base = DEO_COORDS["Centar"];
      coords = {
        lat: base.lat + (Math.random() - 0.5) * 0.025,
        lng: base.lng + (Math.random() - 0.5) * 0.030,
      };
    }
  }
  _bizCoordCache[key] = coords;
  return coords;
}
const BG   = "#EFE5D5";
const SF   = `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`;

/* --- RESPONSIVE HOOK --- */
function useBreakpoint() {
  const getSize = () => ({
    isMobile:  window.innerWidth < 640,
    isTablet:  window.innerWidth >= 640 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
    w:         window.innerWidth,
  });
  const [bp, setBp] = useState(getSize);
  useEffect(() => {
    const handler = () => setBp(getSize());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return bp;
}

const SITE_URL = "https://www.novosadski-adresar.rs";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

function setMetaTag(attrType, attrName, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attrType}="${attrName}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrType, attrName);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Menja <title>, meta description, Open Graph i Twitter tagove, i canonical
// link - po svakoj strani posebno (bitno za SEO: svaka strana mora imati
// svoj, jedinstven naslov i opis da bi Google mogao da ih razlikuje).
function usePageMeta({ title: rawTitle, description: rawDescription, image, path, noindex }) {
  // Duga crta iz podataka (npr. ime biznisa u bazi) se u naslovu i opisu
  // zamenjuje običnom crticom.
  const noLongDash = (s) => (s ? String(s).replace(/\s*\u2014\s*/g, " - ") : s);
  const title = noLongDash(rawTitle);
  const description = noLongDash(rawDescription);
  useEffect(() => {
    if (!title) return;
    // Format: "Naziv stranice - Novosadski Adresar". Brend ide na kraj, ali samo
    // ako naslov ostane do ~65 znakova (Google seče duže naslove, a važne reči
    // su na početku).
    const withBrand = `${title} - Novosadski Adresar`;
    const fullTitle = title.includes("Novosadski Adresar") ? title : (withBrand.length <= 65 ? withBrand : title);
    document.title = fullTitle;
    const url = `${SITE_URL}${path || window.location.pathname}`;
    setMetaTag("name", "description", description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:title", fullTitle);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:url", url);
    setMetaTag("property", "og:site_name", "Novosadski Adresar");
    setMetaTag("property", "og:locale", "sr_RS");
    setMetaTag("property", "og:image", image || DEFAULT_OG_IMAGE);
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", fullTitle);
    setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", image || DEFAULT_OG_IMAGE);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", url);
    // "Duh" stranice (obrisan biznis, netačan link) - reci Google-u da ih
    // izbaci iz indeksa umesto da ih drži zauvek zbog "200 OK" odgovora.
    let robotsEl = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robotsEl) { robotsEl = document.createElement("meta"); robotsEl.setAttribute("name", "robots"); document.head.appendChild(robotsEl); }
      robotsEl.setAttribute("content", "noindex, follow");
    } else if (robotsEl) {
      robotsEl.remove();
    }
  }, [title, description, image, path, noindex]);
}

// Zajednički prikaz "podaci se učitavaju" (spinner u stilu sajta). Koristi se
// svuda gde bi inače, dok podaci još stižu iz baze, pisalo "nema rezultata".
/* Skeleton: siva "senka" sadržaja koja blago treperi dok se podaci učitavaju
   (kao na Instagramu, YouTube-u...). Stil .ns-sk je u GLOBAL_STYLE. */
const SK_ROW_W = ["62%", "48%", "70%", "55%", "66%"];
function SkBar({ w = "100%", h = 12, mt = 0, r = 6 }) {
  return <div className="ns-sk" style={{ width: w, height: h, borderRadius: r, marginTop: mt }} />;
}
// Redovi liste (pretraga, liste u blogu, sačuvano...): ikonica + dve linije teksta
function SkeletonRows({ count = 3, avatar = true, pad = "12px 16px" }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: pad }}>
          {avatar && <div className="ns-sk" style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0 }} />}
          <div style={{ flex: 1, minWidth: 0 }}><SkBar w={SK_ROW_W[i % SK_ROW_W.length]} h={12} /><SkBar w="34%" h={10} mt={7} /></div>
        </div>
      ))}
    </div>
  );
}
// Kartica lokala u kategoriji (isti raspored kao ListingCard)
function ListingCardSkeleton() {
  return (
    <div aria-hidden="true" style={{ background: "#fff", borderRadius: 20, padding: "22px 24px", marginBottom: 14, boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
      <SkBar w="58%" h={18} r={7} />
      <SkBar w={120} h={13} mt={12} />
      {["78%", "46%", "88%"].map((w, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 14 }}>
          <div className="ns-sk" style={{ width: 14, height: 14, borderRadius: 4, flexShrink: 0 }} />
          <div style={{ flex: 1 }}><SkBar w={w} h={11} /></div>
        </div>
      ))}
      <div style={{ display: "flex", gap: 8, marginTop: 16 }}><SkBar w={74} h={26} r={8} /><SkBar w={110} h={26} r={8} /></div>
    </div>
  );
}
function LoadingState({ label = "Učitavanje podataka...", minHeight = 220 }) {
  return (
    <div role="status" aria-live="polite" style={{ minHeight, padding: "6px 0" }}>
      <span style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)", whiteSpace: "nowrap" }}>{label}</span>
      <SkeletonRows count={Math.max(2, Math.min(6, Math.round(minHeight / 62)))} />
    </div>
  );
}
// Ubacuje/menja JSON-LD structured data (Schema.org) blok - omogućava da se
// u Google rezultatima pojave zvezdice ocena i drugi "rich snippet" podaci.
function useStructuredData(id, data) {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    // < > & se pišu kao \u003c..., jer prerender snima <script> sadržaj doslovno u HTML:
    // naziv ili opis lokala sa "</script>" bi inače zatvorio skriptu i ubacio kod u stranicu
    el.textContent = JSON.stringify(data)
      .replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")
      .replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    return () => { el && el.remove(); };
  }, [id, data]);
}

/* --- SHARED PILL STYLE --- */
const STAR_PATH = "M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z";
const PILL_SHADOW = "0 2px 20px rgba(0,0,0,0.13), 0 1px 6px rgba(0,0,0,0.09)";
// Boje kategorija: smirene, ne neon; ista paleta svuda (pretraga, profil, mapa...)
export const CAT_COLORS = {
  "Restorani":"#0079FF", "Kafići":"#D4952B", "Kafici":"#D4952B",
  "Sport":"#7D5BC6", "Teretane":"#7D5BC6", "Noćni život":"#D2454E", "Nocni zivot":"#D2454E",
  "Zdravlje":"#2F95A6", "Hoteli":"#4F7DB3", "Bazeni":"#2A9D8F",
  "Nega":"#3F9B5F", "Usluge":"#3F9B5F", "Auto":"#D0703C", "Zanati":"#8B7355",
};
const PILL_SHADOW_STRONG = "0 4px 24px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.14)";
const pillBase = {
  background: "#FAFAFC",
  borderRadius: 20,
  boxShadow: PILL_SHADOW,
  display: "flex",
  alignItems: "center",
};
/* Icon squares: separate white blocks as in SVG reference */
const iconPill = {
  background: "#FFFFFF",
  borderRadius: 14,
  boxShadow: PILL_SHADOW,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 42,
  height: 42,
  cursor: "pointer",
  flexShrink: 0,
};

/* ==========================================
   NAVBAR
========================================== */
const navLinks = [
  { label: "Zanati",      chevron: true  },
  { label: "Auto",        chevron: true  },
  { label: "Nega",        chevron: true  },
  { label: "Zdravlje",    chevron: true  },
  { label: "Hoteli",      chevron: true  },
  { label: "Sport",       chevron: true  },
  { label: "Bazeni",      chevron: true  },
  { label: "Kafići",      chevron: true  },
  { label: "Restorani",   chevron: true  },
  { label: "Noćni život", chevron: true  },
  { label: "Blog",        chevron: false },
];

// Kompaktni meni za < 1300px - Nega + Auto + Zanati spojeni u "Usluge"
const navLinksCompact = [
  { label: "Usluge",      chevron: true  },
  { label: "Zdravlje",    chevron: true  },
  { label: "Hoteli",      chevron: true  },
  { label: "Sport",       chevron: true  },
  { label: "Bazeni",      chevron: true  },
  { label: "Kafići",      chevron: true  },
  { label: "Restorani",   chevron: true  },
  { label: "Noćni život", chevron: true  },
  { label: "Blog",        chevron: false },
];


const megaMenuData = {
  Restorani: [
    { title: "Domaći restorani",   sub: "Tradicionalni ukusi Vojvodine" },
    { title: "Roštilj i meso",     sub: "Majstori otvorene vatre" },
    { title: "Italijanska hrana",  sub: "Autentične paste i pice" },
    { title: "Azijski ukusi",      sub: "Najbolji suši i vok barovi" },
    { title: "Brza hrana",         sub: "Pljeskavice, burgeri i više" },
    { title: "Veganski restorani", sub: "Zdravo, ukusno i održivo" },
    { title: "Morska hrana",       sub: "Riba i plodovi mora" },
  ],
  Kafići: [
    { title: "Klasični kafići",              sub: "Espresso, kafa i dobra atmosfera" },
    { title: "Specialty Coffee & Pržionice", sub: "Filter, cold brew, latte art" },
    { title: "Poslastičarnice",              sub: "Kolači, torte i deserti" },
    { title: "Barovi i Pubovi",              sub: "Opuštena večera uz piće" },
    { title: "Brunch kafići",               sub: "Jutarnji obroci i kafa" },
    { title: "Nargila barovi",              sub: "Hookah i lounge atmosfera" },
    { title: "Knjižare kafići",             sub: "Čitaj uz aromu kafe" },
  ],
  Sport: [
    { title: "Fitness centri & Teretane",       sub: "Kardio i slobodni tegovi" },
    { title: "CrossFit & Funkcionalni trening", sub: "Intenzivan funkcionalni trening" },
    { title: "Yoga & Pilates",                  sub: "Mir, disanje, ravnoteža" },
    { title: "Borilačke veštine",               sub: "Boks, MMA, karate, džudo" },
    { title: "Sportski baloni & Tereni",        sub: "Padel, tenis, fudbal" },
    { title: "Plesni studiji & Škole plesa",    sub: "Salsa, bachata, moderni ples" },
  ],
  Nega: [
    { title: "Frizerski saloni & Barberi", sub: "Šišanje, brada, stilizovanje" },
    { title: "Kozmetički saloni",          sub: "Manikir, pedikir, tretmani" },
    { title: "Masaža & Spa",              sub: "Opuštanje i regeneracija" },
    { title: "Estetska medicina & Laser centri", sub: "Laser, anti-age, epilacija" },
    { title: "Tetoviranje & Pirsing",     sub: "Tattoo studiji i pirsing" },
  ],
  "Noćni život": [
    { title: "Klubovi & Splavovi",    sub: "DJ, dens i dobra zabava" },
    { title: "Kafane & Tamburaši",    sub: "Živa muzika i boemska noć" },
    { title: "Pub-ovi & Pivnice",     sub: "Craft pivo i opuštena atmosfera" },
    { title: "Koktel & Vinski barovi", sub: "Premium pića i elegancija" },
  ],
  Zdravlje: [
    { title: "Privatne klinike & Laboratorije", sub: "Specijalisti i dijagnostika" },
    { title: "Stomatolozi",                     sub: "Zdrav osmeh za svaki dan" },
    { title: "Apoteke",                         sub: "Lekovi i dodaci ishrani" },
    { title: "Veterinari & Vet ambulante",       sub: "Zdravlje vaših ljubimaca" },
    { title: "Fizioterapeuti & Kiropraktičari",  sub: "Oporavak i rehabilitacija" },
    { title: "Psihoterapija",                   sub: "Mentalno zdravlje i podrška" },
    { title: "Državne bolnice & Domovi zdravlja", sub: "KCV, Betanija i hitna pomoć" },
  ],
  Auto: [
    { title: "Auto servisi & Mehaničari",        sub: "Servis i popravke vozila" },
    { title: "Autoperionice & Dubinsko pranje",  sub: "Pranje i detailing" },
    { title: "Vulkanizeri & Prodaja guma",       sub: "Gume i balansiranje" },
    { title: "Tehnički pregled & Registracija",  sub: "Papiri i osiguranje" },
    { title: "Rent-a-Car",                       sub: "Iznajmljivanje vozila" },
  ],
  Hoteli: [
    { title: "Hoteli & Apartmani",     sub: "Komforan smeštaj u gradu" },
    { title: "Hosteli & Sobe",         sub: "Budget putnici i mladi turisti" },
    { title: "Wellness & Spa hoteli",  sub: "Odmor uz spa tretmane" },
    { title: "Boutique hoteli",        sub: "Dizajnerski i jedinstveni" },
    { title: "Salaši & Etno smeštaj", sub: "Vojvođanski salaši i etno kuće" },
  ],
  Bazeni: [
    { title: "Gradski bazeni & Aquaparci", sub: "Štrand i olimpijski bazeni" },
    { title: "Sportski bazeni",            sub: "Škola plivanja i trening" },
    { title: "Spa & Wellness bazeni",      sub: "Jacuzzi, sauna i relaks" },
    { title: "Privatni & Sezonski bazeni", sub: "Kampovi i vikendice" },
  ],
  Zanati: [
    { title: "Vodoinstalateri & Grejanje", sub: "Curenja, bojleri, radijatori" },
    { title: "Električari",                sub: "Instalacije i servis" },
    { title: "Stolari & Nameštaj",         sub: "Izrada i popravka nameštaja" },
    { title: "Obućari & Kožni artikli",    sub: "Popravka obuće i tašni" },
    { title: "Krojači & Krojačnice",       sub: "Odeća po meri i popravke" },
    { title: "Servis bele tehnike",        sub: "Veš mašine, frižideri, šporeti" },
    { title: "Ključari & Brave",           sub: "Otključavanje i zamena brava 24h" },
  ],
};

// Kombinovani mega meni za kompaktni nav (< 1300px)
// "Usluge" = Nega & Lepota + Auto + Zanati u 3 kolone
const megaMenuDataCompact = {
  ...megaMenuData,
  Usluge: {
    __combined: true,
    kolone: [
      {
        naslov: "Nega & Lepota",
        items: megaMenuData.Nega,
        kat: "Nega",
      },
      {
        naslov: "Auto usluge",
        items: megaMenuData.Auto,
        kat: "Auto",
      },
      {
        naslov: "Zanati",
        items: megaMenuData.Zanati,
        kat: "Zanati",
      },
    ],
  },
};
function FavoritesIcon({ onPageOpen }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { favIds, toggle, blogSlugs, toggleBlog } = useFavorites();
  const { biznisi } = useSupabase();
  const { user } = useAuthContext();

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const favBiznisi = React.useMemo(() => {
    if (!biznisi || favIds.length === 0) return [];
    return biznisi.filter(b => favIds.includes(Number(b.id))).slice(0, 5);
  }, [biznisi, favIds]);
  // Sačuvani blogovi (naslovi iz blogData.json), najnoviji sačuvan prvi
  const favBlogs = React.useMemo(
    () => blogSlugs.map(s => BLOG_POSTS.find(p => p.slug === s)).filter(Boolean).slice(0, 3),
    [blogSlugs]
  );

  const hasAny = favBiznisi.length > 0 || favBlogs.length > 0;
  const totalSaved = favIds.length + favBlogs.length;

  return (
    <div ref={ref} style={{ position: "relative", flexShrink: 0 }}>
      {/* Button */}
      <div role="button" aria-label="Omiljeni lokali" className="icon-sq" onClick={() => setOpen(o => !o)} style={{
        background: "#FFFFFF",
        borderRadius: 10, boxShadow: PILL_SHADOW,
        width: 42, height: 42, display: "flex", alignItems: "center",
        justifyContent: "center", cursor: "pointer", transition: "background 0.4s ease",
        position: "relative",
      }}>
        <svg width="17" height="17" viewBox="0 0 24 23" fill={hasAny ? BLUE : "#111"} stroke="none">
          <path d={STAR_PATH}/>
        </svg>
        {hasAny && (
          // Broj sačuvanog: dovoljno krupan da se lako pročita; širi se za dvocifrene brojeve
          <div style={{
            position: "absolute", top: -7, right: -7,
            background: BLUE, color: "#fff", borderRadius: 999,
            minWidth: 21, height: 21, padding: "0 5px", boxSizing: "border-box",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 11.5, fontWeight: 700, fontFamily: SF, lineHeight: 1,
            fontVariantNumeric: "tabular-nums", letterSpacing: "-0.02em",
            border: "2px solid #fff", boxShadow: "0 2px 6px rgba(0,0,0,0.14)",
          }}>
            {totalSaved > 99 ? "99+" : totalSaved}
          </div>
        )}
      </div>

      {/* Dropdown */}
      <div style={{
        position: "absolute", top: "calc(100% + 10px)", right: 0,
        width: 260, background: "#fff", borderRadius: 16,
        boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.07)",
        padding: "16px 0 8px",
        opacity: open ? 1 : 0,
        transform: open ? "translateY(0)" : "translateY(-6px)",
        pointerEvents: open ? "all" : "none",
        transition: "opacity 0.22s ease, transform 0.22s ease",
        zIndex: 300,
      }}>
        <div style={{ padding: "0 16px 10px", borderBottom: "1px solid #f0f0f0", marginBottom: 6 }}>
          <div style={{ fontFamily: SF, fontSize: 13, fontWeight: 700, color: "#111" }}>Sačuvani lokali i blogovi</div>
          {hasAny && <div style={{ fontFamily: SF, fontSize: 11, color: "#aaa", marginTop: 2 }}>{favIds.length} {favIds.length === 1 ? "lokal" : "lokala"}{favBlogs.length > 0 ? ` · ${blogSlugs.length} ${blogSlugs.length % 10 === 1 && blogSlugs.length % 100 !== 11 ? "blog" : [2, 3, 4].includes(blogSlugs.length % 10) && ![12, 13, 14].includes(blogSlugs.length % 100) ? "bloga" : "blogova"}` : ""}</div>}
        </div>

        {!hasAny ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, padding: "16px 18px" }}>
            <svg width="28" height="28" viewBox="0 0 24 23" fill="none"><path d={STAR_PATH} fill="#ddd"/></svg>
            <div style={{ fontFamily: SF, fontSize: 13, fontWeight: 600, color: "#111" }}>Nema omiljenih</div>
            <div style={{ fontFamily: SF, fontSize: 12, color: "#aaa", textAlign: "center", lineHeight: 1.5 }}>
              {user ? "Sačuvajte lokale i blogove klikom na zvezdicu ★" : "Prijavite se da biste čuvali omiljene lokale i blogove"}
            </div>
            {!user && (
              <button onClick={() => { setOpen(false); onPageOpen && onPageOpen("profile", "login"); }} style={{
                marginTop: 4, background: BLUE, color: "#fff", border: "none",
                borderRadius: 10, padding: "8px 18px", fontFamily: SF,
                fontSize: 13, fontWeight: 600, cursor: "pointer",
              }}>Prijavite se</button>
            )}
          </div>
        ) : (
          <>
            {favBiznisi.length > 0 && (
              <div style={{ padding: "4px 16px 4px", fontFamily: SF, fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.06em" }}>Lokali</div>
            )}
            {favBiznisi.map((biz, i) => {
              const CAT_C = CAT_COLORS;
              const col = CAT_C[biz.category] || BLUE;
              return (
                <div key={i}
                  style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 16px", cursor:"pointer", transition:"background 0.4s ease" }}
                  onMouseEnter={e => e.currentTarget.style.background="#f8f8f8"}
                  onMouseLeave={e => e.currentTarget.style.background="transparent"}
                  onClick={() => { setOpen(false); if (window.__nsNav) window.__nsNav.openBiz(biz); }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(false); if (window.__nsNav) window.__nsNav.openBiz(biz); } }}
                >
                  <div style={{ width:32, height:32, borderRadius:8, background:`${col}15`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                    <MapPin size={14} color={col} />
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{biz.name}</div>
                    <div style={{ fontFamily:SF, fontSize:11, color:"#aaa" }}>{biz.category}</div>
                  </div>
                  {/* Dugme za uklanjanje */}
                  <button
                    onClick={e => { e.stopPropagation(); toggle(biz); }}
                    title="Ukloni iz omiljenih"
                    style={{ background:"transparent", border:"none", cursor:"pointer", padding:4, borderRadius:6, flexShrink:0, opacity:0.4, transition:"opacity 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.opacity="1"}
                    onMouseLeave={e => e.currentTarget.style.opacity="0.4"}
                  >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e00" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                    </svg>
                  </button>
                </div>
              );
            })}
            {favIds.length > 5 && (
              <div style={{ borderTop:"1px solid #f0f0f0", marginTop:4 }}>
                <button onClick={() => { setOpen(false); onPageOpen && onPageOpen("profile"); }} style={{
                  width:"100%", background:"transparent", border:"none",
                  padding:"10px 16px", fontFamily:SF, fontSize:12,
                  fontWeight:600, color:BLUE, cursor:"pointer", textAlign:"center", whiteSpace:"nowrap",
                }}>Pogledaj sve ({favIds.length}) →</button>
              </div>
            )}
            {favBlogs.length > 0 && (
              <div style={{ borderTop: favBiznisi.length ? "1px solid #f0f0f0" : "none", marginTop: favBiznisi.length ? 4 : 0, paddingTop: favBiznisi.length ? 6 : 0 }}>
                <div style={{ padding: "4px 16px 4px", fontFamily: SF, fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.06em" }}>Blogovi</div>
                {favBlogs.map(post => (
                  <div key={post.slug}
                    style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 16px", cursor:"pointer", transition:"background 0.4s ease" }}
                    onMouseEnter={e => e.currentTarget.style.background="#f8f8f8"}
                    onMouseLeave={e => e.currentTarget.style.background="transparent"}
                    onClick={() => { setOpen(false); onPageOpen && onPageOpen(`blog/${post.slug}`); }}
                    role="button" tabIndex={0}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(false); onPageOpen && onPageOpen(`blog/${post.slug}`); } }}
                  >
                    <div style={{ width:32, height:32, borderRadius:8, background:`${BLUE}15`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{post.title}</div>
                      <div style={{ fontFamily:SF, fontSize:11, color:"#aaa" }}>{post.category} · {post.readMin} min</div>
                    </div>
                    <button onClick={e => { e.stopPropagation(); toggleBlog(post.slug); }} title="Ukloni iz sačuvanih"
                      style={{ background:"transparent", border:"none", cursor:"pointer", padding:4, borderRadius:6, flexShrink:0, opacity:0.4, transition:"opacity 0.15s" }}
                      onMouseEnter={e => e.currentTarget.style.opacity="1"}
                      onMouseLeave={e => e.currentTarget.style.opacity="0.4"}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e00" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                      </svg>
                    </button>
                  </div>
                ))}
                {blogSlugs.length > 3 && (
                  <button onClick={() => { setOpen(false); try { sessionStorage.setItem("ns_blog_filter", "sacuvani"); } catch {} onPageOpen && onPageOpen("blog"); }} style={{ width:"100%", background:"transparent", border:"none", padding:"8px 16px", fontFamily:SF, fontSize:12, fontWeight:600, color:BLUE, cursor:"pointer", textAlign:"center" }}>
                    Svi sačuvani blogovi ({blogSlugs.length}) →
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

/* -- Search icon  -  fixed 42px in layout, input expands via position:absolute -- */
// Global search - biznisi + stranice
// Dobija handlere od Navbar-a kroz window globals (da izbjegnemo prop drilling)
function SearchIcon({ onExpand, onCollapse }) {
  const [expanded,  setExpanded]  = useState(false);
  const [query,     setQuery]     = useState("");
  const [results,   setResults]   = useState([]);
  const inputRef  = useRef(null);
  const wrapRef   = useRef(null);
  const { w, isMobile } = useBreakpoint();
  const { biznisi, loading: biznisiLoading } = useSupabase();

  const maxW = Math.min(280, Math.max(140, Math.round(w * 0.15)));

  const PAGES = [
    { name: "Popularne recenzije",  page: "recenzije",    desc: "Sve recenzije lokala" },
    { name: "Ocenite lokal",        page: "oceni",        desc: "Napišite recenziju" },
    { name: "Dodajte vaš biznis",   page: "dodaj-biznis", desc: "Postanite vidljivi" },
    { name: "Kontaktirajte nas",    page: "kontakt",      desc: "Pišite nam" },
    { name: "Blog",                 page: "blog",         desc: "Vodiči i saveti" },
    { name: "Noćni klubovi",        page: "nocni-klubovi",desc: "Klubovi u NS" },
    { name: "Pivnice i pubovi",     page: "pivnice",      desc: "Craft pivo i pubovi" },
    { name: "Jazz kafići i barovi", page: "kokteli-barovi",  desc: "Jazz i kokteli" },
    { name: "Restorani",            cat:  "Restorani",    desc: "Svi restorani" },
    { name: "Kafići",               cat:  "Kafići",       desc: "Svi kafići" },
    { name: "Sport",             cat:  "Sport",     desc: "Sve teretane" },
    { name: "Noćni život",          cat:  "Noćni život",  desc: "Noćni život" },
    { name: "Zdravlje",             cat:  "Zdravlje",     desc: "Zdravlje i wellness" },
  ];

  const CAT_C = CAT_COLORS;

  // Search
  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    // Ime biznisa ima prioritet nad kategorijom/potkategorijom - bez ovoga, pretraga
    // "st medicina" bi vraćala salone lepote čija POTKATEGORIJA slučajno sadrži i "st"
    // i "medicina" (npr. "Estetska medicina..."), a stvarni biznis po imenu "ST MEDICINA"
    // bi ostao van prikazanih 5 rezultata jer je alfabetski iza njih.
    const norm = normalizeSearch(query);
    const nameMatches = (biznisi||[]).filter(b => searchMatch(b.name, query));
    nameMatches.sort((a, b) => {
      const na = normalizeSearch(a.name), nb = normalizeSearch(b.name);
      const rank = (n) => n === norm ? 0 : n.startsWith(norm) ? 1 : 2;
      return rank(na) - rank(nb);
    });
    const catMatches = (biznisi||[]).filter(b =>
      !searchMatch(b.name, query) && (searchMatch(allCategoriesOf(b).join(" "), query) || searchMatch(b.subcategory, query))
    );
    const bizR = [...nameMatches, ...catMatches]
      .slice(0, 5)
      .map(b => ({ kind: "biz", biz: b }));
    const pageR = PAGES
      .filter(p => searchMatch(p.name, query) || searchMatch(p.desc, query))
      .slice(0, 4)
      .map(p => ({ kind: p.cat ? "cat" : "page", ...p }));
    setResults([...bizR, ...pageR].slice(0, 8));
  }, [query, biznisi]); // eslint-disable-line

  const open  = () => { setExpanded(true); onExpand && onExpand(); setTimeout(() => inputRef.current?.focus(), 50); };
  const close = () => { setExpanded(false); setQuery(""); setResults([]); onCollapse && onCollapse(); };

  // Registruj globalni trigger da ga mobile meni može pozvati
  useEffect(() => {
    window.__nsSearchOpen = open;
    return () => { delete window.__nsSearchOpen; };
  }); // eslint-disable-line

  useEffect(() => {
    if (!expanded) return;
    const h = e => { if (wrapRef.current && !wrapRef.current.contains(e.target)) close(); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [expanded]); // eslint-disable-line

  useEffect(() => {
    const h = e => { if (e.key === "Escape") close(); };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, []);

  const handleSelect = (item) => {
    const nav = window.__nsNav;
    if (!nav) { close(); return; }
    if (item.kind === "biz")  nav.openBiz(item.biz);
    if (item.kind === "page") nav.goTo(item.page);
    if (item.kind === "cat")  nav.selectCat(item.cat);
    close();
  };

  const showDropdown = expanded && query.trim().length > 0;

  return (
    <div ref={wrapRef} style={{
      display: "flex", alignItems: "center",
      width: expanded ? Math.min(280, Math.max(120, (w - 1024) * 0.15 + 120)) : 42,
      height: 42,
      transition: "width 0.32s cubic-bezier(0.4,0,0.2,1)",
      flexShrink: 0,
      position: "relative",
      borderRadius: 10,
      boxShadow: PILL_SHADOW,
    }}>

      {/* Input bar - visibilan kad je expanded */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0,
        height: 42,
        background: "#fff",
        borderRadius: 10,
        display: "flex", alignItems: "center",
        overflow: "hidden",
        opacity: expanded ? 1 : 0,
        pointerEvents: expanded ? "auto" : "none",
        transition: "opacity 0.2s ease",
      }}>
        <input
          ref={inputRef}
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder="Pretraži lokale, kategorije..."
          style={{
            flex: 1, border: "none", outline: "none",
            fontFamily: SF, fontSize: 15, color: "#111",
            background: "transparent", paddingLeft: 14,
            minWidth: 0, cursor: "text",
          }}
        />
        {query && (
          <button aria-label="Obriši pretragu" onClick={() => { setQuery(""); setResults([]); inputRef.current?.focus(); }}
            style={{ background:"none", border:"none", cursor:"pointer", color:"#bbb", fontSize:16, lineHeight:1, padding:"0 6px", flexShrink:0 }}>
            ×
          </button>
        )}
      </div>

      {/* Search/Close dugme - animirani SVG morph lupa ↔ X */}
      <style>{`
        .ns-search-btn { position:absolute; top:0; right:0; width:42px; height:42px; background:#fff; border:none; border-radius:10px; box-shadow:0 2px 20px rgba(0,0,0,0.13), 0 1px 6px rgba(0,0,0,0.09); cursor:pointer; display:flex; align-items:center; justify-content:center; padding:0; overflow:hidden; }


        /* Lupa: circle + handle vidljivi, X sakriveni */
        .ns-search-btn.is-closed .ns-si-circle { stroke-dashoffset: 0;   opacity: 1; transition: stroke-dashoffset 0.38s cubic-bezier(0.4,0,0.2,1), opacity 0.18s ease; }
        .ns-search-btn.is-closed .ns-si-handle { stroke-dashoffset: 0;   opacity: 1; transition: stroke-dashoffset 0.38s cubic-bezier(0.4,0,0.2,1) 0.04s, opacity 0.18s ease; }
        .ns-search-btn.is-closed .ns-si-x1    { stroke-dashoffset: 20;  opacity: 0; transition: stroke-dashoffset 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.15s ease; }
        .ns-search-btn.is-closed .ns-si-x2    { stroke-dashoffset: 20;  opacity: 0; transition: stroke-dashoffset 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.15s ease; }

        /* X: circle + handle sakriveni, X vidljiv */
        .ns-search-btn.is-open .ns-si-circle { stroke-dashoffset: 38;  opacity: 0; transition: stroke-dashoffset 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.15s ease; }
        .ns-search-btn.is-open .ns-si-handle { stroke-dashoffset: 10;  opacity: 0; transition: stroke-dashoffset 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.12s ease; }
        .ns-search-btn.is-open .ns-si-x1    { stroke-dashoffset: 0;   opacity: 1; transition: stroke-dashoffset 0.36s cubic-bezier(0.4,0,0.2,1) 0.08s, opacity 0.2s ease 0.06s; }
        .ns-search-btn.is-open .ns-si-x2    { stroke-dashoffset: 0;   opacity: 1; transition: stroke-dashoffset 0.36s cubic-bezier(0.4,0,0.2,1) 0.12s, opacity 0.2s ease 0.1s; }
      `}</style>

      <button
        id="ns-search-trigger"
        aria-label={expanded ? "Zatvori pretragu" : "Pretraži"}
        className={`ns-search-btn ${expanded ? "is-open" : "is-closed"}`}
        onClick={expanded ? close : open}
      >
        <svg width="17" height="17" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Krug lupe */}
          <circle
            className="ns-si-circle"
            cx="8.5" cy="8.5" r="5.5"
            stroke="#333" strokeWidth="1.75" fill="none"
            strokeDasharray="38" strokeDashoffset="0"
            strokeLinecap="round"
          />
          {/* Drška lupe */}
          <line
            className="ns-si-handle"
            x1="12.7" y1="12.7" x2="17.5" y2="17.5"
            stroke="#333" strokeWidth="1.75"
            strokeDasharray="10" strokeDashoffset="0"
            strokeLinecap="round"
          />
          {/* X linija 1: ↘ */}
          <line
            className="ns-si-x1"
            x1="4" y1="4" x2="16" y2="16"
            stroke="#333" strokeWidth="1.75"
            strokeDasharray="20" strokeDashoffset="20"
            strokeLinecap="round"
          />
          {/* X linija 2: ↙ */}
          <line
            className="ns-si-x2"
            x1="16" y1="4" x2="4" y2="16"
            stroke="#333" strokeWidth="1.75"
            strokeDasharray="20" strokeDashoffset="20"
            strokeLinecap="round"
          />
        </svg>
      </button>

      {/* Dropdown rezultati - samo kad ima query */}
      {showDropdown && (
        <div style={{
          position: "absolute", top: 52, right: 0,
          width: Math.min(isMobile ? w - 24 : 360, Math.max(240, (w - 1024) * 0.15 + 200)),
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
          zIndex: 999,
          overflow: "hidden",
          paddingBottom: results.length === 0 ? 0 : 6,
        }}>
          {results.length === 0 && biznisiLoading ? (
            <LoadingState label="Učitavanje podataka..." minHeight={96} size={24} />
          ) : results.length === 0 ? (
            // Prazno stanje: simetrično centrirano, dug upit se skraćuje u jednom redu
            <div style={{ padding: "22px 20px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", fontFamily: SF }}>
              <div style={{ width: 40, height: 40, borderRadius: 12, background: "#f2f2f5", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111", letterSpacing: "-0.02em" }}>Nema rezultata</div>
              <div style={{ fontSize: 13, color: "#8e8e93", marginTop: 4, maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                za „{query.trim()}“
              </div>
              <div style={{ fontSize: 12.5, color: "#aeaeb2", marginTop: 8, lineHeight: 1.45 }}>Proverite naziv ili probajte kategoriju, npr. „pica“ ili „frizer“.</div>
            </div>
          ) : (
            <>
              {/* Lokali */}
              {results.some(r => r.kind === "biz") && (
                <>
                  <div style={{ padding: "10px 16px 4px", fontFamily: SF, fontSize: 11, fontWeight: 700, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.07em" }}>
                    Lokali
                  </div>
                  {results.filter(r => r.kind === "biz").map((item, i) => {
                    const col = CAT_C[item.biz.category] || BLUE;
                    return (
                      <div key={i} onClick={() => handleSelect(item)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleSelect(item); } }}
                        style={{ display:"flex", alignItems:"center", gap:10, padding:"9px 16px", cursor:"pointer" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f7f7f7"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                        <div style={{ width:32, height:32, borderRadius:8, background:`${col}18`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          <MapPin size={13} color={col} />
                        </div>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                            {item.biz.name}
                          </div>
                          <div style={{ fontSize:11, color:"#aaa" }}>
                            {allCategoriesOf(item.biz).join(" · ")}{item.biz.deoGrada ? ` · ${item.biz.deoGrada}` : ""}
                          </div>
                        </div>
                        {item.biz.rating > 0 && (
                          <div style={{ fontSize:11, color:BLUE, fontWeight:700, flexShrink:0 , whiteSpace: "nowrap"}}>
                            ★ {(+item.biz.rating).toFixed(1)}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}

              {/* Stranice */}
              {results.some(r => r.kind !== "biz") && (
                <>
                  <div style={{ padding: "10px 16px 4px", fontFamily: SF, fontSize: 11, fontWeight: 700, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.07em", borderTop: results.some(r=>r.kind==="biz") ? "1px solid #f2f2f2" : "none", marginTop: results.some(r=>r.kind==="biz") ? 4 : 0 }}>
                    Stranice
                  </div>
                  {results.filter(r => r.kind !== "biz").map((item, i) => (
                    <div key={i} onClick={() => handleSelect(item)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleSelect(item); } }}
                      style={{ display:"flex", alignItems:"center", gap:10, padding:"9px 16px", cursor:"pointer" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f7f7f7"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <div style={{ width:32, height:32, borderRadius:8, background:"#f2f2f7", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111" }}>{item.name}</div>
                        <div style={{ fontSize:11, color:"#aaa" }}>{item.desc}</div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}





/* ── Profile dropdown ─────────────────────────────────────── */
function ProfileDropdown({ onPageOpen }) {
  const [open, setOpen] = React.useState(false);
  const [pos, setPos] = React.useState({ top: 0, right: 0 });
  const ref = React.useRef(null);
  const { user, token, setSession, profile } = useAuthContext();

  const portalRef = React.useRef(null);

  React.useEffect(() => {
    const handler = e => {
      const clickedTrigger = ref.current && ref.current.contains(e.target);
      const clickedPortal = portalRef.current && portalRef.current.contains(e.target);
      if (!clickedTrigger && !clickedPortal) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Izračunaj poziciju triggera za Portal
  const handleOpen = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + 8,
        right: window.innerWidth - rect.right,
      });
    }
    setOpen(o => !o);
  };

  const handleLogout = async () => {
    setOpen(false);
    try { if (token) await authAPI.signOut(token); } catch {}
    clearAllAuthStorage();
    setSession(null);
  };

  // Build initials - 2 slova iz profila (Ime Prezime), fallback email.
  // Čita "profile" reaktivno iz AuthContext (učitava se odmah po prijavi),
  // ne iz keša koji se ranije punio samo posetom "Moj profil" stranici.
  const initials = React.useMemo(() => {
    if (!user) return null;
    const f = (profile?.first_name || "")[0] || "";
    const l = (profile?.last_name  || "")[0] || "";
    if (f || l) return (f + l).toUpperCase();
    return (user.email || "U")[0].toUpperCase();
  }, [user, profile]);

  const [profileHover, setProfileHover] = React.useState(false);

  return (
    <div ref={ref} style={{ position: "relative", flexShrink: 0 }}>
      {/* Icon button */}
      <div
        role="button"
        aria-label="Profil"
        className={user ? "profile-btn" : "icon-sq-nohover"}
        onClick={handleOpen}
        onMouseEnter={() => { if (user) setProfileHover(true); }}
        onMouseLeave={() => { if (user) setProfileHover(false); }}
        style={{
          background: "#FFFFFF",
          borderRadius: 10, boxShadow: PILL_SHADOW,
          width: 42, height: 42,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", transition: "background 0.4s ease",
        }}
      >
        {user ? (
          <span className="profile-initials" style={{
            fontFamily: SF, fontSize: 13, fontWeight: 800,
            color: BLUE, letterSpacing: "-0.01em",
            transition: "color 0.4s ease", pointerEvents: "none",
          }}>{initials}</span>
        ) : (
          <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
            <path d="M10.957 21.9141C12.4538 21.9141 13.861 21.6276 15.1787 21.0547C16.5036 20.4818 17.6709 19.6904 18.6807 18.6807C19.6904 17.6709 20.4818 16.5072 21.0547 15.1895C21.6276 13.8646 21.9141 12.4538 21.9141 10.957C21.9141 9.46029 21.6276 8.05306 21.0547 6.73535C20.4818 5.41048 19.6904 4.24316 18.6807 3.2334C17.6709 2.22363 16.5036 1.43229 15.1787 0.859375C13.8538 0.286458 12.443 0 10.9463 0C9.44954 0 8.03874 0.286458 6.71387 0.859375C5.39616 1.43229 4.23242 2.22363 3.22266 3.2334C2.22005 4.24316 1.43229 5.41048 0.859375 6.73535C0.286458 8.05306 0 9.46029 0 10.957C0 12.4538 0.286458 13.8646 0.859375 15.1895C1.43229 16.5072 2.22363 17.6709 3.2334 18.6807C4.24316 19.6904 5.4069 20.4818 6.72461 21.0547C8.04948 21.6276 9.46029 21.9141 10.957 21.9141ZM10.957 20.0879C9.68945 20.0879 8.50423 19.8516 7.40137 19.3789C6.2985 18.9062 5.32812 18.2546 4.49023 17.4238C3.65951 16.5859 3.00781 15.6156 2.53516 14.5127C2.06966 13.4098 1.83691 12.2246 1.83691 10.957C1.83691 9.68945 2.06966 8.50423 2.53516 7.40137C3.00781 6.2985 3.65951 5.32812 4.49023 4.49023C5.32096 3.65234 6.28776 3.00065 7.39062 2.53516C8.49349 2.0625 9.67871 1.82617 10.9463 1.82617C12.2139 1.82617 13.3991 2.0625 14.502 2.53516C15.6048 3.00065 16.5752 3.65234 17.4131 4.49023C18.251 5.32812 18.9062 6.2985 19.3789 7.40137C19.8516 8.50423 20.0879 9.68945 20.0879 10.957C20.0879 12.2246 19.8516 13.4098 19.3789 14.5127C18.9134 15.6156 18.2617 16.5859 17.4238 17.4238C16.5931 18.2546 15.6227 18.9062 14.5127 19.3789C13.4098 19.8516 12.2246 20.0879 10.957 20.0879ZM18.3047 18.0361L18.2725 17.918C18.0934 17.388 17.6745 16.8688 17.0156 16.3604C16.3639 15.8519 15.5189 15.4329 14.4805 15.1035C13.4492 14.7741 12.2747 14.6094 10.957 14.6094C9.64648 14.6094 8.47201 14.7741 7.43359 15.1035C6.40234 15.4329 5.55729 15.8519 4.89844 16.3604C4.23958 16.8688 3.82064 17.3844 3.6416 17.9072L3.60938 18.0361C4.25391 18.6735 5.0166 19.2178 5.89746 19.6689C6.77832 20.1201 7.66634 20.4639 8.56152 20.7002C9.46387 20.9437 10.2624 21.0654 10.957 21.0654C11.6589 21.0654 12.4574 20.9437 13.3525 20.7002C14.2477 20.4639 15.1322 20.1201 16.0059 19.6689C16.8867 19.2178 17.653 18.6735 18.3047 18.0361ZM10.957 12.7832C11.6445 12.7904 12.2676 12.6185 12.8262 12.2676C13.3848 11.9095 13.8252 11.4225 14.1475 10.8066C14.4769 10.1908 14.6416 9.49967 14.6416 8.7334C14.6416 8.01009 14.4769 7.34766 14.1475 6.74609C13.818 6.14453 13.374 5.66471 12.8154 5.30664C12.264 4.94141 11.6445 4.75879 10.957 4.75879C10.2695 4.75879 9.64648 4.94141 9.08789 5.30664C8.5293 5.66471 8.08529 6.14453 7.75586 6.74609C7.42643 7.34766 7.2653 8.01009 7.27246 8.7334C7.27962 9.49967 7.44434 10.1872 7.7666 10.7959C8.09603 11.4046 8.53646 11.888 9.08789 12.2461C9.64648 12.597 10.2695 12.776 10.957 12.7832Z" fill="black"/>
          </svg>
        )}
      </div>

      {/* Dropdown panel - Portal da bude iznad svega */}
      {open && ReactDOM.createPortal(
        <div ref={portalRef} style={{
          position: "fixed", top: pos.top, right: pos.right,
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 4px 24px rgba(0,0,0,0.14), 0 1px 4px rgba(0,0,0,0.06)",
          padding: "8px",
          zIndex: 99999,
          minWidth: 180,
          animation: "fadeInDown 0.15s ease",
        }}>
          {user ? (
            /* LOGGED IN menu */
            <>
              <div style={{padding:"8px 12px 6px",fontFamily:SF,fontSize:11,fontWeight:600,color:"#bbb",letterSpacing:"0.04em",textTransform:"uppercase"}}>
                {user.email}
              </div>
              <div style={{height:1,background:"#f0f0f0",margin:"4px 0"}}/>
              <button
                onClick={() => { setOpen(false); onPageOpen && onPageOpen("profile"); }}
                style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",border:"none",borderRadius:10,background:"transparent",cursor:"pointer",fontFamily:SF,fontSize:13,fontWeight:500,color:"#111",letterSpacing:"-0.02em",textAlign:"left",transition:"background 0.4s ease"}}
                onMouseEnter={e=>e.currentTarget.style.background=`rgba(0,121,255,0.07)`}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                Moj profil
              </button>
              <div style={{height:1,background:"#f0f0f0",margin:"4px 0"}}/>
              <button
                onClick={handleLogout}
                style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",border:"none",borderRadius:10,background:"transparent",cursor:"pointer",fontFamily:SF,fontSize:13,fontWeight:500,color:"#e00",letterSpacing:"-0.02em",textAlign:"left",transition:"background 0.4s ease"}}
                onMouseEnter={e=>e.currentTarget.style.background="rgba(220,0,0,0.06)"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#e00" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Odjavite se
              </button>
            </>
          ) : (
            /* LOGGED OUT menu */
            <>
              <button
                onClick={() => { setOpen(false); onPageOpen && onPageOpen("profile", "login"); }}
                style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",border:"none",borderRadius:10,background:"transparent",cursor:"pointer",fontFamily:SF,fontSize:13,fontWeight:500,color:"#111",letterSpacing:"-0.02em",textAlign:"left",transition:"background 0.4s ease"}}
                onMouseEnter={e=>e.currentTarget.style.background=`rgba(0,121,255,0.07)`}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{display:"block",flexShrink:0}}>
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
                Prijavite se
              </button>
              <div style={{ height: 1, background: "#f0f0f0", margin: "4px 0" }} />
              <button
                onClick={() => { setOpen(false); onPageOpen && onPageOpen("profile", "register"); }}
                style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",border:"none",borderRadius:10,background:"transparent",cursor:"pointer",fontFamily:SF,fontSize:13,fontWeight:500,color:"#111",letterSpacing:"-0.02em",textAlign:"left",transition:"background 0.4s ease"}}
                onMouseEnter={e=>e.currentTarget.style.background=`rgba(0,121,255,0.07)`}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{display:"block",flexShrink:0}}>
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
                </svg>
                Registrujte se
              </button>
            </>
          )}
        </div>,
        document.body
      )}
    </div>
  );
}


// Inline search results za mobile drawer
function DrawerSearchResults({ onClose, onPageOpen }) {
  const [results, setResults] = useState([]);
  const [hasQuery, setHasQuery] = useState(false);
  const { biznisi, loading: biznisiLoading } = useSupabase();

  const PAGES = [
    { name:"Popularne recenzije", page:"recenzije" },
    { name:"Ocenite lokal",       page:"oceni"      },
    { name:"Dodajte vaš biznis",  page:"dodaj-biznis"},
    { name:"Kontaktirajte nas",   page:"kontakt"    },
    { name:"Blog",                page:"blog"       },
    { name:"Noćni klubovi",       page:"nocni-klubovi"},
    { name:"Pivnice i pubovi",    page:"pivnice"    },
    { name:"Jazz kafići",         page:"kokteli-barovi"},
  ];
  const CAT_C = CAT_COLORS;

  useEffect(() => {
    window.__nsDrawerSearch = (q) => {
      if (!q || q.trim().length === 0) { setResults([]); setHasQuery(false); return; }
      setHasQuery(true);
      // Ime biznisa ima prioritet nad kategorijom/potkategorijom (isti razlog kao u SearchIcon).
      const qNorm = normalizeSearch(q);
      const nameMatches = (biznisi||[]).filter(b=>searchMatch(b.name,q));
      nameMatches.sort((a,b) => {
        const na = normalizeSearch(a.name), nb = normalizeSearch(b.name);
        const rank = (n) => n === qNorm ? 0 : n.startsWith(qNorm) ? 1 : 2;
        return rank(na) - rank(nb);
      });
      const catMatches = (biznisi||[]).filter(b => !searchMatch(b.name,q) && (searchMatch(allCategoriesOf(b).join(" "),q)||searchMatch(b.subcategory,q)));
      const bizR = [...nameMatches, ...catMatches].slice(0,4).map(b=>({kind:"biz",biz:b}));
      const pageR = PAGES.filter(p=>searchMatch(p.name,q)||searchMatch(p.desc,q)).slice(0,3).map(p=>({kind:"page",...p}));
      setResults([...bizR,...pageR].slice(0,6));
    };
    return () => { delete window.__nsDrawerSearch; };
  }, [biznisi]); // eslint-disable-line

  if (!hasQuery) return null;

  if (results.length === 0 && biznisiLoading) {
    return <div style={{ borderTop:"1px solid #ebebeb" }}><LoadingState label="Učitavanje podataka..." minHeight={80} size={22} /></div>;
  }
  if (results.length === 0) {
    return (
      <div style={{ borderTop:"1px solid #ebebeb", padding:"14px 14px 10px", fontFamily:SF, fontSize:13, color:"#aaa", textAlign:"center" }}>
        Nema rezultata
      </div>
    );
  }

  return (
    <div style={{ borderTop:"1px solid #ebebeb", padding:"4px 0 6px" }}>
      {results.map((item, i) => {
        const col = item.kind==="biz" ? (CAT_C[item.biz?.category]||BLUE) : BLUE;
        const label = item.kind==="biz" ? item.biz.name : item.name;
        const sub   = item.kind==="biz" ? allCategoriesOf(item.biz).join(" · ") : "Stranica";
        return (
          <div key={i}
            onClick={() => {
              if (item.kind==="biz" && window.__nsNav) window.__nsNav.openBiz(item.biz);
              else if (item.kind==="page") { if (onPageOpen) onPageOpen(item.page); }
              setResults([]);
              setHasQuery(false);
              onClose();
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if (item.kind==="biz" && window.__nsNav) window.__nsNav.openBiz(item.biz);
              else if (item.kind==="page") { if (onPageOpen) onPageOpen(item.page); }
              setResults([]);
              setHasQuery(false);
              onClose();
            } }}
            style={{ display:"flex", alignItems:"center", gap:10, padding:"9px 14px", cursor:"pointer" }}
            onMouseEnter={e=>e.currentTarget.style.background="#ebebeb"}
            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{ width:28, height:28, borderRadius:8, background:`${col}18`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <MapPin size={12} color={col} />
            </div>
            <div>
              <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111" }}>{label}</div>
              <div style={{ fontFamily:SF, fontSize:11, color:"#aaa" }}>{sub}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function MobileDrawerFavorites({ onPageOpen, onClose }) {
  const { favIds, toggle, blogSlugs, toggleBlog } = useFavorites();
  const { biznisi } = useSupabase();
  const { user } = useAuthContext();
  const [favOpen, setFavOpen] = useState(false);

  const favBiznisi = React.useMemo(() => {
    if (!biznisi || favIds.length === 0) return [];
    return biznisi.filter(b => favIds.includes(Number(b.id)));
  }, [biznisi, favIds]);
  // Sačuvani blogovi (naslovi iz blogData.json), najnoviji sačuvan prvi
  const favBlogs = React.useMemo(
    () => blogSlugs.map(s => BLOG_POSTS.find(p => p.slug === s)).filter(Boolean),
    [blogSlugs]
  );
  const totalSaved = favIds.length + favBlogs.length;
  const sectionLabel = { padding:"10px 14px 4px", fontFamily:SF, fontSize:11, fontWeight:700, color:"#aaa", textTransform:"uppercase", letterSpacing:"0.06em" };
  const trashIcon = (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e00" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
    </svg>
  );

  const CAT_C = CAT_COLORS;

  return (
    <div>
      <div
        onClick={() => {
          if (!user) { onClose(); onPageOpen && onPageOpen("profile", "login"); return; }
          setFavOpen(o => !o);
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (!user) { onClose(); onPageOpen && onPageOpen("profile", "login"); return; }
          setFavOpen(o => !o);
        } }}
        style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", borderRadius:10, background:"#f5f5f5", cursor:"pointer" }}
      >
        <svg width="17" height="17" viewBox="0 0 24 23" fill={BLUE} stroke="none">
          <path d={STAR_PATH}/>
        </svg>
        <span style={{ fontSize:13, fontWeight:500, color:"#111", fontFamily:SF }}>Sačuvani lokali i blogovi</span>
        {totalSaved > 0 ? (
          <span style={{ marginLeft:"auto", background:BLUE, color:"#fff", borderRadius:999, minWidth:20, height:20, padding:"0 6px", fontSize:11, fontWeight:700, fontFamily:SF, display:"flex", alignItems:"center", justifyContent:"center", lineHeight:1 }}>
            {totalSaved}
          </span>
        ) : !user ? (
          <span style={{ marginLeft:"auto", fontSize:11, color:"#bbb", fontFamily:SF }}>Prijavite se</span>
        ) : (
          <span style={{ marginLeft:"auto", fontSize:11, color:"#bbb", fontFamily:SF }}>0</span>
        )}
      </div>

      {/* Expandovana lista */}
      {favOpen && (
        <div style={{ marginTop:4, borderRadius:10, background:"#fafafa", overflow:"hidden" }}>
          {totalSaved === 0 && (
            <div style={{ padding:"12px 14px", fontSize:12, color:"#aaa", fontFamily:SF }}>
              Nemate sačuvanih lokala ni blogova
            </div>
          )}
          {favBiznisi.length > 0 && favBlogs.length > 0 && <div style={sectionLabel}>Lokali</div>}
          {favBiznisi.map((biz, i) => (
            <div key={i}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderBottom: i < favBiznisi.length-1 ? "1px solid #eee" : "none" }}
            >
              <div onClick={() => { onClose(); if (window.__nsNav) window.__nsNav.openBiz(biz); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClose(); if (window.__nsNav) window.__nsNav.openBiz(biz); } }}
                style={{ display:"flex", alignItems:"center", gap:10, flex:1, minWidth:0, cursor:"pointer" }}>
                <MapPin size={14} color={CAT_C[biz.category] || BLUE} />
                <div>
                  <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111" }}>{biz.name}</div>
                  <div style={{ fontFamily:SF, fontSize:11, color:"#999" }}>{biz.category}</div>
                </div>
              </div>
              <button
                onClick={() => toggle(biz)}
                title="Ukloni"
                style={{ background:"transparent", border:"none", cursor:"pointer", padding:6, flexShrink:0, opacity:0.4 }}
                onMouseEnter={e => e.currentTarget.style.opacity="1"}
                onMouseLeave={e => e.currentTarget.style.opacity="0.4"}
              >
                {trashIcon}
              </button>
            </div>
          ))}
          {favBlogs.length > 0 && favBiznisi.length > 0 && <div style={{ ...sectionLabel, borderTop:"1px solid #eee" }}>Blogovi</div>}
          {favBlogs.map((post, i) => (
            <div key={post.slug}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderBottom: i < favBlogs.length-1 ? "1px solid #eee" : "none" }}
            >
              <div onClick={() => { onClose(); onPageOpen && onPageOpen(`blog/${post.slug}`); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClose(); onPageOpen && onPageOpen(`blog/${post.slug}`); } }}
                style={{ display:"flex", alignItems:"center", gap:10, flex:1, minWidth:0, cursor:"pointer" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0 }}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontFamily:SF, fontSize:13, fontWeight:600, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{post.title}</div>
                  <div style={{ fontFamily:SF, fontSize:11, color:"#999" }}>{post.category} · {post.readMin} min</div>
                </div>
              </div>
              <button
                onClick={() => toggleBlog(post.slug)}
                title="Ukloni"
                style={{ background:"transparent", border:"none", cursor:"pointer", padding:6, flexShrink:0, opacity:0.4 }}
              >
                {trashIcon}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


function Navbar({ onCategorySelect, onPageOpen, transparentMobile = false, isFixed = false, isOnHome = false, introPhase = "done", introAnimReady = true }) {
  const { isDesktop, w, isMobile } = useBreakpoint();
  const [drawerOpen, setDrawerOpen]     = useState(false);
  useScrollLock(drawerOpen);
  const [activeMenu, setActiveMenu]     = useState(null);
  const [mobileOpen, setMobileOpen]     = useState(null);
  const [searchOpen, setSearchOpen]     = useState(false);
  const [scrolled, setScrolled]         = useState(false);
  const closeTimer = useRef(null);
  const navWrapRef = useRef(null);
  const pillRef    = useRef(null);
  const [pillWidth, setPillWidth] = useState(0);
  const [dropdownPos, setDropdownPos] = useState({ top: 62, left: 760 });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 0.85);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Ove moraju biti pre useEffect-a
  const showPill    = w >= 1150;
  const isCompact   = w < 1400; // ispod 1400px koristimo kompaktni meni
  const activeNavLinks  = isCompact ? navLinksCompact : navLinks;
  const activeMegaMenu  = isCompact ? megaMenuDataCompact : megaMenuData;
  const navFontSize = w >= 1600 ? 13 : w >= 1440 ? 12 : w >= 1400 ? 11.5 : 11;
  const navPadding  = w >= 1600 ? "7px 10px" : w >= 1440 ? "6px 8px" : w >= 1400 ? "5px 7px" : "5px 5px";

  // Mjeri širinu pilla i ažurira je pri promjeni veličine
  useEffect(() => {
    const measure = () => {
      if (pillRef.current) setPillWidth(pillRef.current.offsetWidth);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [showPill]);

  /* -- Desktop hover logic -- */
  const handleLinkEnter = (label) => {
    clearTimeout(closeTimer.current);
    if (activeMegaMenu[label]) {
      if (pillRef.current) {
        const r = pillRef.current.getBoundingClientRect();
        setDropdownPos({ top: r.bottom + 8, left: r.left + r.width / 2 });
      }
      setActiveMenu(label);
    } else {
      setActiveMenu(null);
    }
  };
  const handleWrapLeave = () => {
    closeTimer.current = setTimeout(() => setActiveMenu(null), 150);
  };
  const handleWrapEnter = () => { clearTimeout(closeTimer.current); };

  const isOpen = !!(activeMenu && activeMegaMenu[activeMenu]);
  const activeData = isOpen ? activeMegaMenu[activeMenu] : null;

  /* -- Mobile accordion toggle -- */
  const toggleMobile = (label) => {
    setMobileOpen(prev => (activeMegaMenu[label] ? (prev === label ? null : label) : null));
  };

  return (
    <>
      <style>{`
        @keyframes slideIn { from { transform: translateX(100%) } to { transform: translateX(0) } }
        @keyframes fadeInDown { from { opacity:0; transform:translateY(-6px) } to { opacity:1; transform:translateY(0) } }
        .nav-link-btn:hover { background: rgba(0,0,0,0.06) !important; }
        .nav-link-btn:hover span { color: #0079FF !important; }
        .icon-sq:hover { background: #f4f4f4 !important; }
        .icon-sq-nohover:hover { background: #FFFFFF !important; }
        .profile-btn:hover { background: #0079FF !important; }
        .profile-btn:hover .profile-initials { color: #fff !important; }
        /* iOS zoom fix - samo na touch uređajima, sprečava auto-zoom pri fokusu */
        @media (hover: none) and (pointer: coarse) {
          input, textarea, select {
            font-size: 16px !important;
            -webkit-text-size-adjust: 100%;
          }
        }
        .mega-item { transition: background 0.4s ease; }
        .mega-item:hover { background: rgba(0,121,255,0.07) !important; }
        .mega-item:hover .mega-title { color: #0079FF !important; }
        .mega-title { transition: color 0.4s ease; }
        .nav-chevron { transition: transform 0.25s ease; display: inline-flex; }
        .nav-chevron.open { transform: rotate(-180deg); }
        /* stronger shadows on homepage over dark video */
        #ns-navbar.na-home [data-icon-pill] {
          box-shadow: 0 4px 24px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.14) !important;
        }
        .nav-link-btn { transition: background 0.4s ease; }
        .nav-link-btn:hover { background: rgba(0,0,0,0.05); }
        /* content cross-fade inside the always-mounted panel */
        .mega-content { transition: opacity 0.15s ease; }
        .mega-content.fading { opacity: 0; }
      `}</style>

      <nav id="ns-navbar" className={isOnHome ? "na-home" : ""} style={{
        fontFamily: SF, letterSpacing: "-0.01em",
        background: "transparent",
        position: "absolute",
        top: 0, left: 0, right: 0,
        zIndex: 9000,
        padding: "14px 20px",
        display: "flex", alignItems: "center",
        minHeight: 62,
        width: "100%",
        boxSizing: "border-box",
        opacity: introAnimReady ? 1 : 0,
        transform: introAnimReady ? "translateY(0)" : "translateY(-16px)",
        transition: "opacity 0.75s cubic-bezier(0.16,1,0.3,1), transform 0.75s cubic-bezier(0.16,1,0.3,1)",
      }}>

        {/* LEFT: Logo */}
        <a
          href="/"
          onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); onCategorySelect && onCategorySelect(null); }}
          style={{
            background: "#FFFFFF", borderRadius: 10, boxShadow: isOnHome ? PILL_SHADOW_STRONG : PILL_SHADOW,
            padding: w < 280 ? "0" : "11px 20px",
            width: w < 280 ? 42 : "auto",
            height: w < 280 ? 42 : "auto",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0, flexGrow: 0,
            whiteSpace: "nowrap",
            textDecoration: "none",
          }}
        >
          <span style={{ fontWeight: 700, fontSize: w < 280 ? 13 : 13, letterSpacing: "-0.02em", color: "#111" }}>
            {w < 280 ? "NS" : "Novosadski Adresar"}
          </span>
        </a>

        {/* CENTER: Nav pill - flex grow, ne position absolute */}
        {showPill && (
          <div
            ref={navWrapRef}
            onMouseEnter={handleWrapEnter}
            onMouseLeave={handleWrapLeave}
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              justifyContent: "center",
              zIndex: 10,
              pointerEvents: "auto",
            }}
          >
            <div ref={pillRef} style={{
              background: "#FFFFFF", borderRadius: 10, boxShadow: isOnHome ? PILL_SHADOW_STRONG : PILL_SHADOW,
              padding: "0 4px", height: 42, display: "flex", alignItems: "center", gap: 0,
              overflow: "hidden",
              maxWidth: "100%",
            }}>
              {activeNavLinks.map((item, i) => (
                <a key={i} className="nav-link-btn"
                  href={item.label === "Blog" ? "/blog" : item.label === "Profil" ? "/profil" : categoryPath(item.label)}
                  onMouseEnter={() => handleLinkEnter(item.label)}
                  onClick={(e) => {
                    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                    e.preventDefault();
                    if (item.label === "Blog") { onPageOpen && onPageOpen("blog"); }
                    else if (item.label === "Profil") { onPageOpen && onPageOpen("profile"); }
                    else { onCategorySelect && onCategorySelect(item.label); }
                  }}
                  style={{
                    display: "flex", alignItems: "center", gap: 2,
                    padding: navPadding, cursor: "pointer", borderRadius: 8,
                    transition: "background 0.4s ease", background: "transparent",
                    flexShrink: 0, textDecoration: "none",
                  }}
                >
                  <span style={{
                    fontSize: navFontSize,
                    color: activeMenu === item.label ? BLUE : "#111",
                    fontWeight: 500, whiteSpace: "nowrap", letterSpacing: "-0.01em",
                    transition: "color 0.4s ease",
                  }}>
                    {item.label}
                  </span>
                  {item.chevron && (
                    <ChevronDown size={10} color={activeMenu === item.label ? BLUE : "#888"} strokeWidth={2.5}
                      className={`nav-chevron${activeMenu === item.label ? " open" : ""}`} />
                  )}
                </a>
              ))}
            </div>

            {/* Mega dropdown - portal na body, izlazi iz overlay stacking contexta */}
            {ReactDOM.createPortal(
            <div
              onMouseEnter={handleWrapEnter}
              onMouseLeave={handleWrapLeave}
              style={{
              position: "fixed",
              top: dropdownPos.top,
              left: dropdownPos.left,
              transform: isOpen ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(-8px)",
              width: pillWidth > 0 ? pillWidth : "min(780px, calc(100vw - 320px))",
              background: "rgba(255,255,255,0.97)",
              backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
              borderRadius: 20,
              boxShadow: "0 20px 60px rgba(0,0,0,0.12), 0 4px 16px rgba(0,0,0,0.06)",
              padding: "20px 24px 18px", zIndex: 99999,
              opacity: isOpen ? 1 : 0,
              pointerEvents: isOpen ? "all" : "none",
              transition: "opacity 0.18s ease, transform 0.18s ease",
            }}>
              <div style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: "0.07em", color: "#aaa", textTransform: "uppercase", marginBottom: 14, paddingLeft: 4 }}>
                {activeMenu || " "}
              </div>

              {/* Kombinovani meni (Usluge = Nega + Auto + Zanati) - vertikalno */}
              {activeData?.__combined ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  {activeData.kolone.map((kolona, ki) => (
                    <div key={ki}>
                      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", color: BLUE, textTransform: "uppercase", marginBottom: 6, paddingLeft: 14 , whiteSpace: "nowrap"}}>
                        {kolona.naslov}
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
                        {kolona.items.map((item, idx) => (
                          <a key={idx} className="mega-item"
                            href={categoryPath(kolona.kat, item.title)}
                            onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(kolona.kat, item.title); }}
                            style={{ padding: "8px 14px", borderRadius: 12, cursor: "pointer", display: "block", textDecoration: "none" }}
                          >
                            <div className="mega-title" style={{ fontSize: 12, fontWeight: 600, color: "#111", letterSpacing: "-0.01em", marginBottom: 2 }}>{item.title}</div>
                            <div style={{ fontSize: 11, color: "#999", lineHeight: 1.4 }}>{item.sub}</div>
                          </a>
                        ))}
                      </div>
                      {ki < activeData.kolone.length - 1 && (
                        <div style={{ height: 1, background: "#f0f0f0", marginTop: 12 }} />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                /* Normalni meni */
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 4 }}>
                  {(activeData || []).map((item, idx) => (
                    <a key={idx} className="mega-item"
                      href={categoryPath(activeMenu, item.title)}
                      onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(activeMenu, item.title); }}
                      style={{ padding: "10px 14px", borderRadius: 12, cursor: "pointer", background: "transparent", display: "block", textDecoration: "none" }}
                    >
                      <div className="mega-title" style={{ fontSize: 13, fontWeight: 600, color: "#111", letterSpacing: "-0.01em", marginBottom: 3 }}>{item.title}</div>
                      <div style={{ fontSize: 11.5, fontWeight: 400, color: "#999", letterSpacing: "-0.01em", lineHeight: 1.45 }}>{item.sub}</div>
                    </a>
                  ))}
                </div>
              )}
            </div>
            , document.body)}
          </div>
        )}

        {/* RIGHT: Icons group  -  marginLeft:auto pins to far right */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto", flexShrink: 0 }}>
          {isDesktop ? (
            <>
              <FavoritesIcon onPageOpen={onPageOpen} />
              <ProfileDropdown onPageOpen={onPageOpen} />
              <SearchIcon onExpand={() => setSearchOpen(true)} onCollapse={() => setSearchOpen(false)} />
              {/* Hamburger na ekranima 1024-1279px */}
              {!showPill && (
                <button aria-label="Otvori meni" className="ns-icon-pill" onClick={() => setDrawerOpen(true)} style={{ ...iconPill, border: "none", flexShrink: 0 }}>
                  <Menu size={18} color="#333" />
                </button>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <ProfileDropdown onPageOpen={onPageOpen} />
              <button aria-label="Otvori meni" className="ns-icon-pill" onClick={() => setDrawerOpen(true)} style={{ ...iconPill, border: "none", flexShrink: 0 }}>
                <Menu size={18} color="#333" />
              </button>
            </div>
          )}
        </div>

      </nav>


      {/* MOBILE DRAWER with accordion sub-menus */}
      {drawerOpen && (
        <div onClick={() => setDrawerOpen(false)} style={{
          position: "fixed", inset: 0, zIndex: 99999,
          background: "rgba(0,0,0,0.45)", display: "flex", justifyContent: "flex-end",
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", width: "min(320px, 90vw)", height: "100%",
            padding: "24px 20px", display: "flex", flexDirection: "column",
            fontFamily: SF, letterSpacing: "-0.01em", overflowY: "auto",
            animation: "slideIn 0.22s ease",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
              <span style={{ fontWeight: 700, fontSize: 14, letterSpacing: "-0.02em" }}>Novosadski Adresar</span>
              <button aria-label="Zatvori meni" onClick={() => setDrawerOpen(false)} style={{
                background: "#f4f4f4", border: "none", borderRadius: 8,
                width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
              }}>
                <X size={16} color="#333" />
              </button>
            </div>

            {/* Accordion nav links */}
            <div style={{ display: "flex", flexDirection: "column", gap: 2, marginBottom: 24 }}>
              {/* Recenzije postoje samo u meniju na telefonu (na računaru je link u sekciji recenzija) */}
              {[...activeNavLinks, { label: "Recenzije", chevron: false }].map((item, i) => {
                const hasMenu = !!activeMegaMenu[item.label];
                const isCategory = !!categoryMeta[item.label];
                const expanded = mobileOpen === item.label;
                const pageLink = { Blog: "blog", Recenzije: "recenzije" }[item.label];
                return (
                  <div key={i}>
                    <a
                      href={pageLink ? "/" + pageLink : categoryPath(item.label)}
                      onClick={(e) => {
                        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                        e.preventDefault();
                        if (pageLink) {
                          if (onPageOpen) onPageOpen(pageLink);
                          setDrawerOpen(false);
                        } else if (hasMenu || isCategory) {
                          // I kategorije i meni stavke - otvori accordion
                          toggleMobile(item.label);
                        } else {
                          if (onCategorySelect) onCategorySelect(item.label);
                          setDrawerOpen(false);
                        }
                      }}
                      style={{
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                        padding: "14px 12px", borderRadius: 10, cursor: "pointer",
                        background: expanded ? "#f0f4ff" : "transparent",
                        transition: "background 0.4s ease",
                        minHeight: 48, textDecoration: "none",
                      }}
                    >
                      <span style={{ fontSize: 14, color: expanded ? BLUE : "#111", fontWeight: 500 }}>
                        {item.label}
                      </span>
                      {!pageLink && (
                        <ChevronDown
                          size={14}
                          color={expanded ? BLUE : "#aaa"}
                          style={{ transform: expanded ? "rotate(-180deg)" : "rotate(0)", transition: "transform 0.25s ease" }}
                        />
                      )}
                    </a>
                    {/* Accordion body - za kategorije I meni stavke */}
                    {expanded && (() => {
                      const menuData = activeMegaMenu[item.label];

                      // Kategorija bez mega menija - prikaži podkategorije iz megaMenuData
                      const subItems = menuData
                        ? (menuData.__combined ? null : menuData)
                        : (megaMenuData[item.label] || null);

                      // __combined (Usluge) - kolone
                      if (menuData && menuData.__combined) {
                        return (
                          <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "4px 8px 8px", marginTop: 2, background: "#fafafa", borderRadius: 10 }}>
                            {menuData.kolone.map((kolona, ki) => (
                              <div key={ki}>
                                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", color: BLUE, textTransform: "uppercase", padding: "6px 12px 4px" , whiteSpace: "nowrap"}}>
                                  {kolona.naslov}
                                </div>
                                {/* "Svi [naziv]" */}
                                <a
                                  href={categoryPath(kolona.kat)}
                                  onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(kolona.kat); setDrawerOpen(false); }}
                                  style={{ padding: "9px 12px", borderRadius: 8, cursor: "pointer", minHeight: 40, display: "block", textDecoration: "none" }}
                                  onMouseEnter={e => e.currentTarget.style.background = "#eef0f8"}
                                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                >
                                  <div style={{ fontSize: 13, fontWeight: 700, color: BLUE, letterSpacing: "-0.01em" , whiteSpace: "nowrap"}}>Svi {kolona.naslov.toLowerCase()}</div>
                                </a>
                                {kolona.items.map((sub, si) => (
                                  <a key={si}
                                    href={categoryPath(kolona.kat, sub.title)}
                                    onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(kolona.kat, sub.title); setDrawerOpen(false); }}
                                    style={{ padding: "9px 12px", borderRadius: 8, cursor: "pointer", minHeight: 40, display: "block", textDecoration: "none" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#eef0f8"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                  >
                                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", letterSpacing: "-0.01em" }}>{sub.title}</div>
                                    <div style={{ fontSize: 11.5, color: "#888", marginTop: 1, letterSpacing: "-0.01em" }}>{sub.sub}</div>
                                  </a>
                                ))}
                                {ki < menuData.kolone.length - 1 && <div style={{ height: 1, background: "#eee", margin: "4px 12px" }} />}
                              </div>
                            ))}
                          </div>
                        );
                      }

                      // Normalni meni ili kategorija sa podkategorijama
                      if (subItems && subItems.length > 0) {
                        return (
                          <div style={{ display: "flex", flexDirection: "column", gap: 2, padding: "4px 8px 8px", marginTop: 2, background: "#fafafa", borderRadius: 10 }}>
                            {/* "Svi [kategorija]" na vrhu */}
                            <a
                              href={categoryPath(item.label)}
                              onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(item.label); setDrawerOpen(false); }}
                              style={{ padding: "10px 12px", borderRadius: 8, cursor: "pointer", minHeight: 44, display: "block", textDecoration: "none" }}
                              onMouseEnter={e => e.currentTarget.style.background = "#eef0f8"}
                              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                            >
                              <div style={{ fontSize: 13, fontWeight: 700, color: BLUE, letterSpacing: "-0.01em" , whiteSpace: "nowrap"}}>Svi {item.label.toLowerCase()}</div>
                            </a>
                            <div style={{ height: 1, background: "#eee", margin: "0 12px 4px" }} />
                            {subItems.map((sub, si) => (
                              <a key={si}
                                href={categoryPath(item.label, sub.title)}
                                onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); if (onCategorySelect) onCategorySelect(item.label, sub.title); setDrawerOpen(false); }}
                                style={{ padding: "10px 12px", borderRadius: 8, cursor: "pointer", minHeight: 44, display: "block", textDecoration: "none" }}
                                onMouseEnter={e => e.currentTarget.style.background = "#eef0f8"}
                                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                              >
                                <div style={{ fontSize: 13, fontWeight: 600, color: "#111", letterSpacing: "-0.01em" }}>{sub.title}</div>
                                <div style={{ fontSize: 11.5, color: "#888", marginTop: 1, letterSpacing: "-0.01em" }}>{sub.sub}</div>
                              </a>
                            ))}
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>
                );
              })}
            </div>

            <div style={{ height: 1, background: "#eee", marginBottom: 20 }} />

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {/* Omiljeni - funkcionalan */}
              <MobileDrawerFavorites onPageOpen={onPageOpen} onClose={() => setDrawerOpen(false)} />
              {/* Nalog */}
              <div onClick={() => { if (onPageOpen) onPageOpen("profile"); setDrawerOpen(false); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); if (onPageOpen) onPageOpen("profile"); setDrawerOpen(false); } }}
                style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", borderRadius:10, background:"#f5f5f5", cursor:"pointer" }}>
                <svg width="17" height="17" viewBox="0 0 22 22" fill="none">
                  <path d="M10.957 21.9141C12.4538 21.9141 13.861 21.6276 15.1787 21.0547C16.5036 20.4818 17.6709 19.6904 18.6807 18.6807C19.6904 17.6709 20.4818 16.5072 21.0547 15.1895C21.6276 13.8646 21.9141 12.4538 21.9141 10.957C21.9141 9.46029 21.6276 8.05306 21.0547 6.73535C20.4818 5.41048 19.6904 4.24316 18.6807 3.2334C17.6709 2.22363 16.5036 1.43229 15.1787 0.859375C13.8538 0.286458 12.443 0 10.9463 0C9.44954 0 8.03874 0.286458 6.71387 0.859375C5.39616 1.43229 4.23242 2.22363 3.22266 3.2334C2.22005 4.24316 1.43229 5.41048 0.859375 6.73535C0.286458 8.05306 0 9.46029 0 10.957C0 12.4538 0.286458 13.8646 0.859375 15.1895C1.43229 16.5072 2.22363 17.6709 3.2334 18.6807C4.24316 19.6904 5.4069 20.4818 6.72461 21.0547C8.04948 21.6276 9.46029 21.9141 10.957 21.9141ZM10.957 20.0879C9.68945 20.0879 8.50423 19.8516 7.40137 19.3789C6.2985 18.9062 5.32812 18.2546 4.49023 17.4238C3.65951 16.5859 3.00781 15.6156 2.53516 14.5127C2.06966 13.4098 1.83691 12.2246 1.83691 10.957C1.83691 9.68945 2.06966 8.50423 2.53516 7.40137C3.00781 6.2985 3.65951 5.32812 4.49023 4.49023C5.32096 3.65234 6.28776 3.00065 7.39062 2.53516C8.49349 2.0625 9.67871 1.82617 10.9463 1.82617C12.2139 1.82617 13.3991 2.0625 14.502 2.53516C15.6048 3.00065 16.5752 3.65234 17.4131 4.49023C18.251 5.32812 18.9062 6.2985 19.3789 7.40137C19.8516 8.50423 20.0879 9.68945 20.0879 10.957C20.0879 12.2246 19.8516 13.4098 19.3789 14.5127C18.9134 15.6156 18.2617 16.5859 17.4238 17.4238C16.5931 18.2546 15.6227 18.9062 14.5127 19.3789C13.4098 19.8516 12.2246 20.0879 10.957 20.0879ZM18.3047 18.0361L18.2725 17.918C18.0934 17.388 17.6745 16.8688 17.0156 16.3604C16.3639 15.8519 15.5189 15.4329 14.4805 15.1035C13.4492 14.7741 12.2747 14.6094 10.957 14.6094C9.64648 14.6094 8.47201 14.7741 7.43359 15.1035C6.40234 15.4329 5.55729 15.8519 4.89844 16.3604C4.23958 16.8688 3.82064 17.3844 3.6416 17.9072L3.60938 18.0361C4.25391 18.6735 5.0166 19.2178 5.89746 19.6689C6.77832 20.1201 7.66634 20.4639 8.56152 20.7002C9.46387 20.9437 10.2624 21.0654 10.957 21.0654C11.6589 21.0654 12.4574 20.9437 13.3525 20.7002C14.2477 20.4639 15.1322 20.1201 16.0059 19.6689C16.8867 19.2178 17.653 18.6735 18.3047 18.0361ZM10.957 12.7832C11.6445 12.7904 12.2676 12.6185 12.8262 12.2676C13.3848 11.9095 13.8252 11.4225 14.1475 10.8066C14.4769 10.1908 14.6416 9.49967 14.6416 8.7334C14.6416 8.01009 14.4769 7.34766 14.1475 6.74609C13.818 6.14453 13.374 5.66471 12.8154 5.30664C12.264 4.94141 11.6445 4.75879 10.957 4.75879C10.2695 4.75879 9.64648 4.94141 9.08789 5.30664C8.5293 5.66471 8.08529 6.14453 7.75586 6.74609C7.42643 7.34766 7.2653 8.01009 7.27246 8.7334C7.27962 9.49967 7.44434 10.1872 7.7666 10.7959C8.09603 11.4046 8.53646 11.888 9.08789 12.2461C9.64648 12.597 10.2695 12.776 10.957 12.7832Z" fill={BLUE}/>
                </svg>
                <span style={{ fontSize:13, fontWeight:500, color:"#111", fontFamily:SF }}>Nalog</span>
              </div>
              {/* Pretraga - inline search input */}
              <div style={{ borderRadius:10, background:"#f5f5f5", overflow:"hidden" }}>
                <div style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px" }}>
                  <svg width="17" height="17" viewBox="0 0 21 22" fill="none" style={{ flexShrink:0 }}>
                    <path d="M0 8.572C0 9.754 0.222 10.864 0.666 11.902C1.11 12.934 1.726 13.843 2.514 14.631C3.301 15.419 4.211 16.035 5.243 16.479C6.281 16.923 7.391 17.145 8.572 17.145C9.56 17.145 10.506 16.98 11.41 16.651C12.32 16.322 13.148 15.843 13.893 15.214L19.329 20.65C19.508 20.829 19.733 20.918 20.006 20.918C20.263 20.918 20.482 20.826 20.661 20.64C20.847 20.454 20.94 20.228 20.94 19.963C20.94 19.705 20.851 19.483 20.672 19.297L15.258 13.872C15.937 13.113 16.459 12.263 16.824 11.323C17.189 10.383 17.371 9.396 17.371 8.362C17.371 7.181 17.149 6.074 16.705 5.042C16.261 4.004 15.645 3.094 14.857 2.314C14.069 1.526 13.159 0.91 12.127 0.466C11.095 0.022 9.988 -0.2 8.806 -0.2C7.624 -0.2 6.517 0.022 5.485 0.466C4.453 0.91 3.544 1.526 2.756 2.314C1.968 3.094 1.352 4.004 0.908 5.042C0.3 6.408 0 7.455 0 8.572ZM1.738 8.572C1.738 7.583 1.928 6.651 2.307 5.776C2.693 4.901 3.216 4.133 3.876 3.473C4.536 2.813 5.304 2.29 6.179 1.904C7.054 1.518 7.986 1.325 8.975 1.325C9.964 1.325 10.896 1.518 11.771 1.904C12.646 2.29 13.414 2.813 14.074 3.473C14.734 4.133 15.257 4.901 15.643 5.776C16.029 6.651 16.222 7.583 16.222 8.572C16.222 9.561 16.029 10.493 15.643 11.368C15.257 12.243 14.734 13.011 14.074 13.671C13.414 14.331 12.646 14.854 11.771 15.24C10.896 15.626 9.964 15.819 8.975 15.819C7.986 15.819 7.054 15.626 6.179 15.24C5.304 14.854 4.536 14.331 3.876 13.671C3.216 13.011 2.693 12.243 2.307 11.368C1.928 10.493 1.738 9.561 1.738 8.572Z" fill={BLUE}/>
                  </svg>
                  <input
                    id="ns-drawer-search"
                    placeholder="Pretražite..."
                    onChange={e => {
                      const q = e.target.value;
                      if (window.__nsDrawerSearch) window.__nsDrawerSearch(q);
                    }}
                    style={{ flex:1, border:"none", outline:"none", background:"transparent", fontFamily:SF, fontSize:14, color:"#111" }}
                  />
                  <style>{`#ns-drawer-search::placeholder { color: #888; }`}</style>
                </div>
                {/* Rezultati direktno u draweru */}
                <DrawerSearchResults onClose={() => setDrawerOpen(false)} onPageOpen={onPageOpen} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ==========================================
   HERO
========================================== */

// Static hero slides
const HERO_SLIDES_FALLBACK = [
  {
    title: "Restorani",
    category: "Restorani",
    desc: "Srpska kuhinja, mediteranski ukusi, azijski specijaliteti - sve što Novi Sad nudi na jednom mestu. Filtrirajte po lokaciji, oceni i tipu kuhinje. Nađite tačno ono što tražite, brzo i bez muke.",
    // Namerno NIJE webpack import kao ostale - ovo je prvi (uvek vidljiv)
    // slajd, pa mora da bude na stabilnoj putanji koju možemo unapred da
    // "preload"-ujemo u index.html (vidi <link rel="preload">), da browser
    // počne da je preuzima ODMAH, paralelno sa JS kodom, umesto da čeka da
    // se ceo sajt izvrši pre nego što uopšte sazna da ta slika postoji.
    img: process.env.PUBLIC_URL + "/hero-img-1.webp",
    mobilePosition: "center 40%",
    video: require("./novosadski-adresar-slike/restorani-hd.mp4"),
    videoMobile: require("./novosadski-adresar-slike/restorani-sd.mp4"),
    videoLite: require("./novosadski-adresar-slike/restorani-lite.mp4")
  },
  {
    title: "Kafići",
    category: "Kafići",
    desc: "Mirni kutci za rad, živahne terase za druženje, skriveni lokali koje vredi otkriti. Novosadski kafići su više od mesta za kafu - to su prostori koji postaju deo vaše rutine. Pronađite svoj omiljeni.",
    img: heroImg2,
    mobilePosition: "center 40%",
    video: require("./novosadski-adresar-slike/kafici-hd.mp4"),
    videoMobile: require("./novosadski-adresar-slike/kafici-sd.mp4"),
    videoLite: require("./novosadski-adresar-slike/kafici-lite.mp4")
  },
  {
    title: "Zanati",
    category: "Zanati",
    desc: "Stolari, krojači, zlatari, bravari - majstori koji rade po meri i stoje iza svakog posla. U svetu masovne proizvodnje, pravi zanat se prepoznaje na prvi pogled. Pronađite majstora kome možete da verujete.",
    img: heroImg3,
    mobilePosition: "center 40%",
    video: require("./novosadski-adresar-slike/zanati-hd.mp4"),
    videoMobile: require("./novosadski-adresar-slike/zanati-sd.mp4"),
    videoLite: require("./novosadski-adresar-slike/zanati-lite.mp4"),
    pageKey: "Zanati"
  },
];

// Hero image map - pick a background by category name
const HERO_IMG_BY_CAT = {
  "Restorani": heroImg1, "Kafići": heroImg2, "Zanati": heroImg3,
};
const HERO_IMG_DEFAULT = heroImg1;

// Build slides from live biznisi filtered to isPopular === true.
// Falls back to HERO_SLIDES_FALLBACK when no live data.
function buildHeroSlides(biznisi) {
  if (!biznisi) return HERO_SLIDES_FALLBACK;
  const popular = biznisi.filter(b => b.isPopular);
  if (popular.length === 0) return HERO_SLIDES_FALLBACK;
  const dynamicSlides = popular.map(b => ({
    title:    b.name,
    category: b.category,
    desc:     b.sub || b.category,
    img:      HERO_IMG_BY_CAT[b.category] || HERO_IMG_DEFAULT,
  }));
  // Uvek zadrži prvi slide (Restorani sa videom) na početku
  return [HERO_SLIDES_FALLBACK[0], ...dynamicSlides.filter(s => s.category !== "Restorani")];
}

// ── SCROLL LOCK HOOK - koristi se u svim modalima ──────────────────────────
function useScrollLock(active) {
  useEffect(() => {
    if (!active) return;
    const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = scrollbarW + "px";
    return () => {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    };
  }, [active]);
}

// ── MODAL PORTAL - renderuje van sekcija sa transform-om, backdrop radi ispravno
function Modal({ onClose, children, zIndex = 1000 }) {
  useScrollLock(true);
  return ReactDOM.createPortal(
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex,
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body
  );
}

// ── SCROLL REVEAL HOOK ──────────────────────────────────────────────────────
function useReveal() {
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
          obs.unobserve(e.target);
        }
      });
    // threshold 0: element se pojavi čim i najmanji deo uđe u ekran. Sa procentom
    // (npr. 0.05) dugački blokovi, kao tekst bloga, čekaju previše skrolovanja.
    }, { threshold: 0, rootMargin: "0px 0px -40px 0px" });

    // Pronađe i posmatra sve ".na-reveal" elemente koji još nisu otkriveni.
    // Bezbedno je zvati ovo više puta - već-posmatrani/već-vidljivi elementi
    // se ignorišu, tako da ne izaziva ponovni "flicker" postojećeg sadržaja.
    const scan = () => {
      document.querySelectorAll(".na-reveal:not(.visible)").forEach(el => obs.observe(el));
    };
    const timer = setTimeout(scan, 50);

    // Recenzije i slična asinhrona sadržaji se dodaju u DOM TEK kad stignu
    // sa servera - dešava se posle prvog mounta. MutationObserver hvata baš
    // te naknadno dodate ".na-reveal" elemente i otkriva ih, bez potrebe da
    // se ceo efekat ponovo pokreće na svaki render (što je ranije izazivalo
    // treperenje pri hover-u nad zvezdicama za ocenu).
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearTimeout(timer);
      mo.disconnect();
      obs.disconnect();
    };
  }, []);
}

// Hero snimci postoje u tri verzije: HD (desktop, ~1.5 MB), SD (telefon, ~0.8 MB)
// i "lite" (~0.33 MB, 480p) za slabu mrežu. Počinje se od verzije za uređaj; ako
// se ne učita na vreme, prelazi se na lite, a ako ni ona ne stigne, ostaju slike.
// Izbor važi do kraja posete (sessionStorage "ns_hero_tier"), jer browser ne
// prijavljuje uvek tačnu brzinu mreže.
function initialHeroTier() {
  try {
    const saved = sessionStorage.getItem("ns_hero_tier");
    if (saved === "lite" || saved === "off") return saved;
    const c = navigator.connection;
    if (c && c.saveData) return "off";
    if (c && /2g$/.test(c.effectiveType || "")) return "off";
    if (c && c.effectiveType === "3g") return "lite";
  } catch {}
  return "full";
}
const HERO_TIER_WAIT = { full: 4000, lite: 10000 };

function Hero({ onCategorySelect, onPageOpen, slides, isOnHome, videoAllowed, introPhase, introAnimReady }) {
  // Početna ostaje renderovana ispod svake druge stranice (biznis, kategorija,
  // kontakt...). Bez ovoga je SVAKA poseta bilo kojoj stranici skidala hero
  // video od ~4MB koji posetilac ne vidi, a pošto se slajdovi sami smenjuju,
  // vremenom i ostale video snimke. Video se zato učitava tek kad je
  // posetilac stvarno na početnoj (i ostaje učitan ako se kasnije vrati).
  const [videoEnabled, setVideoEnabled] = useState(false);
  useEffect(() => { if (videoAllowed) setVideoEnabled(true); }, [videoAllowed]);
  // Slika slajda je uvek ispod snimka. Snimak se pojavi preko nje tek kad ga
  // browser ima dovoljno da ga pusti bez zastajkivanja (canplaythrough), pa se
  // na sporoj mreži ne vidi crn ekran ni seckanje, nego slika.
  const [tier, setTier] = useState(initialHeroTier);
  const [videoReady, setVideoReady] = useState({});
  const videoReadyRef = useRef(videoReady);
  videoReadyRef.current = videoReady;
  const useVideo = videoEnabled && tier !== "off";
  const videoSrcFor = (slide) => tier === "lite" ? (slide.videoLite || slide.videoMobile || slide.video)
    : isMobile ? (slide.videoMobile || slide.video) : slide.video;
  const HERO_SLIDES = HERO_SLIDES_FALLBACK;
  const { isMobile, isTablet } = useBreakpoint();
  const [active, setActive] = useState(0);
  const [textVisible, setTextVisible] = useState(true);
  const titleSize = isMobile ? 54 : isTablet ? 68 : 108;
  const px        = isMobile ? 16 : 20;
  const videoRefs = useRef([]);
  // Linija napretka (desno) prati stvarni snimak: puni se po currentTime/duration,
  // a slajd se menja kad se snimak završi. Bez snimka (slike) slajd traje IMG_SLIDE_MS.
  const IMG_SLIDE_MS = 6000;
  const fillRef = useRef(null);
  const advancingRef = useRef(false);
  const advance = React.useCallback(() => {
    if (advancingRef.current) return;
    advancingRef.current = true;
    setTextVisible(false);
    setTimeout(() => {
      setActive(prev => (prev + 1) % HERO_SLIDES.length);
      setTextVisible(true);
      advancingRef.current = false;
    }, 280);
  }, [HERO_SLIDES.length]);

  // Robusno pokretanje videa - na mobilnom Safariju play() pozvan pre nego
  // sto je dovoljno podataka ubaferovano ume da tiho ne uradi nista i nema
  // vise nijednog eventa koji bi to sam ispravio (ostaje crn ekran dok
  // korisnik rucno ne promeni slajd). Zato probamo par puta zaredom.
  const ensurePlaying = React.useCallback((i) => {
    const el = videoRefs.current[i];
    if (!el || !HERO_SLIDES[i]?.video) return;
    el.muted = true;
    el.playsInline = true;
    let attempts = 0;
    const attempt = () => {
      const cur = videoRefs.current[i];
      if (!cur) return; // unmounted
      if (cur.paused) cur.play().catch(() => {});
      attempts += 1;
      if (attempts < 6 && cur.paused) setTimeout(attempt, 250 * attempts);
    };
    attempt();
  }, [HERO_SLIDES]);

  // bfcache fix - pauzira/nastavlja videe kada se menja vidljivost stranice
  React.useEffect(() => {
    const resumeActive = () => ensurePlaying(active);
    const pauseAll = () => {
      videoRefs.current.forEach(el => { if (el) el.pause(); });
    };

    const handlePageShow = (e) => {
      if (e.persisted) {
        videoRefs.current.forEach((el, i) => {
          if (!el) return;
          el.pause();
          if (i === active && HERO_SLIDES[i]?.video) {
            el.currentTime = 0;
          }
        });
        setTimeout(() => ensurePlaying(active), 150);
      }
    };

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        // Na mobilnom (izlazak iz browsera pa povratak) video ume da ostane
        // zamrznut na jednom kadru a da ga browser i dalje interno vodi kao
        // da svira (.paused ostaje false) - zato ga nasilno pauziramo pa
        // ponovo pokrećemo umesto da se oslanjamo na .paused proveru.
        const el = videoRefs.current[active];
        if (el && HERO_SLIDES[active]?.video) {
          el.pause();
          el.currentTime = el.currentTime; // nudge dekoder
        }
        resumeActive();
      }
      else pauseAll();
    };

    window.addEventListener("pageshow", handlePageShow);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [active, ensurePlaying]); // eslint-disable-line react-hooks/exhaustive-deps

  // Ako se snimak aktivnog slajda ne učita na vreme, prelazi se na lakšu
  // verziju (full -> lite -> samo slike), do kraja posete.
  useEffect(() => {
    if (!useVideo || !isOnHome || !HERO_SLIDES[active]?.video || videoReady[active]) return;
    const t = setTimeout(() => {
      const next = tier === "full" ? "lite" : "off";
      try { sessionStorage.setItem("ns_hero_tier", next); } catch {}
      setTier(next);
    }, HERO_TIER_WAIT[tier] || 6000);
    return () => clearTimeout(t);
  }, [useVideo, isOnHome, active, videoReady, tier]); // eslint-disable-line react-hooks/exhaustive-deps
  // Kad se snimci isključe, prekini preuzimanje koje je već počelo
  useEffect(() => {
    if (tier !== "off") return;
    videoRefs.current.forEach((el) => { if (el) { try { el.pause(); el.removeAttribute("src"); el.load(); } catch {} } });
  }, [tier]);

  const handleSlide = (i) => {
    if (i === active) return;
    setTextVisible(false);
    setTimeout(() => {
      setActive(i);
      setTextVisible(true);
    }, 280);
  };

  const introFiredRef = useRef(false);

  // Kad intro počne da se diže - odmah pusti video od 0
  useEffect(() => {
    if (introPhase !== "lifting" && introPhase !== "done") return;
    if (introFiredRef.current) return;
    introFiredRef.current = true;
    const el = videoRefs.current[active];
    if (el && HERO_SLIDES[active]?.video) {
      el.currentTime = 0;
    }
    ensurePlaying(active);
  }, [introPhase, ensurePlaying]); // eslint-disable-line react-hooks/exhaustive-deps

  // Kad se promeni slide - restartuj video (preskoci prvi put jer intro to radi)
  useEffect(() => {
    if (introPhase !== "lifting" && introPhase !== "done") return;
    if (!introFiredRef.current) return; // intro još nije krenuo
    HERO_SLIDES.forEach((slide, i) => {
      const el = videoRefs.current[i];
      if (!el) return;
      if (i === active && slide.video) {
        el.currentTime = 0;
      } else {
        el.pause();
      }
    });
    ensurePlaying(active);
  }, [active, ensurePlaying]); // eslint-disable-line react-hooks/exhaustive-deps

  // Kad se korisnik vrati na homepage, restartuj aktivni video
  useEffect(() => {
    if (!isOnHome) return;
    const el = videoRefs.current[active];
    if (el && HERO_SLIDES[active]?.video) {
      el.currentTime = 0;
    }
    setTimeout(() => ensurePlaying(active), 100);
  }, [isOnHome, ensurePlaying]); // eslint-disable-line react-hooks/exhaustive-deps

  // Kad posetilac nije na početnoj, video se pauzira (ne troši procesor ni
  // prenos podataka dok ga niko ne gleda).
  useEffect(() => {
    if (isOnHome) return;
    videoRefs.current.forEach(el => { if (el) el.pause(); });
  }, [isOnHome]);

  // Napredak slajda: krene kad intro počne da se diže, samo na početnoj (inače
  // bi smenjivanje u pozadini redom učitavalo sve snimke). Sa snimkom linija
  // prati snimak (dok se učitava ili zastane, stoji i linija), a slajd se menja
  // kad se snimak završi. Bez snimka (spora mreža) slajd traje IMG_SLIDE_MS.
  useEffect(() => {
    if (fillRef.current) fillRef.current.style.transform = "scaleY(0)";
    if (!isOnHome) return;
    if (introPhase !== "lifting" && introPhase !== "done") return;
    let videoMode = useVideo && !!HERO_SLIDES[active]?.video;
    let start = performance.now();
    // Ako snimak ne napreduje 9s (npr. iPhone u režimu uštede ne pušta snimke),
    // slajd nastavlja po vremenu od mesta gde je linija stala.
    let lastCt = -1, lastChange = start, prevTick = start;
    let raf;
    const tick = () => {
      const now = performance.now();
      // posle pauze (kartica u pozadini, rAF stoji) ne računaj zastoj
      if (now - prevTick > 1000) lastChange = now;
      prevTick = now;
      let p = 0;
      if (videoMode) {
        const el = videoRefs.current[active];
        if (el && el.duration > 0 && isFinite(el.duration)) p = el.currentTime / el.duration;
        // dok se snimak učitava, zastoj se ne broji (za to služi prelazak na lakšu verziju)
        if (!videoReadyRef.current[active] || (el && el.currentTime !== lastCt)) { if (el) lastCt = el.currentTime; lastChange = now; }
        if (el && el.ended) { p = 1; advance(); }
        else if (now - lastChange > 9000) { videoMode = false; start = now - p * IMG_SLIDE_MS; }
      } else {
        p = (now - start) / IMG_SLIDE_MS;
        if (p >= 1) { p = 1; advance(); }
      }
      if (fillRef.current) fillRef.current.style.transform = `scaleY(${Math.min(1, Math.max(0, p))})`;
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, useVideo, introPhase, isOnHome, advance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section style={{
      position: "sticky", width: "100%", height: "100dvh",
      overflow: "hidden", background: "#111",
    }}>
      <style>{`
        @keyframes heroFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* -- Container -- */}
      <div
        onClick={() => {
          const slide = HERO_SLIDES[active];
          if (slide.pageKey) {
            const nav = window.__nsNav;
            if (nav && nav.selectCat && slide.category) {
              nav.selectCat(slide.category);
            } else if (onCategorySelect) {
              onCategorySelect(slide.category || slide.pageKey);
            }
          } else if (onCategorySelect) {
            onCategorySelect(slide.category);
          }
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const slide = HERO_SLIDES[active];
          if (slide.pageKey) {
            const nav = window.__nsNav;
            if (nav && nav.selectCat && slide.category) {
              nav.selectCat(slide.category);
            } else if (onCategorySelect) {
              onCategorySelect(slide.category || slide.pageKey);
            }
          } else if (onCategorySelect) {
            onCategorySelect(slide.category);
          }
        } }}
        style={{
          position: "absolute",
          inset: 0,
          cursor: "pointer",
          background: "#111",
        }}>

        {HERO_SLIDES.map((slide, i) =>
          slide.video ? (
            <React.Fragment key={i}>
            {/* Slika slajda, vidljiva dok snimak ne bude spreman (ili umesto njega) */}
            <img
              src={slide.img}
              alt={slide.title}
              decoding="async"
              fetchpriority={i === 0 ? "high" : undefined}
              style={{
                position: "absolute", inset: 0, width: "100%", height: "100%",
                objectFit: "cover",
                objectPosition: isMobile ? (slide.mobilePosition || "center center") : "center center",
                opacity: i === active && !(useVideo && videoReady[i]) ? 0.85 : 0,
                // kad snimak krene, slika nestaje tek pošto se on potpuno pojavi
                transition: i !== active ? "none" : (useVideo && videoReady[i]) ? "opacity 0.3s ease 0.8s" : "opacity 0.6s ease",
                willChange: "opacity", zIndex: 0,
              }}
            />
            <video
              ref={el => videoRefs.current[i] = el}
              src={useVideo ? videoSrcFor(slide) : undefined}
              poster={slide.img}
              muted
              autoPlay={useVideo && i === active}
              playsInline
              disablePictureInPicture
              preload={useVideo && i === active ? "auto" : "none"}
              onCanPlayThrough={() => setVideoReady(r => (r[i] ? r : { ...r, [i]: true }))}
              onEnded={() => { if (i === active && isOnHome) advance(); }}
              onLoadedMetadata={e => {
                // Ako je intro već pokrenuo ovaj (aktivni) video, ne diraj ga -
                // pauziranje ovde bi otkazalo taj play() poziv i ostavilo crn
                // ekran dok korisnik ručno ne promeni slajd.
                if (i === active && introFiredRef.current) return;
                e.target.pause();
                e.target.currentTime = 0;
              }}
              onCanPlay={e => {
                // Retry pokretanja: ako je ovo aktivni slajd i intro je prošao,
                // sigurno pokreni video čim ima dovoljno bafera (rešava
                // "ostane crno, mora refresh" na sporom netu).
                if (i === active && introFiredRef.current) {
                  ensurePlaying(i);
                }
              }}
              onStalled={e => {
                if (i === active && introFiredRef.current) ensurePlaying(i);
              }}
              style={{
                position: "absolute", inset: 0, width: "100%", height: "100%",
                objectFit: "cover",
                objectPosition: "center center",
                opacity: i === active && useVideo && videoReady[i] ? 0.85 : 0,
                transition: i === active ? "opacity 0.8s ease" : "none",
                willChange: "opacity", zIndex: 0,
              }}
            />
            </React.Fragment>
          ) : (
            <img
              key={i}
              src={slide.img}
              alt={slide.title}
              style={{
                position: "absolute", inset: 0,
                width: "100%", height: "100%",
                objectFit: "cover",
                objectPosition: isMobile ? (slide.mobilePosition || "center center") : "center center",
                opacity: i === active ? 0.85 : 0,
                transition: i === active ? "opacity 0.6s ease" : "none",
                willChange: "opacity", zIndex: 0,
              }}
            />
          )
        )}

        {/* Bottom gradient for text legibility */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.28) 40%, transparent 70%)",
          zIndex: 1,
        }} />

        {/* Text overlay */}
        <div style={{
            position: "absolute",
            bottom: isMobile ? 56 : 84,
            left: isMobile ? 20 : 64,
            // Na telefonu tekst staje ~28px pre linija slajdera (one su 20-24px od desne ivice)
            right: isMobile ? 52 : "auto",
            color: "#fff",
            fontFamily: SF,
            maxWidth: isMobile ? "none" : 760,
            textShadow: isMobile ? "0 1px 14px rgba(0,0,0,0.35)" : "none",
            zIndex: 2,
            opacity: !introAnimReady ? 0 : textVisible ? 1 : 0,
            transform: !introAnimReady ? "translateY(28px)" : textVisible ? "translateY(0)" : "translateY(6px)",
            transition: introAnimReady
              ? "opacity 0.75s cubic-bezier(0.16,1,0.3,1), transform 0.75s cubic-bezier(0.16,1,0.3,1)"
              : "none",
          }}>
          {/* Naslov slajda je h1 samo na početnoj: hero ostaje renderovan ispod
              prekrivača kategorije/biznisa, a stranica sme da ima jedan h1 */}
          {React.createElement(isOnHome ? "h1" : "div", {
            style: {
              fontSize: titleSize,
              fontWeight: 800,
              margin: "0 0 14px",
              letterSpacing: "-0.035em",
              lineHeight: 0.98,
            },
          }, HERO_SLIDES[active].title)}
          <p style={{
            fontSize: isMobile ? 16 : 17,
            fontWeight: 400,
            margin: 0,
            opacity: isMobile ? 0.95 : 0.88,
            lineHeight: isMobile ? 1.5 : 1.55,
            maxWidth: isMobile ? "100%" : 480,
            letterSpacing: "-0.01em",
          }}>
            {HERO_SLIDES[active].desc}
          </p>

        </div>

        {/* Slider progress indicators */}
        <div style={{
          position: "absolute",
          right: 20,
          top: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
          zIndex: 3,
          paddingTop: isMobile ? 82 : 100,
          paddingBottom: 40,
        }}>
          {HERO_SLIDES.map((_, i) => (
            <div
              key={i}
              onClick={e => { e.stopPropagation(); handleSlide(i); }}
              style={{
                width: 4,
                flex: i === active ? 3 : 1,
                borderRadius: 999,
                background: "rgba(255,255,255,0.25)",  /* track */
                cursor: "pointer",
                transition: "flex 0.4s ease",
                flexShrink: 0,
                position: "sticky",
                overflow: "hidden",
              }}
            >
              {/* Fill bar  -  re-mounts on active change via key to restart animation */}
              {i === active && (
                <div
                  key={`fill-${active}`}
                  ref={fillRef}
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "#ffffff",
                    borderRadius: 999,
                    transformOrigin: "top",
                    transform: "scaleY(0)",
                    willChange: "transform",
                  }}
                />
              )}
              {/* Inactive: solid dim fill */}
              {i !== active && (
                <div style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.35)",
                  borderRadius: 999,
                }} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==========================================
   POPULAR CATEGORIES
========================================== */

const categories = [
  { label: "Restorani",  img: catRestorani },
  { label: "Kafići",     img: catKafici    },
  { label: "Sport",      img: catSport     },
  { label: "Bazeni",     img: catBazeni    },
  { label: "Zdravlje",   img: catZdravlje  },
  { label: "Hoteli",     img: catHoteli    },
];

function PopularCategories({ onCategorySelect }) {
  const { isMobile, w } = useBreakpoint();
  const px = isMobile ? "16px" : "48px";
  useReveal();

  // Correct 5-item sequence, no duplicates
  const cats = [
    { label: "Restorani", img: catRestorani },
    { label: "Hoteli",    img: catHoteli    },
    { label: "Sport",     img: catSport     },
    { label: "Kafići",    img: catKafici    },
    { label: "Bazeni",    img: catBazeni    },
    { label: "Zdravlje",  img: catZdravlje  },
  ];

  const cols = isMobile
    ? w < 340 ? "repeat(2, 1fr)" : "repeat(2, 1fr)"
    : w < 900 ? "repeat(3, 1fr)" : w < 1200 ? "repeat(3, 1fr)" : "repeat(6, 1fr)";

  return (
    <section className="na-reveal" style={{ background: BG, padding: isMobile ? `56px 16px 40px` : `64px 48px 44px` }}>
      <style>{`
        .cat-card { position: relative; height: 190px; border-radius: 24px; overflow: hidden; cursor: pointer;
          background: #222; box-shadow: 0 1px 3px rgba(0,0,0,0.07);
          transition: box-shadow 0.45s cubic-bezier(0.16,1,0.3,1), transform 0.45s cubic-bezier(0.16,1,0.3,1); }
        .cat-card:hover { transform: translateY(-5px);
          box-shadow: 0 24px 48px rgba(0,0,0,0.18), 0 0 0 2px rgba(0,0,0,0.14); }
        @media (max-width: 480px) { .cat-card { height: 148px; border-radius: 18px; } }
        .cat-card .cat-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover;
          transform: scale(1); transition: transform 0.8s cubic-bezier(0.16,1,0.3,1); }
        .cat-card:hover .cat-img { transform: scale(1.08); }
        .cat-card .cat-overlay { position: absolute; inset: 0; pointer-events: none;
          background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.18) 42%, rgba(0,0,0,0) 62%); }
        .cat-card .cat-arrow { position: absolute; top: 14px; right: 14px; width: 32px; height: 32px;
          border-radius: 50%; display: flex; align-items: center; justify-content: center;
          background: rgba(255,255,255,0.16); border: 1px solid rgba(255,255,255,0.3);
          backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
          opacity: 0; transform: scale(0.75) translate(-4px,4px);
          transition: all 0.4s cubic-bezier(0.16,1,0.3,1); }
        .cat-card:hover .cat-arrow { opacity: 1; transform: scale(1) translate(0,0); }
        @media (max-width: 480px) { .cat-card .cat-arrow { display: none; } }
        .cat-card .cat-label { position: absolute; left: 18px; right: 18px; bottom: 16px;
          display: flex; flex-direction: column; gap: 3px; }
        .cat-card .cat-label h2 { margin: 0; color: #fff; font-size: 17px; font-weight: 700;
          letter-spacing: -0.02em; text-shadow: 0 1px 8px rgba(0,0,0,0.4); }
        .cat-card .cat-sub { font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.78);
          letter-spacing: -0.01em; opacity: 0; transform: translateY(4px);
          transition: all 0.4s cubic-bezier(0.16,1,0.3,1) 0.04s; }
        .cat-card:hover .cat-sub { opacity: 1; transform: translateY(0); }
        @media (max-width: 480px) { .cat-card .cat-sub { display: none; } }
      `}</style>

      {/* -- Header row -- */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: isMobile ? "column" : "row",
        marginBottom: isMobile ? 28 : 32,
        gap: isMobile ? 10 : 8,
      }}>
        <h2 style={{ fontFamily: SF, letterSpacing: "-0.03em", fontSize: isMobile ? 32 : 38, fontWeight: 800, margin: 0, lineHeight: 1.15 }}>
          Popularne kategorije
        </h2>
        <div style={{ fontFamily: SF, fontSize: isMobile ? 16 : 17, fontWeight: 500, letterSpacing: "-0.01em",
          lineHeight: 1.5, color: "#333", textAlign: isMobile ? "left" : "right", marginTop: isMobile ? 4 : 4, maxWidth: isMobile ? "100%" : 460 }}>
          {isMobile ? (
            <span>Istražite <span style={{ color: BLUE, fontWeight: 800 }}>Novi Sad</span> kroz pažljivo sortirane kategorije. Sve što vam treba, udaljeno je samo <span style={{ color: BLUE, fontWeight: 800 }}>jedan klik</span>.</span>
          ) : (
            <>
              <span>Istražite </span><span style={{ color: BLUE, fontWeight: 800, whiteSpace: "nowrap" }}>Novi Sad</span><span> kroz pažljivo sortirane kategorije.</span>
              <br />
              <span>Sve što vam treba, udaljeno je samo </span><span style={{ color: BLUE, fontWeight: 800, whiteSpace: "nowrap" }}>jedan klik</span><span>.</span>
            </>
          )}
        </div>
      </div>

      {/* -- Card grid -- */}
      <div style={{ display: "grid", gridTemplateColumns: cols, gap: isMobile ? 10 : 18 }}>
        {cats.map((cat, idx) => (
          <a key={idx} className="cat-card" href={categoryPath(cat.label)}
            onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); onCategorySelect && onCategorySelect(cat.label); }}
          >
            <img src={cat.img} alt={cat.label} className="cat-img" />
            <div className="cat-overlay" />
            <div className="cat-arrow">
              <ArrowUpRight size={16} color="#fff" strokeWidth={2.25} />
            </div>
            <div className="cat-label">
              <h2 style={{ fontFamily: SF }}>{cat.label}</h2>
              <span className="cat-sub">Istraži kategoriju</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

/* ==========================================
   ADS
========================================== */
function AdsSection() {
  const { isMobile } = useBreakpoint();
  return (
    <section style={{ display: "none", background: BG, padding: `0 ${isMobile ? "16px" : "48px"} 36px` }}>
      <div style={{ background: "#fff", borderRadius: 14, height: 400, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #e0e0e0" }}>
        <span style={{ fontFamily: SF, fontSize: 13, color: "#aaa" }}>Google Ads Section</span>
      </div>
    </section>
  );
}

/* ==========================================
   REVIEWS
========================================== */
const USER_ICON_REVIEW = "data:image/svg+xml;base64,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";

// ── Review shape ──────────────────────────────────────────────────────────
function mapDbReview(r) {
  return {
    name:     r.ime      || "Korisnik",
    time:     r.vreme    || "",
    title:    r.naslov   || "",
    rating:   r.ocena    || 5,
    business: r.biznis   || "",
    category: r.kategorija || "",
    short:    r.kratko   || "",
    full:     r.puno     || r.kratko || "",
  };
}

// Static fallback - used when DB returns 0 rows
const FALLBACK_REVIEWS = [
  { name: "Ana K.", time: "1h ago", title: "Najbolja pica u gradu, bez konkurencije!", rating: 5, business: "Restoran Fontana", category: "Restorani",
    short: "Oduševljena sam! Pica je autentična italijanska, testo savršeno hrskavo.",
    full:  "Oduševljena sam! Pica je autentična italijanska, testo savršeno hrskavo, a sastojci vrhunski. Atmosfera je intimna i prijatna, a osoblje neverovatno ljubazno. Toplo preporučujem svima koji traže pravi gastronomski užitak u Novom Sadu. Svaka čast!" },
  { name: "Petar P.", time: "3h ago", title: "Savršeno mesto za prvu jutarnju kafu i opuštanje", rating: 5, business: "Kafić Dunav", category: "Kafići",
    short: "Moj omiljeni ritual je kafa u ovom prelepom kafiću. Pogled na Dunav je neprocenjiv.",
    full:  "Moj omiljeni ritual je kafa u ovom prelepom kafiću. Pogled na Dunav je neprocenjiv, a kafa uvek sveže pržena i mirisna. Osoblje me već poznaje i uvek me dočeka sa osmehom. Idealno mesto da započnete dan u miru i tišini, daleko od gradske buke." },
  { name: "Mališa J.", time: "Juče", title: "Fantastičan hotel, sve na svom mestu", rating: 5, business: "Hotel Prezident", category: "Hoteli",
    short: "Ovaj hotel je pravo blago! Čist, održavan, sa puno sadržaja i zelenila.",
    full:  "Ovaj hotel je pravo blago! Čist, održavan, sa puno sadržaja i zelenila. Deca obožavaju bazen, a ja volim jutarnje šetnje. Idealno mesto za odmor." },
  { name: "Stefan B.", time: "2d ago", title: "Odlična teretana, profesionalna oprema!", rating: 5, business: "CrossFit Novi Sad", category: "Sport",
    short: "Moderna oprema, čisto i prostrano. Treneri su stručni i uvek raspoloženi za pomoć.",
    full:  "Moderna oprema, čisto i prostrano. Treneri su stručni i uvek raspoloženi za pomoć. Idealno za sve nivoe treniranosti." },
  { name: "Milica D.", time: "5d ago", title: "Savršen koktel bar za posebne večeri", rating: 5, business: "Jazz Bar Petrovaradin", category: "Noćni život",
    short: "Predivan pogled na Dunav i kokteli kojima nema premca. Muzika odlična vikendom.",
    full:  "Predivan pogled na Dunav i kokteli kojima nema premca. Muzika odlična vikendom, osoblje pažljivo i ljubazno." },
  { name: "Nikola V.", time: "1w ago", title: "Savršen bazen za celu porodicu", rating: 4, business: "Aquapark Štrand", category: "Bazeni",
    short: "Tobogani, čista voda i profesionalno osoblje. Deca su bila presrećna!",
    full:  "Tobogani, čista voda i profesionalno osoblje. Deca su bila presrećna! Jedina mana je guzva vikendom." },
  { name: "Maja T.", time: "1w ago", title: "Najbolja specialty kafa u gradu!", rating: 5, business: "Black Sheep Coffee", category: "Kafići",
    short: "Konačno pravi specialty kafić u Novom Sadu. Filter kafa je fenomenalna.",
    full:  "Konačno pravi specialty kafić u Novom Sadu. Filter kafa je fenomenalna, bariste su stručni i strpljivi. Enterijer je moderan i ugodan, wifi radi odlično za rad. Svakako ću se vraćati!" },
  { name: "Dragan M.", time: "2w ago", title: "Hotel Crowne Plaza na višem nivou", rating: 5, business: "Hotel Crowne Plaza", category: "Hoteli",
    short: "Profesionalan servis, čiste sobe i odličan doručak. Preporučujem za poslovne putnike.",
    full:  "Profesionalan servis, čiste sobe i odličan doručak. Preporučujem za poslovne putnike. Lokacija je savršena, parking bez problema, a osoblje uvek ljubazno i na usluzi." },
  { name: "Jelena M.", time: "4d ago", title: "Hotel koji oduševljava na svakom koraku", rating: 5, business: "Hotel Vojvodina", category: "Hoteli",
    short: "Bila sam prijatno iznenađena luksuzom i ljubaznošću osoblja. Soba je bila besprekorna.",
    full:  "Bila sam prijatno iznenađena luksuzom i ljubaznošću osoblja. Soba je bila besprekorna, krevet udoban, a doručak obilat i ukusan. Spa centar je pravi raj. Jedina zamerka - bazen je zatvoren radi renoviranja, ali sve ostalo je na 10+." },
  { name: "Marko L.", time: "3d ago", title: "Wok & Roll - azijska kuhinja na vrhunskom nivou", rating: 5, business: "Wok & Roll", category: "Restorani",
    short: "Svež, autentičan ukus wok jela. Porcije su ogromne, cena pristupačna.",
    full:  "Svež, autentičan ukus wok jela. Porcije su ogromne, cena pristupačna. Osoblje je super brzo i ljubazno. Idealno za ručak ili večeru kad hoćete nešto drugačije od balkanske kuhinje." },
  { name: "Sandra R.", time: "6d ago", title: "FitZone - jedina teretana koja mi treba", rating: 5, business: "FitZone Premium", category: "Sport",
    short: "Ogromna teretana, 24/7 otvorena, sauna i bazen u paketu. Vrijednost za novac.",
    full:  "Ogromna teretana, 24/7 otvorena, sauna i bazen u paketu. Vrijednost za novac. Treneri su profesionalni i uvek raspoloženi za savjet. Nikada nije prenatrpano jer je prostor dovoljno velik." },
  { name: "Igor P.", time: "2w ago", title: "Noćni klub Exit Arena - nezaboravno iskustvo", rating: 4, business: "Exit Arena", category: "Noćni život",
    short: "Savršen zvuk, dobra organizacija, svetska muzika. Jedini minus - gužva na ulazu.",
    full:  "Savršen zvuk, dobra organizacija, svetska muzika. Jedini minus - gužva na ulazu traje previše. Ali kad uđete unutra, sve je na nivou. Obavezno za ljubitelje elektronske muzike." },
  { name: "Vesna K.", time: "3w ago", title: "Yoga Studio Lotus - mir u srcu grada", rating: 5, business: "Yoga Studio Lotus", category: "Sport",
    short: "Predivna atmosfera, stručni instruktori i male grupe. Upravo ono što mi je trebalo.",
    full:  "Predivna atmosfera, stručni instruktori i male grupe. Upravo ono što mi je trebalo. Prostorija je uvek čista i mirisna, muzika opuštajuća. Preporučujem svima koji traže bijeg od stresa." },
];

// Static reviews hook - uses only FALLBACK_REVIEWS
// Konvertuje datum string ili timestamp u "pre X" format
function timeAgo(input) {
  if (!input) return "";

  // Ako već sadrži "pre", "ago", "danas", "juče" - vrati kao-što-jeste (Google format)
  if (/^(pre |ago|danas|juče|just now|upravo)/i.test(input.trim())) return input;

  let date = null;

  if (typeof input === "number") {
    date = new Date(input);
  } else if (typeof input === "string") {
    // ISO format (naše recenzije: "2026-05-17T21:45:00.000Z")
    if (input.includes("T") && input.includes("-")) {
      const d = new Date(input);
      if (!isNaN(d.getTime())) date = d;
    }

    // Srpski datum "17. maja 2026."
    if (!date) {
      const meseci = {
        "januara":1,"februara":2,"marta":3,"aprila":4,"maja":5,"juna":6,
        "jula":7,"avgusta":8,"septembra":9,"oktobra":10,"novembra":11,"decembra":12
      };
      const m = input.match(/(\d+)\.\s+(\w+)\s+(\d{4})/);
      if (m) {
        const mesec = meseci[m[2].toLowerCase()];
        if (mesec) date = new Date(parseInt(m[3]), mesec - 1, parseInt(m[1]), 12, 0, 0);
      }
    }

    // Generički parse (fallback)
    if (!date) {
      const gen = new Date(input);
      if (!isNaN(gen.getTime())) date = gen;
    }
  }

  if (!date || isNaN(date.getTime())) return input; // vrati original ako ne možemo parsirati

  const now = Date.now();
  const diff = Math.floor((now - date.getTime()) / 1000); // sekunde

  if (diff < 60)          return "upravo sada";
  if (diff < 3600)        { const m = Math.floor(diff / 60);   return `pre ${m} ${m === 1 ? "minut" : "minuta"}`; }
  if (diff < 7200)        return "pre sat vremena";
  if (diff < 86400)       { const h = Math.floor(diff / 3600); return `pre ${h} ${h < 5 ? "sata" : "sati"}`; }
  // Provjeri je li juče (isti kalendarski dan - 1)
  const today    = new Date(); today.setHours(0,0,0,0);
  const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
  const dateDay  = new Date(date); dateDay.setHours(0,0,0,0);
  if (dateDay.getTime() === today.getTime())     return "danas";
  if (dateDay.getTime() === yesterday.getTime()) return "juče";

  if (diff < 7 * 86400)   { const d = Math.floor(diff / 86400);       return `pre ${d} ${d === 1 ? "dan" : "dana"}`; }
  if (diff < 30 * 86400)  { const w = Math.floor(diff / (7 * 86400)); return `pre ${w} ${w === 1 ? "nedelju" : w < 5 ? "nedelje" : "nedelja"}`; }
  if (diff < 365 * 86400) { const mo = Math.floor(diff / (30 * 86400)); return `pre ${mo} ${mo === 1 ? "mesec" : mo < 5 ? "meseca" : "meseci"}`; }
  const y = Math.floor(diff / (365 * 86400)); return `pre ${y} ${y === 1 ? "godinu" : y < 5 ? "godine" : "godina"}`;
}
function normalizeReview(row) {
  const vremeSource = row.datum || row.vreme || "";
  return {
    id:          row.id,
    name:        row.autor      || "Anonimni korisnik",
    business:    row.biznis_ime || "",
    category:    row.kategorija  || row.category   || "",
    rating:      parseFloat(row.ocena) || 0,
    text:        row.tekst      || "",
    short:       (row.tekst || "").slice(0, 160) || "",
    full:        row.tekst      || "",
    time:        timeAgo(vremeSource) || row.vreme || "",
    rawVreme:    vremeSource,
    izvor:       row.izvor      || "korisnik",
    reply_to_id: row.reply_to_id || null,
  };
}

// Globalni cache za recenzije (da ne fetchujemo više puta)
const _reviewsCache = { data: null, ts: 0 };

// Parsira vreme string u timestamp za sortiranje
function parseVremeToTs(vreme) {
  if (!vreme) return 0;
  const now = Date.now();

  // ISO format (naše nove recenzije: "2026-05-17T21:45:00Z")
  if (vreme.includes("T") && vreme.includes("-")) {
    const d = new Date(vreme);
    if (!isNaN(d.getTime())) return d.getTime();
  }

  // Srpski datum "17. maja 2026."
  const meseci = {
    "januara":1,"februara":2,"marta":3,"aprila":4,"maja":5,"juna":6,
    "jula":7,"avgusta":8,"septembra":9,"oktobra":10,"novembra":11,"decembra":12
  };
  const srpskiMatch = vreme.match(/(\d+)\.\s+(\w+)\s+(\d{4})/);
  if (srpskiMatch) {
    const mesec = meseci[srpskiMatch[2].toLowerCase()];
    if (mesec) return new Date(parseInt(srpskiMatch[3]), mesec - 1, parseInt(srpskiMatch[1]), 12, 0, 0).getTime();
  }

  // "pre X jedinica" format (sa brojem): "pre 3 nedelje", "pre 2 meseca"
  const preMatch = vreme.match(/pre\s+(\d+)\s+(\w+)/);
  if (preMatch) {
    const n = parseInt(preMatch[1]);
    const unit = preMatch[2].toLowerCase();
    const map = {
      "sekund":1e3,"sekunde":1e3,"sekundi":1e3,
      "minut":6e4,"minuta":6e4,"minute":6e4,
      "sat":36e5,"sata":36e5,"sati":36e5,
      "dan":864e5,"dana":864e5,
      "nedelju":6048e5,"nedelje":6048e5,"nedelja":6048e5,
      "mesec":2592e6,"meseca":2592e6,"meseci":2592e6,
      "godinu":31536e6,"godine":31536e6,"godina":31536e6,
      "second":1e3,"seconds":1e3,"minutes":6e4,
      "hour":36e5,"hours":36e5,"day":864e5,"days":864e5,
      "week":6048e5,"weeks":6048e5,"month":2592e6,"months":2592e6,
      "year":31536e6,"years":31536e6,
    };
    const ms = map[unit];
    if (ms) return now - n * ms;
  }

  // "pre nedelju dana", "pre mesec dana" - bez broja (= 1)
  const preJedanMap = [
    [/pre\s+(minut|minutu)\b/, 6e4],
    [/pre\s+(sat|sata)\b/, 36e5],
    [/pre\s+(dan|dana)\b/, 864e5],
    [/pre\s+(nedelju|nedelje)\b/, 6048e5],
    [/pre\s+(mesec|meseca)\b/, 2592e6],
    [/pre\s+(godinu|godine)\b/, 31536e6],
  ];
  for (const [re, ms] of preJedanMap) {
    if (re.test(vreme)) return now - ms;
  }

  // "upravo sada"
  if (vreme.includes("upravo")) return now;

  return 0; // nepoznat format - ide na kraj
}

function useReviews(opts = {}) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey(k => k + 1);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        let url = `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?select=*&or=(obrisano.is.null,obrisano.eq.false)`;

        if (opts.biznis_ime) {
          url += `&biznis_ime=eq.${encodeURIComponent(opts.biznis_ime)}`;
        }

        if (opts.sort === "Najviša ocena" || opts.sort === "najvisa") {
          url += "&order=ocena.desc";
        } else if (opts.sort === "Najniža ocena" || opts.sort === "najniza") {
          url += "&order=ocena.asc";
        } else {
          url += "&order=id.desc";
        }

        if (opts.limit) url += `&limit=${opts.limit}`;

        const headers = { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${SUPABASE_ANON}` };

        // Kad učitavamo SVE recenzije (bez filtera po jednom biznisu i bez
        // eksplicitnog limita), Supabase server podrazumevano vraća najviše
        // 1000 redova po pozivu - sa 10.000+ recenzija u bazi to je tiho
        // odsecalo starije recenzije (npr. sve iz "Noćni život" kategorije)
        // iz filtera. Paginacija kroz offset učitava bukvalno sve.
        let data;
        if (!opts.biznis_ime && !opts.limit) {
          data = [];
          const PAGE = 1000;
          let offset = 0;
          while (true) {
            const pageRes = await fetch(`${url}&limit=${PAGE}&offset=${offset}`, { headers });
            if (!pageRes.ok) throw new Error(`Supabase error: ${pageRes.status}`);
            const pageData = await pageRes.json();
            if (!Array.isArray(pageData) || pageData.length === 0) break;
            data = data.concat(pageData);
            if (pageData.length < PAGE) break;
            offset += PAGE;
          }
        } else {
          const res = await fetch(url, { headers });
          if (!res.ok) throw new Error(`Supabase error: ${res.status}`);
          data = await res.json();
        }

        // Fetchuj biznise da dobijemo kategorije po imenu (paginirano - ima
        // 1288+ biznisa, isti razlog kao gore).
        let bizKatLookup = {};
        let nocniZivotImes = [];
        try {
          let bizData = [];
          const BPAGE = 1000;
          let boff = 0;
          while (true) {
            const bizUrl = `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Biznisi Novi Sad")}?select=ime,kategorija&limit=${BPAGE}&offset=${boff}`;
            const bizRes = await fetch(bizUrl, { headers });
            if (!bizRes.ok) break;
            const pageBiz = await bizRes.json();
            if (!Array.isArray(pageBiz) || pageBiz.length === 0) break;
            bizData = bizData.concat(pageBiz);
            if (pageBiz.length < BPAGE) break;
            boff += BPAGE;
          }
          bizData.forEach(b => {
            const raw = (b.ime||"").toLowerCase().trim();
            const clean = raw.replace(/[„""''«»\-–-]/g, "").replace(/\s+/g," ").trim();
            const kat = b.kategorija||"";
            if (raw) bizKatLookup[raw] = kat;
            if (clean && clean !== raw) bizKatLookup[clean] = kat;
            if (kat === "Noćni život" && b.ime) nocniZivotImes.push((b.ime||"").toLowerCase().trim());
          });
        } catch {}

        let normalized = data.map(r => {
          const rev = normalizeReview(r);
          const raw = (rev.business||r.biznis_ime||"").toLowerCase().trim();
          const clean = raw.replace(/[„""''«»\-–-]/g,"").replace(/\s+/g," ").trim();
          let cat = bizKatLookup[raw] || bizKatLookup[clean] || "";
          if (!cat) {
            for (const [k, v] of Object.entries(bizKatLookup)) {
              if (k && raw && (raw.includes(k) || k.includes(raw) || clean.includes(k) || k.includes(clean))) { cat = v; break; }
            }
          }
          // Proveri da li biznis_ime matchuje neki nocni zivot biznis
          if (!cat && raw) {
            const isNZ = nocniZivotImes.some(nz => nz && (raw.includes(nz) || nz.includes(raw) || clean.includes(nz) || nz.includes(clean)));
            if (isNZ) cat = "Noćni život";
          }
          if (cat) rev.category = cat;
          return rev;
        });

        // Fetchuj sve replies posebno (imaju prazan biznis_ime pa ih server filter ne vraća)
        let allReplies = [];
        if (opts.biznis_ime) {
          const repliesUrl = `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?select=*&izvor=eq.reply&or=(obrisano.is.null,obrisano.eq.false)&order=id.asc`;
          try {
            const repRes = await fetch(repliesUrl, { headers });
            if (repRes.ok) {
              const repData = await repRes.json();
              allReplies = repData.map(normalizeReview);
            }
          } catch {}
        } else {
          // Kad učitavamo sve, replies su već u normalized
          allReplies = normalized.filter(r => r.reply_to_id || r.izvor === "reply");
        }

        if (!opts.sort || opts.sort === "najnovije" || opts.sort === "sve") {
          normalized = normalized.sort((a, b) => {
            const tsA = parseVremeToTs(a.rawVreme) || parseVremeToTs(a.time);
            const tsB = parseVremeToTs(b.rawVreme) || parseVremeToTs(b.time);
            return tsB - tsA;
          });
        }

        // Grupiši sve replies uz recenzije - uključujući nested (reply na reply)
        // Korak 1: pronađi sve IDs recenzija za koje imamo replies
        const mainReviews = normalized.filter(r => !r.reply_to_id && r.izvor !== "reply");

        // Korak 2: za svaku recenziju, sakupi sve replies (direktne i nested)
        // Nested reply ima reply_to_id koji pokazuje na drugi reply
        // Rešavamo iterativno: dok ima neprikačenih replies, pokušaj da ih prikačiš na roditeljski reply
        const collectAllReplies = (rootId, allRepliesFlat) => {
          const directReplies = allRepliesFlat
            .filter(rep => rep.reply_to_id === rootId)
            .sort((a, b) => parseVremeToTs(a.rawVreme) - parseVremeToTs(b.rawVreme));
          // Rekurzivno dodaj nested replies kao deo iste liste (flat prikaz u nizu)
          const result = [];
          for (const rep of directReplies) {
            result.push(rep);
            const nested = collectAllReplies(rep.id, allRepliesFlat);
            result.push(...nested);
          }
          return result;
        };

        const allWithReplies = mainReviews.map(r => ({
          ...r,
          replies: collectAllReplies(r.id, allReplies),
        }));
        if (!cancelled) setReviews(allWithReplies);
      } catch (e) {
        console.error("useReviews error:", e);
        if (!cancelled) setReviews(FALLBACK_REVIEWS);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts.biznis_ime, opts.sort, opts.limit, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { reviews, loading, refresh };
}

function BlueStars({ count }) {
  return (
    <div style={{ display: "flex", gap: 3 }}>
      {[1,2,3,4,5].map(i => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 23" fill="none">
          <path d="M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z"
            fill={i <= count ? "#0079FF" : "#e0e0e0"}
          />
        </svg>
      ))}
    </div>
  );
}

// ── Admin context ───────────────────────────────────────────────
const AdminContext = React.createContext(false);
function useIsAdmin() { return React.useContext(AdminContext); }

// ── Reply List - Instagram/TikTok stil sa uvlačenjem ────────────
const REPLY_PAGE = 2; // inicijalno prikazujemo 2

function ReplyItem({ rep, depth, onReplyClick, parentName }) {
  const indent = depth > 0 ? 18 : 0;
  const bgColor = depth === 0 ? "#f5f5f7" : "#ebebeb";

  return (
    <div style={{ marginLeft: indent, display: "flex", gap: 8, alignItems: "flex-start" }}>
      {/* Avatar */}
      <img src={USER_ICON_REVIEW} alt="user" width="18" height="18"
        style={{ opacity: 0.5, flexShrink: 0, marginTop: 10 }} />
      {/* Sadržaj */}
      <div style={{
        flex: 1, minWidth: 0, background: bgColor, borderRadius: 10,
        padding: "8px 12px",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
          <span style={{ fontFamily: SF, fontSize: 12, fontWeight: 700, color: "#111" }}>
            {rep.name || rep.autor}
          </span>
          <span style={{ fontFamily: SF, fontSize: 11, color: "#bbb", flexShrink: 0, marginLeft: 8 }}>{rep.time}</span>
        </div>
        <p style={{ fontFamily: SF, fontSize: 12, color: "#444", lineHeight: 1.55, margin: "0 0 5px", wordBreak: "break-word", overflowWrap: "break-word" }}>
          {depth > 0 && parentName && (
            <span style={{ color: BLUE, fontWeight: 600, marginRight: 4 , whiteSpace: "nowrap"}}>@{parentName}</span>
          )}
          {rep.text || rep.full}
        </p>
        <div style={{ display:"flex", gap:10, alignItems:"center" }}>
          {onReplyClick && (
            <button onClick={() => onReplyClick(rep)} style={{
              background: "none", border: "none", cursor: "pointer",
              display: "inline-flex", alignItems: "center", gap: 3,
              color: "#aaa", fontFamily: SF, fontSize: 11, fontWeight: 600,
              padding: 0, transition: "color 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.color = BLUE}
            onMouseLeave={e => e.currentTarget.style.color = "#aaa"}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/>
              </svg>
              Odgovori
            </button>
          )}
          {useIsAdmin() && (
            <button onClick={async () => { if (!window.confirm("Obriši odgovor?")) return; try { await deleteRecenzija(rep.id, null); window.location.reload(); } catch { alert("Brisanje nije uspelo. Pokušajte ponovo."); } }}
              style={{ background:"none", border:"none", cursor:"pointer", color:"#ff3b30", padding:2, opacity:0.5, transition:"opacity 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.opacity="1"}
              onMouseLeave={e => e.currentTarget.style.opacity="0.5"}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function ReplyList({ replies, onReplyClick }) {
  const nameMap = {};
  replies.forEach(r => { if (r.id) nameMap[r.id] = r.name || r.autor; });

  return (
    <div style={{ marginTop: 10 }}>
      {/* Scrollable kontejner - fiksna visina, ne širi karticu */}
      <div style={{
        maxHeight: 180,
        overflowY: replies.length > 2 ? "auto" : "visible",
        display: "flex", flexDirection: "column", gap: 6,
        paddingRight: replies.length > 2 ? 4 : 0,
        // Webkit scrollbar stilizacija
      }}>
        <style>{`
          .reply-scroll::-webkit-scrollbar { width: 3px; }
          .reply-scroll::-webkit-scrollbar-track { background: transparent; }
          .reply-scroll::-webkit-scrollbar-thumb { background: #ddd; border-radius: 99px; }
          .reply-scroll::-webkit-scrollbar-thumb:hover { background: #bbb; }
        `}</style>
        <div className="reply-scroll" style={{
          maxHeight: 180,
          overflowY: replies.length > 2 ? "auto" : "visible",
          display: "flex", flexDirection: "column", gap: 6,
          paddingRight: replies.length > 2 ? 4 : 0,
        }}>
          {replies.map((rep, ri) => {
            const isNested = rep.reply_to_id && replies.some(r => r.id === rep.reply_to_id);
            const depth = isNested ? 1 : 0;
            const parentName = isNested ? nameMap[rep.reply_to_id] : null;
            return (
              <ReplyItem
                key={rep.id || ri}
                rep={rep}
                depth={depth}
                parentName={parentName}
                onReplyClick={onReplyClick}
              />
            );
          })}
        </div>
      </div>
      {/* Indikator skrola ako ima više odgovora */}
      {replies.length > 2 && (
        <div style={{
          fontFamily: SF, fontSize: 11, color: "#bbb",
          marginTop: 5, textAlign: "right",
        }}>
          {replies.length} odgovora · skroluj za više
        </div>
      )}
    </div>
  );
}

// ── Reply Modal ────────────────────────────────────────────────
function ReplyModal({ review, onClose, onSent, onAuthRequest }) {
  const { user, token, getFreshToken } = useAuthContext();
  const { isMobile } = useBreakpoint();
  useScrollLock(true);
  const tekstRef = useRef("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const modalStyle = {
    position: "fixed", inset: 0, zIndex: 9999,
    background: "rgba(0,0,0,0.4)", backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    display: "flex",
    alignItems: isMobile ? "flex-end" : "center",
    justifyContent: "center",
    padding: isMobile ? 0 : 20,
  };
  const boxStyle = {
    background: "#fff",
    borderRadius: isMobile ? "20px 20px 0 0" : 20,
    padding: isMobile ? "20px 20px 40px" : "28px 32px",
    width: isMobile ? "100%" : 480,
    boxShadow: "0 -4px 40px rgba(0,0,0,0.12)",
    position: "sticky",
  };

  if (!user) {
    return ReactDOM.createPortal(
      <div onClick={onClose} style={modalStyle}>
        <div onClick={e => e.stopPropagation()} style={boxStyle}>
          {isMobile && <div style={{ width: 36, height: 4, borderRadius: 999, background: "#e0e0e0", margin: "0 auto 20px" }} />}
          <div style={{ textAlign: "center", padding: "8px 0" }}>
            <div style={{ width: 48, height: 48, borderRadius: "50%", background: `${BLUE}15`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <div style={{ fontFamily: SF, fontSize: 17, fontWeight: 700, color: "#111", marginBottom: 8, letterSpacing: "-0.01em" }}>
              Prijavite se da odgovorite
            </div>
            <p style={{ fontFamily: SF, fontSize: 14, color: "#888", lineHeight: 1.6, margin: "0 auto 24px", maxWidth: 260 }}>
              Da biste odgovorili na recenziju potreban vam je nalog.
            </p>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={onClose} style={{ flex: 1, background: "#f2f2f7", border: "none", borderRadius: 12, padding: "13px", fontFamily: SF, fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#555" }}>Otkaži</button>
              <button onClick={() => { onClose(); if (onAuthRequest) onAuthRequest(); }} style={{ flex: 1, background: BLUE, border: "none", borderRadius: 12, padding: "13px", fontFamily: SF, fontSize: 14, fontWeight: 700, cursor: "pointer", color: "#fff" }}>Prijavite se</button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  const handleSend = async () => {
    const tekst = tekstRef.current;
    if (!tekst.trim()) { setErr("Unesite odgovor."); return; }
    setSending(true); setErr("");
    try {
      await insertReply({
        recenzija_id: review.id,
        autor: (() => {
          try {
            const raw = sessionStorage.getItem("ns_profile") || localStorage.getItem("ns_profile");
            if (raw) { const p = JSON.parse(raw); const n = `${p.first_name||""} ${p.last_name||""}`.trim(); if (n) return n; }
          } catch {}
          return user.user_metadata?.full_name || user.user_metadata?.name || "Korisnik";
        })(),
        tekst: tekst.trim(),
        token: (getFreshToken && await getFreshToken()) || token,
      });
      setSent(true);
      if (onSent) onSent();
    } catch (e) {
      setErr(describeError(e));
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return ReactDOM.createPortal(
      <div onClick={onClose} style={modalStyle}>
        <div onClick={e => e.stopPropagation()} style={boxStyle}>
          {isMobile && <div style={{ width: 36, height: 4, borderRadius: 999, background: "#e0e0e0", margin: "0 auto 20px" }} />}
          <div style={{ textAlign: "center", padding: "8px 0" }}>
            <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#34C75915", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#34C759" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div style={{ fontFamily: SF, fontSize: 17, fontWeight: 700, color: "#111", marginBottom: 6 }}>Odgovor objavljen!</div>
            <p style={{ fontFamily: SF, fontSize: 14, color: "#888", marginBottom: 24 }}>Vaš odgovor je uspešno sačuvan.</p>
            <button onClick={onClose} style={{ width: "100%", background: BLUE, border: "none", borderRadius: 12, padding: "13px", fontFamily: SF, fontSize: 15, fontWeight: 700, color: "#fff", cursor: "pointer" }}>Zatvori</button>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  const previewText = (review.text || review.full || review.tekst || "").slice(0, 100);

  return ReactDOM.createPortal(
    <div onClick={onClose} style={modalStyle}>
      <div onClick={e => e.stopPropagation()} style={boxStyle}>
        {isMobile && <div style={{ width: 36, height: 4, borderRadius: 999, background: "#e0e0e0", margin: "0 auto 18px" }} />}
        <div style={{ fontFamily: SF, fontSize: 16, fontWeight: 700, color: "#111", marginBottom: 3, letterSpacing: "-0.01em" }}>
          Odgovorite na recenziju
        </div>
        <div style={{ fontFamily: SF, fontSize: 13, color: "#999", marginBottom: 14 }}>
          {review.name || review.autor}
          {(review.business || review.biznis_ime) ? ` · ${review.business || review.biznis_ime}` : ""}
        </div>
        {previewText && (
          <div style={{ background: "#f5f5f7", borderRadius: 10, padding: "10px 14px", fontFamily: SF, fontSize: 13, color: "#666", lineHeight: 1.55, marginBottom: 14, wordBreak: "break-word", overflowWrap: "break-word", overflow: "hidden" }}>
            "{previewText}{(review.text || "").length > 100 ? "…" : ""}"
          </div>
        )}
        <textarea
          key="reply-textarea"
          defaultValue=""
          onChange={e => { tekstRef.current = e.target.value; setErr(""); }}
          placeholder="Napišite vaš odgovor..."
          rows={3}
          style={{
            width: "100%", borderRadius: 12, border: `1.5px solid ${err ? "#ff3b30" : "#e8e8e8"}`,
            padding: "12px 14px", fontFamily: SF, fontSize: 14, color: "#111",
            lineHeight: 1.6, outline: "none", resize: "none", background: "#fafafa",
            boxSizing: "border-box", transition: "border-color 0.2s",
          }}
          onFocus={e => e.target.style.borderColor = BLUE}
          onBlur={e => e.target.style.borderColor = err ? "#ff3b30" : "#e8e8e8"}
        />
        {err && <div style={{ fontFamily: SF, fontSize: 12, color: "#ff3b30", marginTop: 5 }}>{err}</div>}
        <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
          <button onClick={onClose} style={{ flex: 1, background: "#f2f2f7", border: "none", borderRadius: 12, padding: "13px", fontFamily: SF, fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#555" }}>Otkaži</button>
          <button onClick={handleSend} disabled={sending} style={{ flex: 2, background: sending ? "#aaa" : BLUE, border: "none", borderRadius: 12, padding: "13px", fontFamily: SF, fontSize: 14, fontWeight: 700, color: "#fff", cursor: sending ? "default" : "pointer" }}>
            {sending ? "Šaljem..." : "Pošalji odgovor"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

const AVATAR_COLORS = ["#0079FF", "#2f6fed", "#0a58c2", "#3d8bff", "#1450a3", "#1c63d1"];
function avatarColorFor(name) {
  const s = (name || "?");
  let sum = 0;
  for (let i = 0; i < s.length; i++) sum += s.charCodeAt(i);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
}
function GoogleGIcon({ size = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>
      <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z"/>
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/>
    </svg>
  );
}

function ReviewCard({ r, onReplyClick }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [hov, setHov] = useState(false);
  const { isMobile } = useBreakpoint();
  useScrollLock(modalOpen);

  const CARD_CHARS  = 120;
  const textFull    = (r.tekst || r.full || r.text || "").trim();
  const needsModal  = textFull.length > CARD_CHARS;
  const displayText = needsModal
    ? textFull.slice(0, CARD_CHARS).trimEnd() + "…"
    : textFull;
  const stars = Math.round(parseFloat(r.ocena || r.rating) || 0);
  const izvorLabel = r.izvor === "google"
    ? "Google recenzija"
    : r.izvor === "sajt" ? "Novosadski Adresar recenzija"
    : r.izvor === "korisnik" ? "Novosadski Adresar recenzija"
    : null;
  const reviewerName = r.name || r.autor || "Anonimni korisnik";
  const avatarColor  = avatarColorFor(reviewerName);
  const initial      = reviewerName.trim().charAt(0).toUpperCase() || "?";

  return (
    <>
      {/* ── Kartica fiksne visine ── */}
      <div
        onMouseEnter={() => setHov(true)}
        onMouseLeave={() => setHov(false)}
        style={{
        background: "#fff", borderRadius: 20,
        padding: isMobile ? "18px 18px" : "22px 24px",
        border: `1px solid ${hov ? "rgba(0,121,255,0.22)" : "rgba(0,0,0,0.05)"}`,
        boxShadow: hov ? "0 20px 40px rgba(0,0,0,0.10)" : "0 2px 24px rgba(0,0,0,0.07), 0 1px 4px rgba(0,0,0,0.04)",
        transform: hov ? "translateY(-4px)" : "none",
        transition: "border-color 0.35s cubic-bezier(0.4,0,0.2,1), box-shadow 0.35s cubic-bezier(0.4,0,0.2,1), transform 0.35s cubic-bezier(0.4,0,0.2,1)",
        display: "flex", flexDirection: "column", gap: 10,
        position: "relative", minWidth: 0, overflow: "hidden",
      }}>
        {/* Dekorativni navodnik u pozadini */}
        <div style={{
          position: "absolute", top: -10, right: 8, fontFamily: "Georgia, serif",
          fontSize: 90, fontWeight: 700, color: "rgba(0,121,255,0.05)",
          lineHeight: 1, pointerEvents: "none", userSelect: "none", zIndex: 0,
        }}>"</div>
        {/* Zaglavlje */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8, minWidth: 0, position: "relative", zIndex: 1 }}>
          <div style={{ display: "flex", gap: 10, alignItems: "center", minWidth: 0, flex: 1 }}>
            <div style={{
              width: 34, height: 34, borderRadius: "50%", background: avatarColor,
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0, color: "#fff", fontFamily: SF, fontWeight: 700, fontSize: 14,
            }}>
              {initial}
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <span style={{ fontFamily: SF, fontSize: 13, fontWeight: 600, color: "#111", letterSpacing: "-0.01em", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {reviewerName}
              </span>
              {(r.business || r.biznis_ime) && (
                <span style={{ fontFamily: SF, fontSize: 12, fontWeight: 600, color: BLUE, letterSpacing: "-0.01em", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {r.business || r.biznis_ime}
                </span>
              )}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0, marginLeft: 8 }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 3 }}>
              <span style={{ fontFamily: SF, fontSize: 12, color: "#bbb" }}>{r.time || r.vreme || ""}</span>
              {izvorLabel && (
                <span style={{ display: "flex", alignItems: "center", gap: 4, fontFamily: SF, fontSize: 10, fontWeight: 500, color: "#c8c8c8" }}>
                  {r.izvor === "google" && <GoogleGIcon size={10} />}
                  {izvorLabel}
                </span>
              )}
            </div>
            {useIsAdmin() && (
              <button onClick={async (e) => { e.stopPropagation(); if (!window.confirm("Obriši?")) return; try { await deleteRecenzija(r.id, null); window.location.reload(); } catch { alert("Brisanje nije uspelo. Pokušajte ponovo."); } }}
                style={{ background:"none", border:"none", cursor:"pointer", color:"#ff3b30", padding:3, borderRadius:6, opacity:0.45, transition:"opacity 0.2s", flexShrink:0 }}
                onMouseEnter={e => e.currentTarget.style.opacity="1"}
                onMouseLeave={e => e.currentTarget.style.opacity="0.45"}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/>
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Zvezdice */}
        <BlueStars count={stars} />

        {/* Naslov ako postoji */}
        {r.title && (
          <div style={{ fontFamily: SF, fontSize: 14, fontWeight: 700, color: "#111", letterSpacing: "-0.01em", lineHeight: 1.3, flexShrink: 0 }}>
            {r.title}
          </div>
        )}

        {/* Tekst - skraćen, ostalo sakriveno */}
        <p style={{ fontFamily: SF, fontSize: 13, color: "#555", lineHeight: 1.65, margin: 0, flex: 1, overflow: "hidden", wordBreak: "break-word", overflowWrap: "break-word" }}>
          {displayText}
          {needsModal && (
            <span onClick={() => setModalOpen(true)}
              style={{ color: BLUE, fontWeight: 600, cursor: "pointer", marginLeft: 4, whiteSpace: "nowrap" }}>
              više
            </span>
          )}
        </p>



        {/* Reply dugme + replies */}
        {(r.izvor === "sajt" || r.izvor === "korisnik") && (
          <div>
            {/* Prikazani replies */}
            {r.replies && r.replies.length > 0 && <ReplyList replies={r.replies} onReplyClick={onReplyClick} />}
            {onReplyClick && (
              <button
                onClick={() => onReplyClick(r)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  display: "flex", alignItems: "center", gap: 5,
                  color: "#bbb", fontFamily: SF, fontSize: 12, fontWeight: 600,
                  padding: "6px 0 0", alignSelf: "flex-start",
                  transition: "color 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.color = BLUE}
                onMouseLeave={e => e.currentTarget.style.color = "#bbb"}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/>
                </svg>
                Odgovori
              </button>
            )}
          </div>
        )}
      </div>

      {/* ── Modal sa punim tekstom ── */}
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)}>
          <div style={{
              background: "#fff", borderRadius: 20,
              padding: isMobile ? "24px 20px" : "32px 36px",
              maxWidth: 560, width: "100%",
              maxHeight: "80vh", overflowY: "auto",
              boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
              position: "relative",
            }}>
            <button onClick={() => setModalOpen(false)} style={{ position:"absolute", top:16, right:16, width:32, height:32, borderRadius:"50%", background:"#f2f2f7", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1 1l10 10M11 1L1 11" stroke="#555" strokeWidth="1.8" strokeLinecap="round"/></svg>
            </button>
            <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:16, paddingRight:40, minWidth:0 }}>
              <div style={{
                width: 40, height: 40, borderRadius: "50%", background: avatarColor,
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0, color: "#fff", fontFamily: SF, fontWeight: 700, fontSize: 16,
              }}>
                {initial}
              </div>
              <div style={{ minWidth:0, flex:1 }}>
                <div style={{ fontFamily:SF, fontSize:14, fontWeight:700, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{reviewerName}</div>
                <div style={{ display:"flex", gap:4, flexWrap:"wrap", marginTop:2, minWidth:0 }}>
                  {(r.business || r.biznis_ime) && <span style={{ fontFamily:SF, fontSize:12, color:BLUE, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"100%" }}>{r.business || r.biznis_ime}</span>}
                  {(r.time || r.vreme) && <span style={{ fontFamily:SF, fontSize:12, color:"#bbb" }}>· {r.time || r.vreme}</span>}
                </div>
              </div>
            </div>
            <div style={{ marginBottom:16 }}><BlueStars count={stars} /></div>
            {r.title && <div style={{ fontFamily:SF, fontSize:17, fontWeight:800, color:"#111", marginBottom:10, letterSpacing:"-0.02em" }}>{r.title}</div>}
            <p style={{ fontFamily:SF, fontSize:15, color:"#333", lineHeight:1.75, margin:0 }}>{textFull}</p>
          </div>
        </Modal>
      )}
    </>
  );
}
// Recenzije za početnu. Prikazuje se samo 6 kartica, pa se ne učitava cela
// tabela (10.000+ redova, ~2 MB u dvadesetak zahteva), nego nekoliko malih
// nasumičnih isečaka recenzija sa ocenom 5 i tekstom (ukupno oko 35 KB).
// Vraća već izabrane recenzije: najviše jedna po biznisu.
const HOME_REVIEWS_COUNT = 6;
function useHomeReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey(k => k + 1);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const headers = { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${SUPABASE_ANON}` };
        const table = `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}`;
        const base = `${table}?select=*&or=(obrisano.is.null,obrisano.eq.false)&ocena=eq.5&tekst=not.is.null&tekst=neq.&tekst=neq.EMPTY&reply_to_id=is.null&order=id.desc`;
        const SLICE = 20, SLICES = 4;

        // Koliko takvih recenzija ima (broj stiže u zaglavlju, bez podataka)
        const countRes = await fetch(`${base}&limit=1`, { headers: { ...headers, "Prefer": "count=exact" } });
        if (!countRes.ok) throw new Error(`Supabase error: ${countRes.status}`);
        const total = parseInt((countRes.headers.get("content-range") || "").split("/")[1], 10) || 0;

        // Recenzije istog biznisa stoje jedna do druge, pa se uzima više isečaka sa
        // različitih mesta da bi se dobili različiti biznisi
        const maxOffset = Math.max(0, total - SLICE);
        const offsets = new Set();
        while (offsets.size < Math.min(SLICES, Math.floor(maxOffset / SLICE) + 1)) offsets.add(Math.floor(Math.random() * (maxOffset + 1)));
        const pages = await Promise.all([...offsets].map(async (off) => {
          const res = await fetch(`${base}&limit=${SLICE}&offset=${off}`, { headers });
          return res.ok ? res.json() : [];
        }));
        const pool = pages.flat().filter(r => r && (r.tekst || "").trim());

        // Mešanje (Fisher-Yates), pa najviše jedna recenzija po biznisu
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        const seen = new Set();
        const picked = [];
        for (const row of pool) {
          const biz = (row.biznis_ime || "").trim();
          if (!biz || seen.has(biz)) continue;
          seen.add(biz);
          picked.push(normalizeReview(row));
          if (picked.length === HOME_REVIEWS_COUNT) break;
        }

        // Odgovori na izabrane recenzije (retko ih ima; jedan mali zahtev)
        let replies = [];
        if (picked.length) {
          try {
            const repRes = await fetch(`${table}?select=*&reply_to_id=in.(${picked.map(r => r.id).join(",")})&or=(obrisano.is.null,obrisano.eq.false)&order=id.asc`, { headers });
            if (repRes.ok) replies = (await repRes.json()).map(normalizeReview);
          } catch {}
        }
        if (!cancelled) setReviews(picked.map(r => ({ ...r, replies: replies.filter(rep => rep.reply_to_id === r.id) })));
      } catch (e) {
        console.error("useHomeReviews error:", e);
        if (!cancelled) setReviews(FALLBACK_REVIEWS.slice(0, HOME_REVIEWS_COUNT));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);

  return { reviews, loading, refresh };
}

// Kartica-senka dok se recenzije učitavaju (isti oblik kao prava kartica)
function ReviewCardSkeleton() {
  const bar = (w, h = 12, mt = 0) => <div className="ns-sk" style={{ width: w, height: h, borderRadius: 6, marginTop: mt }} />;
  return (
    <div aria-hidden="true" style={{ background: "#fff", borderRadius: 20, padding: "24px 24px 26px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div className="ns-sk" style={{ width: 34, height: 34, borderRadius: "50%", flexShrink: 0 }} />
        <div style={{ flex: 1 }}>{bar("42%", 13)}{bar("30%", 11, 8)}</div>
      </div>
      {bar(96, 14, 16)}
      {bar("100%", 12, 16)}{bar("92%", 12, 9)}{bar("60%", 12, 9)}
    </div>
  );
}

function Reviews({ onViewAll, onPageOpen }) {
  const { isMobile, w } = useBreakpoint();
  const cols = isMobile ? 1 : w < 900 ? 2 : 3;
  const px   = isMobile ? "16px" : "48px";
  const { reviews, loading, refresh: refreshReviews } = useHomeReviews();
  const [replyReview, setReplyReview] = useState(null);
  useScrollLock(!!replyReview);
  useReveal();
  const shown = isMobile ? 3 : HOME_REVIEWS_COUNT;

  return (
    <section className="na-reveal" style={{ background: BG, padding: `48px ${px}` }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <h2 style={{
          fontFamily: SF, letterSpacing: "-0.03em",
          fontSize: isMobile ? 32 : 38, fontWeight: 800, margin: "0 0 12px", color: "#111", lineHeight: 1.15,
        }}>
          Popularne <span style={{ color: BLUE, fontWeight: 800 , whiteSpace: "nowrap"}}>recenzije</span>
        </h2>
        <p style={{
          fontFamily: SF, fontSize: isMobile ? 16 : 17, fontWeight: 500,
          letterSpacing: "-0.01em", color: "#333",
          margin: "0 auto 28px", lineHeight: 1.6, maxWidth: isMobile ? 400 : 420,
        }}>
          Pročitajte <span style={{ color: BLUE, fontWeight: 700 , whiteSpace: "nowrap"}}>iskrena</span> mišljenja korisnika o
          {" "}najmilenijim mestima u <span style={{ color: BLUE, fontWeight: 700 , whiteSpace: "nowrap"}}>Novom Sadu</span>.
        </p>
        <style>{`
          .reviews-cta .reviews-cta-arrow { transition: transform 0.3s cubic-bezier(0.4,0,0.2,1); }
          .reviews-cta:hover .reviews-cta-arrow { transform: translate(3px,-3px); }
          .rv-sk { background: linear-gradient(90deg, #eef0f3 25%, #f7f8fa 37%, #eef0f3 63%); background-size: 400% 100%; animation: rvShimmer 1.4s ease infinite; }
          @keyframes rvShimmer { from { background-position: 100% 50%; } to { background-position: 0 50%; } }
          @media (prefers-reduced-motion: reduce) { .rv-sk { animation: none; } }
        `}</style>
        <button className="btn-blue reviews-cta" onClick={() => onViewAll && onViewAll()} style={{
          background: BLUE, color: "#fff", border: "none",
          borderRadius: 10,
          width: isMobile ? "85%" : 350,
          maxWidth: isMobile ? 320 : "none",
          height: 50,
          fontSize: 14, fontWeight: 700, cursor: "pointer",
          fontFamily: SF, letterSpacing: "-0.01em",
          boxShadow: "0 4px 20px rgba(0,0,0,0.13)",
          display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7,
        }}>
          Pogledajte sve recenzije
          <ArrowUpRight size={16} className="reviews-cta-arrow" strokeWidth={2.5} />
        </button>
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: isMobile ? 14 : 20,
        alignItems: "start",
      }}>
        {replyReview && <ReplyModal review={replyReview} onClose={() => setReplyReview(null)} onSent={() => { setReplyReview(null); refreshReviews(); }} onAuthRequest={() => onPageOpen && onPageOpen("profile", "login")} />}
        {loading && reviews.length === 0
          ? Array.from({ length: shown }, (_, i) => <ReviewCardSkeleton key={i} />)
          : reviews.slice(0, shown).map((r, i) => <ReviewCard key={r.id ?? i} r={r} onReplyClick={setReplyReview} />)}
      </div>
    </section>
  );
}

/* ==========================================
   POPULAR SEARCHES
========================================== */





const searches = [
  { img: PSEARCH_1, title: "Noćni klubovi i splavovi",  sub: "Noćni život", cat: "Noćni život", subcat: "Klubovi & Splavovi",                    pos: "center center", bg: "#0a1628", scale: 1.4 },
  { img: PSEARCH_2, title: "Vinski barovi",             sub: "Noćni život", cat: "Noćni život", subcat: "Koktel & Vinski barovi"                                                                    },
  { img: PSEARCH_3, title: "Brunch mesta",              sub: "Kafići",      cat: "Kafići",      subcat: "Brunch kafići"                                                                             },
  { img: PSEARCH_4, title: "Fitness centri i teretane", sub: "Sport",       cat: "Sport",       subcat: "Fitness centri & Teretane"                                                                 },
  { img: PSEARCH_5, title: "Nargila barovi",            sub: "Kafići",      cat: "Kafići",      subcat: "Nargila barovi"                                                                            },
  { img: PSEARCH_6, title: "Frizerski saloni",          sub: "Nega",        cat: "Nega",        subcat: "Frizerski saloni & Barberi"                                                                },
  { img: PSEARCH_7, title: "Specialty kafa",            sub: "Kafići",      cat: "Kafići",      subcat: "Specialty Coffee & Pržionice"                                                              },
  { img: PSEARCH_8, title: "Etno smeštaj",              sub: "Hoteli",      cat: "Hoteli",      subcat: "Salaši & Etno smeštaj"                                                                    },
];

/* --- Global cursor --- */
function GlobalCursor({ visibleRef }) {
  const elRef = useRef(null);
  const pos = useRef({ x: -200, y: -200 });

  useEffect(() => {
    // Postavi na van ekrana odmah da ne bude vidljiv na 0,0
    if (elRef.current) {
      elRef.current.style.transform = `translate(-200px, -200px)`;
    }

    const move = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };
      if (!elRef.current) return;
      // Uvek prati miš - bez tranzicije na poziciji, samo opacity se animira
      elRef.current.style.transform = `translate(${e.clientX - 26}px, ${e.clientY - 26}px)`;
      elRef.current.style.opacity = visibleRef.current ? "1" : "0";
    };

    // Skrolovanje trackpadom ne pomera stvarni pokazivač miša, pa se ne
    // pokreće mouseleave kad kartica "otpliva" ispod njega - kursor ostaje
    // zaglavljen vidljiv i posle sekcije. Zato ga na svaki skrol prisilno
    // sakrijemo; ponovo će se pojaviti tek na sledeći stvaran hover.
    const hideOnScroll = () => {
      visibleRef.current = false;
      if (elRef.current) elRef.current.style.opacity = "0";
    };

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("scroll", hideOnScroll, { passive: true, capture: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("scroll", hideOnScroll, { capture: true });
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      ref={elRef}
      style={{
        position:       "fixed",
        top:            0,
        left:           0,
        width:          52,
        height:         52,
        borderRadius:   "50%",
        background:     BLUE,
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        pointerEvents:  "none",
        zIndex:         99999,
        opacity:        0,
        // SAMO opacity se animira, transform NIKAD nema tranziciju
        transition:     "opacity 0.18s ease",
        willChange:     "transform, opacity",
        boxShadow:      "0 4px 20px rgba(0,0,0,0.14)",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M4 14L14 4M14 4H6M14 4V12"
          stroke="white" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}

/* --- Single card --- */
function PopularSearchCard({ item, cardW, cursorVisibleRef, onClick }) {
  const [hovered, setHovered] = useState(false);
  const { isMobile } = useBreakpoint();
  const isHov = isMobile ? false : hovered; // na mobilnom nikad hover efekat

  /* Portrait 449:674 */
  const IMG_H = Math.round(cardW * (674 / 449));

  const onEnter = () => {
    setHovered(true);
    if (cursorVisibleRef) cursorVisibleRef.current = true;
  };
  const onLeave = () => {
    setHovered(false);
    if (cursorVisibleRef) cursorVisibleRef.current = false;
  };

  return (
    <a
      href={item.cat ? categoryPath(item.cat, item.subcat) : "/"}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); onClick && onClick(item); }}
      style={{ flexShrink: 0, width: cardW, cursor: isMobile ? "pointer" : "none", userSelect: "none", display: "block", textDecoration: "none" }}
    >
      {/* Image box  -  height always fixed so text never shifts */}
      <div style={{
        width:        cardW,
        height:       IMG_H,
        borderRadius: isHov ? `${Math.round(cardW / 2)}px` : 18,
        overflow:     "hidden",
        background:   item.bg || "#1a1a1a",
        lineHeight:   0,
        boxShadow:    isHov ? "0 20px 40px rgba(0,0,0,0.22)" : "0 1px 3px rgba(0,0,0,0.08)",
        transition:   "border-radius 0.44s cubic-bezier(0.4,0,0.2,1), box-shadow 0.44s cubic-bezier(0.4,0,0.2,1)",
      }}>
        <img
          src={item.img}
          alt={item.title}
          draggable={false}
          style={{
            display:        "block",
            width:          "100%",
            height:         "100%",
            minHeight:      "100%",
            objectFit:      "cover",
            objectPosition: item.pos || "center center",
            transform:      isHov ? `scale(${(item.scale || 1) * 1.06})` : `scale(${item.scale || 1})`,
            transition:     "transform 0.44s cubic-bezier(0.4,0,0.2,1)",
            pointerEvents:  "none",
          }}
        />
      </div>

      {/* Caption  -  fixed height, text never moves */}
      <div style={{ marginTop: 14, height: 54, overflow: "hidden" }}>
        <div style={{
          fontFamily:    SF,
          fontSize:      16,
          fontWeight:    700,
          color:         isHov ? BLUE : "#111",
          letterSpacing: "-0.01em",
          lineHeight:    1.35,
          marginBottom:  3,
          transition:    "color 0.2s ease",
          whiteSpace:    "nowrap",
          overflow:      "hidden",
          textOverflow:  "ellipsis",
        }}>
          {item.title}
        </div>
        <div style={{
          fontFamily:    SF,
          fontSize:      14,
          fontWeight:    500,
          color:         isHov ? BLUE : "#888",
          letterSpacing: "-0.01em",
          transition:    "color 0.2s ease",
        }}>
          {item.sub}
        </div>
      </div>
    </a>
  );
}

/* --- Arrow button --- */
function SearchArrow({ dir, onClick }) {
  const [hov, setHov] = useState(false);
  const { isMobile } = useBreakpoint();
  const btnSize = isMobile ? 44 : 40;
  const size = isMobile ? 18 : 16;
  return (
    <button
      className="ns-arrow"
      aria-label={dir === "left" ? "Prethodno" : "Sledeće"}
      onClick={onClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        width: btnSize, height: btnSize, borderRadius: "50%",
        background: hov ? BLUE : "#fff",
        border: `1px solid ${hov ? BLUE : "rgba(0,0,0,0.08)"}`,
        boxShadow: hov ? "0 6px 18px rgba(0,0,0,0.13)" : "0 1px 4px rgba(0,0,0,0.06)",
        cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease",
        transform: hov ? "scale(1.06)" : "scale(1)",
        marginLeft: dir === "right" ? 10 : 0,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 44 44" fill="none"
        style={{ transform: dir === "left" ? "scaleX(-1)" : "none" }}
      >
        <path
          d="M32 22.28C32 22.55 31.95 22.8 31.86 23.03C31.76 23.26 31.6 23.48 31.39 23.69L19.22 35.59C18.86 35.94 18.44 36.11 17.94 36.11C17.59 36.11 17.29 36.03 17.02 35.86C16.73 35.7 16.51 35.49 16.34 35.22C16.18 34.95 16.09 34.64 16.09 34.3C16.09 33.81 16.29 33.37 16.67 32.98L27.64 22.28L16.67 11.58C16.29 11.19 16.09 10.75 16.09 10.25C16.09 9.92 16.18 9.61 16.34 9.34C16.51 9.06 16.73 8.84 17.02 8.69C17.29 8.52 17.59 8.44 17.94 8.44C18.44 8.44 18.86 8.61 19.22 8.97L31.39 20.88C31.6 21.08 31.76 21.3 31.86 21.53C31.95 21.76 32 22.01 32 22.28Z"
          fill={hov ? "#fff" : "#111"}
          style={{ transition: "fill 0.3s ease" }}
        />
      </svg>
    </button>
  );
}

/* --- Main section --- */
function PopularSearches({ onCategorySelect, cursorRef }) {
  const { isMobile, w } = useBreakpoint();
  const px    = isMobile ? "16px" : "48px";
  const pxNum = isMobile ? 16 : 48;
  useReveal();

  const localCursorRef = useRef(false);
  const cursorVisibleRef = cursorRef || localCursorRef;

  const CARD_W   = isMobile ? Math.round(w * 0.78) : w < 900 ? 240 : 320;
  const CARD_GAP = isMobile ? 24 : 20;
  const STEP     = CARD_W + CARD_GAP;
  const N        = searches.length;

  const visibleW = w - pxNum; // širina vidljivog dela (bez levog paddinga)
  const visibleCount = Math.floor(visibleW / STEP); // koliko kartica stane
  const maxIdx = Math.max(0, N - visibleCount);

  const [idx,      setIdx]      = useState(0);
  const [dragging, setDragging] = useState(false);
  const [inView,   setInView]   = useState(false);
  const dragX   = useRef(0);
  const autoRef = useRef(null);
  const sectionRef = useRef(null);

  // Pokreni auto-scroll tek kad sekcija uđe u viewport
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        setIdx(0); // uvek kreni od prve kartice
        obs.disconnect();
      }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const startAuto = () => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => {
      setIdx((i) => (i >= maxIdx ? 0 : i + 1));
    }, 5000);
  };

  useEffect(() => {
    if (!inView) return;
    startAuto();
    return () => clearInterval(autoRef.current);
  }, [inView, maxIdx, STEP]); // eslint-disable-line react-hooks/exhaustive-deps

  const goRight = () => { setIdx((i) => (i >= maxIdx ? 0 : i + 1)); startAuto(); };
  const goLeft  = () => { setIdx((i) => (i <= 0 ? maxIdx : i - 1)); startAuto(); };

  const onDown = (cx) => { setDragging(true); dragX.current = cx; clearInterval(autoRef.current); };
  const onMove = () => {};
  const onUp   = (cx) => {
    if (!dragging) return;
    setDragging(false);
    const delta = dragX.current - cx;
    const thr   = STEP * 0.25;
    if      (delta >  thr) setIdx((i) => Math.min(i + 1, maxIdx));
    else if (delta < -thr) setIdx((i) => Math.max(i - 1, 0));
    startAuto();
  };

  const trackW = N * CARD_W + (N - 1) * CARD_GAP + CARD_GAP; // +CARD_GAP = desni padding kao između kartica
  const maxOffset = Math.max(0, trackW - visibleW);
  const offset = -Math.min(idx * STEP, maxOffset);

  return (
    <section ref={sectionRef} className="na-reveal" style={{ background: BG, padding: `48px 0 52px ${px}`, overflow: "hidden" }}>
      <style>{`
        .ps-card-wrap {
          opacity: 0;
          transform: translateY(40px) scale(0.96);
          transition: opacity 0.9s cubic-bezier(0.16,1,0.3,1),
                      transform 0.9s cubic-bezier(0.16,1,0.3,1);
        }
        .ps-card-wrap.ps-visible {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      `}</style>
      {/* GlobalCursor se renderuje na root nivou app-a, ne ovde */}

      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "center", marginBottom: 28, paddingRight: px,
      }}>
        <h2 style={{
          fontFamily: SF, letterSpacing: "-0.03em",
          fontSize: isMobile ? 32 : 38, fontWeight: 800,
          margin: 0, color: "#111", lineHeight: 1.15,
        }}>
          Popularne pretrage u{" "}
          <span style={{ color: BLUE, fontWeight: 800 , whiteSpace: "nowrap"}}>Novom Sadu</span>
        </h2>
        <div style={{ display: "flex", gap: 0 }}>
          <SearchArrow dir="left"  onClick={goLeft}  />
          <SearchArrow dir="right" onClick={goRight} />
        </div>
      </div>

      <div
        onMouseEnter={() => !isMobile && clearInterval(autoRef.current)}
        onMouseLeave={() => !isMobile && startAuto()}
        style={{ overflow: "hidden" }}
      >
        <div
          onMouseDown={(e)  => onDown(e.clientX)}
          onMouseMove={(e)  => onMove(e.clientX)}
          onMouseUp={(e)    => onUp(e.clientX)}
          onMouseLeave={(e) => onUp(e.clientX)}
          onTouchStart={(e) => onDown(e.touches[0].clientX)}
          onTouchMove={(e)  => onMove(e.touches[0].clientX)}
          onTouchEnd={(e)   => onUp(e.changedTouches[0].clientX)}
          style={{
            display:       "flex",
            gap:           CARD_GAP,
            width:         trackW,
            transform:     `translateX(${offset}px)`,
            transition:    dragging ? "none" : "transform 0.55s cubic-bezier(0.4,0,0.2,1)",
            willChange:    "transform",
            cursor:        dragging ? "grabbing" : "none",
            paddingBottom: 8,
            touchAction:   "pan-y",
          }}
        >
          {searches.map((item, i) => (
            <div
              key={i}
              className={`ps-card-wrap${inView ? " ps-visible" : ""}`}
              style={{ transitionDelay: inView ? `${i * 0.12}s` : "0s", flexShrink: 0 }}
            >
              <PopularSearchCard
                item={item}
                cardW={CARD_W}
                cursorVisibleRef={isMobile ? null : cursorVisibleRef}
                onClick={(it) => { if (it.cat && onCategorySelect) onCategorySelect(it.cat, it.subcat || null); }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


/* ==========================================
   NIGHTLIFE
========================================== */

const nightlife = [
  {
    video: nlVideo1,
    thumb: nlThumb1,
    img: heroImg1,
    anchor: "right",
    pageKey: "nocni-klubovi",
    title: "Noćni Klubovi",
    desc: "Doživite energičnu atmosferu uz svetski poznate DJ-eve, modernu muziku i vrhunsku rasvetu u najpopularnijim noćnim klubovima u Novom Sadu. Savršeno za ljubitelje elektronske muzike i nezaboravne žurke.",
    cta: "Istražite klubove",
  },
  {
    video: nlVideo2,
    thumb: nlThumb2,
    img: heroImg2,
    anchor: "left",
    pageKey: "pivnice",
    title: "Najbolje Novosadske Pivnice",
    desc: "Uživajte u autentičnoj atmosferi novosadskih pivnica. Od zanatskih piva (craft beer) do tradicionalnih sorti, pronađite savršeno mesto za opuštanje sa prijateljima uz domaću muziku i hranu.",
    cta: "Istražite pivnice",
  },
  {
    video: nlVideo3,
    thumb: nlThumb3,
    img: heroImg3,
    videoPosition: "center 85%",
    anchor: "right",
    pageKey: "kokteli-barovi",
    title: "Koktel & Vinski Barovi",
    desc: "Otkrijte najelegantnija mesta za večernji izlazak u Novom Sadu. Od savršeno mešanih koktela do pažljivo odabranih vina, ovi barovi nude premium iskustvo uz sofisticiranu atmosferu i vrhunsku uslugu.",
    cta: "Istražite barove",
  },
];

// Statična slika (prvi kadar videa) - ne preuzimamo ceo video samo da bismo
// dobili thumbnail (to je bilo ~28MB po poseti i browser je stalno "učitavao").
function VideoThumb({ thumb, videoPosition, style: outerStyle }) {
  return (
    <div style={{ position: "absolute", inset: 0, ...outerStyle }}>
      <img src={thumb} alt="" loading="lazy" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: videoPosition || "center center", display: "block" }} />
    </div>
  );
}

function NightlifeCard({ item, isMobile, isTablet, onCategorySelect, onPageOpen, stackMode }) {
  const [hov, setHov] = useState(false);
  // Video (5-11MB) se preuzima tek kad korisnik pređe mišem preko kartice;
  // do tada se prikazuje statična slika (poster).
  const [wantVideo, setWantVideo] = useState(false);
  const videoRef = useRef(null);
  const resetTimerRef = useRef(null);
  const isLeft = item.anchor === "left";

  const containerRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (isMobile || isTablet) return;
    const el = containerRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setInView(true); obs.disconnect(); }
    }, { rootMargin: "200px" });
    obs.observe(el);
    return () => obs.disconnect();
  }, [isMobile, isTablet]);

  useEffect(() => {
    if (isMobile || isTablet) return;
    const vid = videoRef.current;
    if (!vid) return;
    if (hov) {
      vid.play().catch(() => {});
    } else {
      vid.pause();
    }
  }, [hov, isMobile, isTablet]);

  /* -- MOBILE + TABLET: video pauziran na 00:00, bez hover efekta -- */
  if (isMobile || isTablet) {
    return (
      <a
        href={item.pageKey ? "/" + item.pageKey : categoryPath("Noćni život")}
        onClick={(e) => {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          if (item.pageKey && onPageOpen) {
            onPageOpen(item.pageKey);
          } else if (onCategorySelect) {
            onCategorySelect("Noćni život");
          }
        }}
        style={{
          display: "block", textDecoration: "none",
          borderRadius: 20, overflow: "hidden",
          background: "#111", cursor: "pointer",
          boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
        }}
      >
        {/* Video zamrznut na 00:00 - canvas hvata prvi frame kao poster */}
        <div style={{ height: isTablet ? 280 : 220, overflow: "hidden", background: "#111", position: "relative" }}>
          <VideoThumb thumb={item.thumb} videoPosition={item.videoPosition} />
        </div>
        {/* Content */}
        <div style={{ padding: isTablet ? "28px 32px" : "24px 22px", background: "#fff" }}>
          <div style={{
            fontFamily: SF, fontSize: isTablet ? 20 : 19, fontWeight: 700,
            color: "#111", letterSpacing: "-0.01em", lineHeight: 1.2, marginBottom: 10,
          }}>
            {item.title}
          </div>
          <p style={{
            fontFamily: SF, fontSize: 14, fontWeight: 400, color: "#555",
            lineHeight: 1.65, letterSpacing: "-0.01em", margin: "0 0 20px",
          }}>
            {item.desc}
          </p>
          <div className="btn-blue" role="button" tabIndex={0}
            onClick={e => { e.stopPropagation(); e.preventDefault(); if (item.pageKey && onPageOpen) onPageOpen(item.pageKey); else if (onCategorySelect) onCategorySelect("Noćni život"); }}
            onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); if (item.pageKey && onPageOpen) onPageOpen(item.pageKey); else if (onCategorySelect) onCategorySelect("Noćni život"); } }}
            style={{
            background: BLUE, color: "#fff", border: "none",
            borderRadius: 10, width: "100%", height: 48,
            fontSize: 14, fontWeight: 600, cursor: "pointer",
            fontFamily: SF, letterSpacing: "-0.01em",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
          }}>
            {item.cta || "Pogledajte više"}
            <ArrowUpRight size={15} strokeWidth={2.5} />
          </div>
        </div>
      </a>
    );
  }

  /* -- DESKTOP only (>=1024px): floating white label over video -- */
  return (
    <a
      ref={containerRef}
      href={item.pageKey ? "/" + item.pageKey : categoryPath("Noćni život")}
      onMouseEnter={() => { setWantVideo(true); setHov(true); }}
      onMouseLeave={() => setHov(false)}
      onClick={(e) => {
        // pravi link (Google ga prati), običan klik ostaje u sajtu; Ctrl/srednji klik otvara novi tab
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (item.pageKey && onPageOpen) onPageOpen(item.pageKey); else if (onCategorySelect) onCategorySelect("Noćni život");
      }}
      style={{
        display: "block", textDecoration: "none",
        borderRadius: 20, overflow: "hidden", background: "#111",
        position: stackMode ? "sticky" : "relative", top: stackMode ? 40 : undefined,
        height: 520, cursor: "pointer",
      }}
    >
      <video
        ref={videoRef}
        src={wantVideo ? item.video : undefined}
        poster={item.thumb}
        muted
        loop
        playsInline
        disablePictureInPicture
        preload={wantVideo ? "auto" : "none"}
        style={{
          position: "absolute", inset: 0, width: "100%", height: "100%",
          objectFit: "cover", objectPosition: item.videoPosition || "center center", display: "block",
          opacity: hov ? 0.92 : 0.7,
          transform: hov ? "scale(1.04)" : "scale(1)",
          transition: "opacity 700ms cubic-bezier(0.4, 0, 0.2, 1), transform 700ms cubic-bezier(0.4, 0, 0.2, 1)",
          willChange: "opacity, transform",
        }}
      />

      {/* White label  -  anchored top & bottom so it fills most of the card height */}
      <div style={{
        position: "absolute",
        top: 28,
        bottom: 28,
        left:  isLeft  ? "auto" : 32,
        right: isLeft  ? 32    : "auto",
        background: "#ffffff",
        borderRadius: 20,
        padding: "44px 40px",
        width: 420,
        boxShadow: hov ? "0 28px 64px rgba(0,0,0,0.07), 0 8px 24px rgba(0,0,0,0.2)" : "0 20px 60px rgba(0,0,0,0.25)",
        transition: "transform 0.4s ease, box-shadow 0.4s ease",
        transform: hov ? "translateY(-6px)" : "translateY(0)",
        /* flex column + space-between pushes button to the bottom */
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}>
        {/* Top content group */}
        <div>
          <div style={{
            fontFamily: SF, letterSpacing: "-0.01em", fontSize: 26,
            fontWeight: 700, color: "#111", marginBottom: 16, lineHeight: 1.15,
          }}>
            {item.title}
          </div>
          <p style={{
            fontFamily: SF, fontSize: 15, fontWeight: 400, color: "#555",
            lineHeight: 1.72, letterSpacing: "-0.01em", margin: 0,
          }}>
            {item.desc}
          </p>
        </div>

        {/* Button anchored to bottom via space-between */}
        <div className="btn-blue nl-cta" role="button" tabIndex={0}
          onClick={e => { e.stopPropagation(); e.preventDefault(); if (item.pageKey && onPageOpen) onPageOpen(item.pageKey); else if (onCategorySelect) onCategorySelect("Noćni život"); }}
          onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); if (item.pageKey && onPageOpen) onPageOpen(item.pageKey); else if (onCategorySelect) onCategorySelect("Noćni život"); } }}
          style={{
          background: BLUE, color: "#fff", border: "none",
          borderRadius: 10, width: "100%", height: 52,
          fontSize: 15, fontWeight: 600, cursor: "pointer",
          fontFamily: SF, letterSpacing: "-0.01em", flexShrink: 0,
          display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
        }}>
          {item.cta || "Pogledajte više"}
          <ArrowUpRight size={16} className="nl-cta-arrow" strokeWidth={2.5} />
        </div>
      </div>
    </a>
  );
}

function NightlifeSection({ onCategorySelect, onPageOpen }) {
  const { isMobile, w } = useBreakpoint();
  const isTablet = w >= 640 && w < 1024;
  const px = isMobile ? "20px" : isTablet ? "32px" : "48px";
  useReveal();

  // "Stacking" scroll efekat radi samo prvi put kad korisnik skroluje DO ove
  // sekcije u trenutnoj poseti stranice. Čim je jednom napusti (u bilo kom
  // pravcu - nastavi nadole ili se vrati nagore), gasimo ga trajno za ostatak
  // te posete, tako da ponovni prolazak (npr. posle povratka na vrh strane)
  // prikazuje kartice normalno, bez lepljenja/prekrivanja.
  const sectionRef = useRef(null);
  const [stackMode, setStackMode] = useState(true);
  const hasEnteredRef = useRef(false);

  useEffect(() => {
    if (isMobile || isTablet) return;
    const el = sectionRef.current;
    if (!el) return;
    // rootMargin razvučen 800px na obe strane - "izašla je iz vidokruga"
    // se registruje tek kad je sekcija STVARNO daleko van ekrana (ne čim
    // pređe ivicu), da promena visine (koja gasi stacking) ne pogodi nešto
    // što je korisnik trenutno gleda i izazove skok skrola.
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        hasEnteredRef.current = true;
      } else if (hasEnteredRef.current) {
        setStackMode(false);
        obs.disconnect();
      }
    }, { threshold: 0, rootMargin: "800px 0px 800px 0px" });
    obs.observe(el);
    return () => obs.disconnect();
  }, [isMobile, isTablet]);

  return (
    <section ref={sectionRef} className="na-reveal" style={{ background: BG, padding: `80px ${px}` }}>
      <style>{`
        .nl-cta .nl-cta-arrow { transition: transform 0.3s cubic-bezier(0.4,0,0.2,1); }
        .nl-cta:hover .nl-cta-arrow { transform: translate(3px,-3px); }
      `}</style>
      <div style={{ textAlign: "center", marginBottom: isMobile ? 48 : 64 }}>
        <p style={{
          fontFamily: SF, fontSize: 14, fontWeight: 700,
          color: BLUE, margin: "0 0 14px", letterSpacing: "0.12em",
          textTransform: "uppercase",
        }}>
          Spremni za izlazak?
        </p>
        <h2 style={{
          fontFamily: SF, letterSpacing: "-0.03em",
          fontSize: isMobile ? 32 : 38,
          fontWeight: 800, margin: "0 0 12px", color: "#111", lineHeight: 1.15,
        }}>
          Noćni život u{" "}
          <span style={{ color: BLUE, fontWeight: 800 , whiteSpace: "nowrap"}}>Novom Sadu</span>
        </h2>
        <p style={{
          fontFamily: SF, fontSize: isMobile ? 16 : 17, fontWeight: 500,
          letterSpacing: "-0.01em", color: "#333",
          margin: "0 auto", lineHeight: 1.6, maxWidth: isMobile ? 400 : 620,
        }}>
          <span style={{ whiteSpace: isMobile ? "normal" : "nowrap" }}>
            Istražite najbolje ocenjene lokale za{" "}
            <span style={{ color: BLUE, fontWeight: 700 }}>noćni provod</span>.{" "}
            Novi Sad
          </span>
          {!isMobile && <br />}{" "}nudi bogat i raznolik noćni život za sve ukuse.
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 16 : isTablet ? 20 : 40 }}>
        {nightlife.map((item, i) => (
          (isMobile || isTablet || !stackMode) ? (
            <NightlifeCard key={i} item={item} isMobile={isMobile} isTablet={isTablet} onCategorySelect={onCategorySelect} onPageOpen={onPageOpen} stackMode={false} />
          ) : (
            /* "Scroll traka" viša od same kartice - dok se skrola kroz višak
               prostora, kartica ostaje zalepljena (sticky) na mestu, a sledeća
               je prekriva odozgo kad njena traka počne. Otud efekat slaganja. */
            <div key={i} style={{ position: "relative", height: 760 }}>
              <NightlifeCard item={item} isMobile={isMobile} isTablet={isTablet} onCategorySelect={onCategorySelect} onPageOpen={onPageOpen} stackMode={true} />
            </div>
          )
        ))}
      </div>
    </section>
  );
}

/* ==========================================
   CTA BLOCKS
========================================== */

const ICON_MAP     = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1OSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ5LjE2NjggMjAuNTgzN0M0OS4xNjY4IDMyLjg1ODEgMzUuNTUwMSA0NS42NDE1IDMwLjk3NzYgNDkuNTg5NUMzMC41NTE3IDQ5LjkwOTggMzAuMDMzMSA1MC4wODMgMjkuNTAwMiA1MC4wODNDMjguOTY3MiA1MC4wODMgMjguNDQ4NyA0OS45MDk4IDI4LjAyMjcgNDkuNTg5NUMyMy40NTAyIDQ1LjY0MTUgOS44MzM1IDMyLjg1ODEgOS44MzM1IDIwLjU4MzdDOS44MzM1IDE1LjM2NzcgMTEuOTA1NSAxMC4zNjU0IDE1LjU5MzcgNi42NzcyM0MxOS4yODE5IDIuOTg5MDEgMjQuMjg0MiAwLjkxNjk5MiAyOS41MDAyIDAuOTE2OTkyQzM0LjcxNjEgMC45MTY5OTIgMzkuNzE4NCAyLjk4OTAxIDQzLjQwNjYgNi42NzcyM0M0Ny4wOTQ4IDEwLjM2NTQgNDkuMTY2OCAxNS4zNjc3IDQ5LjE2NjggMjAuNTgzN1oiIHN0cm9rZT0iIzAwNzlGRiIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI5LjUgMjcuOTU4QzMzLjU3MzEgMjcuOTU4IDM2Ljg3NSAyNC42NTYxIDM2Ljg3NSAyMC41ODNDMzYuODc1IDE2LjUwOTkgMzMuNTczMSAxMy4yMDggMjkuNSAxMy4yMDhDMjUuNDI2OSAxMy4yMDggMjIuMTI1IDE2LjUwOTkgMjIuMTI1IDIwLjU4M0MyMi4xMjUgMjQuNjU2MSAyNS40MjY5IDI3Ljk1OCAyOS41IDI3Ljk1OFoiIHN0cm9rZT0iIzAwNzlGRiIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
const ICON_ADD     = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1OSA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjI5MTcgMjkuNUg0Ni43MDg0IiBzdHJva2U9IiMwMDc5RkYiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI5LjUgMTIuMjkxNVY0Ni43MDgyIiBzdHJva2U9IiMwMDc5RkYiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
const ICON_RATE    = "data:image/svg+xml;base64,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";
const ICON_CONTACT = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OSA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjY3NzcgNDQuMjc1NUMyOS43NTUyIDQ0LjQ2ODggMjkuODkwMSA0NC42MzM3IDMwLjA2NDEgNDQuNzQ4MkMzMC4yMzgxIDQ0Ljg2MjcgMzAuNDQzIDQ0LjkyMTIgMzAuNjUxMiA0NC45MTU4QzMwLjg1OTUgNDQuOTEwNSAzMS4wNjExIDQ0Ljg0MTYgMzEuMjI5IDQ0LjcxODRDMzEuMzk2OSA0NC41OTUxIDMxLjUyMzIgNDQuNDIzNSAzMS41OTA3IDQ0LjIyNjVMNDQuODYxNiA1LjQzNDgxQzQ0LjkyNjkgNS4yNTM5IDQ0LjkzOTQgNS4wNTgxMyA0NC44OTc1IDQuODcwNEM0NC44NTU2IDQuNjgyNjYgNDQuNzYxMiA0LjUxMDc0IDQ0LjYyNTIgNC4zNzQ3M0M0NC40ODkyIDQuMjM4NzIgNDQuMzE3MiA0LjE0NDI2IDQ0LjEyOTUgNC4xMDI0QzQzLjk0MTggNC4wNjA1NCA0My43NDYgNC4wNzMwMSA0My41NjUxIDQuMTM4MzVMNC43NzM0MyAxNy40MDkyQzQuNTc2NCAxNy40NzY4IDQuNDA0NzUgMTcuNjAzIDQuMjgxNTMgMTcuNzcwOUM0LjE1ODMxIDE3LjkzODggNC4wODk0MSAxOC4xNDA1IDQuMDg0MDggMTguMzQ4N0M0LjA3ODc0IDE4LjU1NjkgNC4xMzcyMyAxOC43NjE4IDQuMjUxNjkgMTguOTM1OEM0LjM2NjE2IDE5LjEwOTggNC41MzExMSAxOS4yNDQ3IDQuNzI0NDMgMTkuMzIyMkwyMC45MTQ4IDI1LjgxNDdDMjEuNDI2NyAyNi4wMTk2IDIxLjg5MTcgMjYuMzI2MSAyMi4yODE5IDI2LjcxNTZDMjIuNjcyMSAyNy4xMDUxIDIyLjk3OTMgMjcuNTY5NSAyMy4xODUyIDI4LjA4MUwyOS42Nzc3IDQ0LjI3NTVaIiBzdHJva2U9IiMwMDc5RkYiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQ0LjYxODYgNC4zODMzTDIyLjI4MjcgMjYuNzE3MSIgc3Ryb2tlPSIjMDA3OUZGIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
const ICON_ARROW   = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyIDIyLjI4MTJDMzIgMjIuNTUyMSAzMS45NTMxIDIyLjgwMjEgMzEuODU5NCAyMy4wMzEyQzMxLjc1NTIgMjMuMjYwNCAzMS41OTkgMjMuNDc5MiAzMS4zOTA2IDIzLjY4NzVMMTkuMjE4OCAzNS41OTM3QzE4Ljg2NDYgMzUuOTM3NSAxOC40Mzc1IDM2LjEwOTQgMTcuOTM3NSAzNi4xMDk0QzE3LjU5MzggMzYuMTA5NCAxNy4yODY1IDM2LjAyNiAxNy4wMTU2IDM1Ljg1OTRDMTYuNzM0NCAzNS43MDMxIDE2LjUxMDQgMzUuNDg5NiAxNi4zNDM4IDM1LjIxODdDMTYuMTc3MSAzNC45NDc5IDE2LjA5MzggMzQuNjQwNiAxNi4wOTM4IDM0LjI5NjlDMTYuMDkzOCAzMy44MDczIDE2LjI4NjUgMzMuMzY5OCAxNi42NzE5IDMyLjk4NDRMMjcuNjQwNiAyMi4yODEyTDE2LjY3MTkgMTEuNTc4MUMxNi4yODY1IDExLjE5MjcgMTYuMDkzOCAxMC43NSAxNi4wOTM4IDEwLjI1QzE2LjA5MzggOS45MTY2NyAxNi4xNzcxIDkuNjE0NTggMTYuMzQzOCA5LjM0Mzc1QzE2LjUxMDQgOS4wNjI1IDE2LjczNDQgOC44NDM3NSAxNy4wMTU2IDguNjg3NUMxNy4yODY1IDguNTIwODMgMTcuNTkzOCA4LjQzNzUgMTcuOTM3NSA4LjQzNzVDMTguNDM3NSA4LjQzNzUgMTguODY0NiA4LjYxNDU4IDE5LjIxODggOC45Njg3NUwzMS4zOTA2IDIwLjg3NUMzMS41OTkgMjEuMDgzMyAzMS43NTUyIDIxLjMwMjEgMzEuODU5NCAyMS41MzEyQzMxLjk1MzEgMjEuNzYwNCAzMiAyMi4wMTA0IDMyIDIyLjI4MTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";

function CTARow({ iconSrc, title, right, isMobile, onAction }) {
  const [hov, setHov] = useState(false);
  const { w } = useBreakpoint();
  const isSmall = w < 1024;

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={() => onAction && onAction()}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: isSmall ? "auto" : 170,
        minHeight: isSmall ? 0 : 170,
        padding: isSmall ? (isMobile ? "36px 0" : "30px 0") : "0",
        background: hov ? BLUE : "transparent",
        borderBottom: `1px solid ${hov ? BLUE : "rgba(0,0,0,0.10)"}`,
        cursor: "pointer",
        transition: "background 0.4s ease, border-radius 0.4s ease, padding 0.4s ease, margin 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease",
        paddingLeft:  hov ? 24 : 0,
        paddingRight: hov ? 24 : 0,
        marginLeft:   hov ? -24 : 0,
        marginRight:  hov ? -24 : 0,
        borderRadius: hov ? 18 : 0,
        boxShadow: hov ? "0 16px 40px rgba(0,0,0,0.1)" : "none",
        userSelect: "none",
        boxSizing: "border-box",
        gap: 12,
      }}
    >
      {/* Left: icon + title */}
      <div style={{ display: "flex", alignItems: "center", gap: isSmall ? 16 : 22, flexShrink: 0 }}>
        <img
          src={iconSrc}
          alt={title}
          width={isSmall ? 32 : 32}
          height={isSmall ? 32 : 32}
          style={{
            display: "block", flexShrink: 0,
            filter: hov ? "brightness(0) invert(1)" : "none",
            transition: "filter 0.4s ease",
          }}
        />
        <span style={{
          fontFamily: SF,
          fontSize: isSmall ? (isMobile ? 20 : 21) : 32,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          color: hov ? "#fff" : "#111",
          transition: "color 0.4s ease",
          lineHeight: 1.1,
          whiteSpace: "nowrap",
        }}>
          {title}
        </span>
      </div>

      {/* Right: description + arrow  -  hidden on true mobile, visible tablet+ */}
      {!isMobile && (
        <div style={{
          display: "flex", alignItems: "center", gap: 6,
          flexShrink: 1, minWidth: 0, overflow: "hidden",
          marginLeft: "auto",
          paddingLeft: 16,
        }}>
          <span style={{
            fontFamily: SF,
            fontSize: isSmall ? 12 : 14,
            fontWeight: 500,
            color: hov ? "#fff" : "#000",
            letterSpacing: "-0.01em",
            transition: "color 0.4s ease",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}>
            {right}
          </span>
          <img
            src={ICON_ARROW}
            alt=""
            width={18} height={18}
            style={{
              display: "block", flexShrink: 0,
              filter: hov ? "brightness(0) invert(1)" : "none",
              transform: hov ? "translateX(4px)" : "translateX(0)",
              transition: "filter 0.4s ease, transform 0.4s cubic-bezier(0.4,0,0.2,1)",
            }}
          />
        </div>
      )}
    </div>
  );
}

function CTABlocks({ onMapOpen, onPageOpen }) {
  const { isMobile, w } = useBreakpoint();
  const isSmall = w < 1024;
  const px = isMobile ? "20px" : w < 900 ? "32px" : "48px";
  useReveal();

  // Planovi su vidljivi svima; prijava se traži tek kad posetilac izabere plan
  const handleAddBiznis = () => { onPageOpen && onPageOpen("dodaj-biznis"); };

  const rows = [
    { iconSrc: ICON_ADD,     title: "Dodajte vaš biznis",    right: "Postanite vidljivi kupcima u Novom Sadu",            onAction: handleAddBiznis },
    { iconSrc: ICON_RATE,    title: "Ocenite i preporučite", right: "Vaša recenzija pomaže drugima da odaberu najbolje", onAction: () => onPageOpen && onPageOpen("oceni")   },
    { iconSrc: ICON_CONTACT, title: "Kontaktirajte nas",     right: "Tu smo za sva vaša pitanja i predloge",           onAction: () => onPageOpen && onPageOpen("kontakt") },
  ];

  return (
    <section style={{ background: BG, padding: `64px ${px}` }}>

      {/* Header  -  stacks on mobile & small tablet */}
      <div style={{
        display: "flex",
        flexDirection: isSmall ? "column" : "row",
        justifyContent: isSmall ? "flex-start" : "space-between",
        alignItems: "flex-start",
        marginBottom: isMobile ? 36 : 56,
        gap: isSmall ? 14 : 40,
      }}>
        <h2 style={{
          fontFamily: SF, letterSpacing: "-0.03em",
          fontSize: isMobile ? 32 : 38,
          fontWeight: 800, margin: 0, color: "#111",
          lineHeight: 1.15,
          maxWidth: isSmall ? "100%" : "56%",
          flex: "0 0 auto",
        }}>
          Slušamo, cenimo i uvažavamo{" "}
          <span style={{ color: BLUE, fontWeight: 800 , whiteSpace: "nowrap"}}>vaše mišljenje</span>.
        </h2>

        {/* Right paragraph  -  only on proper desktop */}
        {!isSmall && (
          <p style={{
            fontFamily: SF, fontSize: 17, fontWeight: 500,
            color: "#333", letterSpacing: "-0.01em",
            lineHeight: 1.6, margin: 0,
            maxWidth: 320, textAlign: "right",
            flex: "0 0 auto",
          }}>
            <span style={{ color: BLUE, fontWeight: 700 , whiteSpace: "nowrap"}}>Vaše mišljenje</span>{" "}
            nam je od velikog značaja za dalji razvoj. Podelite svoje
            iskustvo i postanite deo zajednice koju gradi{" "}
            <span style={{ color: BLUE, fontWeight: 700 , whiteSpace: "nowrap"}}>Novosadski Adresar</span>.
          </p>
        )}
      </div>

      {/* Rows */}
      <div>
        {rows.map((row, i) => (
          <CTARow key={i} {...row} isMobile={isMobile} onAction={row.onAction} />
        ))}
        <div style={{ borderBottom: "1px solid rgba(0,0,0,0.10)" }} />
      </div>


    </section>
  );
}

/* ==========================================
   CONTACT FORM + FOOTER  (merged, blue bg)
========================================== */

function ContactForm() {
  const { isMobile, w } = useBreakpoint();
  const isNarrow = w < 768;
  const [name,    setName]    = React.useState("");
  const [email,   setEmail]   = React.useState("");
  const [message, setMessage] = React.useState("");
  const [website,  setWebsite]  = React.useState(""); // honeypot - nevidljivo poljue, botovi ga popune
  const [sending,  setSending]  = React.useState(false);
  const [sent,     setSent]     = React.useState(false);
  const [sendErr,  setSendErr]  = React.useState("");

  const handleSubmit = async () => {
    if (website.trim()) { setSent(true); setName(""); setEmail(""); setMessage(""); return; } // bot - tiho "uspeh"
    if (!email.trim()) { setSendErr("Email je obavezan."); return; }
    if (!isValidEmail(email.trim())) { setSendErr("Unesite ispravnu email adresu (npr. ime@gmail.com)."); return; }
    if (!message.trim()) { setSendErr("Poruka je obavezna."); return; }
    if (message.trim().length < 10) { setSendErr("Poruka je prekratka - opišite vaš upit."); return; }
    setSending(true); setSendErr("");
    try {
      await insertKontakt({ ime: name, email, poruka: message });
      setSent(true);
      setName(""); setEmail(""); setMessage("");
      setTimeout(() => setSent(false), 5000);
    } catch (e) {
      setSendErr(describeError(e));
    } finally {
      setSending(false);
    }
  };

  const inputStyle = {
    width: "100%", boxSizing: "border-box",
    background: "rgba(255,255,255,0.15)",
    border: "1.5px solid rgba(255,255,255,0.35)",
    borderRadius: 10, padding: "14px 18px",
    fontFamily: SF, fontSize: 14, color: "#fff",
    outline: "none", letterSpacing: "-0.01em",
    "::placeholder": { color: "rgba(255,255,255,0.6)" },
  };

  return (
    <section style={{
      background: BLUE,
      padding: isNarrow ? "52px 20px 64px" : "64px 48px 80px",
    }}>
      <style>{`
        .cf-input::placeholder { color: rgba(255,255,255,0.65); }
        .cf-input:focus { border-color: rgba(255,255,255,0.8) !important; }
      `}</style>

      <div style={{
        display: "flex",
        flexDirection: isNarrow ? "column" : "row",
        gap: isNarrow ? 40 : 80,
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}>
        {/* Left  -  heading */}
        <div style={{ flex: "0 0 auto", maxWidth: isNarrow ? "100%" : "42%" }}>
          <h2 style={{
            fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif",
            letterSpacing: "-0.04em",
            fontSize: isNarrow ? 42 : 72,
            fontWeight: 800, color: "#fff",
            margin: "0 0 20px", lineHeight: 1.0,
          }}>
            Budimo u<br />kontaktu!
          </h2>
          <p style={{
            fontFamily: SF, fontSize: 15, fontWeight: 500,
            color: "rgba(255,255,255,0.85)", letterSpacing: "-0.01em",
            lineHeight: 1.6, margin: 0, maxWidth: 440,
          }}>
            Imate pitanje, predlog ili želite da prijavite problem na sajtu? Pišite nam direktno.
          </p>
        </div>

        {/* Right  -  form */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 12, width: "100%", maxWidth: isNarrow ? "100%" : 480 }}>
          {/* Honeypot - nevidljivo za ljude, botovi ga popune */}
          <input
            type="text" name="website" tabIndex={-1} autoComplete="off"
            value={website} onChange={e => setWebsite(e.target.value)}
            style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
            aria-hidden="true"
          />
          <input
            className="cf-input"
            placeholder="Ime i prezime"
            value={name}
            onChange={e => setName(e.target.value)}
            style={{ ...inputStyle }}
          />
          <input
            className="cf-input"
            placeholder="Vaš email (obavezno)"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{ ...inputStyle }}
          />
          <textarea
            className="cf-input"
            placeholder="Vaša poruka (predlog ili prijava...)"
            value={message}
            onChange={e => setMessage(e.target.value)}
            rows={4}
            style={{ ...inputStyle, resize: "none", lineHeight: 1.6 }}
          />
          {sendErr && (
            <p style={{ fontFamily: SF, fontSize: 13, color: "#ffcdd2", margin: "0 0 4px" }}>{sendErr}</p>
          )}
          {sent && (
            <p style={{ fontFamily: SF, fontSize: 13, color: "#c8f7c5", margin: "0 0 4px", display: "flex", alignItems: "center", gap: 6 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8f7c5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Poruka je poslata! Kontaktiraćemo vas uskoro.
            </p>
          )}
          <button className="btn-dark" onClick={handleSubmit} disabled={sending} style={{
            background: sending ? "rgba(0,0,0,0.5)" : "#000", color: "#fff", border: "none",
            borderRadius: 10, padding: "15px 32px",
            fontSize: 15, fontWeight: 700,
            cursor: sending ? "not-allowed" : "pointer", fontFamily: SF,
            letterSpacing: "-0.01em",
            alignSelf: "flex-start",
            transition: "background 0.4s ease",
          }}>
            {sending ? "Slanje..." : "Pošalji poruku"}
          </button>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  const { isMobile, w } = useBreakpoint();
  const isSmall = w < 900;

  const cols = [
    { title: "Restorani",    cat: "Restorani",    links: ["Domaći restorani", "Roštilj i meso", "Italijanska hrana", "Azijski ukusi", "Brza hrana", "Veganski restorani", "Morska hrana"] },
    { title: "Kafići",       cat: "Kafići",        links: ["Klasični kafići", "Specialty Coffee & Pržionice", "Poslastičarnice", "Barovi i Pubovi", "Brunch kafići", "Nargila barovi", "Knjižare kafići"] },
    { title: "Noćni život",  cat: "Noćni život",   links: ["Klubovi & Splavovi", "Kafane & Tamburaši", "Pub-ovi & Pivnice", "Koktel & Vinski barovi"] },
    { title: "Sport",        cat: "Sport",         links: ["Fitness centri & Teretane", "CrossFit & Funkcionalni trening", "Yoga & Pilates", "Borilačke veštine", "Sportski baloni & Tereni", "Plesni studiji & Škole plesa"] },
    { title: "Nega",         cat: "Nega",          links: ["Frizerski saloni & Barberi", "Kozmetički saloni", "Masaža & Spa", "Estetska medicina & Laser centri", "Tetoviranje & Pirsing"] },
    { title: "Auto",         cat: "Auto",          links: ["Auto servisi & Mehaničari", "Autoperionice & Dubinsko pranje", "Vulkanizeri & Prodaja guma", "Tehnički pregled & Registracija", "Rent-a-Car"] },
    { title: "Zdravlje",     cat: "Zdravlje",      links: ["Privatne klinike & Laboratorije", "Stomatolozi", "Apoteke", "Veterinari & Vet ambulante", "Fizioterapeuti & Kiropraktičari", "Psihoterapija", "Državne bolnice & Domovi zdravlja"] },
    { title: "Hoteli",       cat: "Hoteli",        links: ["Hoteli & Apartmani", "Hosteli & Sobe", "Wellness & Spa hoteli", "Boutique hoteli", "Salaši & Etno smeštaj"] },
    { title: "Bazeni",       cat: "Bazeni",        links: ["Gradski bazeni & Aquaparci", "Sportski bazeni", "Spa & Wellness bazeni", "Privatni & Sezonski bazeni"] },
    { title: "Zanati",       cat: "Zanati",        links: ["Vodoinstalateri & Grejanje", "Električari", "Stolari & Nameštaj", "Obućari & Kožni artikli", "Krojači & Krojačnice", "Servis bele tehnike", "Ključari & Brave"] },
  ];

  const gridCols = isMobile ? "repeat(2,1fr)" : isSmall ? "repeat(3,1fr)" : "repeat(5,1fr)";

  return (
    <footer style={{
      background: BLUE,
      padding: isMobile ? "0 20px 40px" : "0 48px 52px",
    }}>
      <div style={{ borderTop: "1px solid rgba(0,0,0,0.18)", marginBottom: isMobile ? 36 : 48 }} />

      <div style={{
        display: "grid",
        gridTemplateColumns: gridCols,
        gap: isMobile ? "32px 20px" : "32px 24px",
        marginBottom: isMobile ? 40 : 52,
      }}>
        {cols.map((col, ci) => (
          <div key={ci}>
            <a
              href={categoryPath(col.cat)}
              onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); window.dispatchEvent(new CustomEvent('footer-nav', { detail: { cat: col.cat } })); }}
              style={{
                fontFamily: SF, fontSize: 15, fontWeight: 700,
                color: "#fff", letterSpacing: "-0.01em",
                marginBottom: 14, cursor: "pointer",
                display: "block", textDecoration: "none",
              }}
              onMouseEnter={e => e.target.style.opacity="0.75"}
              onMouseLeave={e => e.target.style.opacity="1"}
            >
              {col.title}
            </a>
            {col.links.map((link, li) => (
              <a key={li}
                href={categoryPath(col.cat, link)}
                onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); window.dispatchEvent(new CustomEvent('footer-nav', { detail: { cat: col.cat, sub: link } })); }}
                style={{
                  fontFamily: SF, fontSize: 13, fontWeight: 400,
                  color: "rgba(255,255,255,0.7)",
                  letterSpacing: "-0.01em",
                  marginBottom: 8, cursor: "pointer",
                  transition: "color 0.2s ease",
                  display: "block", textDecoration: "none",
                }}
                onMouseEnter={e => e.target.style.color="#fff"}
                onMouseLeave={e => e.target.style.color="rgba(255,255,255,0.7)"}
              >
                {link}
              </a>
            ))}
          </div>
        ))}
      </div>

      <div style={{
        borderTop: "1px solid rgba(0,0,0,0.18)",
        paddingTop: 20,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
      }}>
        <span style={{ fontFamily: SF, fontSize: 12, color: "rgba(255,255,255,0.55)", letterSpacing: "-0.01em" }}>
          © 2026 Novosadski Adresar. Sva prava zadržana.
        </span>
        {/* Pravi linkovi (<a href>): bez njih Google i Ahrefs nisu nalazili ove stranice
            ("orphan"). Običan klik i dalje otvara stranicu unutar sajta. */}
        <div style={{ display: "flex", gap: isMobile ? "10px 16px" : 20, flexWrap: "wrap" }}>
          {[
            { label: "Blog",                 page: "blog" },
            { label: "Recenzije",            page: "recenzije" },
            { label: "Oceni lokal",          page: "oceni" },
            { label: "Dodaj biznis",         page: "dodaj-biznis" },
            { label: "Kontakt",              page: "kontakt" },
            { label: "Uslovi korišćenja",    page: "uslovi-koriscenja" },
            { label: "Politika privatnosti", page: "politika-privatnosti" },
            { label: "Kolačići",             page: "kolacici" },
          ].map(({ label, page }) => (
            <a key={page} href={"/" + page}
              onClick={(e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); window.__nsNav && window.__nsNav.goTo(page); }}
              style={{
              fontFamily: SF, fontSize: 12,
              color: "rgba(255,255,255,0.55)", textDecoration: "none",
              cursor: "pointer", letterSpacing: "-0.01em",
              transition: "color 0.2s ease",
            }}
              onMouseEnter={e => e.target.style.color="#fff"}
              onMouseLeave={e => e.target.style.color="rgba(255,255,255,0.55)"}
            >{label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}


class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  componentDidCatch(e, info) { console.error("ErrorBoundary caught:", e, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, color: "#c00", fontFamily: "monospace", fontSize: 13 }}>
          <b>Greška:</b> {this.state.error.message}
        </div>
      );
    }
    return this.props.children;
  }
}

/* ==========================================
   ROOT
========================================== */
/* ==========================================
   ROOT
========================================== */
/* ============================================================
   BIZNISI U VASOJ BLIZINI  -  Apple Maps Style
============================================================ */

const NEARBY_CAT_COLORS = {
  Restorani: "#0079FF", Kafici: "#D4952B", Teretane: "#7D5BC6",
  Hoteli: "#4F7DB3", Bazeni: "#2A9D8F", Usluge: "#3F9B5F",
  "Nocni zivot": "#D2454E", Zdravlje: "#2F95A6",
};

function getMapBusinesses() {
  const coords = [
    [45.2517,19.8369],[45.2601,19.8432],[45.2480,19.8510],[45.2550,19.8290],
    [45.2630,19.8350],[45.2445,19.8455],[45.2575,19.8520],[45.2510,19.8610],
    [45.2490,19.8240],[45.2660,19.8410],[45.2530,19.8300],[45.2440,19.8380],
    [45.2600,19.8480],[45.2470,19.8540],[45.2555,19.8260],[45.2615,19.8390],
    [45.2495,19.8460],[45.2540,19.8335],[45.2580,19.8420],[45.2465,19.8490],
    [45.2625,19.8365],[45.2505,19.8570],[45.2545,19.8285],[45.2590,19.8445],
  ];
  let all = [], ci = 0;
  Object.entries(listingData).forEach(([cat, items]) => {
    items.forEach(item => {
      all.push({ ...item, category: cat,
        lat: coords[ci % coords.length][0],
        lng: coords[ci % coords.length][1] });
      ci++;
    });
  });
  return all;
}

function toXY(lat, lng, W, H) {
  const x = ((lng - 19.810) / (19.875 - 19.810)) * W;
  const y = ((45.275 - lat) / (45.275 - 45.230)) * H;
  return { x: Math.max(8, Math.min(W-8, x)), y: Math.max(8, Math.min(H-8, y)) };
}

/* Module-level business card for sidebar */
function NearbyBizCard({ biz, isActive, isHovered, isSaved, onFocus, onEnter, onLeave, onSave }) {
  const color = NEARBY_CAT_COLORS[biz.category] || BLUE;
  // Uzmi prvu sliku biznisa iz baze
  const imgUrl = Array.isArray(biz.images) && biz.images.length > 0
    ? (typeof biz.images[0] === "string" ? biz.images[0] : biz.images[0]?.url || null)
    : null;
  return (
    <div
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={onFocus}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onFocus && onFocus(e); } }}
      style={{
        display: "flex", alignItems: "flex-start", gap: 12,
        padding: "12px 16px",
        background: isActive ? `${BLUE}0f` : isHovered ? "rgba(0,0,0,0.03)" : "transparent",
        cursor: "pointer",
        transition: "all 0.4s ease",
      }}
    >
      {/* Slika biznisa ili category fallback */}
      <div style={{
        width: 46, height: 46, borderRadius: 10, flexShrink: 0, marginTop: 1,
        background: imgUrl ? "transparent" : `${color}18`,
        overflow: "hidden",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: imgUrl ? "0 1px 6px rgba(0,0,0,0.12)" : "none",
      }}>
        {imgUrl ? (
          <img
            src={imgUrl}
            alt={biz.name}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            onError={e => { e.target.style.display = "none"; e.target.parentNode.style.background = `${color}18`; }}
          />
        ) : (
          <MapPin size={16} color={color} strokeWidth={2}/>
        )}
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: SF, fontSize: 14, fontWeight: 700, color: "#111",
          letterSpacing: "-0.01em", marginBottom: 2, whiteSpace: "nowrap",
          overflow: "hidden", textOverflow: "ellipsis" }}>
          {biz.name}
        </div>
        <div style={{ fontSize: 12, color: "#888", marginBottom: 4,
          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {biz.sub}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
          {[1,2,3,4,5].map(i => (
            <svg key={i} width="10" height="10" viewBox="0 0 24 23" fill="none">
              <path d="M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z" fill={i <= biz.rating ? BLUE : "#e0e0e0"}/>
            </svg>
          ))}
          <span style={{ fontSize: 11, color: "#bbb", marginLeft: 2 }}>
            ({biz.reviews || 0})
          </span>
        </div>
      </div>

      {/* Save button */}
      <button
        onClick={e => { e.stopPropagation(); onSave(); }}
        style={{ background: "none", border: "none", cursor: "pointer",
          padding: "2px 0", flexShrink: 0, marginTop: 2,
          transition: "transform 0.2s cubic-bezier(0.34,1.56,0.64,1)",
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 23" fill={isSaved ? BLUE : "none"} stroke={isSaved ? "none" : "#ccc"} strokeWidth="1.5">
          <path d="M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z" fill={isSaved ? BLUE : "none"} stroke={isSaved ? "none" : "#ccc"} strokeWidth="1.5"/>
        </svg>
      </button>
    </div>
  );
}


/* ── Auth modal za favorites ── */
function AddBizAuthModal({ onClose, onLogin, onRegister }) {
  React.useEffect(() => {
    const h = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.45)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:"#fff", borderRadius:24, padding:"40px 36px 32px", maxWidth:420, width:"100%", boxShadow:"0 24px 80px rgba(0,0,0,0.18)", position:"relative", animation:"fadeInDown 0.25s ease" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"#f5f5f7", border:"none", borderRadius:"50%", width:32, height:32, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", color:"#666", padding:0 }} aria-label="Zatvori"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" style={{ display: "block" }}><path d="M6 6l12 12M18 6L6 18" /></svg></button>
        <div style={{ width:64, height:64, borderRadius:"50%", background:`${BLUE}12`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
          </svg>
        </div>
        <h2 style={{ fontFamily:SF, fontSize:22, fontWeight:800, color:"#111", margin:"0 0 10px", letterSpacing:"-0.03em", textAlign:"center" }}>Dodajte vaš biznis</h2>
        <p style={{ fontFamily:SF, fontSize:14, color:"#888", lineHeight:1.65, margin:"0 0 28px", textAlign:"center", letterSpacing:"-0.02em" }}>
          Prijavite se ili registrujte da biste dodali vaš biznis i postali vidljivi u Novom Sadu.
        </p>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <button onClick={onLogin} style={{ width:"100%", height:50, background:BLUE, color:"#fff", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:700, cursor:"pointer", letterSpacing:"-0.02em", boxShadow:"0 4px 20px rgba(0,0,0,0.11)" }}>Prijavite se</button>
          <button onClick={onRegister} style={{ width:"100%", height:50, background:"#f5f5f7", color:"#111", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:600, cursor:"pointer", letterSpacing:"-0.02em" }}>Registrujte se</button>
        </div>
      </div>
    </div>
  );
}

function FavAuthModal({ onClose, onLogin, onRegister, title = "Sačuvajte omiljene lokale", text = "Prijavite se ili registrujte da biste čuvali omiljene lokale i pristupali im sa svog profila." }) {
  React.useEffect(() => {
    const h = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.45)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:"#fff", borderRadius:24, padding:"40px 36px 32px", maxWidth:420, width:"100%", boxShadow:"0 24px 80px rgba(0,0,0,0.18)", position:"relative", animation:"fadeInDown 0.25s ease" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"#f5f5f7", border:"none", borderRadius:"50%", width:32, height:32, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", color:"#666", padding:0 }} aria-label="Zatvori"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" style={{ display: "block" }}><path d="M6 6l12 12M18 6L6 18" /></svg></button>
        <div style={{ width:64, height:64, borderRadius:"50%", background:`${BLUE}12`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
          <svg width="28" height="28" viewBox="0 0 24 23" fill={BLUE}><path d="M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z"/></svg>
        </div>
        <h2 style={{ fontFamily:SF, fontSize:22, fontWeight:800, color:"#111", margin:"0 0 10px", letterSpacing:"-0.03em", textAlign:"center" }}>{title}</h2>
        <p style={{ fontFamily:SF, fontSize:14, color:"#888", lineHeight:1.65, margin:"0 0 28px", textAlign:"center", letterSpacing:"-0.02em" }}>
          {text}
        </p>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <button onClick={onLogin} style={{ width:"100%", height:50, background:BLUE, color:"#fff", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:700, cursor:"pointer", letterSpacing:"-0.02em", boxShadow:"0 4px 20px rgba(0,0,0,0.11)" }}>Prijavite se</button>
          <button onClick={onRegister} style={{ width:"100%", height:50, background:"#f5f5f7", color:"#111", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:600, cursor:"pointer", letterSpacing:"-0.02em" }}>Registrujte se</button>
        </div>
      </div>
    </div>
  );
}

function AuthRequiredModal({ onClose, onLogin, onRegister }) {
  React.useEffect(() => {
    const h = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.45)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:"#fff", borderRadius:24, padding:"40px 36px 32px", maxWidth:420, width:"100%", boxShadow:"0 24px 80px rgba(0,0,0,0.18)", position:"relative" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"#f5f5f7", border:"none", borderRadius:"50%", width:32, height:32, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", color:"#666", padding:0 }} aria-label="Zatvori"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" style={{ display: "block" }}><path d="M6 6l12 12M18 6L6 18" /></svg></button>
        <div style={{ width:64, height:64, borderRadius:"50%", background:`${BLUE}12`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
        <h2 style={{ fontFamily:SF, fontSize:22, fontWeight:800, color:"#111", margin:"0 0 10px", letterSpacing:"-0.03em", textAlign:"center" }}>Napišite recenziju</h2>
        <p style={{ fontFamily:SF, fontSize:14, color:"#888", lineHeight:1.65, margin:"0 0 28px", textAlign:"center", letterSpacing:"-0.02em" }}>
          Prijavite se ili registrujte da biste ostavili recenziju i podelili iskustvo sa zajednicom.
        </p>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <button onClick={onLogin} style={{ width:"100%", height:50, background:BLUE, color:"#fff", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:700, cursor:"pointer", letterSpacing:"-0.02em", boxShadow:"0 4px 20px rgba(0,0,0,0.11)" }}>Prijavite se</button>
          <button onClick={onRegister} style={{ width:"100%", height:50, background:"#f5f5f7", color:"#111", border:"none", borderRadius:14, fontFamily:SF, fontSize:15, fontWeight:600, cursor:"pointer", letterSpacing:"-0.02em" }}>Registrujte se</button>
        </div>
      </div>
    </div>
  );
}

/* ==========================================
   AUTH + PROFILE PAGE
========================================== */

// ── Admin helper funkcije ────────────────────────────────────────
async function checkIsAdmin(userId, token) {
  try {
    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/admini?user_id=eq.${userId}&select=user_id&limit=1`,
      { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
    );
    const data = await res.json();
    return Array.isArray(data) && data.length > 0;
  } catch { return false; }
}

async function getAdminStats(token) {
  const h = { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}`, "Prefer": "count=exact" };
  const getCount = async (url) => {
    const r = await fetch(url, { headers: h });
    const cr = r.headers.get("content-range");
    return cr ? cr.split("/")[1] : "?";
  };
  const [biznisi, recenzije, korisnici, kontakt] = await Promise.all([
    getCount(`${SUPABASE_URL}/rest/v1/${encodeURIComponent("Biznisi Novi Sad")}?select=id`),
    getCount(`${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?select=id&izvor=neq.reply`),
    // Koristimo RPC funkciju jer RLS blokira direktno čitanje svih profila
    fetch(`${SUPABASE_URL}/rest/v1/rpc/get_users_count`, {
      method: "POST",
      headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
      body: "{}",
    }).then(r => r.json()).then(n => String(n)).catch(() => "?"),
    getCount(`${SUPABASE_URL}/rest/v1/Kontakt?select=id`),
  ]);
  return { biznisi, recenzije, korisnici, kontakt };
}

async function getKontaktPoruke(token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/Kontakt?select=*&order=datum.desc`,
    { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
  );
  return res.ok ? res.json() : [];
}

// ── Biznis zahtevi ──────────────────────────────────────────────
// Upis u tabelu sa poljem "plan". Ako kolona "plan" još nije dodata u bazi,
// PostgREST odbija ceo upis; tada se isti red šalje ponovo bez tog polja, da
// dodavanje biznisa nikad ne zavisi od toga. Vraća { res, planSaved }.
async function postWithOptionalPlan(url, headers, row) {
  let res = await fetch(url, { method: "POST", headers, body: JSON.stringify(row) });
  if (res.ok || !("plan" in row)) return { res, planSaved: res.ok && "plan" in row };
  const txt = await res.clone().text().catch(() => "");
  if (!/plan/i.test(txt)) return { res, planSaved: false };
  const { plan, ...withoutPlan } = row; // eslint-disable-line no-unused-vars
  res = await fetch(url, { method: "POST", headers, body: JSON.stringify(withoutPlan) });
  return { res, planSaved: false };
}

async function insertBiznisZahtev({ user_id, ime, kategorija, adresa, telefon, email, sajt, opis, radno_vreme, slike, plan = "free", token }) {
  const { res, planSaved } = await postWithOptionalPlan(`${SUPABASE_URL}/rest/v1/biznis_zahtevi`, {
    "apikey": SUPABASE_ANON,
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Prefer": "return=minimal",
  }, { user_id, ime, kategorija, adresa, telefon, email, sajt, opis, radno_vreme, slike, plan, status: "pending" });
  if (!res.ok) throw await apiError(res);
  notifyAdmin("biznis_zahtev", { ime, kategorija, adresa, telefon, email, sajt, opis, radno_vreme, plan }, token);
  trackEvent("business_request", { kategorija, plan });
  return { planSaved };
}

// Otpremi fotografije za zahtev u Supabase Storage (bucket "biznis-slike").
// Ako bucket ne postoji ili upload ne uspe za neku sliku, ta slika se
// preskače (ne blokira slanje ostatka zahteva) i greška se vraća pozivaocu
// da može da obavesti korisnika - umesto da tiho izgubi fotografiju.
async function toUploadJpeg(file) {
  const okType = /^image\/(jpeg|png|webp)$/.test(file.type);
  if (okType && file.size <= 1.5 * 1024 * 1024) return file; // već mala i u dozvoljenom formatu
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
    const c = document.createElement("canvas");
    c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
    c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
    const blob = await new Promise((res) => c.toBlob(res, "image/jpeg", 0.85));
    if (!blob) throw new Error("toBlob");
    return new File([blob], "slika.jpg", { type: "image/jpeg" });
  } catch {
    // browser ne ume da otvori sliku: pošalji original samo ako je dozvoljen i ispod 5 MB
    return okType && file.size <= 5 * 1024 * 1024 ? file : null;
  }
}

async function uploadBiznisSlike(files, userId, token) {
  const urls = [];
  const failed = []; // [{ name, reason }] - razlog za svaku sliku koja nije otpremljena
  for (let i = 0; i < files.length; i++) {
    // Telefonske slike su često veće od 5 MB (limit bucketa) ili u formatu koji bucket ne
    // prima (HEIC). Zato svaku sliku koju browser ume da prikaže smanjimo na najviše
    // 1600 px i pretvorimo u JPG. SVG/HTML nikad ne prolazi (bucket prima samo jpg/png/webp).
    const name = files[i].name || `slika ${i + 1}`;
    const file = await toUploadJpeg(files[i]);
    if (!file) {
      const tooBig = files[i].size > 5 * 1024 * 1024;
      failed.push({ name, reason: tooBig ? "fajl je veći od 5 MB, a nije mogao da se smanji" : "format nije podržan (koristite JPG, PNG ili WebP)" });
      continue;
    }
    const ext = file.type === "image/png" ? "png" : file.type === "image/webp" ? "webp" : "jpg";
    const path = `${userId}/${Date.now()}-${i}.${ext}`;
    try {
      const res = await fetch(`${SUPABASE_URL}/storage/v1/object/biznis-slike/${path}`, {
        method: "POST",
        headers: {
          "apikey": SUPABASE_ANON,
          "Authorization": `Bearer ${token}`,
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });
      if (!res.ok) {
        const reason = res.status === 413 ? "fajl je prevelik za server"
          : res.status === 415 || res.status === 400 ? "server nije prihvatio format slike"
          : res.status === 401 || res.status === 403 ? "prijava je istekla ili nema dozvolu za otpremanje"
          : `server je odbio sliku (kod ${res.status})`;
        failed.push({ name, reason });
        continue;
      }
      urls.push(`${SUPABASE_URL}/storage/v1/object/public/biznis-slike/${path}`);
    } catch { failed.push({ name, reason: "nema veze sa serverom" }); }
  }
  return { urls, anyFailed: failed.length > 0, failed };
}

async function getMyBiznisZahtevi(user_id, token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/biznis_zahtevi?user_id=eq.${user_id}&select=*&order=created_at.desc`,
    { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
  );
  return res.ok ? res.json() : [];
}

async function getAdminBiznisZahtevi(token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/biznis_zahtevi?select=*&order=created_at.desc`,
    { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
  );
  return res.ok ? res.json() : [];
}

async function updateBiznisZahtevStatus(id, status, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/biznis_zahtevi?id=eq.${id}`, {
    method: "PATCH",
    headers: {
      "apikey": SUPABASE_ANON,
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ status }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

// Odobrava zahtev I automatski kreira biznis u glavnoj tabeli
// Na javni listing prenosimo samo slike iz našeg biznis-slike bucket-a,
// ne proizvoljne adrese koje je podnosilac zahteva upisao mimo forme.
function ownBucketImages(slike) {
  const prefix = `${SUPABASE_URL}/storage/v1/object/public/biznis-slike/`;
  try {
    const arr = typeof slike === "string" ? JSON.parse(slike) : slike;
    if (!Array.isArray(arr)) return null;
    const ok = arr.filter((u) => typeof u === "string" && u.startsWith(prefix) && !u.includes(".."));
    return ok.length ? JSON.stringify(ok) : null;
  } catch { return null; }
}

async function approveBiznisZahtev(zahtev, token) {
  // 1. Radno vreme iz zahteva ("Ponedeljak: 08:00 - 22:00 | ... | Nedelja: Zatvoreno")
  //    u format ostalih lokala u bazi ("ponedeljak: 08:00–22:00", "nedelja: Zatvoreno");
  //    dani bez unetog vremena ("Subota: /") se izostavljaju umesto da se upiše "/".
  const parseRV = (rvText) => {
    if (!rvText) return null;
    const out = rvText.split(" | ").map(entry => {
      const m = entry.match(/^(.+?):\s*(.+)$/);
      if (!m) return null;
      const day = m[1].trim().toLowerCase();
      const val = m[2].trim();
      if (/^zatvoreno$/i.test(val)) return `${day}: Zatvoreno`;
      const t = val.match(/^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/);
      return t ? `${day}: ${t[1]}–${t[2]}` : null;
    }).filter(Boolean);
    return out.length ? out : null;
  };

  // 2. Geocoding - pretvori adresu u lat/lng pomoću OpenStreetMap Nominatim (besplatno)
  let lat = null, lng = null;
  try {
    const query = encodeURIComponent(`${zahtev.adresa}, Novi Sad, Serbia`);
    const geoRes = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`,
      { headers: { "User-Agent": "NovosadskiAdresar/1.0" } }
    );
    const geoData = await geoRes.json();
    if (geoData && geoData.length > 0) {
      lat = parseFloat(geoData[0].lat);
      lng = parseFloat(geoData[0].lon);
    }
  } catch { /* geocoding nije kritičan, nastavljamo bez koordinata */ }

  // Deo grada: najbliži poznati deo grada, ako je lokacija dovoljno blizu (do ~1,5 km)
  let deoGrada = null;
  if (lat && lng) {
    let best = null, bestD = Infinity;
    for (const [name, c] of Object.entries(DEO_COORDS)) {
      const d = Math.hypot((c.lat - lat) * 111, (c.lng - lng) * 78.5); // km
      if (d < bestD) { bestD = d; best = name; }
    }
    if (bestD <= 1.5) deoGrada = best.replace(/ \d+$/, ""); // "Liman 3" -> "Liman", kao u filterima
  }

  // 3. Unesi biznis u Biznisi Novi Sad (samo kolone koje tabela ima)
  const biznis = {
    ime: zahtev.ime,
    // u bazi su Sport i Nega upisani kao Teretane i Usluge
    kategorija: CATEGORY_DB_NAME_MAP[zahtev.kategorija] || zahtev.kategorija,
    adresa: zahtev.adresa,
    telefon: zahtev.telefon,
    email: zahtev.email || null,
    website: zahtev.sajt ? (/^https?:\/\//i.test(zahtev.sajt) ? zahtev.sajt : "https://" + zahtev.sajt.replace(/^\/+/, "")) : null,
    opis: zahtev.opis,
    radno_vreme: parseRV(zahtev.radno_vreme),
    slike: ownBucketImages(zahtev.slike),
    ocena: 0,
    broj_recenzija: 0,
    ...(deoGrada ? { deo_grada: deoGrada } : {}),
    ...(lat && lng ? { lat, lng } : {}),
    // Plan sa zahteva prelazi na biznis (free | verified | premium | sponsored);
    // nepoznata vrednost (poslata mimo forme) pada na free
    plan: ["free", "verified", "premium", "sponsored"].includes(zahtev.plan) ? zahtev.plan : "free",
  };

  const { res } = await postWithOptionalPlan(`${SUPABASE_URL}/rest/v1/${encodeURIComponent("Biznisi Novi Sad")}`, {
    "apikey": SUPABASE_ANON,
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Prefer": "return=minimal",
  }, biznis);
  if (!res.ok) {
    const d = await res.json().catch(() => {});
    throw new Error(d?.message || d?.hint || `HTTP ${res.status}`);
  }

  // 4. Označi zahtev kao odobren
  await updateBiznisZahtevStatus(zahtev.id, "approved", token);
  clearBiznisiCache(); // nov lokal odmah u pretrazi i kategoriji
}

async function oznaciBrochitano(id, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/Kontakt?id=eq.${id}`, {
    method: "PATCH",
    headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ procitano: true }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

async function deleteRecenzija(id, token) {
  const t = token || (() => {
    try { const s = JSON.parse(localStorage.getItem("ns_session") || sessionStorage.getItem("ns_session") || "{}"); return s.access_token || SUPABASE_ANON; } catch { return SUPABASE_ANON; }
  })();
  // Soft delete - označi kao obrisano, ne briše iz baze
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?id=eq.${id}`, {
    method: "PATCH",
    headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${t}`, "Content-Type": "application/json" },
    body: JSON.stringify({ obrisano: true, obrisano_datum: new Date().toISOString() }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

async function getObrisaneRecenzije(token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?obrisano=eq.true&select=*&order=obrisano_datum.desc`,
    { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
  );
  return res.ok ? res.json() : [];
}

async function vratiRecenziju(id, token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?id=eq.${id}`, {
    method: "PATCH",
    headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ obrisano: false, obrisano_datum: null }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

// Admin: trajno briše sakrivenu recenziju i sve odgovore na nju (RLS "Admin brise recenzije")
async function trajnoObrisiRecenziju(id, token) {
  const t = encodeURIComponent("Recenzije Novi Sad");
  const headers = { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}`, "Prefer": "return=representation" };
  await fetch(`${SUPABASE_URL}/rest/v1/${t}?reply_to_id=eq.${encodeURIComponent(id)}`, { method: "DELETE", headers });
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${t}?id=eq.${encodeURIComponent(id)}`, { method: "DELETE", headers });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const rows = await res.json().catch(() => []);
  if (Array.isArray(rows) && rows.length === 0) throw new Error("Brisanje nije dozvoljeno");
}

async function getAllRecenzije(token) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/${encodeURIComponent("Recenzije Novi Sad")}?select=*&order=id.desc&limit=100`,
    { headers: { "apikey": SUPABASE_ANON, "Authorization": `Bearer ${token}` } }
  );
  return res.ok ? res.json() : [];
}

function FavoriteCard({ fav }) {
  const name = fav.business_name || fav.name || "Lokal";
  const cat  = fav.category || "";
  const CAT_C = CAT_COLORS;
  const col = CAT_C[cat] || BLUE;
  return (
    <div style={{
      background:"#fff", borderRadius:16, padding:"18px 20px",
      display:"flex", alignItems:"center", gap:16,
      boxShadow:"0 2px 12px rgba(0,0,0,0.06)",
    }}>
      <div style={{width:44,height:44,borderRadius:12,background:`${col}15`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
        <MapPin size={18} color={col}/>
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontFamily:SF,fontSize:15,fontWeight:700,color:"#111",letterSpacing:"-0.02em",marginBottom:3,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{name}</div>
        {cat && <div style={{fontFamily:SF,fontSize:12,color:"#999",letterSpacing:"-0.02em"}}>{cat}</div>}
      </div>
    </div>
  );
}

/* ─── URL ↔ STATE helpers ─── */
// Encode the full app state into a URL path
function stateToPath(activePage, activeCategory, activeBusiness, activeMap, activeReviews, activeCategoryFilter) {
  if (activeMap)                           return "/mapa";
  if (activeReviews)                       return "/recenzije";
  if (activeBusiness)                      return bizPath(activeBusiness);
  if (activeCategory) {
    return categoryPath(activeCategory, activeCategoryFilter);
  }
  if (activePage)                          return "/" + activePage;
  return "/";
}

// Naziv kategorije iz dela adrese. Nazivi iz baze ("Teretane", "Usluge") se
// svode na one koje sajt prikazuje ("Sport", "Nega"), da svaka kategorija ima
// samo jednu adresu.
function resolveCategoryName(urlSegment) {
  const dbToDisplay = Object.fromEntries(Object.entries(CATEGORY_DB_NAME_MAP).map(([display, db]) => [db, display]));
  const found = matchBySlug([...Object.keys(SUB_CATEGORIES), ...Object.keys(dbToDisplay)], urlSegment);
  return found ? (dbToDisplay[found] || found) : null;
}

// Decode a URL path back to app-state shape
// ── Prelazak na stranicu tek kad je spremna ──────────────────────────────
// Kao na većim sajtovima: posle klika posetilac ostaje na trenutnoj stranici
// (gore ide tanka plava traka) dok se ne učitaju kod nove stranice, njeni
// podaci i glavna slika. Nova stranica se onda pojavi gotova i animacije
// kreću odmah. Ako nešto traje duže od NAV_MAX_WAIT, ipak se prelazi, pa
// stranica sama prikaže svoje učitavanje (spora mreža ne sme da "zaledi" klik).
const NAV_MAX_WAIT = 1000;

const STATIC_PAGE_COMPONENTS = {
  blog: BlogPage, profile: ProfilePage, "dodaj-biznis": AddBusinessPage, oceni: WriteReviewPage,
  kontakt: ContactPage, "nocni-klubovi": NightlifeSubPage, pivnice: NightlifeSubPage, "kokteli-barovi": NightlifeSubPage,
  "uslovi-koriscenja": TermsPage, "politika-privatnosti": PrivacyPage, kolacici: CookiesPage,
};

// Slika se smatra spremnom kad je učitana (ili ako ne uspe - tada ne čekamo)
function preloadImage(src) {
  if (!src) return null;
  return new Promise((res) => { const img = new Image(); img.onload = res; img.onerror = res; img.src = src; });
}
const firstImageOf = (biz) => {
  const first = biz && Array.isArray(biz.images) ? biz.images[0] : null;
  return typeof first === "string" ? first : first && (first.url || first.src) || null;
};

// Vraća obećanje koje se ispuni kad je odredište spremno, ili null ako je sve već tu
function prepareTarget({ page, category, business, reviews }) {
  const waits = [];
  const add = (p) => { if (p) waits.push(p.catch(() => {})); };
  if (category) {
    if (!CategoryPage.isLoaded()) add(CategoryPage.preload());
    if (!getCachedCategory(category)) add(loadCategory(category));
    if (CATEGORY_HERO_IMG[category]) add(preloadImage(CATEGORY_HERO_IMG[category]));
  } else if (business) {
    if (!SingleBusinessPage.isLoaded()) add(SingleBusinessPage.preload());
    add(preloadImage(firstImageOf(business)));
  } else if (reviews) {
    if (!AllReviewsPage.isLoaded()) add(AllReviewsPage.preload());
  } else if (page) {
    const C = STATIC_PAGE_COMPONENTS[page] || (String(page).startsWith("blog/") ? BlogPage : null);
    if (C && !C.isLoaded()) add(C.preload());
    // Prijava: i slike pozadine, da se obrazac pojavi odmah ceo
    if (page === "profile") add(ProfilePage.preload().then((m) => m.preloadAuthImages && m.preloadAuthImages()));
  }
  return waits.length ? Promise.all(waits) : null;
}

// Tanka plava traka na vrhu ekrana dok se čeka sledeća stranica
const navProgress = (() => {
  let el = null, timer = null, w = 0, hideT = null;
  const ensure = () => {
    if (el) return el;
    el = document.createElement("div");
    el.setAttribute("aria-hidden", "true");
    Object.assign(el.style, { position: "fixed", top: "0", left: "0", height: "3px", width: "0", background: BLUE, zIndex: "10001", opacity: "0", pointerEvents: "none", borderRadius: "0 3px 3px 0" });
    document.body.appendChild(el);
    return el;
  };
  return {
    start() {
      const e = ensure(); clearInterval(timer); clearTimeout(hideT);
      w = 10;
      e.style.transition = "none"; e.style.width = "0"; e.style.opacity = "1";
      void e.offsetWidth;
      e.style.transition = "width .3s ease, opacity .3s ease";
      e.style.width = w + "%";
      timer = setInterval(() => { w += (88 - w) * 0.14; e.style.width = w + "%"; }, 160);
    },
    done() {
      clearInterval(timer);
      if (!el || el.style.opacity !== "1") return;
      el.style.width = "100%";
      hideT = setTimeout(() => { el.style.opacity = "0"; }, 220);
    },
  };
})();

// Prelazak mišem / prvi dodir na link unutar sajta: odredište se počne
// učitavati unapred, pa je posle klika obično već spremno.
const _prefetched = new Set();
function prefetchHref(href) {
  let url;
  try { url = new URL(href, window.location.href); } catch { return; }
  if (url.origin !== window.location.origin) return;
  const path = url.pathname;
  if (_prefetched.has(path) || path === window.location.pathname) return;
  _prefetched.add(path);
  try { const p = prepareTarget(pathToState(path)); if (p) p.catch(() => {}); } catch {}
}

function pathToState(path) {
  if (path === "/" || path === "")             return { page: null, category: null, business: null, map: false, reviews: false };
  // Stranica Mapa više ne postoji: stara adresa vodi na početnu (vidi i applyPath)
  if (path === "/mapa")                        return { page: null, category: null, business: null, map: false, reviews: false };
  if (path === "/recenzije")                   return { page: null, category: null, business: null, map: false, reviews: true  };
  // Meni linkuje "/profil" (srpski), a stranica je interno "profile" - obe adrese rade
  if (path === "/profil")                      return { page: "profile", category: null, business: null, map: false, reviews: false };
  // /biznis/<ime> ili /biznis/<ime>/<id> (druga, treća... radnja lanca sa istim imenom, vidi bizPath.js)
  const bizIdMatch = path.match(/^\/biznis\/([^/]+)\/(\d+)\/?$/);
  const bizMatch = bizIdMatch || path.match(/^\/biznis\/(.+)$/);
  if (bizMatch) {
    // We can only restore name from URL; the full object lives in session storage
    // Pokvaren link (npr. "%E0%A4%A") ili oštećen keš ne sme da obori ceo sajt
    let name = bizMatch[1];
    try { name = decodeURIComponent(bizMatch[1]); } catch {}
    const id = bizIdMatch ? Number(bizIdMatch[2]) : null;
    let biz = id ? { name, id } : { name };
    try { const stored = sessionStorage.getItem("ns_biz_" + name + (id ? "/" + id : "")); if (stored) biz = JSON.parse(stored); } catch {}
    return { page: null, category: null, business: biz, map: false, reviews: false };
  }
  // /kategorija/{kategorija}/{potkategorija} - potkategorija je opciona,
  // omogućava direktan, indeksibilan link ka svakoj potkategoriji posebno
  // (npr. "Restorani/Italijanska hrana") umesto samo internog filtera.
  // Adrese su čisti slugovi ("/kategorija/kafici/klasicni-kafici"). Deo adrese
  // se razrešava u pravi naziv; prihvataju se i stari oblici ("Kafići",
  // "KAFICI"), a adresa se zatim ispravlja na kanonsku (vidi applyPath).
  // Nepostojeća kategorija pada na "stranica nije pronađena" (noindex) umesto
  // na praznu listu koja bi mogla da se indeksira.
  const catAnyMatch = path.match(/^\/kategorija\/([^/]+)(?:\/([^/]+))?\/?$/);
  if (catAnyMatch) {
    const category = resolveCategoryName(catAnyMatch[1]);
    if (category) {
      const subcategory = catAnyMatch[2] ? matchBySlug(SUB_CATEGORIES[category] || [], catAnyMatch[2]) : null;
      return { page: null, category, ...(subcategory ? { subcategory } : {}), business: null, map: false, reviews: false };
    }
  }
  return { page: path.slice(1) || null, category: null, business: null, map: false, reviews: false };
}

// Generiše čist sessionStorage ključ za scroll poziciju - pokriva sve rute
const getSimpleKey = (biz, cat, activePg, activeRev) => {
  if (biz) return `scroll_biz_${biz.id || biz.name}`;
  if (cat) return `scroll_cat_${cat}`;
  if (activeRev) return "scroll_view_recenzije";
  if (activePg && activePg !== "home") return `scroll_view_${activePg}`;
  return "scroll_home";
};

// Sve poznate vrednosti "activePage" state-a - svaka odgovara stvarnoj
// komponenti ispod. Bilo šta van ove liste (netačno otkucana adresa, stari
// link, slučajan tekst posle "/") znači da stranica ne postoji.
const VALID_STATIC_PAGES = [
  "oceni", "nocni-klubovi", "pivnice", "kokteli-barovi", "dodaj-biznis",
  "kontakt", "uslovi-koriscenja", "politika-privatnosti", "kolacici", "profile", "blog",
];

// "blog/<slug>" je važeća stranica samo ako takav članak postoji (blogData.json)
const isBlogPostPage = (page) => typeof page === "string" && page.startsWith("blog/") && BLOG_POSTS.some((p) => p.slug === page.slice(5));

// Kategorije koje se nude na stranici "nije pronađeno", da posetilac ne ode sa sajta
const NOT_FOUND_LINKS = ["Restorani", "Kafići", "Noćni život", "Sport", "Zanati", "Nega", "Zdravlje", "Hoteli"];
const NOT_FOUND_CSS = `
  .nf-digits { display: flex; justify-content: center; align-items: center; gap: .02em; line-height: .9; }
  .nf-pin { display: inline-flex; margin: 0 .04em; opacity: 0; transform: translateY(40px) scale(.96); animation: nfIn .9s cubic-bezier(0.16,1,0.3,1) forwards, nfFloat 5.5s ease-in-out infinite; animation-delay: .17s, 1.4s; }
  .nf-pin svg { height: .8em; width: auto; display: block; }
  .nf-digit { display: inline-block; font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important; font-weight: 800 !important; opacity: 0; transform: translateY(40px) scale(.96); animation: nfIn .9s cubic-bezier(0.16,1,0.3,1) forwards, nfFloat 5.5s ease-in-out infinite; background: linear-gradient(160deg, ${BLUE} 0%, #4da3ff 55%, ${BLUE} 100%); background-size: 100% 200%; -webkit-background-clip: text; background-clip: text; color: transparent; }
  .nf-digit:nth-child(1) { animation-delay: .05s, 1s; }
    .nf-digit:nth-child(3) { animation-delay: .29s, 1.8s; }
  .nf-fade { opacity: 0; transform: translateY(18px); animation: nfIn .8s cubic-bezier(0.16,1,0.3,1) forwards; }
  .nf-btn { transition: background .25s ease, transform .25s ease; }
  .nf-btn:hover { background: #0062d4 !important; transform: translateY(-2px); }
  .nf-chip { display: inline-flex; align-items: center; gap: 6px; padding: 10px 16px; border-radius: 999px; background: #fff; box-shadow: ${PILL_SHADOW}; text-decoration: none; font-family: ${SF}; font-size: 14px; font-weight: 600; color: #111; transition: color .3s ease, transform .3s cubic-bezier(0.4,0,0.2,1); }
  .nf-chip:hover { color: ${BLUE}; transform: translateY(-2px); }
  .nf-chip .nf-arrow { transition: transform .3s cubic-bezier(0.4,0,0.2,1); }
  .nf-chip:hover .nf-arrow { transform: translate(3px,-3px); }
  @keyframes nfIn { to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes nfFloat { 0%, 100% { translate: 0 0; } 50% { translate: 0 -10px; } }
  @media (prefers-reduced-motion: reduce) { .nf-digit, .nf-pin, .nf-fade { animation: none !important; opacity: 1 !important; transform: none !important; } }
`;

// Logo Novosadskog Adresara (pin sa "NS", isti crtež kao favicon). gradId mora
// biti jedinstven ako je logo više puta na istoj stranici.
function NsPinLogo({ gradId = "nsPinGrad", style }) {
  return (
      <svg viewBox="6 4 20 25.6" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Novosadski Adresar" style={style}>
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={BLUE} />
            <stop offset="100%" stopColor="#4da3ff" />
          </linearGradient>
        </defs>
        <path d="M16.0002 4.32031C10.4002 4.32031 6.2002 8.67031 6.2002 14.4703C6.2002 21.7203 16.0002 29.2603 16.0002 29.2603C16.0002 29.2603 25.8002 21.7203 25.8002 14.4703C25.8002 8.67031 21.6002 4.32031 16.0002 4.32031Z" fill={`url(#${gradId})`} />
        <path d="M16 20C19.3137 20 22 17.3137 22 14C22 10.6863 19.3137 8 16 8C12.6863 8 10 10.6863 10 14C10 17.3137 12.6863 20 16 20Z" fill="#fff" />
        <path fill={BLUE} d="M15.881 12.3636V16H15.217L13.6349 13.7113H13.6083V16H12.8395V12.3636H13.5142L15.0838 14.6506H15.1158V12.3636H15.881ZM18.4889 13.4094C18.4747 13.2662 18.4137 13.1549 18.306 13.0756C18.1983 12.9963 18.0521 12.9567 17.8675 12.9567C17.742 12.9567 17.636 12.9744 17.5496 13.0099C17.4632 13.0443 17.3969 13.0922 17.3508 13.1538C17.3058 13.2153 17.2833 13.2852 17.2833 13.3633C17.2809 13.4284 17.2945 13.4852 17.3241 13.5337C17.3549 13.5823 17.3969 13.6243 17.4502 13.6598C17.5035 13.6941 17.565 13.7243 17.6349 13.7504C17.7047 13.7752 17.7793 13.7965 17.8586 13.8143L18.1853 13.8924C18.3439 13.9279 18.4895 13.9753 18.6221 14.0344C18.7546 14.0936 18.8695 14.1664 18.9665 14.2528C19.0636 14.3393 19.1388 14.4411 19.192 14.5582C19.2465 14.6754 19.2743 14.8098 19.2755 14.9613C19.2743 15.1838 19.2175 15.3768 19.105 15.5401C18.9938 15.7023 18.8328 15.8284 18.6221 15.9183C18.4126 16.0071 18.1598 16.0515 17.8639 16.0515C17.5703 16.0515 17.3147 16.0065 17.0969 15.9165C16.8802 15.8266 16.711 15.6934 16.589 15.517C16.4683 15.3395 16.405 15.1199 16.3991 14.8583H17.143C17.1513 14.9802 17.1862 15.082 17.2478 15.1637C17.3105 15.2442 17.394 15.3052 17.4981 15.3466C17.6035 15.3868 17.7224 15.407 17.855 15.407C17.9852 15.407 18.0983 15.388 18.1942 15.3501C18.2912 15.3123 18.3664 15.2596 18.4197 15.1921C18.4729 15.1246 18.4996 15.0471 18.4996 14.9595C18.4996 14.8778 18.4753 14.8092 18.4268 14.7536C18.3794 14.6979 18.3096 14.6506 18.2172 14.6115C18.1261 14.5724 18.0142 14.5369 17.8817 14.505L17.4857 14.4055C17.1791 14.331 16.9371 14.2144 16.7595 14.0558C16.5819 13.8971 16.4938 13.6835 16.4949 13.4148C16.4938 13.1946 16.5523 13.0022 16.6707 12.8377C16.7903 12.6732 16.9542 12.5447 17.1626 12.4524C17.3709 12.3601 17.6076 12.3139 17.8728 12.3139C18.1427 12.3139 18.3782 12.3601 18.5795 12.4524C18.7819 12.5447 18.9393 12.6732 19.0518 12.8377C19.1642 13.0022 19.2222 13.1928 19.2258 13.4094H18.4889Z" />
      </svg>
  );
}

// Logo stoji umesto nule u "404"
function NfPin() {
  return <span className="nf-pin"><NsPinLogo gradId="nfPinGrad" /></span>;
}

// Ekran za učitavanje cele stranice: pozadina u boji stranice koja se otvara i
// animacija u sredini. Pojavljuje se tek posle kratke pauze, da se kod brzog
// učitavanja ne vidi treptaj. fixed = preko svega (koristi ga prijava).
const PAGE_LOADER_CSS = `
  .pl-wrap { display: flex; align-items: center; justify-content: center; }
  .pl-inner { display: flex; flex-direction: column; align-items: center; gap: 14px; opacity: 0; animation: plIn .3s ease .15s forwards; }
  .pl-ring { width: 38px; height: 38px; border-radius: 50%; border: 3px solid var(--pl-track); border-top-color: ${BLUE}; animation: spin .7s linear infinite; }
  @keyframes plIn { to { opacity: 1; } }
`;
function PageLoader({ bg = BG, dark = false, fixed = false }) {
  return (
    <div className="pl-wrap" role="status" aria-live="polite" style={{
      background: bg, minHeight: "100vh",
      ...(fixed ? { position: "fixed", inset: 0, zIndex: 50 } : {}),
      "--pl-track": dark ? "rgba(255,255,255,0.14)" : `${BLUE}26`,
    }}>
      <style>{PAGE_LOADER_CSS}</style>
      <div className="pl-inner">
        <div className="pl-ring" />
        <span style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" }}>Učitavanje...</span>
      </div>
    </div>
  );
}

// Prijava/registracija ima tamnu pozadinu, pa je i njen ekran za učitavanje taman
function AuthLoadingScreen() {
  return <PageLoader bg="#111" dark fixed />;
}

const nfBlue = (t) => <strong style={{ color: BLUE, fontWeight: 700, whiteSpace: "nowrap" }}>{t}</strong>;
function NotFoundContent({ title = "Stranica nije pronađena", text }) {
  const { isMobile } = useBreakpoint();
  const body = text || <>Adresa koju ste otvorili ne postoji ili je zastarela. Vratite se na {nfBlue("početnu")} ili izaberite kategoriju u {nfBlue("Novom Sadu")}.</>;
  // Kategorija se otvara unutar sajta (bez ponovnog učitavanja); početna je običan link
  const go = (e, cat) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!window.__nsNav) return;
    e.preventDefault();
    window.__nsNav.selectCat(cat);
  };
  return (
    <div style={{ background: BG, minHeight: isMobile ? "auto" : "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: isMobile ? "130px 16px 72px" : "140px 48px 96px" }}>
      <style>{NOT_FOUND_CSS}</style>
      <div style={{ position: "relative", textAlign: "center", maxWidth: 640, width: "100%" }}>
        <div className="nf-digits" aria-hidden="true" style={{ fontFamily: SF, fontSize: isMobile ? 132 : 220, fontWeight: 800, letterSpacing: "-0.06em", marginBottom: isMobile ? 18 : 24 }}>
          <span className="nf-digit">4</span><NfPin /><span className="nf-digit">4</span>
        </div>
        <h1 className="nf-fade" style={{ animationDelay: ".45s", fontFamily: SF, fontSize: isMobile ? 26 : 34, fontWeight: 800, color: "#111", letterSpacing: "-0.03em", lineHeight: 1.15, margin: "0 0 12px" }}>{title}</h1>
        <p className="nf-fade" style={{ animationDelay: ".55s", fontFamily: SF, fontSize: isMobile ? 15 : 17, color: "#111", lineHeight: 1.7, margin: "0 auto 28px", maxWidth: 480, letterSpacing: "-0.01em" }}>
          {body}
        </p>
        <div className="nf-fade" style={{ animationDelay: ".65s", marginBottom: isMobile ? 34 : 42 }}>
          <a href="/" className="nf-btn" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: BLUE, color: "#fff", fontFamily: SF, fontSize: 15, fontWeight: 700, padding: "14px 30px", borderRadius: 14, textDecoration: "none" }}>
            Nazad na početnu
          </a>
        </div>
        <div className="nf-fade" style={{ animationDelay: ".8s" }}>
          <div style={{ fontFamily: SF, fontSize: 12, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Popularne kategorije</div>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10 }}>
            {NOT_FOUND_LINKS.map((c) => (
              <a key={c} className="nf-chip" href={categoryPath(c)} onClick={(e) => go(e, c)}>
                {c} <ArrowUpRight size={13} className="nf-arrow" strokeWidth={2.5} color={BLUE} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function NotFoundOverlay({ path }) {
  usePageMeta({
    title: "Stranica nije pronađena",
    description: "Tražena stranica ne postoji na Novosadskom Adresaru.",
    path,
    noindex: true,
  });
  return (
    <div>
      <Navbar onCategorySelect={cat => { if (window.__nsNav) window.__nsNav.selectCat(cat); }} onPageOpen={page => { if (window.__nsNav) window.__nsNav.goTo(page); }} />
      <NotFoundContent />
      <ContactForm />
      <Footer />
    </div>
  );
}

function NovosadskiAdresarInner() {
  const { user, token } = useAuthContext();
  const globalCursorRef = useRef(false); // shared ref for custom cursor visibility

  // NAPOMENA: ovde je ranije stajao "window.addEventListener('unload', noop)"
  // - trik koji NAMERNO onemogućava bfcache (browser-ovo trenutno keširanje
  // stranice za instant "nazad"/"napred"). Komentar je tvrdio da to sprečava
  // zamrzavanje kod video elemenata, ali je verovatno radio suprotno: bez
  // bfcache-a, SVAKI povratak unazad (uključujući iOS swipe-back gest) mora
  // da ponovo izgradi celu stranicu od nule umesto trenutnog vraćanja iz
  // keša - što se tačno poklapa sa prijavljenim zamrzavanjem od par sekundi
  // pri iOS gestu za nazad. "unload" listener-i su i zvanično zastareli
  // (browser upozorenje). Hero komponenta već ispravno hvata "pageshow" sa
  // e.persisted i resetuje/nastavlja video kad se stranica vrati iz
  // bfcache-a, tako da ovaj stari zaobilazni trik više nije potreban.
  const [routeReady, setRouteReady] = useState(false);
  const firstPathDoneRef = useRef(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeCategoryFilter, setActiveCategoryFilter] = useState(null);
  const [activeBusiness, setActiveBusiness] = useState(null);
  const [activeMap,      setActiveMap]      = useState(false);
  const [activePage,     setActivePage]     = useState(null);
  const [profileInitialTab, setProfileInitialTab] = useState("login");
  const overlayRef = useRef(null); // ref za scroll na overlay stranicama
  // Čita trenutnu scroll poziciju - window za home, overlayRef za overlay stranice
  const getScrollPos = () => {
    const isHome = !activeBusiness && !activeCategory && !activePage && !activeReviews;
    if (isHome) return window.scrollY;
    return overlayRef.current ? overlayRef.current.scrollTop : 0;
  };
  const [activeReviews,  setActiveReviews]  = useState(false);

  // ── Supabase: učitaj samo popularne biznise za hero - minimalni egress na home ────────────
  const popularBiznisi = useSupabasePopular();

  // Hero slides: koristi popularne biznise iz baze
  const heroSlides = buildHeroSlides(popularBiznisi);

  // effectiveListingData - koristi statičke podatke na home-u
  // CategoryPage sam fetchuje svoju kategoriju lazy
  const effectiveListingData = listingData;



  // ── Globalni scroll - useLayoutEffect se izvršava SINHRONO pre browser paint-a
  // Home page: skroluje window. Overlay stranice: skroluju overlay div kontejner.
  useLayoutEffect(() => {
    const currentKey = getSimpleKey(activeBusiness, activeCategory, activePage, activeReviews);
    const savedPosition = sessionStorage.getItem(currentKey);
    const isHome = !activeBusiness && !activeCategory && !activePage && !activeReviews;
    const pos = savedPosition ? parseInt(savedPosition, 10) : 0;
    if (isHome) {
      // Home skroluje window
      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo(0, pos);
      document.documentElement.style.scrollBehavior = "";
    } else if (overlayRef.current) {
      // Overlay stranice skroluju overlay kontejner
      overlayRef.current.scrollTop = pos;
    }
    if (savedPosition) sessionStorage.removeItem(currentKey);
  }, [activeCategory, activeBusiness, activePage, activeReviews]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Google Analytics - SPA ne generiše novo učitavanje stranice,
  // pa page_view moramo ručno da pošaljemo pri svakoj promeni rute.
  useEffect(() => {
    // samo ako je posetilac prihvatio kolačiće (inače GA nije ni učitan, vidi index.html)
    if (typeof window.gtag !== "function" || !window.__nsGaLoaded) return;
    window.gtag("event", "page_view", {
      page_path: window.location.pathname + window.location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [activeCategory, activeBusiness, activePage, activeReviews, activeMap]);

  // ── Push a history entry when state changes ────────────────────
  const pushHistory = (path) => {
    if (window.location.pathname !== path) {
      window.history.pushState({}, "", path);
    }
  };

  // ── Global navigation helper (bez prop-drillinga) ──────────────
  useEffect(() => {
    window.__nsNav = {
      // Trenutna stranica se zatvara tek kad se otvori biznis (handleBusinessOpenNow);
      // ranije zatvaranje je na trenutak prikazivalo početnu i upisivalo "/" u istoriju
      openBiz:   (biz) => handleBusinessOpen(biz),
      goTo:      (page) => goToPage(page),
      selectCat: (cat)  => handleCategorySelect(cat),
    };
    return () => { delete window.__nsNav; };
  }); // eslint-disable-line react-hooks/exhaustive-deps

  const applyPath = (path) => {
    const s = pathToState(path);
    if (path === "/mapa") window.history.replaceState(window.history.state, "", "/");
    // Stara ili drugačije napisana adresa kategorije ("/kategorija/Kafići",
    // "/kategorija/KAFICI") se zamenjuje kanonskom bez novog unosa u istoriji,
    // da dugme "nazad" ne vraća na staru adresu.
    if (s.category) {
      const canonical = categoryPath(s.category, s.subcategory);
      if (canonical !== path) window.history.replaceState(window.history.state, "", canonical + window.location.search + window.location.hash);
    }
    setActivePage(s.page);
    setActiveCategory(s.category);
    setActiveBusiness(s.business);
    setActiveMap(s.map);
    setActiveReviews(s.reviews || false);
    setActiveCategoryFilter(s.category ? (s.subcategory || null) : null);
  };

  // ── Browser back/forward ───────────────────────────────────────
  // DIJAGNOSTIČKI POJEDNOSTAVLJENO - bez rAF/startTransition/data-is-back
  // trika (koji nisu pomogli kod iOS swipe-back zamrzavanja). Ovo je
  // najprostiji mogući oblik, da utvrdimo da li je taj dodatni kod bio uzrok
  // usporenja ili je problem negde drugde (npr. u samom iOS renderovanju).
  useEffect(() => {
    const onPop = () => {
      const path = window.location.pathname;
      applyPath(path);
    };
    window.addEventListener("popstate", onPop);
    applyPath(window.location.pathname);
    // Tek sada stanje odgovara adresi. Pre toga je "isOnHome" na trenutak
    // tačno i kad je otvorena neka druga stranica (početno stanje je prazno).
    setRouteReady(true);
    window.scrollTo(0, 0);
    return () => window.removeEventListener("popstate", onPop);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Pre prvog applyPath stanje je prazno ("/"): bez ove provere svako direktno
    // otvaranje stranice je ubacivalo lažni korak "/" u istoriju (nazad je vodio na
    // početnu umesto nazad na Google) i brisalo ?filtere iz adrese kategorije
    if (!routeReady) return;
    const path = stateToPath(activePage, activeCategory, activeBusiness, activeMap, activeReviews, activeCategoryFilter);
    // Prvi put samo ispravka oblika adrese (npr. /profil -> /profile), bez novog koraka
    if (!firstPathDoneRef.current) {
      firstPathDoneRef.current = true;
      if (window.location.pathname !== path) window.history.replaceState(window.history.state, "", path + window.location.search + window.location.hash);
      return;
    }
    pushHistory(path);
  }, [routeReady, activeCategory, activeBusiness, activePage, activeMap, activeReviews, activeCategoryFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Učitavanje unapred na prelazak mišem / dodir linka ─────────────────
  useEffect(() => {
    const onIntent = (e) => {
      const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (a) prefetchHref(a.getAttribute("href"));
    };
    document.addEventListener("pointerover", onIntent, { passive: true });
    document.addEventListener("touchstart", onIntent, { passive: true });
    return () => {
      document.removeEventListener("pointerover", onIntent);
      document.removeEventListener("touchstart", onIntent);
    };
  }, []);

  // ── Footer navigacija ──────────────────────────────────────────
  useEffect(() => {
    const handler = (e) => {
      const { cat, sub } = e.detail;
      handleCategorySelect(cat, sub || null);
    };
    window.addEventListener('footer-nav', handler);
    return () => window.removeEventListener('footer-nav', handler);
  }); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Navigation helpers ─────────────────────────────────────────
  const [mapFocusBiz, setMapFocusBiz] = React.useState(null);
  // Svaki novi klik poništava prethodno čekanje (važi poslednji klik)
  const navSeqRef = useRef(0);
  const navigateWhenReady = (target, apply) => {
    const id = ++navSeqRef.current;
    let ready = null;
    try { ready = prepareTarget(target); } catch {}
    if (!ready) { apply(); return; }
    let finished = false;
    const showBar = setTimeout(() => navProgress.start(), 80);
    const go = () => {
      if (finished) return;
      finished = true;
      clearTimeout(showBar);
      if (id !== navSeqRef.current) return;
      navProgress.done();
      apply();
    };
    ready.then(go, go);
    setTimeout(go, NAV_MAX_WAIT);
  };

  const goToPage = (page, tab) => {
    navigateWhenReady({ page, reviews: page === "recenzije" }, () => goToPageNow(page, tab));
  };
  const goToPageNow = (page, tab) => {
    // Snimi skrol trenutnog ekrana pre odlaska
    sessionStorage.setItem(getSimpleKey(activeBusiness, activeCategory, activePage, activeReviews), getScrollPos());
    if (page === "recenzije") { setActiveReviews(true); setActivePage(null); setActiveCategory(null); setActiveBusiness(null); setActiveMap(false); return; }
    setActiveReviews(false);
    if (page === "profile" && tab) setProfileInitialTab(tab);
    if (page === "map" && tab && tab.focusBiz) {
      setMapFocusBiz(tab.focusBiz);
      setActiveMap(false) /* stranica Mapa je uklonjena */; setActivePage(null); setActiveCategory(null); setActiveBusiness(null);
      setMapOpenIstrazi(false);
      return;
    } else if (page === "map") {
      setMapFocusBiz(null);
      setMapOpenIstrazi(false);
      setActiveMap(false) /* stranica Mapa je uklonjena */; setActivePage(null); setActiveCategory(null); setActiveBusiness(null);
      return;
    }
    setActivePage(page);
    setActiveCategory(null);
    setActiveBusiness(null);
    setActiveMap(false);
  };
  const [mapOpenIstrazi, setMapOpenIstrazi] = React.useState(false);

  // Geolokacija se sad traži unutar same NearbyMapPage (kad je openIstrazi true) -
  // ima punu UI povratnu informaciju (spinner, greška, watchPosition za najbolji fix).
  // Ranije se ovde pozivala odvojena, "tiha" geolokacija koja je skoro uvek stizala
  // PRE nego što bi je NearbyMapPage uopšte mogla iskoristiti (React useState initial
  // value se ne ažurira kad prop stigne kasnije), pa dugme "Biznisi u blizini" praktično
  // nikad nije uspevalo da locira korisnika.
  const goToMap = () => {
    sessionStorage.setItem(getSimpleKey(activeBusiness, activeCategory, activePage, activeReviews), getScrollPos());
    setMapOpenIstrazi(true);
    setActiveMap(false) /* stranica Mapa je uklonjena */;
    setActivePage(null);
    setActiveCategory(null);
    setActiveBusiness(null);
  };
  const handleCategorySelect = (label, subcategory = null) => {
    if (label && categoryMeta[label]) navigateWhenReady({ category: label }, () => handleCategorySelectNow(label, subcategory));
    else handleCategorySelectNow(label, subcategory);
  };
  const handleCategorySelectNow = (label, subcategory = null) => {
    sessionStorage.setItem(getSimpleKey(activeBusiness, activeCategory, activePage, activeReviews), getScrollPos());
    setActiveReviews(false);
    if (label === null) {
      setActiveCategory(null); setActiveCategoryFilter(null);
      setActiveBusiness(null); setActivePage(null); setActiveMap(false);
      return;
    }
    if (categoryMeta[label]) {
      setActiveCategory(label);
      setActiveCategoryFilter(subcategory || null);
      setActiveBusiness(null); setActivePage(null); setActiveMap(false);
    }
  };
  const handleBusinessOpen = (biz) => {
    if (!biz || typeof biz !== "object" || biz.nativeEvent || biz._reactName) return;
    navigateWhenReady({ business: biz }, () => handleBusinessOpenNow(biz));
  };
  const handleBusinessOpenNow = (biz) => {
    sessionStorage.setItem(getSimpleKey(null, activeCategory, activePage, activeReviews), getScrollPos());
    // Ključ = deo adrese posle /biznis/ ("Ime" ili "Ime/123"), isto što čita pathToState
    try { sessionStorage.setItem("ns_biz_" + decodeURIComponent(bizPath(biz).slice(8)), JSON.stringify(biz)); } catch {}
    setActiveBusiness(biz);
    setActiveCategory(null);
    setActivePage(null);
    setActiveMap(false);
    setActiveReviews(false);
  };

  const GLOBAL_STYLE = `
    html {
      overflow-x: clip;
      background: #EFE5D5;
    }
    body {
      overflow-x: clip;
      background: #EFE5D5;
    }
    /* Ukloni sivi "tap highlight" pravougaonik koji mobilni browseri
       (iOS Safari / Android Chrome) iscrtaju preko dugmeta/linka na dodir. */
    * {
      -webkit-tap-highlight-color: transparent;
    }
    /* Na širim ekranima (gde je navigacija puna, ne hamburger) navigacija
       ostaje "obična", gura sadržaj dole - samo na užim ekranima (ispod
       1150px, gde se meni skuplja u hamburger) pluta providno preko hero
       slike na stranici kategorije. */
    @media (min-width: 1150px) {
      /* "relative" (ne "static"): navigacija i dalje gura sadržaj dole, ali joj
         z-index sada važi. Sa "static" se z-index ignoriše, pa je hero slika
         (koja ima svoj z-index) prekrivala listu pretrage i padajuće menije. */
      body.category-page #ns-navbar {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        width: 100% !important;
        z-index: 100 !important;
      }
    }
    .page-enter {
      animation: pageEnter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
      position: relative;
      z-index: 0;
      isolation: auto;
    }
    body[data-is-back] .page-enter {
      animation: none !important;
    }
      font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
      letter-spacing: -0.02em;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    body, p, span, a, li, td, th, label, input, textarea, button { font-weight: 500; letter-spacing: -0.01em; }
    h1, h2, h3, h4, h5, h6 { font-weight: 700; letter-spacing: -0.02em; }



    /* Global Apple-style button hover - color shift only, no movement */
    button {
      cursor: pointer;
      transition: background-color 0.35s cubic-bezier(0.4,0,0.2,1),
                  background 0.35s cubic-bezier(0.4,0,0.2,1),
                  opacity 0.35s cubic-bezier(0.4,0,0.2,1),
                  scale 0.12s cubic-bezier(0.2,0,0,1);
      transform: none !important;   /* kill translate/scale */
      box-shadow: none !important;
    }
    /* Apple: povratna informacija odmah na dodir (ne tek kad se pusti prst).
       "scale" je posebno svojstvo pa se slaže sa postojećim transform-ima
       i ne smeta pravilu transform:none iznad. */
    button:not(:disabled):active {
      opacity: 0.85;
      scale: 0.97;
    }
    [role="button"]:active, a.ns-card:active {
      scale: 0.985;
    }
    /* Fioka se vuče za ručku i naslov - browser tu ne sme da skroluje stranicu */
    .ns-sheet [data-sheet-handle] { touch-action: none; user-select: none; -webkit-user-select: none; }

    /* Korisnik je u telefonu uključio "Smanji pokrete": bez klizanja i skaliranja,
       samo kratki prelazi providnosti */
    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.15s !important;
        scroll-behavior: auto !important;
      }
      .na-reveal { opacity: 1 !important; transform: none !important; }
      button:not(:disabled):active, [role="button"]:active, a.ns-card:active { scale: 1; }
    }
    /* "Smanji providnost": zamagljene površine postaju pune */
    @media (prefers-reduced-transparency: reduce) {
      * { backdrop-filter: none !important; -webkit-backdrop-filter: none !important; }
    }
    /* Ikonice u navigaciji koje su <button> (meni) imaju istu senku kao ostale ikonice */
    button.ns-icon-pill { box-shadow: ${PILL_SHADOW} !important; }
    .ns-light-input::placeholder { color: #a3a3a3; }
    /* Skeleton kao na Instagramu: siva osnova preko koje stalno prelazi svetli talas s leva na desno */
    /* Gradijent je vezan za ekran (background-attachment: fixed), pa svi sivi delovi
       dele JEDAN talas koji prelazi preko cele kartice odjednom, kao na Instagramu */
    .ns-sk { background-color: #e4e6ea;
      background-image: linear-gradient(100deg, rgba(255,255,255,0) 35%, rgba(255,255,255,0.85) 50%, rgba(255,255,255,0) 65%);
      background-size: 200vw 100%; background-repeat: no-repeat; background-attachment: fixed;
      animation: nsSkWave 1.4s ease-in-out infinite; }
    @keyframes nsSkWave { from { background-position: -150vw 0; } to { background-position: 50vw 0; } }
    @media (prefers-reduced-motion: reduce) { .ns-sk { animation: none; } }
    button.ns-arrow { box-shadow: ${PILL_SHADOW} !important; }
    button.ns-arrow:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.13) !important; }

    /* Blue brand buttons -> darker azure on hover */
    button.btn-blue:hover  { background: #0062d4 !important; }

    /* Black/dark buttons -> charcoal on hover */
    button.btn-dark:hover  { background: #1a1a1a !important; }

    /* Ghost / icon-only buttons - just opacity fade */
    button.btn-icon:hover  { opacity: 0.6; background: transparent !important; }

    @keyframes pageEnter {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    .page-enter {
      animation: pageEnter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
      position: relative;
      z-index: 0;
      isolation: auto;
    }
    body[data-is-back] .page-enter {
      animation: none !important;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }

  `;

  const [introPhase, setIntroPhase] = useState("visible");
  const [introAnimReady, setIntroAnimReady] = useState(false);
  // index.html već prikazuje isti preloader (#na-boot) od prvog trenutka, pre
  // nego što JS stigne. Ako je on već stigao da prikaže tekst (JS se učitavao
  // duže od ~0.7s), naš preloader ga preuzima bez ponovne animacije teksta,
  // da ne bi trepnuo.
  const [introBooted] = useState(() =>
    typeof document !== "undefined" && !!document.getElementById("na-boot") && performance.now() > 700
  );
  // useLayoutEffect (ne useEffect) - mora da se primeni PRE prvog crtanja
  // stranice, inače se scrollbar vidi na trenutak pre nego što se sakrije.
  // Prostor za scrollbar je rezervisan unapred preko CSS "scrollbar-gutter"
  // (vidi index.css), pa ovde više nije potrebna ručna padding kompenzacija
  // koja je izazivala da se na tren vide "dva" scrollbara.
  React.useLayoutEffect(() => {
    document.documentElement.classList.add("scroll-stable");
    document.documentElement.style.overflow = "hidden";
    // Naš .na-intro je sada u DOM-u (isti izgled), pa statički preloader iz
    // index.html može da ode - pre iscrtavanja, bez treptaja.
    const boot = document.getElementById("na-boot");
    // Preloader je vidljiv već od učitavanja HTML-a, pa se 1.4s računa od tada,
    // a ne od trenutka kad JS stigne (na sporoj vezi bi se inače čekalo duplo).
    const introWait = boot ? Math.max(300, 1400 - performance.now()) : 1400;
    if (boot) boot.remove();

    const timer = setTimeout(() => {
      setIntroPhase("lifting");

      setTimeout(() => {
        setIntroPhase("done");
        document.documentElement.style.overflow = "";
        setTimeout(() => setIntroAnimReady(true), 80);
      }, 600);
    }, introWait);
    return () => {
      clearTimeout(timer);
      document.documentElement.style.overflow = "";
    };
  }, []);

  // Determine which "overlay" page is active
  const isOnHome = !activePage && !activeCategory && !activeBusiness && !activeMap && !activeReviews;

  // Početna se ubacuje u stranicu tek kad je posetilac prvi put stvarno na njoj.
  // Ranije je bila tu (sakrivena) i kad se direktno otvori biznis, kategorija ili
  // kontakt, pa je HTML svake stranice počinjao celim tekstom početne. Google je
  // taj tekst uzimao za opis u rezultatima i stranice smatrao kopijama početne.
  // Kad se jednom prikaže, ostaje ispod ostalih stranica (čuva se skrol pozicija).
  const [homeMounted, setHomeMounted] = useState(() => {
    try { const st = pathToState(window.location.pathname); return !st.page && !st.category && !st.business && !st.reviews; } catch { return true; }
  });
  useEffect(() => { if (routeReady && isOnHome) setHomeMounted(true); }, [routeReady, isOnHome]);

  usePageMeta(isOnHome ? {
    title: "Novosadski Adresar - Vaš vodič kroz Novi Sad",
    description: "Vodič kroz restorane, kafiće, teretane, salone lepote, majstore, hotele i noćni život u Novom Sadu. Prave ocene, recenzije, radno vreme i lokacije.",
    path: "/",
  } : {});

  // Organization/WebSite schema - nevidljiv kod (bez uticaja na dizajn) koji
  // jasno definiše ko smo pretraživačima i AI modelima (entity clarity).
  useStructuredData("organization-structured-data", isOnHome ? {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    "name": "Novosadski Adresar",
    "url": SITE_URL,
    "logo": { "@type": "ImageObject", "url": `${SITE_URL}/logo512.png`, "width": 512, "height": 512 },
    "image": `${SITE_URL}/logo512.png`,
    "email": "info@novosadski-adresar.rs",
    "contactPoint": { "@type": "ContactPoint", "contactType": "customer support", "email": "info@novosadski-adresar.rs", "url": `${SITE_URL}/kontakt`, "availableLanguage": ["sr"] },
    "address": { "@type": "PostalAddress", "addressLocality": "Novi Sad", "addressCountry": "RS" },
    "description": "Novosadski Adresar je vodič kroz najbolje lokale u Novom Sadu - restorani, kafići, saloni lepote, majstori, noćni život i još mnogo toga. Prave recenzije, ocene i lokacije pravih korisnika.",
    "areaServed": { "@type": "City", "name": "Novi Sad" },
  } : null);
  useStructuredData("website-structured-data", isOnHome ? {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Novosadski Adresar",
    "url": SITE_URL,
    "inLanguage": "sr",
    "publisher": { "@id": `${SITE_URL}/#organization` },
    "description": "Vodič kroz najbolje lokale u Novom Sadu - restorani, kafići, saloni lepote, majstori, noćni život i još mnogo toga.",
  } : null);

  useEffect(() => {
    if (!isOnHome) {
      // Overlay stranice (mapa, biznis, kategorija...) skroluju preko
      // sopstvenog "overlayRef" div-a, ne preko <html>. Uklanjamo
      // "scroll-stable" klasu ovde jer bi <html> inače i dalje rezervisao
      // prostor za scrollbar koji nikad ne prikazuje (jer ne skroluje) -
      // to je izgledalo kao "dva scrollbara" jedan pored drugog. Gasimo i
      // <body> skrol iz istog razloga (nekad body sam ima svoj scrollbar
      // ako mu <html> ne zabrani overflow direktno).
      document.documentElement.classList.remove("scroll-stable");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.classList.add("scroll-stable");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }
    return () => {
      document.documentElement.classList.add("scroll-stable");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [isOnHome]); // eslint-disable-line

  if (activeCategory) {
    document.body.classList.add('category-page');
  } else {
    document.body.classList.remove('category-page');
  }

  return (
    <>
      <style>{GLOBAL_STYLE}</style>
      <style>{`
        /* ── INTRO OVERLAY ── */
        .na-intro {
          position: fixed; inset: 0; z-index: 99999;
          background: #0a0a0a;
          display: flex; align-items: center; justify-content: center;
          flex-direction: column; gap: 20px;
          transition: transform 0.85s cubic-bezier(0.76, 0, 0.24, 1),
                      opacity 0.85s cubic-bezier(0.76, 0, 0.24, 1);
          pointer-events: all;
          will-change: transform, opacity;
        }
        .na-intro.lifting {
          transform: translateY(-100%);
          opacity: 0;
        }
        .na-intro.done { display: none; }
        .na-intro-logo {
          font-size: 22px; font-weight: 800; color: #fff;
          letter-spacing: -0.04em;
          opacity: 0; animation: introFadeUp 0.6s 0.3s cubic-bezier(0.22,1,0.36,1) forwards;
        }
        .na-intro-sub {
          font-size: 13px; color: rgba(255,255,255,0.4);
          letter-spacing: 0.06em; text-transform: uppercase;
          opacity: 0; animation: introFadeUp 0.6s 0.5s cubic-bezier(0.22,1,0.36,1) forwards;
        }
        @keyframes introFadeUp {
          from { opacity:0; transform:translateY(12px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .na-intro.booted .na-intro-logo,
        .na-intro.booted .na-intro-sub { opacity: 1; animation: none; }

        /* ── NAV + HERO TEXT ENTRANCE (triggeruje se kad intro krene da se diže) ── */
        @keyframes naFadeDown {
          from { opacity: 0; transform: translateY(-16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes naFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .na-nav-enter {
          animation: naFadeDown 0.7s cubic-bezier(0.16,1,0.3,1) both;
        }
        .na-hero-text-enter {
          animation: naFadeUp 0.8s cubic-bezier(0.16,1,0.3,1) both;
        }
        .na-hero-text-enter-delay {
          animation: naFadeUp 0.8s 0.12s cubic-bezier(0.16,1,0.3,1) both;
        }

        /* ── SCROLL ANIMATIONS ── */
        .na-reveal {
          opacity: 0;
          transform: translateY(36px) scale(0.985);
          transition: opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1);
          will-change: opacity, transform;
        }
        .na-reveal.visible {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
        .na-reveal.instant { opacity: 1; transform: translateY(0) scale(1); transition: none; }
        .na-reveal-delay-1 { transition-delay: 0.09s; }
        .na-reveal-delay-2 { transition-delay: 0.18s; }
        .na-reveal-delay-3 { transition-delay: 0.27s; }
      `}</style>

      {/* ── GLOBAL CUSTOM CURSOR (root level, never clipped) ── */}
      <GlobalCursor visibleRef={globalCursorRef} />

      {/* ── INTRO OVERLAY ── */}
      {introPhase !== "done" && (
        <div className={`na-intro${introPhase === "lifting" ? " lifting" : ""}${introBooted ? " booted" : ""}`}>
          <div className="na-intro-logo">Novosadski Adresar</div>
          <div className="na-intro-sub">Novi Sad · Vodič kroz grad</div>
        </div>
      )}

      {/* ── HOME - always position:static, always in flow, scroll position preserved ── */}
      {homeMounted && (
      <div style={{
        background: BG, minHeight: "100vh", overflowX: "clip",
        visibility: isOnHome ? "visible" : "hidden",
        pointerEvents: isOnHome ? "auto" : "none",
        position: "relative",
      }}>
        <Navbar onCategorySelect={handleCategorySelect} onPageOpen={goToPage} transparentMobile={true} isOnHome={isOnHome} introPhase={introPhase} introAnimReady={introAnimReady} />

        <Hero onCategorySelect={handleCategorySelect} onPageOpen={goToPage} slides={heroSlides} isOnHome={isOnHome} videoAllowed={isOnHome && routeReady} introPhase={introPhase} introAnimReady={introAnimReady} />
        <PopularCategories onCategorySelect={handleCategorySelect} />
        <AdsSection />
        <PopularSearches onCategorySelect={handleCategorySelect} cursorRef={globalCursorRef} />
        <Reviews onViewAll={() => {
          sessionStorage.setItem(getSimpleKey(null, null, null, false), getScrollPos());
          setActiveReviews(true);
        }} onPageOpen={goToPage} />
        <NightlifeSection onCategorySelect={handleCategorySelect} onPageOpen={(page) => { goToPage(page); }} />
        <CTABlocks onPageOpen={goToPage} />
        <ContactForm />
        <Footer />
      </div>
      )}

      {/* ── OVERLAY PAGES - position:fixed on top of home, home never moves ── */}
      {!isOnHome && (
        <div ref={overlayRef} id="ns-overlay-scroll" style={{
          position: "fixed", inset: 0,
          background: BG, overflowY: "auto", overflowX: "clip",
          WebkitOverflowScrolling: "touch",
          scrollbarGutter: "stable",
        }}>
          {(activePage === "blog" || isBlogPostPage(activePage)) && (
            <div key={activePage}>
              <React.Suspense fallback={<PageLoader />}>
                <BlogPage
                  slug={activePage === "blog" ? null : activePage.slice(5)}
                  onPageOpen={goToPage}
                  onCategorySelect={handleCategorySelect}
                  onBusinessOpen={handleBusinessOpen}
                />
              </React.Suspense>
            </div>
          )}
          {activeReviews && (
            <div>
              <div key="reviews">
                <React.Suspense fallback={<PageLoader />}>
                  <AllReviewsPage onBack={() => { setActiveReviews(false); }} onCategorySelect={handleCategorySelect} onPageOpen={goToPage} />
                </React.Suspense>
                <ContactForm /><Footer />
              </div>
            </div>
          )}
          {activePage === "oceni" && (
            <>
              <React.Suspense fallback={<PageLoader />}>
                <WriteReviewPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} onCategorySelect={handleCategorySelect} />
              </React.Suspense>
              <ContactForm /><Footer />
            </>
          )}
          {(activePage === "nocni-klubovi" || activePage === "pivnice" || activePage === "kokteli-barovi") && (
            <React.Suspense fallback={<PageLoader />}>
              <NightlifeSubPage pageKey={activePage} onBack={() => setActivePage(null)} onBusinessOpen={handleBusinessOpen} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "dodaj-biznis" && (
            <React.Suspense fallback={<PageLoader />}>
              <AddBusinessPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "kontakt" && (
            <React.Suspense fallback={<PageLoader />}>
              <ContactPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "uslovi-koriscenja" && (
            <React.Suspense fallback={<PageLoader />}>
              <TermsPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "politika-privatnosti" && (
            <React.Suspense fallback={<PageLoader />}>
              <PrivacyPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "kolacici" && (
            <React.Suspense fallback={<PageLoader />}>
              <CookiesPage onBack={() => { setActivePage(null); }} onPageOpen={goToPage} />
            </React.Suspense>
          )}
          {activePage === "profile" && (
            <div key="profile">
              <React.Suspense fallback={user ? <PageLoader /> : <AuthLoadingScreen />}>
                <ProfilePage onBack={() => setActivePage(null)} initialTab={profileInitialTab} />
              </React.Suspense>
            </div>
          )}
          {activeBusiness && (
            <div>
              <Navbar onCategorySelect={handleCategorySelect} onPageOpen={goToPage} />
              <div key={activeBusiness.name}>
                <ErrorBoundary>
                  <React.Suspense fallback={<PageLoader />}>
                    <SingleBusinessPage business={activeBusiness} onPageOpen={goToPage} onBack={(cat, subCat) => {
                      setActiveBusiness(null); setActivePage(null);
                      if (cat) { setActiveCategoryFilter(subCat || null); setActiveCategory(cat); }
                      else { setActiveCategoryFilter(null); setActiveCategory(null); }
                    }} />
                  </React.Suspense>
                </ErrorBoundary>
                <ContactForm /><Footer />
              </div>
            </div>
          )}
          {activeCategory && (
            <div>
              <Navbar onCategorySelect={handleCategorySelect} onPageOpen={goToPage} />
              <div key={activeCategory}>
                <ErrorBoundary>
                  <React.Suspense fallback={<PageLoader />}>
                    <CategoryPage
                      category={activeCategory} subcategoryFilter={activeCategoryFilter}
                      onBack={() => { setActiveBusiness(null); setActiveCategory(null); setActiveCategoryFilter(null); }}
                      onBusinessOpen={handleBusinessOpen} listingDataOverride={effectiveListingData}
                    />
                  </React.Suspense>
                </ErrorBoundary>
                <ContactForm /><Footer />
              </div>
            </div>
          )}
          {!activeMap && !activeReviews && !activeBusiness && !activeCategory && !VALID_STATIC_PAGES.includes(activePage) && !isBlogPostPage(activePage) && (
            <NotFoundOverlay path={window.location.pathname} />
          )}
        </div>
      )}
    </>
  );
}
function FavoritesProvider({ children }) {
  const { user, token } = useAuthContext();
  const [favRows, setFavRows] = React.useState([]); // raw DB rows
  const [showAuthModal, setShowAuthModal] = React.useState(false);

  // Load favorites when user logs in
  React.useEffect(() => {
    if (!user || !token) { setFavRows([]); return; }
    getFavorites(user.id, token)
      .then(rows => setFavRows(Array.isArray(rows) ? rows : []))
      .catch(() => setFavRows([]));
  }, [user?.id, token]); // eslint-disable-line

  const favIds = favRows.map(r => Number(r.biznis_id));

  const isFav = (biz) => {
    if (!biz) return false;
    // Primarno poređenje po id-u
    if (biz.id != null && biz.id !== "") return favIds.includes(Number(biz.id));
    return false;
  };

  const getBizId = (biz) => {
    const n = Number(biz?.id);
    return (!isNaN(n) && n > 0) ? n : null;
  };

  const toggle = async (biz, { onAuthNeeded } = {}) => {
    if (!user || !token) {
      setShowAuthModal(true);
      if (onAuthNeeded) onAuthNeeded();
      return;
    }
    const bizId = getBizId(biz);
    if (!bizId) {
      console.warn("toggle favorites: biz.id nije validan", biz);
      return;
    }

    if (isFav(biz)) {
      // Optimistic remove
      setFavRows(prev => prev.filter(r => Number(r.biznis_id) !== bizId));
      try { await removeFavorite(user.id, bizId, token); }
      catch { setFavRows(prev => [...prev, { biznis_id: bizId, user_id: user.id }]); }
    } else {
      // Optimistic add
      const tempRow = { biznis_id: bizId, user_id: user.id, id: Date.now() };
      setFavRows(prev => [...prev, tempRow]);
      try {
        const rows = await addFavorite(user.id, bizId, token);
        const realRow = Array.isArray(rows) ? rows[0] : rows;
        if (realRow) setFavRows(prev => prev.map(r => r.id === tempRow.id ? realRow : r));
      } catch {
        setFavRows(prev => prev.filter(r => r.id !== tempRow.id));
      }
    }
  };

  // Sačuvani blogovi: isti princip kao omiljeni lokali (optimistično, uz povratak na grešku)
  const [blogSlugs, setBlogSlugs] = React.useState([]);
  React.useEffect(() => {
    if (!user || !token) { setBlogSlugs([]); return; }
    getBlogFavorites(user.id, token)
      .then(rows => setBlogSlugs(Array.isArray(rows) ? rows.map(r => r.slug) : []))
      .catch(() => setBlogSlugs([]));
  }, [user?.id, token]); // eslint-disable-line
  const isBlogFav = (slug) => blogSlugs.includes(slug);
  const toggleBlog = async (slug) => {
    if (!user || !token) { setShowAuthModal(true); return; }
    if (!slug) return;
    if (blogSlugs.includes(slug)) {
      setBlogSlugs(prev => prev.filter(s => s !== slug));
      try { await removeBlogFavorite(user.id, slug, token); }
      catch { setBlogSlugs(prev => (prev.includes(slug) ? prev : [slug, ...prev])); }
    } else {
      setBlogSlugs(prev => [slug, ...prev]);
      try { await addBlogFavorite(user.id, slug, token); }
      catch { setBlogSlugs(prev => prev.filter(s => s !== slug)); }
    }
  };

  return (
    <FavoritesContext.Provider value={{ favIds, favRows, toggle, isFav, showAuthModal, setShowAuthModal, blogSlugs, isBlogFav, toggleBlog }}>
      {children}
    </FavoritesContext.Provider>
  );
}

function AdminProvider({ children }) {
  const { user, token } = useAuthContext();
  const [isAdmin, setIsAdmin] = React.useState(false);
  React.useEffect(() => {
    if (!user || !token) { setIsAdmin(false); return; }
    checkIsAdmin(user.id, token).then(setIsAdmin).catch(() => setIsAdmin(false));
  }, [user?.id]); // eslint-disable-line
  return <AdminContext.Provider value={isAdmin}>{children}</AdminContext.Provider>;
}

// ── Baner za kolačiće ────────────────────────────────────────────────────
// Google Analytics se učitava tek posle "Prihvatam" (window.nsLoadAnalytics u
// public/index.html). Izbor se pamti u localStorage "ns_cookie_consent"
// (granted | denied). Stranica Kolačići može da ga ponovo otvori (događaj ns-cookie-reopen).
const COOKIE_KEY = "ns_cookie_consent";
function CookieBanner() {
  const { isMobile } = useBreakpoint();
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);
  useEffect(() => {
    // prerender (Puppeteer) ne sme da upiše baner u HTML stranica
    if (typeof navigator !== "undefined" && navigator.webdriver) return;
    let t;
    try { if (!localStorage.getItem(COOKIE_KEY)) t = setTimeout(() => setShow(true), 1200); } catch {}
    const reopen = () => { setLeaving(false); setShow(true); };
    window.addEventListener("ns-cookie-reopen", reopen);
    return () => { clearTimeout(t); window.removeEventListener("ns-cookie-reopen", reopen); };
  }, []);
  const choose = (value) => {
    try { localStorage.setItem(COOKIE_KEY, value); } catch {}
    if (value === "granted" && window.nsLoadAnalytics) {
      window.nsLoadAnalytics();
      try { window.gtag("event", "page_view", { page_path: window.location.pathname + window.location.search, page_title: document.title, page_location: window.location.href }); } catch {}
    }
    setLeaving(true);
    setTimeout(() => setShow(false), 280);
  };
  if (!show) return null;
  const btn = { height: 44, padding: "0 20px", borderRadius: 10, border: "none", fontFamily: SF, fontSize: 14, fontWeight: 700, cursor: "pointer", flex: isMobile ? 1 : "0 0 auto", whiteSpace: "nowrap" };
  return (
    <div role="dialog" aria-live="polite" aria-label="Kolačići" style={{
      position: "fixed", zIndex: 8500,
      left: isMobile ? 12 : "auto", right: isMobile ? 12 : 24, bottom: isMobile ? "calc(12px + env(safe-area-inset-bottom))" : 24,
      maxWidth: isMobile ? "none" : 440,
      background: "#fff", borderRadius: 16, padding: isMobile ? "18px 18px 16px" : "20px 22px 18px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.16), 0 2px 8px rgba(0,0,0,0.08)",
      fontFamily: SF,
      opacity: leaving ? 0 : 1, transform: leaving ? "translateY(12px)" : "none",
      transition: "opacity 0.28s ease, transform 0.28s ease",
      animation: leaving ? "none" : "nsCookieIn 0.45s cubic-bezier(0.22,1,0.36,1) both",
    }}>
      <style>{`@keyframes nsCookieIn { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }`}</style>
      <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 6, letterSpacing: "-0.01em" }}>Kolačići</div>
      <p style={{ margin: "0 0 14px", fontSize: 13.5, color: "#555", lineHeight: 1.55 }}>
        Uz vašu dozvolu koristimo Google Analytics, da bismo videli koje stranice vas najviše zanimaju. Ne koristimo kolačiće za reklame.{" "}
        <a href="/kolacici" onClick={(e) => { if (e.button !== 0 || e.metaKey || e.ctrlKey) return; e.preventDefault(); window.__nsNav && window.__nsNav.goTo("kolacici"); }} style={{ color: BLUE, fontWeight: 600, textDecoration: "none" }}>Politika kolačića</a>
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button type="button" onClick={() => choose("denied")} style={{ ...btn, background: "#f1f1f3", color: "#333" }}>Odbijam</button>
        <button type="button" className="btn-blue" onClick={() => choose("granted")} style={{ ...btn, background: BLUE, color: "#fff" }}>Prihvatam</button>
      </div>
    </div>
  );
}

// Prozor za novu lozinku posle klika na link iz mejla "Zaboravili ste lozinku".
// Supabase tim linkom prijavljuje korisnika (type=recovery), ovde se upisuje nova lozinka.
function ResetPasswordModal() {
  const { recoveryMode, setRecoveryMode, getFreshToken } = useAuthContext();
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  useScrollLock(!!recoveryMode);
  if (!recoveryMode) return null;

  const close = () => { setRecoveryMode(false); setPass(""); setPass2(""); setErr(""); setDone(false); };
  const save = async () => {
    if (pass.length < 8) { setErr("Lozinka mora imati najmanje 8 karaktera."); return; }
    if (pass !== pass2) { setErr("Lozinke se ne poklapaju."); return; }
    setLoading(true); setErr("");
    try {
      const token = await getFreshToken();
      if (!token) { setErr("Link je istekao. Zatražite novi preko \"Zaboravili ste lozinku\"."); return; }
      const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        method: "PUT",
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ password: pass }),
      });
      if (res.ok) { setDone(true); return; }
      const d = await res.json().catch(() => ({}));
      const m = String(d.msg || d.message || d.error_description || "").toLowerCase();
      if (m.includes("different from the old")) setErr("Nova lozinka mora biti različita od stare.");
      else if (m.includes("weak") || m.includes("characters")) setErr("Lozinka je preslaba. Koristite najmanje 8 karaktera, slova i brojeve.");
      else setErr(describeError(Object.assign(new Error(m || `HTTP ${res.status}`), { status: res.status, code: d.error_code || d.code })));
    } catch (e) { setErr(describeError(e)); }
    finally { setLoading(false); }
  };

  const input = { width: "100%", border: "1.5px solid #e0e0e0", borderRadius: 12, padding: "13px 16px", fontFamily: SF, fontSize: 15, outline: "none", background: "#fafafa", boxSizing: "border-box", color: "#111", marginBottom: 12 };
  const label = { fontFamily: SF, fontSize: 12, fontWeight: 600, color: "#888", letterSpacing: "0.04em", textTransform: "uppercase", display: "block", marginBottom: 6 };
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 10000, background: "rgba(0,0,0,0.4)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div role="dialog" aria-modal="true" aria-labelledby="reset-pass-title" style={{ background: "#fff", borderRadius: 24, padding: "36px 32px", maxWidth: 420, width: "100%", boxShadow: "0 24px 80px rgba(0,0,0,0.18)" }}>
        <div style={{ width: 52, height: 52, borderRadius: 16, background: `${BLUE}12`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        </div>
        {done ? (<>
          <h2 id="reset-pass-title" style={{ fontFamily: SF, fontSize: 22, fontWeight: 800, color: "#111", margin: "0 0 8px", letterSpacing: "-0.03em" }}>Lozinka je promenjena</h2>
          <p style={{ fontFamily: SF, fontSize: 14, color: "#888", margin: "0 0 24px", lineHeight: 1.6 }}>Prijavljeni ste. Od sada se prijavljujete novom lozinkom.</p>
          <button onClick={close} style={{ width: "100%", background: BLUE, color: "#fff", border: "none", borderRadius: 12, padding: 14, fontFamily: SF, fontSize: 15, fontWeight: 700, cursor: "pointer" }}>U redu</button>
        </>) : (<>
          <h2 id="reset-pass-title" style={{ fontFamily: SF, fontSize: 22, fontWeight: 800, color: "#111", margin: "0 0 8px", letterSpacing: "-0.03em" }}>Postavite novu lozinku</h2>
          <p style={{ fontFamily: SF, fontSize: 14, color: "#888", margin: "0 0 24px", lineHeight: 1.6 }}>Upišite novu lozinku za vaš nalog.</p>
          <label style={label} htmlFor="reset-pass-1">Nova lozinka</label>
          <input id="reset-pass-1" type={show ? "text" : "password"} autoComplete="new-password" placeholder="Min. 8 karaktera" value={pass} onChange={e => setPass(e.target.value)} style={input} autoFocus />
          <label style={label} htmlFor="reset-pass-2">Ponovite lozinku</label>
          <input id="reset-pass-2" type={show ? "text" : "password"} autoComplete="new-password" placeholder="Ista lozinka još jednom" value={pass2} onChange={e => setPass2(e.target.value)} onKeyDown={e => e.key === "Enter" && save()} style={input} />
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontFamily: SF, fontSize: 13, color: "#666", margin: "0 0 16px", cursor: "pointer" }}>
            <input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} /> Prikaži lozinku
          </label>
          {err && <p style={{ fontFamily: SF, fontSize: 13, color: "#ff3b30", margin: "0 0 12px", lineHeight: 1.5 }}>{err}</p>}
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={save} disabled={loading} style={{ flex: 1, background: BLUE, color: "#fff", border: "none", borderRadius: 12, padding: 14, fontFamily: SF, fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>{loading ? "Čuvam..." : "Sačuvaj lozinku"}</button>
            <button onClick={close} style={{ background: "#f5f5f7", color: "#555", border: "none", borderRadius: 12, padding: "14px 20px", fontFamily: SF, fontSize: 15, fontWeight: 600, cursor: "pointer" }}>Kasnije</button>
          </div>
        </>)}
      </div>
    </div>
  );
}

export default function NovosadskiAdresar() {
  const authState = useAuth();
  return (
    <AuthContext.Provider value={authState}>
      <FavoritesProvider>
        <AdminProvider>
          <NovosadskiAdresarInner />
          <CookieBanner />
          <ResetPasswordModal />
        </AdminProvider>
      </FavoritesProvider>
    </AuthContext.Provider>
  );
}

/* ==========================================
   CATEGORY PAGE  (Universal Template)
========================================== */

const categoryMeta = {
  Restorani:     { title: "Pretražite restorane",    plural: "restorani",  emoji: "🍔" },
  Kafići:        { title: "Pretražite kafiće",        plural: "kafića",     emoji: "☕" },
  Sport:         { title: "Sport & Fitnes u NS",      plural: "objekata",   emoji: "🏋️" },
  Nega:          { title: "Nega & Lepota u NS",       plural: "salona",     emoji: "💅" },
  "Noćni život": { title: "Noćni život u NS",         plural: "mesta",      emoji: "🥂" },
  Zdravlje:      { title: "Zdravlje u NS",            plural: "objekata",   emoji: "🏥" },
  Auto:          { title: "Auto usluge u NS",         plural: "servisa",    emoji: "🚗" },
  Hoteli:        { title: "Hoteli & Smeštaj u NS",    plural: "objekata",   emoji: "🏨" },
  Bazeni:        { title: "Bazeni & Aqua u NS",       plural: "bazena",     emoji: "🏊" },
  Zanati:        { title: "Zanati & Majstori u NS",   plural: "zanatlija",  emoji: "🔧" },
};

// SEO naslovi i opisi po kategoriji - pisani da pogode stvarne pretrage
// ("restorani novi sad", "najbolji kafići novi sad"...), svaki jedinstven.
const CATEGORY_SEO = {
  Restorani: {
    title: "Restorani Novi Sad",
    description: "Pronađite najbolje restorane u Novom Sadu - vojvođanska kuhinja, roštilj, italijanska i azijska hrana. Recenzije pravih gostiju, ocene, radno vreme i lokacije.",
  },
  Kafići: {
    title: "Kafići Novi Sad",
    description: "Otkrijte najbolje kafiće u Novom Sadu za jutarnju kafu, rad ili opuštanje. Specialty pržionice, poslastičarnice i klasični kafići - sa pravim ocenama korisnika.",
  },
  Sport: {
    title: "Sport i Fitnes Novi Sad",
    description: "Teretane, CrossFit, joga studiji i sportski tereni u Novom Sadu. Pronađite sportski objekat koji odgovara vašim ciljevima, uz recenzije i ocene korisnika.",
  },
  Nega: {
    title: "Saloni Lepote i Nege Novi Sad",
    description: "Frizerski saloni, kozmetički studiji, spa centri i estetska medicina u Novom Sadu. Pronađite salon od poverenja uz recenzije pravih klijenata.",
  },
  "Noćni život": {
    title: "Noćni Život Novi Sad",
    description: "Najbolji klubovi, splavovi, kafane sa živom muzikom i koktel barovi u Novom Sadu. Sve za nezaboravnu noć - sa ocenama i preporukama korisnika.",
  },
  Zdravlje: {
    title: "Zdravstvene Usluge Novi Sad",
    description: "Privatne klinike, stomatolozi, fizioterapeuti i apoteke u Novom Sadu. Pronađite pouzdanog stručnjaka uz recenzije i ocene pravih pacijenata.",
  },
  Auto: {
    title: "Auto Usluge Novi Sad",
    description: "Auto servisi, perionice, vulkanizeri i rent-a-car u Novom Sadu. Pronađite majstora od poverenja za svoje vozilo, uz ocene i iskustva korisnika.",
  },
  Hoteli: {
    title: "Hoteli i Smeštaj Novi Sad",
    description: "Hoteli, apartmani i vojvođanski salaši u Novom Sadu. Pronađite idealan smeštaj za svoj boravak uz ocene gostiju i tačne informacije o lokaciji.",
  },
  Bazeni: {
    title: "Bazeni Novi Sad",
    description: "Gradski bazeni, aquaparkovi i wellness centri sa saunom u Novom Sadu. Radno vreme, cenovnik i ocene korisnika na jednom mestu.",
  },
  Zanati: {
    title: "Majstori Novi Sad",
    description: "Provereni majstori u Novom Sadu - vodoinstalateri, električari, stolari, ključari i serviseri bele tehnike. Pozovite majstora od poverenja uz prave recenzije.",
  },
};

const listingData = {
  Restorani: [
    { name: "Restoran Fontana",        sub: "Domaći restorani . Centar",        rating: 5, reviews: 234, tags: ["Otvorena terasa","Parking","Rezervacija"] },
    { name: "Kafana Kod Dragana",      sub: "Domaći restorani . Telep",          rating: 4, reviews: 98,  tags: ["Živa muzika","Parking"] },
    { name: "Vojvođanska Kuća",        sub: "Domaći restorani . Petrovaradin",   rating: 5, reviews: 167, tags: ["Domaća hrana","Terasa","Rezervacija"] },
    { name: "La Piazza",               sub: "Italijanska hrana . Novo Naselje",  rating: 5, reviews: 187, tags: ["Bezgluten","Dostava","WiFi"] },
    { name: "Trattoria Roma",          sub: "Italijanska hrana . Centar",        rating: 4, reviews: 143, tags: ["Pasta","Pica","Rezervacija"] },
    { name: "Sushi Garden",            sub: "Azijski ukusi . Liman",             rating: 5, reviews: 201, tags: ["Dostava","Sveže","Rezervacija"] },
    { name: "Wok & Roll",              sub: "Azijski ukusi . Centar",            rating: 4, reviews: 134, tags: ["Wok","Ramen","Dostava"] },
    { name: "Šaran na Keju",           sub: "Roštilj & Meso . Dunavska obala",  rating: 4, reviews: 312, tags: ["Pogled na Dunav","Parking","Terasa"] },
    { name: "Roštilj Majstor",         sub: "Roštilj & Meso . Detelinara",      rating: 5, reviews: 189, tags: ["Roštilj","Parking","Dostava"] },
    { name: "Restoran Mala Fabrika",   sub: "Vegetarijanski . Stari grad",      rating: 5, reviews: 156, tags: ["Vegetarijansko","Vino","Rezervacija"] },
    { name: "Green Plate",             sub: "Vegetarijanski . Liman",           rating: 5, reviews: 112, tags: ["Veganski","Organski","WiFi"] },
    { name: "Burger Spot",             sub: "Brza hrana . Centar",              rating: 4, reviews: 223, tags: ["Burgeri","Dostava","Brzo"] },
    { name: "Pizza Express NS",        sub: "Brza hrana . Novo Naselje",        rating: 4, reviews: 178, tags: ["Pica","Dostava","24/7"] },
    { name: "Takoyaki Street",         sub: "Azijski ukusi . Satelit",          rating: 4, reviews: 88,  tags: ["Japansko","Street food","Dostava"] },
    { name: "Balkan Grill",            sub: "Roštilj & Meso . Petrovaradin",    rating: 5, reviews: 256, tags: ["Ćevapi","Terasa","Parking"] },
  ],
  Kafići: [
    { name: "Kafe Korzo",              sub: "Specialty kafa . Centar",          rating: 5, reviews: 445, tags: ["Cold brew","WiFi","Terasa"] },
    { name: "The Daily Grind",         sub: "Specialty kafa . Satelit",         rating: 5, reviews: 98,  tags: ["Cold brew","Latte art","WiFi"] },
    { name: "Aroma Café",              sub: "Specialty kafa . Liman",           rating: 4, reviews: 167, tags: ["Single origin","Espresso","Mirno"] },
    { name: "Dunav Coffee",            sub: "Terase & bašte . Kej",             rating: 5, reviews: 334, tags: ["Pogled","Terasa","WiFi"] },
    { name: "Kafić Platani",           sub: "Terase & bašte . Stari grad",      rating: 4, reviews: 211, tags: ["Bašta","Hlad","Parkić"] },
    { name: "Letnja Bašta NS",         sub: "Terase & bašte . Petrovaradin",    rating: 5, reviews: 145, tags: ["Pogled na Dunav","Terasa","Rezervacija"] },
    { name: "Sweet Corner",            sub: "Slastičarnice . Centar",           rating: 4, reviews: 122, tags: ["Kolači","Torte","Dostava"] },
    { name: "Pâtisserie Belle",        sub: "Slastičarnice . Novo Naselje",     rating: 5, reviews: 189, tags: ["Francuski kolači","Kafa","Preporučeno"] },
    { name: "Knjižara & Kafe",         sub: "Knjižare kafići . Liman",          rating: 5, reviews: 189, tags: ["Mirna atmosfera","WiFi","Knjige"] },
    { name: "Chapter One",             sub: "Knjižare kafići . Centar",         rating: 5, reviews: 134, tags: ["Knjige","Tiho","WiFi"] },
    { name: "Brunch House",            sub: "Brunch mesta . Novo Naselje",      rating: 4, reviews: 267, tags: ["Doručak","Vegan","Terasa"] },
    { name: "Sunday Morning Café",     sub: "Brunch mesta . Centar",            rating: 5, reviews: 198, tags: ["Brunch","Avokado tost","Rezervacija"] },
    { name: "Mačka Kafić",             sub: "Pet-friendly . Liman",             rating: 5, reviews: 156, tags: ["Mačke","Deca","Instagram"] },
    { name: "Dog & Coffee",            sub: "Pet-friendly . Centar",            rating: 4, reviews: 112, tags: ["Psi dobrodošli","Bašta","WiFi"] },
    { name: "Retro Kafe",              sub: "Terase & bašte . Detelinara",      rating: 4, reviews: 89,  tags: ["Retro","Bašta","Jeftino"] },
  ],
  Teretane: [
    { name: "FitZone Premium",         sub: "Fitness centri . Centar",          rating: 5, reviews: 312, tags: ["24/7","Sauna","Parking"] },
    { name: "Iron Gym",                sub: "Fitness centri . Detelinara",      rating: 4, reviews: 201, tags: ["Tegovi","24/7","Parking"] },
    { name: "SportLife NS",            sub: "Fitness centri . Novo Naselje",    rating: 5, reviews: 178, tags: ["Kardio","Grupni trening","WiFi"] },
    { name: "CrossFit Novi Sad",       sub: "CrossFit boxovi . Liman",          rating: 5, reviews: 187, tags: ["Coaching","Grupni trening"] },
    { name: "CrossFit Fortress",       sub: "CrossFit boxovi . Petrovaradin",   rating: 5, reviews: 143, tags: ["WOD","Outdoor trening","Parking"] },
    { name: "CrossFit Central",        sub: "CrossFit boxovi . Centar",         rating: 4, reviews: 112, tags: ["Funkcionalni trening","Coaching"] },
    { name: "Yoga Studio Lotus",       sub: "Yoga studiji . Stari grad",        rating: 5, reviews: 234, tags: ["Hot yoga","Meditacija","WiFi"] },
    { name: "Zen Yoga NS",             sub: "Yoga studiji . Liman",             rating: 5, reviews: 167, tags: ["Hatha yoga","Meditacija","Mirno"] },
    { name: "Aqua Fitness Club",       sub: "Bazeni . Petrovaradin",            rating: 4, reviews: 156, tags: ["Bazen","Sauna","Parking"] },
    { name: "Swim & Fit",              sub: "Bazeni . Centar",                  rating: 5, reviews: 198, tags: ["Olimpijski bazen","Plivanje","Grupni"] },
    { name: "Pilates Center NS",       sub: "Pilates . Novo Naselje",           rating: 5, reviews: 89,  tags: ["Reformer","Privatni čas"] },
    { name: "Body Balance Studio",     sub: "Pilates . Centar",                 rating: 5, reviews: 134, tags: ["Mat pilates","Žene","Rezervacija"] },
    { name: "Karate Klub Vojvodina",   sub: "Borilačke veštine . Centar",       rating: 4, reviews: 98,  tags: ["Karate","Deca","Odrasli"] },
    { name: "MMA Factory NS",          sub: "Borilačke veštine . Liman",        rating: 5, reviews: 167, tags: ["MMA","BJJ","Kickboxing"] },
    { name: "Judo Klub NS",            sub: "Borilačke veštine . Satelit",      rating: 4, reviews: 78,  tags: ["Judo","Deca","Takmičarsko"] },
  ],
  Hoteli: [
    { name: "Hotel Park",              sub: "Luksuzni hoteli . Centar",         rating: 5, reviews: 678, tags: ["Spa","Restoran","Parking"] },
    { name: "Hotel Prezident Luxury",  sub: "Luksuzni hoteli . Novo Naselje",   rating: 5, reviews: 412, tags: ["Bazen","Sauna","WiFi"] },
    { name: "The Grand NS",            sub: "Luksuzni hoteli . Kej",            rating: 5, reviews: 345, tags: ["Pogled na Dunav","Spa","Restoran"] },
    { name: "Hotel Vojvodina",         sub: "Poslovni hoteli . Trg slobode",    rating: 4, reviews: 334, tags: ["Centar","Istorija","WiFi"] },
    { name: "Business Inn NS",         sub: "Poslovni hoteli . Satelit",        rating: 4, reviews: 223, tags: ["Konferencijska sala","Parking","WiFi"] },
    { name: "Executive Hotel NS",      sub: "Poslovni hoteli . Novo Naselje",   rating: 4, reviews: 189, tags: ["Biznis usluge","WiFi","Restoran"] },
    { name: "Hostel Sova",             sub: "Hosteli . Stari grad",             rating: 4, reviews: 156, tags: ["Budžet","WiFi","Zajednička kuhinja"] },
    { name: "Central Hostel NS",       sub: "Hosteli . Centar",                 rating: 4, reviews: 134, tags: ["Jeftino","Lokacija","Zajednička soba"] },
    { name: "Rimski Hotel",            sub: "Boutique hoteli . Petrovaradin",   rating: 5, reviews: 289, tags: ["Tvrđava","Pogled","Restoran"] },
    { name: "Boutique Hotel Lav",      sub: "Boutique hoteli . Liman",          rating: 5, reviews: 198, tags: ["Dizajn","Spa","Parking"] },
    { name: "Vila Dunav",              sub: "Boutique hoteli . Kej",            rating: 5, reviews: 167, tags: ["Romantično","Dunav","Privatno"] },
    { name: "Green Apartment NS",      sub: "Apartmani . Centar",               rating: 5, reviews: 145, tags: ["Kuhinja","Duži boravak","WiFi"] },
    { name: "City Stay Apartments",    sub: "Apartmani . Novo Naselje",         rating: 4, reviews: 112, tags: ["Apartman","Parking","Kuhinja"] },
    { name: "Wellness Resort Fruška",  sub: "Wellness hoteli . Petrovaradin",   rating: 5, reviews: 234, tags: ["Spa","Priroda","Bazen"] },
    { name: "Relax Hotel & Spa",       sub: "Wellness hoteli . Centar",         rating: 5, reviews: 178, tags: ["Masaža","Sauna","Bazen"] },
  ],
  Bazeni: [
    { name: "Gradski Bazen NS",        sub: "Olimpijski bazeni . Centar",       rating: 5, reviews: 445, tags: ["Olimpijski","Sauna","Teretana"] },
    { name: "Olimpik Swim Club",       sub: "Olimpijski bazeni . Novo Naselje", rating: 5, reviews: 312, tags: ["Takmičarsko","Trening","Parking"] },
    { name: "Aquapark Štrand",         sub: "Aquaparkovi . Štrand",             rating: 5, reviews: 567, tags: ["Tobogani","Plaža","Restoran"] },
    { name: "Fun Aqua Park",           sub: "Aquaparkovi . Petrovaradin",       rating: 4, reviews: 389, tags: ["Tobogani","Deca","Leži na plaži"] },
    { name: "Privatni Bazen Lux",      sub: "Privatni bazeni . Petrovaradin",   rating: 4, reviews: 134, tags: ["Privatno","Grejanje","Parking"] },
    { name: "Villa Pool NS",           sub: "Privatni bazeni . Centar",         rating: 5, reviews: 156, tags: ["Privatno","Jacuzzi","Rezervacija"] },
    { name: "Hotel Spa Bazen",         sub: "Spa bazeni . Novo Naselje",        rating: 5, reviews: 212, tags: ["Jacuzzi","Sauna","Masaža"] },
    { name: "Thermal Spa NS",          sub: "Spa bazeni . Centar",              rating: 5, reviews: 267, tags: ["Termalni bazen","Relaksacija","Masaža"] },
    { name: "Wellness Spa Fruška",     sub: "Spa bazeni . Petrovaradin",        rating: 5, reviews: 189, tags: ["Priroda","Spa","Wellness"] },
    { name: "Dečiji Bazen Fun",        sub: "Dečiji bazeni . Detelinara",       rating: 4, reviews: 89,  tags: ["Deca","Tobogani","Restoran"] },
    { name: "KidsSplash NS",           sub: "Dečiji bazeni . Novo Naselje",     rating: 5, reviews: 134, tags: ["Mala deca","Sigurno","Animatori"] },
    { name: "Fitnes & Bazen Plus",     sub: "Sportski bazeni . Liman",          rating: 5, reviews: 167, tags: ["Teretana","Bazen","Sauna"] },
    { name: "AquaSport Club",          sub: "Sportski bazeni . Centar",         rating: 4, reviews: 145, tags: ["Plivanje","Vaterpolo","Trening"] },
    { name: "ProSwim Academy",         sub: "Olimpijski bazeni . Satelit",      rating: 5, reviews: 198, tags: ["Škola plivanja","Deca","Odrasli"] },
    { name: "AquaFit Center",          sub: "Sportski bazeni . Petrovaradin",   rating: 4, reviews: 112, tags: ["Aqua fitnes","Grupni trening","Parking"] },
  ],
  Usluge: [
    { name: "Frizerski Salon Luna",    sub: "Frizerski saloni . Centar",        rating: 5, reviews: 312, tags: ["Šišanje","Bojenje","Rezervacija"] },
    { name: "Hair Studio Ana",         sub: "Frizerski saloni . Liman",         rating: 5, reviews: 234, tags: ["Frizure","Keratinski tretman","WiFi"] },
    { name: "Barber Shop King",        sub: "Frizerski saloni . Novo Naselje",  rating: 4, reviews: 178, tags: ["Muško šišanje","Brada","Rezervacija"] },
    { name: "Auto Servis Petrović",    sub: "Auto servisi . Detelinara",        rating: 5, reviews: 189, tags: ["Dijagnostika","Popravka","Parking"] },
    { name: "Car Fix NS",              sub: "Auto servisi . Satelit",           rating: 4, reviews: 145, tags: ["Gume","Ulje","Klimatizacija"] },
    { name: "AutoMajstor Pro",         sub: "Auto servisi . Petrovaradin",      rating: 5, reviews: 112, tags: ["Karoserija","Motor","Brzo"] },
    { name: "Stomatologija Smile",     sub: "Stomatologije . Centar",           rating: 5, reviews: 267, tags: ["Implanti","Ortodoncija","Parking"] },
    { name: "Dental Studio NS",        sub: "Stomatologije . Novo Naselje",     rating: 5, reviews: 198, tags: ["Beljenje","Vađenje","Hitni"] },
    { name: "Kozmetički Salon Bella",  sub: "Kozmetički saloni . Centar",       rating: 5, reviews: 223, tags: ["Manikir","Pedikir","Tretmani"] },
    { name: "Beauty House NS",         sub: "Kozmetički saloni . Liman",        rating: 4, reviews: 167, tags: ["Šminka","Waxing","Rezervacija"] },
    { name: "Advokatska Kancelarija Marić", sub: "Pravne usluge . Centar",     rating: 5, reviews: 145, tags: ["Nekretnine","Ugovori","Konsultacije"] },
    { name: "Notar NS",                sub: "Pravne usluge . Centar",           rating: 4, reviews: 112, tags: ["Overa","Testamenti","Brzo"] },
    { name: "Brza Dostava NS",         sub: "Dostava . Centar",                 rating: 4, reviews: 234, tags: ["Isti dan","Paketi","Tracking"] },
    { name: "Kurirska Služba Šalje",   sub: "Dostava . Novo Naselje",           rating: 5, reviews: 178, tags: ["Biznis dostava","Brzo","Pouzdano"] },
    { name: "GlowUp Studio",           sub: "Kozmetički saloni . Petrovaradin", rating: 5, reviews: 134, tags: ["Lice","Telo","Relaksacija"] },
  ],
  "Noćni život": [
    { name: "Exit Club",               sub: "Noćni klubovi . Petrovaradin",     rating: 5, reviews: 1240, tags: ["DJ","Elektronska muzika","Terasa"] },
    { name: "Spens Club",              sub: "Noćni klubovi . Centar",           rating: 4, reviews: 876,  tags: ["Live muzika","Parking","VIP"] },
    { name: "Club Reload",             sub: "Noćni klubovi . Liman",            rating: 5, reviews: 654,  tags: ["House muzika","Bar","Terasa"] },
    { name: "Jazz Cafe Fontana",       sub: "Jazz barovi . Centar",             rating: 5, reviews: 423,  tags: ["Live jazz","Kokteli","Rezervacija"] },
    { name: "Blue Note NS",            sub: "Jazz barovi . Liman",              rating: 5, reviews: 387,  tags: ["Swing","Blues","Privatne zurke"] },
    { name: "Swing Bar",               sub: "Jazz barovi . Stari grad",         rating: 4, reviews: 298,  tags: ["Retro jazz","Vino","Terasa"] },
    { name: "Cocktail Bar Noir",       sub: "Koktejl barovi . Centar",          rating: 5, reviews: 345,  tags: ["Craft kokteli","Atmosfera","Rezervacija"] },
    { name: "Mixology NS",             sub: "Koktejl barovi . Kej",             rating: 5, reviews: 267,  tags: ["Signature kokteli","Pogled","Muzika"] },
    { name: "Craft Beer House",        sub: "Pivnice . Centar",                 rating: 5, reviews: 567,  tags: ["Craft pivo","Domaća hrana","Terasa"] },
    { name: "Starogradska Pivnica",    sub: "Pivnice . Stari grad",             rating: 5, reviews: 712,  tags: ["Tradicija","Live muzika","Rezervacija"] },
    { name: "Bier Garten NS",          sub: "Pivnice . Petrovaradin",           rating: 4, reviews: 334,  tags: ["Bavarski stil","Pogled na Dunav","Terasa"] },
    { name: "Karaoke Night NS",        sub: "Karaoke barovi . Centar",          rating: 4, reviews: 234,  tags: ["Karaoke","Privatne sobe","Kokteli"] },
    { name: "Sing Along Bar",          sub: "Karaoke barovi . Novo Naselje",    rating: 4, reviews: 178,  tags: ["Grupno","Zabava","Pića"] },
    { name: "Casino Royal NS",         sub: "Casino & igre . Centar",           rating: 4, reviews: 345,  tags: ["Rulet","Poker","Bar"] },
    { name: "Lucky Club NS",           sub: "Casino & igre . Novo Naselje",     rating: 4, reviews: 212,  tags: ["Slot mašine","VIP soba","Noćni"] },
  ],
  Zdravlje: [
    { name: "Apoteka Beograd",         sub: "Apoteke . Centar",                 rating: 5, reviews: 567, tags: ["24/7","Recepti","Suplementi"] },
    { name: "Farmacity NS",            sub: "Apoteke . Novo Naselje",           rating: 4, reviews: 345, tags: ["Kozmetika","Vitamini","Brzo"] },
    { name: "Apoteka Zdravlje",        sub: "Apoteke . Liman",                  rating: 5, reviews: 289, tags: ["Homeopatija","Suplementi","Ljubazno"] },
    { name: "Klinika Medigroup NS",    sub: "Privatne klinike . Centar",        rating: 5, reviews: 456, tags: ["Specijalisti","Dijagnostika","Parking"] },
    { name: "Poliklinika Vita",        sub: "Privatne klinike . Novo Naselje",  rating: 5, reviews: 312, tags: ["Ultrazvuk","Lab","Hitni"] },
    { name: "Medical Center NS",       sub: "Privatne klinike . Petrovaradin",  rating: 4, reviews: 234, tags: ["Opšta praksa","Specijalisti","WiFi"] },
    { name: "Spa Centar Lotus",        sub: "Spa centri . Centar",              rating: 5, reviews: 389, tags: ["Masaža","Sauna","Aromaterpaija"] },
    { name: "Wellness Oaza NS",        sub: "Spa centri . Liman",               rating: 5, reviews: 267, tags: ["Relaksacija","Hidroterapija","Paketi"] },
    { name: "Optika Vision NS",        sub: "Optičari . Centar",                rating: 5, reviews: 234, tags: ["Naočare","Leća","Brzo"] },
    { name: "Optika Mundo",            sub: "Optičari . Novo Naselje",          rating: 4, reviews: 178, tags: ["Sunčane naočare","Pregled","Popusti"] },
    { name: "FizioAktiv NS",           sub: "Fizioterapija . Centar",           rating: 5, reviews: 312, tags: ["Rehabilitacija","Sportske povrede","Parking"] },
    { name: "Kinezi Klinika",          sub: "Fizioterapija . Liman",            rating: 5, reviews: 245, tags: ["Kineziologija","Masaža","Elektroterapija"] },
    { name: "Psiholog Dr. Janković",   sub: "Psihologije . Centar",             rating: 5, reviews: 198, tags: ["Individualna terapija","Online","Diskretno"] },
    { name: "Centar za Mentalno Zdravlje", sub: "Psihologije . Novo Naselje",   rating: 5, reviews: 167, tags: ["Grupna terapija","Anksioznost","Podrška"] },
    { name: "Relax Body & Mind",       sub: "Spa centri . Petrovaradin",        rating: 5, reviews: 145, tags: ["Tajlandska masaža","Piling","Paketi"] },
  ],
};

/* Flatten all listings into one array with coords  -  lazy so listingData is ready */
/* Convert lat/lng to pixel position on our SVG map */
function latLngToXY(lat, lng, w, h) {
  /* Novi Sad bounding box approx */
  const minLat = 45.230, maxLat = 45.275;
  const minLng = 19.810, maxLng = 19.875;
  const x = ((lng - minLng) / (maxLng - minLng)) * w;
  const y = ((maxLat - lat) / (maxLat - minLat)) * h;
  return { x: Math.max(10, Math.min(w - 10, x)), y: Math.max(10, Math.min(h - 10, y)) };
}


// Generate stub data for remaining categories
// Stub data no longer needed - all categories defined in listingData above


/* ==========================================
   LISTING CARD  (grid card style)
========================================== */
/* -- Row-style listing card (clean, no photo) -- */
function ListingCard({ item, isMobile, onBusinessOpen }) {
  const [hov, setHov] = useState(false);

  // Potkategorija: uvek bira potkategorija polje direktno iz Supabase
  // parts[0] se NE koristi za kategoriju jer moze biti deo grada
  const parts         = (item.sub || "").split(" . ");
  // Kategorija: potkategorija iz Supabase, fallback na sub ili subcategory
  // Kategorija - uzima potkategorija iz Supabase baze
  // Fallback lanac: item.potkategorija -> item.subcategory -> sub[0] (ako nije deo grada)
  const _deloviGrada = ["Centar","Liman","Novo Naselje","Petrovaradin","Satelit","Detelinara","Telep","Ostalo","Novi Sad","Adice","Stari Grad","Grbavica"];
  const subCatLabel = (
    item.potkategorija ||
    item.subcategory ||
    (parts.length > 0 && parts[0] && !_deloviGrada.includes(parts[0].trim()) ? parts[0].trim() : "") ||
    ""
  ).trim();
  // Deo grada: iz deoGrada polja, ili drugi deo sub (iza " . ")
  const deoGradaLabel = item.deoGrada || (parts.length > 1 ? parts.slice(1).join(", ") : "") || "";
  // Adresa puna
  const rawAddr       = item.address || "";
  const addressLine   = rawAddr && rawAddr.length > 3 ? rawAddr : (deoGradaLabel || "Novi Sad");
  // Tags
  const tagsArr       = Array.isArray(item.tags) ? item.tags : [];
  // Radno vreme - preview prvog unosa
  const hoursArr      = Array.isArray(item.hours) ? item.hours : [];
  // Radno vreme za karticu: svi dani kompaktno
  // Normalizuj i prikazuj radno vreme: prevedi dane na srpski, konvertuj u 24h
  const _srpDani = ["Ponedeljak","Utorak","Sreda","Cetvrtak","Petak","Subota","Nedelja"];
  const hoursText = hoursArr.length > 0
    ? hoursArr.map((h, idx) => {
        const norm = normalizeHourEntry(h);
        const dayRaw = norm.day || "";
        // Ako dan nije prepoznat ili je prazan, uzmi srpski dan po indexu
        const dayLabel = dayRaw && dayRaw !== "Radno vreme" && dayRaw.trim()
          ? dayRaw
          : (_srpDani[idx] || "");
        const prefix = dayLabel ? dayLabel + ": " : "";
        const time   = norm.time || "";
        return prefix + time;
      }).filter(s => s.trim()).join("  |  ")
    : "";

  return (
    <a
      href={bizPath(item)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={(e) => {
        // Pravi <a href> - crawleri (Google, AI botovi) mogu da ga isprate kao
        // stvaran link ka biznisu, umesto div-a bez href-a koji za njih ne postoji.
        // Klik i dalje ide kroz SPA navigaciju (bez punog reload-a stranice);
        // ctrl/cmd/middle-klik i dalje otvara u novom tabu jer je href pravi.
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (!item || typeof item !== "object" || item.nativeEvent) return;
        onBusinessOpen && onBusinessOpen(item);
      }}
      style={{
        display: "block",
        textDecoration: "none",
        background: "#fff",
        borderRadius: 18,
        border: `1px solid ${hov ? "rgba(0,121,255,0.28)" : "rgba(0,0,0,0.06)"}`,
        boxShadow: hov ? "0 12px 28px rgba(0,0,0,0.10), 0 3px 8px rgba(0,0,0,0.05)" : "0 1px 3px rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "border-color 0.35s cubic-bezier(0.4,0,0.2,1), box-shadow 0.35s cubic-bezier(0.4,0,0.2,1), transform 0.35s cubic-bezier(0.4,0,0.2,1)",
        transform: hov ? "translateY(-3px)" : "none",
        marginBottom: 14,
        padding: "22px 26px",
      }}
    >
      {/* Naziv */}
      <div style={{
        fontFamily: SF, fontSize: 18, fontWeight: 700,
        color: hov ? BLUE : "#111", letterSpacing: "-0.01em", marginBottom: 12,
        transition: "color 0.35s ease",
      }}>
        {item.name}
      </div>

      {/* Zvezdice + broj recenzija */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 14 }}>
        {[1,2,3,4,5].map(i => (
          <svg key={i} width="14" height="14" viewBox="0 0 24 23" fill="none">
            <path d="M4.651 22.602C4.873 22.773 5.124 22.831 5.403 22.773C5.683 22.723 5.987 22.58 6.316 22.344L12 18.165L17.692 22.344C18.022 22.58 18.326 22.723 18.605 22.773C18.885 22.831 19.135 22.773 19.357 22.602C19.579 22.437 19.712 22.215 19.755 21.935C19.805 21.656 19.762 21.323 19.626 20.937L17.381 14.255L23.117 10.13C23.454 9.894 23.686 9.65 23.815 9.399C23.944 9.149 23.966 8.891 23.88 8.626C23.794 8.368 23.626 8.175 23.375 8.046C23.124 7.917 22.791 7.856 22.376 7.863L15.34 7.906L13.202 1.192C13.073 0.799 12.909 0.501 12.708 0.301C12.515 0.1 12.278 0 12 0C11.727 0 11.491 0.1 11.29 0.301C11.097 0.501 10.935 0.799 10.807 1.192L8.669 7.906L1.633 7.863C1.217 7.856 0.884 7.917 0.634 8.046C0.383 8.175 0.215 8.368 0.129 8.626C0.043 8.891 0.064 9.149 0.193 9.399C0.322 9.65 0.555 9.894 0.892 10.13L6.628 14.255L4.383 20.937C4.247 21.323 4.2 21.656 4.243 21.935C4.293 22.215 4.43 22.437 4.651 22.602Z"
              fill={i <= Math.round(item.rating || 0) ? BLUE : "#e0e0e0"}/>
          </svg>
        ))}
        <span style={{ fontSize: 12, color: "#888" }}>
          ({item.reviews || item.reviewCount || 0})
        </span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {/* Adresa (+ deo grada) */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: "#555" }}>
          <MapPin size={14} color={hov ? BLUE : "#aaa"} style={{ flexShrink: 0, marginTop: 2, transition: "color 0.35s ease" }} />
          <span>{addressLine}{deoGradaLabel && deoGradaLabel !== addressLine ? ` · ${deoGradaLabel}` : ""}</span>
        </div>

        {/* Kategorija = potkategorija biznisa */}
        {subCatLabel ? (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: "#555" }}>
            <Tag size={14} color={hov ? BLUE : "#aaa"} style={{ flexShrink: 0, marginTop: 2, transition: "color 0.35s ease" }} />
            <span>{subCatLabel}</span>
          </div>
        ) : null}

        {/* Radno vreme - svi dani */}
        {hoursText ? (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12.5, color: "#777", lineHeight: 1.6 }}>
            <Clock size={14} color={hov ? BLUE : "#aaa"} style={{ flexShrink: 0, marginTop: 2, transition: "color 0.35s ease" }} />
            <span>{hoursText}</span>
          </div>
        ) : null}
      </div>

      {/* Specifikacije */}
      {tagsArr.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 14 }}>
          {tagsArr.slice(0, 5).map((tag, i) => (
            <span key={i} style={{
              fontSize: 11.5, fontWeight: 600, color: "#666",
              background: "#f5f5f5", borderRadius: 999, padding: "4px 10px",
            }}>{tag}</span>
          ))}
        </div>
      )}
    </a>
  );
}
const filterInputBase = {
  width: "100%", boxSizing: "border-box",
  border: "1.5px solid #ebebeb", borderRadius: 10,
  padding: "10px 12px", fontFamily: SF, fontSize: 13,
  outline: "none", background: "#fafafa", color: "#111", letterSpacing: "-0.01em",
};

/* -- Removable chip for active filters -- */
// ── iOS donja fioka (filteri na telefonu) ────────────────────────────────
// Ulazi i izlazi "oprugom" (spring), prati prst 1:1 kad se vuče za ručku ili
// naslov (data-sheet-handle), a pri puštanju nastavlja brzinom prsta: ako je
// bačena nadole, zatvara se. Iznad vrha pruža blag otpor (rubber-band).
// children je funkcija (close) => sadržaj, da i dugmad u fioci zatvaraju animirano.
function springAnimate(from, to, v0, { damping = 1, response = 0.35 }, onUpdate, onDone) {
  const w = (2 * Math.PI) / response;
  let x = from - to, v = v0, last = performance.now(), raf;
  const step = (now) => {
    let dt = Math.min(0.064, (now - last) / 1000); last = now;
    // mali koraci da bi integracija bila stabilna i na sporijim telefonima
    while (dt > 0) { const h = Math.min(dt, 0.004); v += (-w * w * x - 2 * damping * w * v) * h; x += v * h; dt -= h; }
    if (Math.abs(x) < 0.5 && Math.abs(v) < 8) { onUpdate(to); if (onDone) onDone(); return; }
    onUpdate(to + x);
    raf = requestAnimationFrame(step);
  };
  raf = requestAnimationFrame(step);
  return () => cancelAnimationFrame(raf);
}
const rubberband = (over, dim, c = 0.55) => (over * dim * c) / (dim + c * Math.abs(over));
const projectFling = (v, d = 0.998) => (v / 1000) * d / (1 - d);

function BottomSheet({ onClose, zIndex = 9000, children }) {
  const sheetRef = React.useRef(null);
  const backdropRef = React.useRef(null);
  const st = React.useRef({ y: 0, stop: null, drag: null, closing: false });
  const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const height = () => (sheetRef.current ? sheetRef.current.offsetHeight : 600);
  const apply = (y) => {
    st.current.y = y;
    if (sheetRef.current) sheetRef.current.style.transform = `translate3d(0,${y}px,0)`;
    if (backdropRef.current) backdropRef.current.style.opacity = String(Math.min(1, Math.max(0, 1 - y / height())));
  };
  const animate = (to, v, opts, done) => {
    if (st.current.stop) st.current.stop();
    if (reduce) { apply(to); if (done) done(); return; }
    st.current.stop = springAnimate(st.current.y, to, v, opts, apply, done);
  };
  const close = (v = 0) => {
    if (st.current.closing) return;
    st.current.closing = true;
    animate(height(), Math.max(0, v), { damping: 1, response: 0.3 }, onClose);
  };
  React.useLayoutEffect(() => {
    apply(height());
    animate(0, 0, { damping: 1, response: 0.35 });
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); if (st.current.stop) st.current.stop(); };
  }, []); // eslint-disable-line

  const onPointerDown = (e) => {
    if (e.button > 0 || st.current.closing) return;
    if (!e.target.closest("[data-sheet-handle]") || e.target.closest("button, input, a, textarea, select")) return;
    st.current.drag = { id: e.pointerId, startY: e.clientY, startSheet: st.current.y, hist: [{ y: e.clientY, t: e.timeStamp }], active: false };
  };
  const onPointerMove = (e) => {
    const d = st.current.drag; if (!d || d.id !== e.pointerId) return;
    const dy = e.clientY - d.startY;
    if (!d.active) {
      if (Math.abs(dy) < 6) return;          // mali prag pre nego što krene vuča
      d.active = true;
      if (st.current.stop) st.current.stop(); // uhvati fioku i usred animacije
      d.startSheet = st.current.y; d.startY = e.clientY;
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch {}
    }
    const y = d.startSheet + (e.clientY - d.startY);
    apply(y < 0 ? rubberband(y, height()) : y);
    d.hist.push({ y: e.clientY, t: e.timeStamp }); if (d.hist.length > 6) d.hist.shift();
  };
  const onPointerEnd = (e) => {
    const d = st.current.drag; st.current.drag = null;
    if (!d || !d.active) return;
    const a = d.hist[0], b = d.hist[d.hist.length - 1];
    const v = b.t > a.t ? ((b.y - a.y) / (b.t - a.t)) * 1000 : 0; // px/s
    const h = height();
    if (st.current.y + projectFling(v) > h * 0.5) close(v);
    else animate(0, v, { damping: 0.85, response: 0.3 });
  };

  return ReactDOM.createPortal(
    <div style={{ position: "fixed", inset: 0, zIndex }}>
      <div ref={backdropRef} onClick={() => close()} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)", opacity: 0 }} />
      <div ref={sheetRef} role="dialog" aria-modal="true" className="ns-sheet"
        onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerEnd} onPointerCancel={onPointerEnd}
        style={{
          position: "absolute", bottom: 0, left: 0, right: 0,
          background: "#fff", borderRadius: "20px 20px 0 0",
          padding: "0 20px", maxHeight: "90vh", overflowY: "auto", overscrollBehavior: "contain",
          fontFamily: SF, boxShadow: "0 -4px 32px rgba(0,0,0,0.15)",
          transform: "translate3d(0,100%,0)", willChange: "transform",
        }}>
        <div data-sheet-handle aria-hidden="true" style={{ display: "flex", justifyContent: "center", padding: "8px 0 2px", cursor: "grab" }}>
          <div style={{ width: 36, height: 5, borderRadius: 3, background: "#d1d1d6" }} />
        </div>
        {typeof children === "function" ? children(close) : children}
      </div>
    </div>,
    document.body
  );
}

function Chip({ label, onRemove }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      background: BLUE, color: "#fff",
      borderRadius: 8, padding: "0 6px 0 12px", height: 30,
      fontSize: 12, fontWeight: 600, lineHeight: 1,
      boxShadow: PILL_SHADOW,
    }}>
      {label}
      <button type="button" onClick={onRemove} aria-label={`Ukloni filter ${label}`} style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 20, height: 20, padding: 0, border: "none", borderRadius: 6,
        background: "rgba(255,255,255,0.18)", color: "#fff", cursor: "pointer", flexShrink: 0,
      }}>
        <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 2l6 6M8 2l-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>
      </button>
    </div>
  );
}

/* -- Apple-style radio row -- */
function RadioItem({ label, selected, onClick }) {
  return (
    <div onClick={onClick}
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick && onClick(e); } }}
      style={{
      display: "flex", alignItems: "center", gap: 8,
      padding: "8px 10px", borderRadius: 10, cursor: "pointer",
      background: selected ? "#eef4ff" : "transparent",
      transition: "background 0.4s ease",
    }}>
      <div style={{
        width: 16, height: 16, borderRadius: "50%",
        border: `2px solid ${selected ? BLUE : "#ddd"}`,
        background: selected ? BLUE : "transparent",
        flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
        transition: "all 0.4s ease",
      }}>
        {selected && <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#fff" }}/>}
      </div>
      <span style={{
        fontSize: 13, fontWeight: selected ? 600 : 400,
        color: selected ? BLUE : "#333",
        transition: "color 0.4s ease",
      }}>{label}</span>
    </div>
  );
}

function FilterBox({ title, onReset, children }) {
  return (
    <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 8px rgba(0,0,0,0.06)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.08em" }}>{title}</div>
        {onReset && <span style={{ fontSize: 11, color: BLUE, cursor: "pointer", fontWeight: 500 , whiteSpace: "nowrap"}} onClick={onReset}>Poništi</span>}
      </div>
      {children}
    </div>
  );
}

function AppleSelect({ value, onChange, children, placeholder }) {
  return (
    <div style={{ position: "relative" }}>
      <select value={value} onChange={e => { onChange(e.target.value); }}
        style={{ ...filterInputBase, appearance: "none", paddingRight: 32, cursor: "pointer", color: value ? "#111" : "#aaa" }}>
        <option value="">{placeholder}</option>
        {children}
      </select>
      <ChevronDown size={14} color="#aaa" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}/>
    </div>
  );
}

const SUB_CATEGORIES = {
  Restorani:     ["Domaći restorani","Roštilj i meso","Italijanska hrana","Azijski ukusi","Brza hrana","Veganski restorani","Morska hrana"],
  Kafići:        ["Klasični kafići","Specialty Coffee & Pržionice","Poslastičarnice","Barovi i Pubovi","Brunch kafići","Nargila barovi","Knjižare kafići"],
  Sport:         ["Fitness centri & Teretane","CrossFit & Funkcionalni trening","Yoga & Pilates","Borilačke veštine","Sportski baloni & Tereni","Plesni studiji & Škole plesa"],
  Nega:          ["Frizerski saloni & Barberi","Kozmetički saloni","Masaža & Spa","Estetska medicina & Laser centri","Tetoviranje & Pirsing"],
  Auto:          ["Auto servisi & Mehaničari","Autoperionice & Dubinsko pranje","Vulkanizeri & Prodaja guma","Tehnički pregled & Registracija","Rent-a-Car"],
  Zdravlje:      ["Privatne klinike & Laboratorije","Stomatolozi","Apoteke","Veterinari & Vet ambulante","Fizioterapeuti & Kiropraktičari","Psihoterapija","Državne bolnice & Domovi zdravlja"],
  "Noćni život": ["Klubovi & Splavovi","Kafane & Tamburaši","Pub-ovi & Pivnice","Koktel & Vinski barovi"],
  Hoteli:        ["Hoteli & Apartmani","Hosteli & Sobe","Wellness & Spa hoteli","Boutique hoteli","Salaši & Etno smeštaj"],
  Bazeni:        ["Gradski bazeni & Aquaparci","Sportski bazeni","Spa & Wellness bazeni","Privatni & Sezonski bazeni"],
  Zanati:        ["Vodoinstalateri & Grejanje","Električari","Stolari & Nameštaj","Obućari & Kožni artikli","Krojači & Krojačnice","Servis bele tehnike","Ključari & Brave"],
};

/* LoadMoreButton - scroll-into-view animacija */
function LoadMoreButton({ onClick, page }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(false);
    const el = ref.current;
    if (!el) return;
    const t = setTimeout(() => {
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
        { threshold: 0 }
      );
      obs.observe(el);
      return () => obs.disconnect();
    }, 50);
    return () => clearTimeout(t);
  }, [page]);
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(14px)",
      transition: "opacity 0.3s ease, transform 0.3s ease",
      textAlign: "center", marginTop: 20,
    }}>
      <button className="btn-blue" onClick={onClick} style={{
        background: BLUE, color: "#fff", border: "none", borderRadius: 10,
        width: "100%", height: 50, fontSize: 14, fontWeight: 700,
        cursor: "pointer", fontFamily: SF,
      }}>Pogledajte više</button>
    </div>
  );
}

/* Fade-in + slide-up animacija za listing kartice - mora biti van CategoryPage zbog Rules of Hooks */
const LISTING_PAGE_SIZE = 6;
function AnimatedListingCard({ item, isMobile, index, isNew, onBusinessOpen }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  const delay = isNew ? Math.min((index % LISTING_PAGE_SIZE) * 25, 120) : Math.min(index * 20, 140);
  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(22px)",
        transition: `opacity 0.22s ease ${delay}ms, transform 0.22s ease ${delay}ms`,
      }}
    >
      <ListingCard item={item} isMobile={isMobile} onBusinessOpen={onBusinessOpen} />
    </div>
  );
}

/* ==========================================
   EXPORTS - koristi ih src/pages/*.js (lazy-loaded stranice) da uvezu
   deljene konstante, hookove, helper funkcije i komponente iz App.js,
   umesto da ih duplira. Jedan izvor istine za sve deljeno stanje.
========================================== */
export {
  // Konstante
  BG, BLUE, SF, SUPABASE_URL, SUPABASE_ANON, TABLE_NAME, GMAPS_KEY, DEO_COORDS,
  PILL_SHADOW, USER_ICON_REVIEW, listingData, CATEGORY_DB_NAME_MAP, SITE_URL,
  categoryMeta, CATEGORY_SEO, SUB_CATEGORIES, LISTING_PAGE_SIZE,
  CATEGORY_HERO_IMG, CATEGORY_HERO_BLUR, filterInputBase,
  // Hookovi
  useBreakpoint, useAuthContext, useFavorites, useIsAdmin, useReveal, useScrollLock,
  useSupabase, useReviews, usePageMeta, useStructuredData, useSupabaseCategory,
  // Helper / API funkcije
  normalizeHourEntry, mapRow, parseVremeToTs, searchMatch, isValidEmail, timeAgo, coordsForBiz, describeError, apiError,
  checkIsAdmin, insertReview, insertKontakt, insertBiznisZahtev, uploadBiznisSlike,
  insertProfile, upsertProfile, getFavorites, getProfile, getUserReviews, deleteReview,
  deleteRecenzija, getAdminStats, getKontaktPoruke, getMyBiznisZahtevi, getAdminBiznisZahtevi,
  updateBiznisZahtevStatus, approveBiznisZahtev, oznaciBrochitano, getObrisaneRecenzije,
  vratiRecenziju, trajnoObrisiRecenziju, authAPI, clearAllAuthStorage, translateAuthError, serbianVocative, notifyUserEmail,
  // Deljene komponente
  Navbar, Footer, ContactForm, Modal, ErrorBoundary, BlueStars, ReplyList, ReplyModal,
  ReviewCard, FavAuthModal, AddBizAuthModal, NotFoundContent, AuthLoadingScreen, AuthRequiredModal, LoadingState, Chip, AnimatedListingCard, LoadMoreButton, FilterBox,
  ReviewCardSkeleton, ListingCardSkeleton, SkeletonRows, SkBar, BottomSheet,
};
